import * as React from 'react';
import { forwardRef } from 'react';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function BackArrowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.957 2.76.943.943-3.625 3.623H15V8.66L3.274 8.659 6.9 12.284l-.943.943-4.762-4.762a.67.67 0 0 1-.07-.86l.07-.083z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6s = /*#__PURE__*/forwardRef(BackArrowIcon);

function CloudDownloadIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.025 3.868C11.325 2.293 9.75 1.243 8 1.243s-3.325 1.05-4.025 2.625C2.313 3.868 1 5.268 1 6.931c0 1.662 1.4 3.062 3.063 3.062h.936v-1.4h-.936c-.886 0-1.663-.777-1.663-1.662 0-.917.707-1.663 1.575-1.663h.91l.37-.831C5.738 3.347 6.816 2.643 8 2.643s2.261.704 2.745 1.794l.37.831h.91c.869 0 1.575.746 1.575 1.663 0 .885-.776 1.662-1.662 1.662h-.954v1.4h.954C13.6 9.993 15 8.593 15 6.931c0-1.663-1.312-3.063-2.975-3.063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.654 12.526v-4.42H7.346l.001 4.42-1.406-1.407-.925.925 2.521 2.521.068.059a.65.65 0 0 0 .857-.059l2.522-2.521-.925-.925z"
  })));
}
var ForwardRef$6r = /*#__PURE__*/forwardRef(CloudDownloadIcon);

function CollapsedIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.624 9.487a.64.64 0 0 1 .821.068l4.546 4.545-.9.9-4.096-4.096L3.9 15l-.9-.9 4.545-4.545zM12.091 1l.9.9-4.546 4.545-.078.068a.64.64 0 0 1-.822-.068L3 1.9l.9-.9 4.095 4.096z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6q = /*#__PURE__*/forwardRef(CollapsedIcon);

function DownArrowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.227 5.943 12.284 5l-4.29 4.291L3.702 5l-.943.943 4.762 4.762c.234.234.6.257.86.07l.083-.07z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6p = /*#__PURE__*/forwardRef(DownArrowIcon);

function DownloadIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.6v1.394H1V13.6zM8.99 1v8.452l2.612-2.61.985.986-3.8 3.8a.7.7 0 0 1-.9.074l-.086-.074L4 7.828l.985-.986 2.611 2.61V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6o = /*#__PURE__*/forwardRef(DownloadIcon);

function DownwardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.233 10.043-.942-.943-3.624 3.625V1H7.333l.001 11.726L3.71 9.1l-.942.943 4.762 4.762c.234.234.6.257.86.07l.082-.07z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6n = /*#__PURE__*/forwardRef(DownwardIcon);

function ExpandIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.09 9.368.9.9-4.545 4.546a.64.64 0 0 1-.82.067l-.08-.067L3 10.268l.9-.9 4.095 4.097zM8.368 1.12l.078.067 4.546 4.546-.9.9-4.096-4.097L3.9 6.632l-.9-.9 4.545-4.546a.64.64 0 0 1 .822-.067",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6m = /*#__PURE__*/forwardRef(ExpandIcon);

function ExternalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.264 3.314v1.273H2.273v9.14h9.14V9.736h1.273v4.628c0 .322-.24.588-.55.63L12.05 15H1.636a.636.636 0 0 1-.63-.55L1 14.364V3.95c0-.322.24-.588.55-.63l.086-.006zM14.364 1c.322 0 .588.24.63.55l.006.086v4.628h-1.273V3.172L8.45 8.45l-.9-.9 5.277-5.278H9.736V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6l = /*#__PURE__*/forwardRef(ExternalIcon);

function ForwardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.043 2.76-.943.943 3.625 3.623H1V8.66l11.726-.001L9.1 12.284l.943.943 4.762-4.762a.67.67 0 0 0 .07-.86l-.07-.083z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6k = /*#__PURE__*/forwardRef(ForwardIcon);

function LeftArrowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.957 2.5.943.943-4.291 4.29 4.291 4.29-.943.944-4.762-4.762a.67.67 0 0 1-.07-.86l.07-.083z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6j = /*#__PURE__*/forwardRef(LeftArrowIcon);

function MergeProfilesIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.028 10.318c.331 0 .605.246.648.565l.006.089v3.566H4.375l-.001-1.989L1.924 15 1 14.075l2.451-2.451-1.989.001v-1.307zm9.51 0v1.307l-1.989-.001L15 14.075l-.925.925-2.451-2.452.001 1.99h-1.307v-3.566c0-.331.246-.605.565-.648l.089-.006zM8 5.563a2.437 2.437 0 1 1 0 4.874 2.437 2.437 0 0 1 0-4.874m0 1.308a1.13 1.13 0 1 0 0 2.258 1.13 1.13 0 0 0 0-2.258M1.925 1l2.449 2.45V1.462h1.308v3.566a.654.654 0 0 1-.565.648l-.089.006H1.462V4.375l1.988-.001L1 1.924zm12.15 0 .925.925-2.451 2.449h1.989v1.308h-3.566a.654.654 0 0 1-.648-.565l-.006-.089V1.462h1.307l-.001 1.989z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6i = /*#__PURE__*/forwardRef(MergeProfilesIcon);

function PageNavigationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.9 5v4a.6.6 0 0 0 .6.6h9.552l-1.976 1.976.848.848 3-3a.6.6 0 0 0 0-.848l-3-3-.848.848L12.052 8.4H3.1V5z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6h = /*#__PURE__*/forwardRef(PageNavigationIcon);

function RedoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.783 1.7 3.03 3.03.068.078a.64.64 0 0 1-.067.822l-3.03 3.03-.9-.9 1.943-1.945H5.879l-.18.005a3.606 3.606 0 0 0 .18 7.208h4.242v1.273H5.88l-.196-.004a4.879 4.879 0 0 1 .196-9.754h6.947l-1.943-1.944z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6g = /*#__PURE__*/forwardRef(RedoIcon);

function RefreshIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.08 0 3.99.9 5.276 2.396l.273-2.01 1.318.178-.507 3.738a.665.665 0 0 1-.656.576l-.09-.006-3.801-.507.175-1.318 2.361.314A5.6 5.6 0 0 0 8 2.33C4.883 2.33 2.33 4.882 2.33 8S4.883 13.67 8 13.67c3.046 0 5.553-2.438 5.666-5.458L13.67 8H15c0 3.852-3.148 7-7 7s-7-3.148-7-7 3.148-7 7-7",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6f = /*#__PURE__*/forwardRef(RefreshIcon);

function ResetIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.968 1a7 7 0 1 1 0 14c-1.312 0-2.72-.435-3.86-1.15l-.24-.157-.215-.146a1.9 1.9 0 1 1 .973-.948c.958.657 2.213 1.07 3.342 1.07a5.67 5.67 0 1 0-4.282-9.382l2.343-.311.176 1.318-3.8.507a.665.665 0 0 1-.73-.481l-.018-.089-.507-3.737 1.319-.18.273 2.032A6.98 6.98 0 0 1 7.968 1",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6e = /*#__PURE__*/forwardRef(ResetIcon);

function RightArrowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.943 2.5 5 3.443l4.291 4.29L5 12.023l.943.944 4.762-4.762a.67.67 0 0 0 .07-.86l-.07-.083z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6d = /*#__PURE__*/forwardRef(RightArrowIcon);

function SwitchIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.321 14.2-.899-.9 1.5-1.5h-8.6v-1.3h8.6l-1.5-1.5.9-.9 2.5 2.5c.2.2.2.6.1.8l-.1.1zM3.722 1.8l.9.9-1.4 1.5h8.6v1.3h-8.6l1.5 1.5-1 .8-2.5-2.6c-.2-.2-.3-.5-.1-.8l.1-.1z"
  })));
}
var ForwardRef$6c = /*#__PURE__*/forwardRef(SwitchIcon);

function ToFromIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.268 10.714-.9.9-3.182-3.182a.64.64 0 0 1-.067-.821l.067-.08L4.368 4.35l.9.9-2.097 2.095h9.657L10.732 5.25l.9-.9 3.182 3.182a.64.64 0 0 1 .067.82l-.067.08-3.182 3.182-.9-.9 2.095-2.096H3.172z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6b = /*#__PURE__*/forwardRef(ToFromIcon);

function TransferIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.912 1.094 13.71 12.892V9.759H15v4.69a.645.645 0 0 1-.557.64l-.088.005h-4.69v-1.29h3.134L1 2.008zm3.779 8.209.912.912-4.69 4.69L1 13.994zM14.355.906c.327 0 .596.242.64.557L15 1.55v4.691h-1.29V3.107l-3.59 3.59-.912-.912 3.59-3.59H9.665V.905z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$6a = /*#__PURE__*/forwardRef(TransferIcon);

function TurnableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 8c0 3.852-3.148 7-7 7-2.08 0-3.99-.901-5.277-2.397l-.272 2.011-1.318-.178.507-3.738a.665.665 0 0 1 .656-.576l.09.006 3.801.507-.175 1.318-2.361-.314A5.6 5.6 0 0 0 8 13.67c3.046 0 5.553-2.437 5.666-5.457L13.67 8zM8 1c2.08 0 3.99.9 5.276 2.396l.273-2.01 1.318.178-.507 3.738a.665.665 0 0 1-.656.576l-.09-.006-3.801-.507.175-1.318 2.361.314A5.6 5.6 0 0 0 8 2.33c-3.046 0-5.553 2.437-5.666 5.457L2.33 8H1c0-3.852 3.148-7 7-7",
    clipRule: "evenodd"
  }));
}
var ForwardRef$69 = /*#__PURE__*/forwardRef(TurnableIcon);

function UndoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.217 1.7-3.03 3.03-.068.078a.64.64 0 0 0 .067.822l3.03 3.03.9-.9-1.943-1.945h6.948l.18.005a3.606 3.606 0 0 1-.18 7.208H5.88v1.273h4.242l.196-.004a4.879 4.879 0 0 0-.196-9.754H3.174l1.943-1.944z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$68 = /*#__PURE__*/forwardRef(UndoIcon);

function UnsortedIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181c56",
    fillRule: "evenodd",
    d: "M8.69 11.77V4.32l2.1 2.1.9-.9-3.18-3.18-.08-.07a.626.626 0 0 0-.82.07L4.43 5.52l.9.9 2.1-2.1v7.45l-2.1-2.1-.9.9 3.18 3.18.08.07c.25.18.6.16.82-.07l3.18-3.18-.9-.9z"
  }));
}
var ForwardRef$67 = /*#__PURE__*/forwardRef(UnsortedIcon);

function UpArrowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.227 9.957-.943.943-4.29-4.291L3.702 10.9l-.943-.943 4.762-4.762a.67.67 0 0 1 .86-.07l.083.07z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$66 = /*#__PURE__*/forwardRef(UpArrowIcon);

function UploadIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.6v1.394H1V13.6zM7.887 1.13a.7.7 0 0 1 .9.074l3.8 3.801-.985.985L8.99 3.38v8.453H7.597L7.596 3.38l-2.61 2.61L4 5.004l3.8-3.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$65 = /*#__PURE__*/forwardRef(UploadIcon);

function UpwardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.233 5.957-.942.943-3.624-3.625V15H7.333l.001-11.726L3.71 6.9l-.942-.943 4.762-4.762a.67.67 0 0 1 .86-.07l.082.07z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$64 = /*#__PURE__*/forwardRef(UpwardIcon);

function VerticalSwitchIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.814 12.245-2.546 2.546a.64.64 0 0 1-.82.067l-.08-.067-2.545-2.546.9-.9 1.46 1.46-.001-8.01h1.273v8.01l1.459-1.46zm6.363-8.536-.9.9-1.459-1.46v8.646h-1.273l.001-8.647-1.46 1.461-.9-.9 2.546-2.545a.64.64 0 0 1 .82-.067l.08.067z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$63 = /*#__PURE__*/forwardRef(VerticalSwitchIcon);

function AnimalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.572 8.474c1.624-2.29 5.11-2.29 6.756.036l1.334 2.202c1.408 2.324-.989 5.046-3.557 4.092l-.116-.042a3.03 3.03 0 0 0-2.1 0l-.116.042c-2.57.954-4.966-1.768-3.558-4.092zm5.772.681C9.19 7.527 6.687 7.527 5.556 9.12l-1.334 2.202c-.817 1.348.595 2.952 2.14 2.379l.116-.043a4.2 4.2 0 0 1 2.92 0l.116.043c1.546.573 2.958-1.03 2.141-2.38zM1.716 4.357a1.64 1.64 0 0 1 2.17.29l.249.29a1.645 1.645 0 0 1-.201 2.328l-.122.092a1.64 1.64 0 0 1-2.17-.29l-.249-.29a1.64 1.64 0 0 1 .182-2.312zm10.274.29a1.64 1.64 0 0 1 2.17-.29l.021.014.121.094a1.64 1.64 0 0 1 .182 2.312l-.248.29a1.645 1.645 0 0 1-2.19.276l-.122-.094a1.64 1.64 0 0 1-.182-2.312zm-8.806.6a.71.71 0 0 0-.926-.14l-.088.066-.07.07a.715.715 0 0 0-.066.848l.063.085.247.29a.71.71 0 0 0 .926.142l.082-.062a.715.715 0 0 0 .08-1.008zm10.362-.18a.716.716 0 0 0-.852.18l-.248.29a.71.71 0 0 0 .06.993l.081.063c.3.205.708.152.946-.126l.248-.29a.71.71 0 0 0-.06-.993l-.09-.069zM5.391 1.03a1.64 1.64 0 0 1 1.877 1.144l.335 1.129a1.644 1.644 0 0 1-1.127 2.045l-.14.034a1.64 1.64 0 0 1-1.877-1.145l-.335-1.128a1.64 1.64 0 0 1 1.104-2.04zM8.61 2.173a1.64 1.64 0 0 1 1.876-1.144l.163.04a1.64 1.64 0 0 1 1.105 2.039l-.336 1.128a1.645 1.645 0 0 1-1.9 1.14l-.14-.035a1.64 1.64 0 0 1-1.104-2.04zm-2.923-.25-.1.01-.095.022a.715.715 0 0 0-.482.89l.336 1.128c.105.352.46.567.794.504l.095-.023a.715.715 0 0 0 .481-.889l-.335-1.128a.71.71 0 0 0-.795-.504zm4.53.003a.716.716 0 0 0-.72.51l-.336 1.13a.71.71 0 0 0 .459.882l.094.024a.715.715 0 0 0 .817-.5l.336-1.128a.71.71 0 0 0-.46-.883l-.101-.025z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$62 = /*#__PURE__*/forwardRef(AnimalIcon);

function AnimalFreeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.232 5.656.236-.276a.68.68 0 0 1 .812-.172l.08.046.086.065c.268.23.3.659.057.945l-.236.276a.68.68 0 0 1-.9.121l-.078-.06a.675.675 0 0 1-.057-.945m-.497 1.629.117.089a1.565 1.565 0 0 0 2.084-.262l.236-.276a1.56 1.56 0 0 0-.173-2.2l-.115-.09-.02-.014a1.56 1.56 0 0 0-2.066.276l-.235.276a1.56 1.56 0 0 0 .172 2.2m-.567 1.201c-.672-.95-1.669-1.467-2.707-1.604l4.218 4.218a3 3 0 0 0-.24-.518zm-7.592-1.87-.078.06a.676.676 0 0 1-.882-.136l-.236-.276-.059-.08a.68.68 0 0 1 .063-.808l.067-.067.083-.063a.68.68 0 0 1 .88.135l.237.276a.68.68 0 0 1-.075.96m.554.685c.674-.575.75-1.56.19-2.216l-.235-.276a1.56 1.56 0 0 0-2.067-.276l-.134.103a1.56 1.56 0 0 0-.173 2.2l.236.277a1.56 1.56 0 0 0 2.066.277zm1.024-4.208a.68.68 0 0 1 .458-.846l.09-.022a.676.676 0 0 1 .756.48l.32 1.074a.68.68 0 0 1-.458.847l-.09.02h-.004l.673.674a1.555 1.555 0 0 0 .724-1.791l-.32-1.075a1.56 1.56 0 0 0-1.786-1.089l-.155.037a1.56 1.56 0 0 0-1.099 1.283L5.36 3.778zm3.951.686.32-1.074a.68.68 0 0 1 .685-.486l.086.01.096.024c.339.1.544.48.437.84l-.32 1.074a.68.68 0 0 1-.777.475l-.09-.022a.68.68 0 0 1-.437-.84m.208 1.69.132.032a1.566 1.566 0 0 0 1.809-1.084l.32-1.074a1.56 1.56 0 0 0-1.052-1.941l-.156-.039a1.56 1.56 0 0 0-1.785 1.09l-.32 1.074A1.56 1.56 0 0 0 9.313 5.47m.129 7.957-.11-.04a4 4 0 0 0-2.78 0l-.11.04c-1.472.546-2.816-.98-2.038-2.264l1.27-2.096c.413-.582 1.02-.918 1.673-1.046l4.29 4.29a1.643 1.643 0 0 1-2.195 1.116m5.558.901L1.673 1 1 1.673l5.443 5.443a3.8 3.8 0 0 0-1.706 1.335l-1.292 2.13c-1.34 2.212.941 4.805 3.387 3.896l.11-.04a2.88 2.88 0 0 1 2 0l.11.04c1.46.542 2.848-.17 3.454-1.298L14.327 15z",
    clipRule: "evenodd",
    transform: "translate(-669 -233) translate(668 232)"
  }));
}
var ForwardRef$61 = /*#__PURE__*/forwardRef(AnimalFreeIcon);

function BabyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.32 8.059-2.759-2.63a.61.61 0 0 0-.433-.178h-2.76a.61.61 0 0 0-.433.178l-2.759 2.63a.605.605 0 0 0 .012.865.625.625 0 0 0 .868-.003l1.775-1.687v1.872h3.834V7.234L11.44 8.92c.242.24.634.242.877.003a.607.607 0 0 0 .008-.86zm-6.334 5.128a.15.15 0 0 1 0-.219l1.011-1.001-1.486-1.388-1.189 1.134c-.404.4-.404 1.05 0 1.449l.013.01 1.68 1.658a.58.58 0 0 0 .817.004.564.564 0 0 0 .005-.807l-.004-.004-.001-.001zm4-2.608-1.488 1.388 1.012 1a.15.15 0 0 1 0 .218l-.846.837a.566.566 0 0 0-.002.807.58.58 0 0 0 .819.001h.001l1.68-1.659.012-.009c.405-.4.405-1.05 0-1.45zM8.399 4.678a1.89 1.89 0 0 0 1.153-2.426 1.924 1.924 0 0 0-2.454-1.14 1.89 1.89 0 0 0-1.156 2.425A1.926 1.926 0 0 0 8.4 4.677",
    clipRule: "evenodd",
    transform: "translate(-527 -279) translate(524 278)"
  }));
}
var ForwardRef$60 = /*#__PURE__*/forwardRef(BabyIcon);

function BicycleHotelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.87 5.008a.6.6 0 0 1 .479.429l.749 2.647.164.577-.008.002.216.777h.033a2.499 2.499 0 1 1-1.194.303l-.148-.531-1.712 1.936a.602.602 0 0 1-.952-.07l-.954-1.466-.322.553a2.5 2.5 0 0 1 .775 1.806 2.5 2.5 0 0 1-4.996 0 2.498 2.498 0 0 1 3.18-2.402l.632-1.08-.499-.766h-.518a.6.6 0 0 1 0-1.2h1.898l.12.012a.597.597 0 0 1-.072 1.183l.148.226 2.79-.466-.362-1.279H7.998V5h1.773zm-5.372 5.664a1.3 1.3 0 0 0 0 2.597 1.299 1.299 0 0 0 1.084-2.01l-.515.882-.07.098a.6.6 0 0 1-.965-.703l.503-.862zm7.57.92.02.12a.6.6 0 0 1-1.133.314l-.044-.113-.264-.951a1.296 1.296 0 0 0 .856 2.273 1.298 1.298 0 0 0 .31-2.557zm-4.465-2.55.468.72.83-.938z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.815 5.74-.63 1.02L8 2.955 1.814 6.761l-.628-1.022L8 1.546z"
  }));
}
var ForwardRef$5$ = /*#__PURE__*/forwardRef(BicycleHotelIcon);

function BicycleParkingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.87 5.54a.6.6 0 0 1 .479.428l.749 2.647.164.577-.008.002.216.778.033-.001a2.499 2.499 0 1 1-1.194.303l-.148-.53-1.712 1.935a.602.602 0 0 1-.952-.07l-.954-1.465-.322.552a2.5 2.5 0 0 1 .775 1.806 2.5 2.5 0 0 1-4.996 0 2.498 2.498 0 0 1 3.18-2.401l.632-1.081-.499-.766h-.518a.6.6 0 0 1 0-1.2h1.898l.12.012a.597.597 0 0 1-.072 1.183l.148.227 2.79-.467-.362-1.279H7.998V5.531h1.773zm-5.372 5.663a1.3 1.3 0 0 0 0 2.597 1.299 1.299 0 0 0 1.084-2.01l-.515.882-.07.098a.6.6 0 0 1-.965-.703l.503-.862zm7.57.92.02.12a.6.6 0 0 1-1.133.315l-.044-.114-.264-.95a1.296 1.296 0 0 0 .856 2.273 1.298 1.298 0 0 0 .31-2.558zm-4.465-2.55.468.72.83-.938zM8.672 1a1.568 1.568 0 1 1 0 3.137H7.334v1.15h-1.2V1zM7.334 2.938h1.338a.37.37 0 0 0 0-.739H7.334z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5_ = /*#__PURE__*/forwardRef(BicycleParkingIcon);

function BusShelterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.993 4.636a3.311 3.311 0 0 1 2.337 5.657 5.07 5.07 0 0 1 3.173 4.498l.005.209h-1.334a3.74 3.74 0 0 0-3.548-3.736l-.193-.005h-.881a3.74 3.74 0 0 0-3.736 3.548L3.81 15H2.477a5.08 5.08 0 0 1 3.178-4.708 3.311 3.311 0 0 1 2.337-5.656m0 1.334a1.978 1.978 0 1 0 0 3.955 1.978 1.978 0 0 0 0-3.955m.168-4.948.107.038 6.667 3.03-.552 1.214-6.39-2.905-6.391 2.905L1.05 4.09l6.667-3.03a.67.67 0 0 1 .444-.038",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5Z = /*#__PURE__*/forwardRef(BusShelterIcon);

function CabinIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.557 1.166a.657.657 0 0 1 .873 0l5.437 4.833c.14.124.22.303.22.49v7.854a.657.657 0 0 1-.656.657H9.806a.657.657 0 0 1-.657-.657v-3.572H6.84v3.572a.66.66 0 0 1-.568.651L6.18 15H2.558a.657.657 0 0 1-.657-.657V6.49c0-.188.08-.367.22-.491zm.437 1.369-4.78 4.249v6.902h2.31v-3.572c0-.332.248-.607.568-.65l.09-.007h3.624c.363 0 .657.295.657.657v3.572h2.31V6.785z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 10.55v-1.1h10v1.1zM3 8.55v-1.1h10v1.1zM3 6.55v-1.1h10v1.1zM5 4.55v-1.1h6v1.1zM3 12.55v-1.1h3.333v1.1zM10 12.55v-1.1h4v1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.95 6V2h1.1v4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5Y = /*#__PURE__*/forwardRef(CabinIcon);

function FullIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.603 6.282a2.44 2.44 0 1 0-4.883 0c0 .758.344 1.435.886 1.882A3.82 3.82 0 0 0 1 11.784v.38h8.323v-.38l-.002-.127a3.82 3.82 0 0 0-2.603-3.492 2.44 2.44 0 0 0 .885-1.883m4.56 5.375A3.82 3.82 0 0 0 9.56 8.165 2.442 2.442 0 0 0 8.003 3.84c-.3 0-.584.061-.85.161a3.02 3.02 0 0 1 .551 3.952 4.45 4.45 0 0 1 2.218 3.694l.002.138v.38h2.241v-.38zm2.838 0a3.82 3.82 0 0 0-2.604-3.492 2.442 2.442 0 0 0-1.556-4.325c-.3 0-.584.061-.85.161a3.02 3.02 0 0 1 .551 3.952 4.44 4.44 0 0 1 2.218 3.694l.002.138v.38h2.241v-.38z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5X = /*#__PURE__*/forwardRef(FullIcon);

function ManySeatsAvailableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.594 8.165a3.82 3.82 0 0 1 2.604 3.492l.003.128v.379h-.757v-.38c0-1.475-1.052-2.687-2.44-2.974a3 3 0 0 0-.228-.03c-.363-.493-.99-.778-.99-.778.1 0 .217-.004.255-.008.867-.084 1.683-.836 1.683-1.712 0-.931-.755-1.686-1.685-1.686a1 1 0 0 0-.294.042l-.027-.04c-.108-.156-.235-.339-.53-.597.246-.11.608-.161.851-.161a2.441 2.441 0 0 1 1.555 4.325m2.8 0A3.82 3.82 0 0 1 15 11.657l.002.128v.379h-.757v-.38a3.04 3.04 0 0 0-2.441-2.974 3 3 0 0 0-.227-.03c-.362-.493-.99-.778-.99-.778.099 0 .217-.004.255-.008.868-.084 1.683-.836 1.683-1.712 0-.931-.754-1.686-1.685-1.686a1 1 0 0 0-.293.042l-.03-.043A2.9 2.9 0 0 0 9.988 4c.246-.11.609-.161.85-.161a2.442 2.442 0 0 1 1.557 4.325",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.162 4.597a1.686 1.686 0 1 0-.001 3.371 1.686 1.686 0 0 0 0-3.37m0-.757a2.442 2.442 0 0 1 1.556 4.325 3.82 3.82 0 0 1 2.604 3.493l.002.127v.379h-.757v-.38a3.06 3.06 0 0 0-2.943-3.057l-.118-.003h-.688a3.063 3.063 0 0 0-3.06 2.944l-.001.117v.379H1v-.38a3.82 3.82 0 0 1 2.607-3.62A2.442 2.442 0 0 1 5.162 3.84",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5W = /*#__PURE__*/forwardRef(ManySeatsAvailableIcon);

function SeatsAvailableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.594 8.165a3.82 3.82 0 0 1 2.604 3.492l.003.128v.379h-.757v-.38c0-1.475-1.052-2.687-2.44-2.974a3 3 0 0 0-.228-.03c-.363-.493-.99-.778-.99-.778.1 0 .217-.004.255-.008.867-.084 1.683-.836 1.683-1.712 0-.931-.755-1.686-1.685-1.686a1 1 0 0 0-.294.042l-.027-.04c-.108-.156-.235-.339-.53-.597.246-.11.608-.161.851-.161a2.441 2.441 0 0 1 1.555 4.325m2.8 0A3.82 3.82 0 0 1 15 11.657l.002.128v.379h-.757v-.38a3.04 3.04 0 0 0-2.441-2.974 3 3 0 0 0-.227-.03c-.362-.493-.99-.778-.99-.778.099 0 .217-.004.255-.008.868-.084 1.683-.836 1.683-1.712 0-.931-.754-1.686-1.685-1.686a1 1 0 0 0-.293.042l-.03-.043A2.9 2.9 0 0 0 9.988 4c.246-.11.609-.161.85-.161a2.442 2.442 0 0 1 1.557 4.325",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.162 3.84a2.441 2.441 0 0 1 1.556 4.325 3.82 3.82 0 0 1 2.604 3.492l.002.128v.379H1v-.38a3.82 3.82 0 0 1 2.607-3.62A2.44 2.44 0 0 1 5.162 3.84",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5V = /*#__PURE__*/forwardRef(SeatsAvailableIcon);

function StandingAvailableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.999 11.657a3.82 3.82 0 0 0-2.604-3.492 2.442 2.442 0 0 0-1.556-4.325c-.242 0-.605.052-.851.16.32.28.442.473.558.638a1 1 0 0 1 .293-.042c.93 0 1.685.755 1.685 1.686 0 .876-.815 1.628-1.683 1.712a4 4 0 0 1-.255.008s.628.285.99.779c.09.008.209.025.227.029a3.04 3.04 0 0 1 2.44 2.975v.379h.758v-.38z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.604 6.282a2.442 2.442 0 1 0-3.998 1.882A3.82 3.82 0 0 0 1 11.784v.38h8.324v-.38l-.002-.127a3.82 3.82 0 0 0-2.604-3.492 2.44 2.44 0 0 0 .886-1.883M9.56 8.165a3.82 3.82 0 0 1 2.604 3.492l.002.128v.38h-2.24v-.38l-.003-.138a4.44 4.44 0 0 0-2.217-3.694 3.019 3.019 0 0 0-.552-3.952c.266-.1.55-.16.851-.16A2.441 2.441 0 0 1 9.56 8.164",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5U = /*#__PURE__*/forwardRef(StandingAvailableIcon);

function CoffeeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.531 13.645V15H1.28v-1.355zm1.522-8.796c.343 0 .626.254.671.585l.006.092v2.2c0 .932-.718 1.696-1.631 1.77l-.146.006h-.925a5.64 5.64 0 0 1-4.9 3.294l-.222.005A5.625 5.625 0 0 1 1.28 7.175v-1.65c0-.373.303-.676.677-.676zm-2.877 1.354H2.635v.972a4.27 4.27 0 0 0 4.05 4.266l.206.005.196-.004a4.27 4.27 0 0 0 4.09-4.267zm2.199 0h-.844v.972q0 .499-.084.973h.506c.208 0 .38-.15.416-.347l.006-.076zM4.834 1.55v2.454H3.479V1.55zm5.498 0v2.454H8.977V1.55zM7.582 1v2.454H6.229V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5T = /*#__PURE__*/forwardRef(CoffeeIcon);

function CouchetteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.897 7.756a.63.63 0 0 0-.626-.547h-.09V4.248a.685.685 0 0 0-.684-.685h-3.374a.8.8 0 0 0-.382.107 1.1 1.1 0 0 0-.46-.107H6.622c-.166 0-.32.042-.462.107a.8.8 0 0 0-.383-.107H2.406a.686.686 0 0 0-.685.685v2.961h-.089a.63.63 0 0 0-.626.547L1 7.84v4.596h1.264v-1.666h11.374v1.666h1.265V7.841zM13.096 4.65v2.56H10.39V4.65zm-3.792.023V7.21H6.603l.02-2.56zM2.808 4.65h2.704v2.559H2.807zm10.83 4.857H2.265l-.001-1.034h11.375z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5S = /*#__PURE__*/forwardRef(CouchetteIcon);

function CutleryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.213 1v3.03h1.091V1h1.334l-.001 3.03h1.091V1h1.334v5.515c0 .99-.766 1.802-1.739 1.874l-.14.005-.546-.001V15H4.305V8.393h-.545c-.99 0-1.802-.765-1.874-1.738l-.005-.14V1zm10.91 14h-1.334v-4.182h-2.97a.67.67 0 0 1-.659-.568l-.007-.098V5.303A4.303 4.303 0 0 1 13.456 1c.334 0 .612.247.66.568l.006.099zM12.788 2.408l-.149.039a2.97 2.97 0 0 0-2.148 2.672l-.006.184v4.182h2.303zM6.728 5.363H3.213v1.152c0 .272.198.496.457.538l.089.008h2.424a.545.545 0 0 0 .538-.457l.007-.089z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5R = /*#__PURE__*/forwardRef(CutleryIcon);

function LockerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.517 6.45c.245 0 .447.187.479.429l.004.067v1.582h2.481c.255 0 .467.165.51.382l.009.083V14.3c0 .257-.232.465-.519.465H3.52c-.287 0-.519-.208-.519-.465V8.993c0-.256.232-.464.519-.464L6 8.528V6.946c0-.25.182-.458.417-.491l.066-.005zM5 9.568H4v4.158l1-.001zm5 0H6v4.157h4zm2 0h-1v4.157h1zM9.034 7.442H6.966l-.001 1.086h2.069zM5.932 1a1.92 1.92 0 0 1 1.671 1h4.125l.772 1-.772 1h-.645l-.644-.666L9.796 4l-.645-.666L8.507 4h-.904a1.92 1.92 0 0 1-1.671 1C4.865 5 4 4.104 4 3s.865-2 1.932-2M5.5 2.379c-.332 0-.6.277-.6.62s.268.621.6.621.6-.277.6-.62-.269-.621-.6-.621",
    clipRule: "evenodd",
    transform: "translate(-1283 -504) translate(1280 503)"
  }));
}
var ForwardRef$5Q = /*#__PURE__*/forwardRef(LockerIcon);

function ParkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.596 7.414h-1.37v-2.02h1.358c.82 0 1.219.37 1.22.995 0 .538-.323 1.03-1.208 1.025M7.999 1c3.862 0 7 3.141 7 7s-3.138 7-7 7c-3.86 0-7-3.141-7-7s3.14-7 7-7m0 1C4.692 2 2 4.691 2 8s2.692 6 6 6c3.31 0 6-2.691 6-6s-2.69-6-6-6m.553 2c1.69 0 2.788.79 2.788 2.348 0 1.6-1.007 2.52-2.8 2.52H7.227V12H5.625V4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5P = /*#__PURE__*/forwardRef(ParkIcon);

function ParkAndRideIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7m0 1C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m3.004 5.65v1.3h1.3v1h-1.3v1.3h-1v-1.3h-1.3v-1h1.3v-1.3zM6.81 4.75c1.373 0 2.265.64 2.265 1.908 0 1.299-.818 2.047-2.274 2.047H5.732v2.545h-1.3v-6.5zm.026 1.133H5.732v1.64h1.113c.72.005.982-.395.981-.832 0-.508-.324-.808-.99-.808",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5O = /*#__PURE__*/forwardRef(ParkAndRideIcon);

function ParkingGarageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.493 5.5H5.2v9h1.801v-3.525h1.48c2.015 0 3.148-1.035 3.148-2.833 0-1.754-1.235-2.642-3.136-2.642m.05 3.84H7V7.069H8.53c.923 0 1.371.415 1.372 1.12.002.605-.363 1.158-1.359 1.153M14 5.1 8 2.7 2 5.1V3.807l5.555-2.223c.285-.114.605-.114.89 0L14 3.808z",
    transform: "translate(-2 -1)"
  }));
}
var ForwardRef$5N = /*#__PURE__*/forwardRef(ParkingGarageIcon);

function PlayroomIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14.002A7 7 0 0 1 8 1m2.19 4.465c-1.412 1.1-2.704 1.386-4.846 1.406l-.284.002c-1.645-.001-2.242.122-2.774.752q-.014.187-.013.375a5.727 5.727 0 0 0 11.454 0v-.03c-.815-.188-1.818-.683-2.807-1.663a8 8 0 0 1-.71-.813zM5.396 8.58a.868.868 0 1 1 0 1.736.868.868 0 0 1 0-1.736m5.206 0a.868.868 0 1 1 0 1.736.868.868 0 0 1 0-1.736M8 2.273a5.73 5.73 0 0 0-5.305 3.566c.542-.173 1.213-.23 2.124-.238L5.06 5.6c2.317.001 3.413-.263 4.827-1.543a.636.636 0 0 1 .965.132q.445.7.965 1.214c.554.55 1.141.924 1.726 1.155A5.73 5.73 0 0 0 8 2.273",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5M = /*#__PURE__*/forwardRef(PlayroomIcon);

function PowerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.167 8.987-.06.074c-.277.41.01.99.53.99h5.63l-.604 4.222c-.088.621.68.982 1.1.518l7.07-7.776.06-.074a.637.637 0 0 0-.53-.99h-5.63l.604-4.223c.088-.62-.68-.981-1.1-.518zm6.617-5.389L7.37 6.497l-.006.088A.636.636 0 0 0 8 7.223h4.924l-4.709 5.18.415-2.898.006-.088A.636.636 0 0 0 8 8.78H3.075z",
    clipRule: "evenodd",
    transform: "translate(-1245 -233) translate(1244 232)"
  }));
}
var ForwardRef$5L = /*#__PURE__*/forwardRef(PowerIcon);

function PremiumSeatIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.679 13.663h2.367V15h-5.44v-1.337h1.736v-3.039h-.813a3.53 3.53 0 0 1-3.153-1.939l-.085-.18-3.041-6.97L2.475 1l1.822 4.175h3.39v1.337H4.88l.636 1.458a2.2 2.2 0 0 0 1.85 1.312l.163.006h4.517c.145 0 .284.047.399.132l.08.07 2.23 2.292-.959.932-2.033-2.09H9.68z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5K = /*#__PURE__*/forwardRef(PremiumSeatIcon);

function SeatIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.667 1 .847 4.522h3.43v1.29H5.756L6.11 8.7c.078.42.42.734.836.783l.115.007h5.473v1.29l-2.928-.001v2.931h2.917V15H6.817v-1.29h1.499v-2.931H7.061a2.26 2.26 0 0 1-2.183-1.683l-.036-.158-1.442-7.7z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5J = /*#__PURE__*/forwardRef(SeatIcon);

function SeatCompartmentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.617 2.999a1.1 1.1 0 0 1 1.082.902l.014.106.408 4.861h1.41a1.1 1.1 0 0 1 1.1 1.1v2.434a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6V3.6l.012-.121a.6.6 0 0 1 .588-.479zM2.2 11.802h3.232v-1.735H3.569a.6.6 0 0 1-.598-.55l-.446-5.319H2.2zM14.4 2.999a.6.6 0 0 1 .588.479l.012.12v8.804a.6.6 0 0 1-.6.6H9.97a.6.6 0 0 1-.6-.6V9.968a1.1 1.1 0 0 1 1.1-1.1h1.41l.408-4.861.014-.106A1.1 1.1 0 0 1 13.383 3zm-.925 1.2-.446 5.319a.6.6 0 0 1-.598.55h-1.862v1.734h3.232V4.198z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.969 7.621h-1.37v5.27H7.4V7.62H6.03v-1.2H9.97z"
  }));
}
var ForwardRef$5I = /*#__PURE__*/forwardRef(SeatCompartmentIcon);

function SeatCompartmentFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 14 10",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.617-.001A1.1 1.1 0 0 1 2.7.901l.014.106.408 4.861h1.41a1.1 1.1 0 0 1 1.1 1.1v2.434a.6.6 0 0 1-.6.6H.6a.6.6 0 0 1-.6-.6V.6L.012.478A.6.6 0 0 1 .6-.001zM13.4-.001a.6.6 0 0 1 .588.479l.012.12v8.804a.6.6 0 0 1-.6.6H8.97a.6.6 0 0 1-.6-.6V6.968a1.1 1.1 0 0 1 1.1-1.1h1.41l.408-4.861.014-.106A1.1 1.1 0 0 1 12.383 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.969 4.621h-1.37v5.27H6.4V4.62H5.03v-1.2H8.97z"
  }));
}
var ForwardRef$5H = /*#__PURE__*/forwardRef(SeatCompartmentFilledIcon);

function SleepIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.264 5.789-.001 3.963h12.008c.32 0 .584.239.626.547l.006.086v4.596h-1.264l-.001-1.667H2.263v1.667H1V5.789zm11.375 5.228-11.376-.001v1.034h11.375zm-1.444-9.561.007.086v1.074c0 .612.465 1.115 1.06 1.176l.122.006h1.074c.354 0 .613.334.525.677a2.84 2.84 0 0 1-3.425 2.05 2.82 2.82 0 0 1-2.084-2.084 2.843 2.843 0 0 1 2.05-3.424.54.54 0 0 1 .671.439m-1.077.954-.015.012a1.77 1.77 0 0 0-.574 1.773 1.74 1.74 0 0 0 1.275 1.276c.64.15 1.259-.05 1.674-.466l.1-.108.01-.016h-.204a2.265 2.265 0 0 1-2.245-1.963l-.016-.153-.004-.149z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5G = /*#__PURE__*/forwardRef(SleepIcon);

function StrollerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.54 12.221a1.39 1.39 0 1 1-.001 2.78 1.39 1.39 0 0 1 0-2.78m-5.558 0a1.39 1.39 0 1 1 0 2.78 1.39 1.39 0 0 1 0-2.78M8.98 1a5.13 5.13 0 0 1 5.125 4.913l.005.217v2.723a2.193 2.193 0 0 1-2.036 2.187l-.157.005H5.641A2.194 2.194 0 0 1 3.453 9.01l-.006-.156v-3.88a.94.94 0 0 0-.838-.935l-.102-.006H1.9V2.778h.607c1.163 0 2.116.906 2.19 2.05l.005.145-.001.99h3.65V1.627c0-.346.281-.627.628-.627m-.014 6.216H4.702v1.637c0 .446.312.82.73.915l.107.018.102.005h6.275a.94.94 0 0 0 .932-.829l.007-.11-.001-1.635H8.979zm.64-4.91v3.656h3.246l-.015-.212a3.88 3.88 0 0 0-2.922-3.382l-.199-.044z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5F = /*#__PURE__*/forwardRef(StrollerIcon);

function TVMIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.56 10.57V6.2h-.863v4.37zM1 2.393h14V1H1zm2.8 12.093a.5.5 0 0 0 .49.513h2.443a.5.5 0 0 0 .49-.513c0-.566.438-1.027.977-1.027.503 0 .919.402.972.915l.006.112a.5.5 0 0 0 .489.513h2.444a.5.5 0 0 0 .489-.513V4h-1.231l-.001 9.768h-1.074l-.043-.122a2.21 2.21 0 0 0-1.904-1.413l-.147-.005c-.938 0-1.726.592-2.051 1.418l-.044.122H5.032V4H3.8zm4.624-5.666h.864V6.2h-.864z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5E = /*#__PURE__*/forwardRef(TVMIcon);

function ToiletIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.092 15.832 1.096-3.872h.024L7.3 15.832h1.376l1.616-5.664H8.9l-.936 3.848H7.94l-1.016-3.848H5.492L4.5 14.016h-.024l-.928-3.848H2.116l1.6 5.664zm8.608.152c.968 0 1.712-.376 2.184-.928l-.896-.92c-.256.376-.704.608-1.232.608-.952 0-1.632-.736-1.632-1.744 0-1 .672-1.752 1.648-1.752.488 0 .928.216 1.168.544l.896-.944c-.464-.528-1.296-.832-2.12-.832-1.72 0-3.048 1.192-3.048 2.984 0 1.76 1.304 2.984 3.032 2.984",
    clipRule: "evenodd",
    transform: "translate(-1173 -237) translate(1172 232)"
  }));
}
var ForwardRef$5D = /*#__PURE__*/forwardRef(ToiletIcon);

function TrainCarIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12.5A1.25 1.25 0 1 1 4 15a1.25 1.25 0 0 1 0-2.5m8 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M14 1c.552 0 1 .407 1 .91v8.18c0 .504-.448.91-1 .91H2c-.552 0-1-.406-1-.91V1.91C1 1.406 1.448 1 2 1zm-.2 6.2H2.2v2.6h11.6zm-6.4-5H2.2V6h5.2zm6.4 0H8.6V6h5.2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5C = /*#__PURE__*/forwardRef(TrainCarIcon);

function VendingMachineIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 8c0 3.859 3.14 7.001 7.001 7.001 3.86 0 7-3.142 7-7.001s-3.14-7-7-7C4.14 1 1 4.141 1 8m1 0c0-3.309 2.692-6 6.001-6A6.006 6.006 0 0 1 14 8a6.007 6.007 0 0 1-5.999 6.001A6.01 6.01 0 0 1 2 8m5.036-2.818a.25.25 0 0 1 .057.494l-.057.006H6.99l.302.685c.153.326.261.558.289.872l.007.165v3.758a.903.903 0 0 1-.755.914l-.12.012-1.417.001a.92.92 0 0 1-.89-.818l-.006-.115V7.404c0-.349.088-.584.225-.886l.073-.157.136-.298.113-.26.05-.12h-.045a.25.25 0 0 1-.057-.494l.057-.007zm-.92.5h-.25l-.042.1c-.065.153-.156.371-.257.605l-.145.313c-.172.37-.22.485-.22.704v3.758c-.002.071.046.124.11.127h1.37c.055-.002.107-.063.106-.113V7.404c0-.218-.049-.333-.22-.699zM12.24 6c.213 0 .408.13.478.31a.51.51 0 0 1-.108.583l-3.188 3.184c-.101.127-.26.197-.348.185L9 10.266A.525.525 0 0 1 8.5 9.74V6.518A.53.53 0 0 1 9.025 6zm-2.942.799v2.274L11.572 6.8zM6.584 3.8l.052.014a.17.17 0 0 1 .094.114l.003.052v.709H5.254v-.721l.01-.05a.18.18 0 0 1 .1-.106l.051-.012z",
    clipRule: "evenodd",
    transform: "translate(-1389 -504) translate(1388 503)"
  }));
}
var ForwardRef$5B = /*#__PURE__*/forwardRef(VendingMachineIcon);

function WaitingRoomIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.26 7.155a.41.41 0 0 1 .41.41l-.001 1.617h.676V7.566a.41.41 0 0 1 .328-.402l.083-.009h3.38a.41.41 0 0 1 .41.41l-.001 1.617h1.265a.41.41 0 0 1 .404.337l.007.074V15H13.4l-.001-1.1H8.524V15h-1v-1.1H2.6V15h-.82V9.593l.007-.074a.41.41 0 0 1 .403-.336l1.279-.001V7.566a.41.41 0 0 1 .328-.402l.083-.009zm6.14 2.848h-.855v1.956a.41.41 0 0 1-.327.402l-.083.008h-3.38a.41.41 0 0 1-.41-.41v-1.777h-.676v1.777a.41.41 0 0 1-.327.402l-.083.008H3.88a.41.41 0 0 1-.41-.41l-.001-1.956h-.868L2.6 12.9h10.799zM6.847 11H4.289v.548h2.56zm4.876 0H9.166v.548h2.558zm0-3.024H9.166v2.22h2.558zm-4.875 0h-2.56v2.22h2.559zM11.218 1a2.462 2.462 0 1 1 0 4.924 2.462 2.462 0 0 1 0-4.924m.002.71a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m.196.59v.923h.923v.616h-1.231a.31.31 0 0 1-.302-.246l-.006-.062V2.3z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5A = /*#__PURE__*/forwardRef(WaitingRoomIcon);

function WaterTapIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.739 1h5.512v1.315H6.74z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.844 4.246h-2.45c-1.83 0-3.242 1.578-3.242 3.434H4.46c0-1.21.905-2.119 1.934-2.119H14.4V4.246h-4.248V2.128H8.844zM4.291 9.459l-.485.442-.484-.442a.65.65 0 0 1 .969 0m-.485 1.479a10 10 0 0 0-.239.33 6 6 0 0 0-.48.81c-.13.278-.179.479-.179.599 0 .674.466 1.008.898 1.008s.899-.334.899-1.008c0-.12-.05-.321-.18-.598a6 6 0 0 0-.48-.81 10 10 0 0 0-.239-.331m0-1.037-.484-.442-.002.002-.005.005-.015.017a7 7 0 0 0-.241.285c-.153.187-.359.45-.566.75a7 7 0 0 0-.588.999c-.16.342-.305.752-.305 1.16C1.6 14.112 2.687 15 3.806 15c1.12 0 2.207-.888 2.207-2.323 0-.408-.145-.818-.305-1.16a7 7 0 0 0-.588-1 12 12 0 0 0-.807-1.034l-.016-.017-.004-.005-.001-.001-.001-.001z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5z = /*#__PURE__*/forwardRef(WaterTapIcon);

function WheelchairIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.719 7.942v1.273a2.257 2.257 0 1 0 2.176 2.855l.035-.147 1.247.253a3.53 3.53 0 1 1-3.64-4.23zM7.454 1a2.372 2.372 0 0 1 .636 4.658v1.127h2.257v1.273L8.09 8.057v1.62h3.414c.211 0 .406.105.524.275l.045.077 1.736 3.472-1.139.569-1.56-3.12H7.454a.636.636 0 0 1-.63-.55l-.006-.086V5.658A2.373 2.373 0 0 1 7.455 1m0 1.273a1.1 1.1 0 1 0 0 2.198 1.1 1.1 0 0 0 0-2.198",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5y = /*#__PURE__*/forwardRef(WheelchairIcon);

function WifiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 10.474a1.237 1.237 0 1 1 0 2.474 1.237 1.237 0 0 1 0-2.474m0-3.712c1.384 0 2.703.514 3.755 1.416l.194.174.452.422-.844.904-.453-.422C10.247 8.456 9.15 8 8 8c-1.072 0-2.1.397-2.93 1.1l-.174.156-.453.422-.844-.904.452-.422C5.132 7.342 6.53 6.762 8 6.762M8 3.05c2.398 0 4.654.919 6.353 2.515l.21.203.437.437-.875.875-.437-.437A8.03 8.03 0 0 0 8 4.287c-2.072 0-4.019.79-5.49 2.165l-.198.19-.437.438L1 6.205l.437-.437A9.26 9.26 0 0 1 8 3.05",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5x = /*#__PURE__*/forwardRef(WifiIcon);

function DenmarkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__DenmarkIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 10 14 10 14 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.652 0 3.652 4.022 0 4.022 0 5.978 3.652 5.978 3.652 10 4.667 10 5.478 10 5.478 5.978 14 5.978 14 4.022 5.478 4.022 5.478 0z"
  })));
}
var ForwardRef$5w = /*#__PURE__*/forwardRef(DenmarkIcon);

function NorwayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__NorwayIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M14 0 0 0 0 10 14 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M14 0 0 0 0 10 14 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.594 10 6.594 6.304 14 6.304 14 3.696 6.594 3.696 6.594 0 4.16 0 4.16 3.696 0 3.696 0 4.348 0 5.652 0 6.304 4.16 6.304 4.16 10 4.768 10 5.986 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M0 4.348 0 5.652 4.768 5.652 4.768 10 5.986 10 5.986 5.652 14 5.652 14 4.348 5.986 4.348 5.986 0 4.768 0 4.768 4.348z"
  })));
}
var ForwardRef$5v = /*#__PURE__*/forwardRef(NorwayIcon);

function SamiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SamiIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035AD",
    d: "M14.7 3 7.4 3 7.4 13 14.7 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC241F",
    d: "M1.3 3H5.6V13H1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007229",
    d: "M5.6 3H6.5V13H5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE00",
    d: "M6.5 3H7.4V13H6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.2 8c0-1.5-1.2-2.7-2.7-2.7v5.3C8 10.7 9.2 9.5 9.2 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC241F",
    d: "M6.5 4.8v.5C8 5.3 9.2 6.5 9.2 8S8 10.7 6.5 10.7v.5c1.8 0 3.2-1.4 3.2-3.2S8.3 4.8 6.5 4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035AD",
    d: "M3.8 8c0-1.5 1.2-2.7 2.7-2.7v-.5C4.7 4.8 3.3 6.2 3.3 8s1.4 3.2 3.2 3.2v-.5C5 10.7 3.8 9.5 3.8 8"
  }));
}
var ForwardRef$5u = /*#__PURE__*/forwardRef(SamiIcon);

function SwedenIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SwedenIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 10 14 10 14 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M3.652 0 3.652 4.022 3.652 4.022 0 4.022 0 5.978 3.652 5.978 3.652 5.978 3.652 10 4.667 10 5.478 10 5.478 5.978 5.478 5.978 14 5.978 14 4.022 5.478 4.022 5.478 4.022 5.478 0z"
  })));
}
var ForwardRef$5t = /*#__PURE__*/forwardRef(SwedenIcon);

function UKIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 10",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__UKIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(-1 -4) translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H14V10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4.81 6.286 0 9.999.582 9.999 5.4 6.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 6.286 0 9.322 3.935 6.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M1.734 10 5.724 10 5.724 6.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M8.274 10 12.264 10 8.274 6.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M8.599 6.286 13.417 9.999 14 9.999 9.189 6.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M10.063 6.286 14 9.322 14 6.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M10.063 3.713 10.063 3.715 14 3.715 14 .677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.417 0 8.599 3.713 9.189 3.713 14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M8.274 0 8.274 3.075 12.264 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 3.715 3.935 3.715 3.935 3.713 0 .677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 0 4.81 3.713 5.399 3.713.581 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M1.734 0 5.724 3.075 5.724 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14 4.348 7.652 4.348 7.652 4.276 7.652 3.406 7.652 0 6.348 0 6.348 3.406 6.348 4.276 6.348 4.348 5.985 4.348 4.768 4.348 0 4.348 0 5.653 4.768 5.653 5.985 5.653 6.348 5.653 6.348 10 7.652 10 7.652 5.653 14 5.653z"
  })));
}
var ForwardRef$5s = /*#__PURE__*/forwardRef(UKIcon);

function LogoNegativeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__LogoNegativeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5959",
    d: "M0 14.799 15.783 14.799 15.783 13.377 0 13.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 2h6.45v1.567H1.674v2.312h4.236v1.566H1.675v2.237H6.45v1.566H0zm14.107 0h1.676v9.248h-.18L9.848 5.752v5.496H8.173V2h.179l5.755 5.597z"
  }));
}
var ForwardRef$5r = /*#__PURE__*/forwardRef(LogoNegativeIcon);

function LogoPositiveIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__LogoPositiveIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5959",
    d: "M0 14.799 15.783 14.799 15.783 13.377 0 13.377z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 2h6.45v1.567H1.674v2.312h4.236v1.566H1.675v2.237H6.45v1.566H0zm14.107 0h1.676v9.248h-.18L9.848 5.752v5.496H8.173V2h.179l5.755 5.597z"
  }));
}
var ForwardRef$5q = /*#__PURE__*/forwardRef(LogoPositiveIcon);

function AKTIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__AKTIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m3.2 7H9.9L8.6 4.1l.6-1.5zm-7.5 5.5H2.4l5-11.3h1.3l-3.1 7zm8.7 0L11 9.4H6.3l.5-1.2h4.9l.5 1.2 1.4 3.1z"
  }));
}
var ForwardRef$5p = /*#__PURE__*/forwardRef(AKTIcon);

function AlesundTurvognIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 566.929 566.929",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__AlesundTurvognIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M240.215 545.06c-6.429-1.282-7.762-5.958-9.382-11.139-3.794-12.14-6.775-24.57-12.053-37.264-3.14 4.597-1.724 9.293-2.643 13.406-1.59 7.126-2.09 14.523-2.655 21.837-.294 3.823-1.42 6.08-5.598 5.24-3.75-.756-5.006-2.25-4.186-6.85 1.373-7.715 1.967-15.627 2.53-23.556-1.566 6.654-3.114 13.312-4.704 19.96-.803 3.358-2.559 4.664-6.42 4.946-11.942.875-28.439-9.181-30.337-23.573-.319-2.418-1.207-4.76-1.99-7.742-3.594 3.054-6.259 6.445-10.412 7.724-10.368 3.194-17.818.537-25.219-9.062-11.001-14.27-5.063-45.077 10.164-54.833 11.013-7.056 23.796-1.695 30.037 8.175 3.388 5.358 4.277 11.492 4.53 18.617 9.545-10.43 20.518-9.8 31.39-5.203 5.21 2.204 9.947 5.3 15.775 6.013 2.529.31 3.336 2.725 4.222 5.02 5.08 13.158 7.424 27.225 13.78 41.172 1.258-9.47 2.754-17.902 3.34-26.397.268-3.875 1.662-7.51 1.517-11.438-.13-3.562 2.846-3.341 5.037-2.853 2.226.497 5.19.642 4.613 4.55-2.561 17.359-4.915 34.748-7.499 52.103-.507 3.412.417 7.057-1.731 10.692-.68.455-1.199.455-2.106.455m-79.166-82.614c-.842-1.744-1.479-3.628-2.56-5.208-4.99-7.287-12.076-7.662-17.847-1.141-7.732 8.735-10.038 19.13-8.675 30.31 1.188 9.746 11.593 14.869 18.794 9.72 6.952-4.97 13.157-24.126 10.288-33.681m13.686 43.25c3.118 9.724 8.269 14.255 16.927 14.888.253-.285.656-.534.737-.862 1.008-4.128 2.669-8.26 2.718-12.407.038-3.223-4.325-3.216-6.535-4.92-2.941-2.266-.33-4.672-.02-6.857.296-2.076 2.292-1.835 4.25-1.439 4.856.983 9.086 4.196 14.506 4.245 1.319-6.03 3.55-11.624 2.6-18.214-2.555 3.208-3.488.411-4.825-.91-7.202-7.117-19.26-8.236-23.921-1.805-5.883 8.116-8.716 17.225-6.437 28.282ZM312.612 545.06c-3.652-5.12-1.993-11.015-2.878-16.502-1.686-10.46-1.837-21.164-2.683-31.762-.368-4.601-1.59-9.098-1.231-13.807.219-2.867.673-4.658 4.088-5.023 5.56-.595 11.034-2.106 16.597-2.517 8.046-.595 15.215-4.249 22.934-5.837 15.35-3.157 21.482 5.851 21.062 18.963-.132 4.096-1.034 8.524-4.582 11.832 8.574 7.51 9.041 19.076 15.225 27.617-7.378 5.036-9.654 4.507-12.977-2.645-1.952-4.201-3.732-8.483-5.723-12.665-1.754-3.685-4.449-4.74-8.563-3.507-4.497 1.346-3.126 4.71-2.512 7.082 1.446 5.59 1.112 11.574 3.912 16.874.999 1.89.82 3.849-2.063 4.237-2.28.306-4.394 1.627-7.282.998-2.827-14.713-6-29.594-8.447-44.594-1.423-8.725-1.283-9.093-10.258-7.789-3.616.525-7.244.967-10.851 1.444-.265.789-.68 1.366-.58 1.833.924 4.336-1.758 9.787 1.615 12.917 3.479 3.227 8.337-.021 12.553-.642 4.084-.602 6.2.99 6.86 4.978.642 3.877-1.24 4.762-4.783 5.357-14.75 2.476-14.622 2.612-12.56 17.758.472 3.465 2.518 3.533 4.912 3.255 3.83-.444 7.68-.92 11.432-1.777 3.204-.733 5.012.495 5.585 3.376.568 2.86.956 5.975-3.258 6.71a953 953 0 0 0-19.803 3.645c-2.016.191-3.636.191-5.741.191m37.842-65.965c-4.189.759-6.067 2.579-4.373 7.236 1.09 2.994.94 6.419 1.587 9.601.42 2.06.901 4.094 4.108 3.495 5.517-1.03 9.166-5.303 8.908-11.071-.276-6.15-2.955-8.819-10.23-9.26M273.024 545.06c-3.26-3.704-2.081-7.303-.323-11.092 2.618.941 5.078 1.942 7.608 2.712 5.754 1.75 9.411.178 12.19-4.694 2.875-5.044.265-8.642-3.179-11.645-2.588-2.257-5.774-3.885-8.833-5.536-8.768-4.731-12.27-15.741-8.054-25.72 3.795-8.983 13.493-12.88 23.286-9.357 4.536 1.632 5.05 4.462 1.867 11.311-2.327-.686-4.726-1.315-7.072-2.103-4.224-1.42-7.433.45-9.485 3.696-2.126 3.362-1.734 6.98 1.224 10.108 2.87 3.035 6.37 5.072 10.147 6.608 6.549 2.664 9.237 7.633 9.692 14.452.51 7.645-.521 14.685-6.135 20.89-7.567.37-14.977.37-22.933.37M366.712 224.262c1.142 1.263 2.95 1.968 3.38 4.324-4.506 1.326-8.794-.535-13.293-.4 5.76 2.025 11.407 4.491 17.301 5.982 12.613 3.191 23.296 10.442 34.833 15.88 3.376 1.591 5.614 4.071 1.191 7.767 10.921 5.226 21.617 9.096 32.398 12.767 3.477 1.185 6.963 2.376 10.343 3.805 3.67 1.55 4.338 3.666.46 6.195 4.307 4.452 11.339 4.485 16.354 9.762-5.045.989-8.388-1.185-11.871-2.094-29.387-7.664-58.01-17.985-87.509-25.254-6.932-1.708-13.983-2.959-21.015-4.22-2.85-.51-5.867-.739-8.235 1.609-10.52 10.428-24.159 13.413-38.003 15.48-13.213 1.973-26.517 3.471-39.943 2.551-.942-.064-1.88-.168-3.077-.276 3.18-2.815 7.444-3.378 16.115-4.142 13.847-1.218 27.852-2.175 40.715-8.245 6.699-3.161 12.165-7.725 13.71-15.492 1.045-5.255-3.456-11.037-8.795-11.382-18.457-1.195-36.529.559-53.138 9.286-10.566 5.551-19.077 13.813-26.133 23.489-.673.923-1.367 1.837-2.135 2.68-.195.214-.71.139-1.227.22-1.035-2.722 1.516-5.062.688-8.772-4.049 3.922-7.892 7.258-11.251 11.027-2.49 2.793-5.394 4.812-8.922 4.92-19.358.594-38.513 4.497-57.94 3.64-6.765-.3-13.51-1.376-19.84-3.903-10.729-4.281-16.33-14.535-15.19-28.032 9.743-1.257 19.639-2.574 29.547-3.788 3.495-.428 5.92 1.12 7.421 4.364.876 1.894 1.826 3.924 4.747 4.379 1.671-5.804 6.05-7.875 12.35-7.623-2.957-4.83-1.923-9.744-1.731-14.693-1.141-1.113-2.334-.755-3.534.027.2 2.304.502 4.568.573 6.84.138 4.378-1.617 7.938-6.1 8.638-5.603.874-3.195-4.453-4.782-7.561-9.094 2.178-18.474 2.781-27.84 3.609-5.18.457-10.435.357-15.561 1.71-4.703 1.241-5.126 4.046-2.598 7.242 3.056 3.864 4.995 8.264 7.07 12.584 1.715 3.573 1.898 7.787-.351 11.043-1.866 2.7-4.686 5.474-9.28 3.164 1.062-7.55-.035-14.675-5.147-21.026-3.94-4.894-9.152-6.954-14.836-8.393-2.387-.604-4.056.037-4.521 2.956-1.394 8.757-3.145 17.459-4.438 26.229-.586 3.974 1.443 6.287 5.725 6.12 9.869-.386 19.737-1.06 29.607-1.088 43.129-.118 86.264-.478 129.384.16 18.102.267 36.16 2.948 54.257 4.249 18.71 1.344 37.228 4.057 55.729 7.007 3.11.495 5.807 1.7 8.927 3.357-4.14 2.538-8.096 2.113-12.276 2.747q8.12 1.657 16.24 3.312c1.89.385 3.786.739 5.67 1.146 6.038 1.306 8.92 8.527 5.563 14.374-3.54-1.847-3.062-8.077-9.177-7.765-3.575 11.936-6.222 24.284-5.178 37.143.422 5.209 5.551 4.137 8.691 5.039 3.12.896 4.211-1.928 4.34-4.753.095-2.125.641-4.018 3.202-3.978 2.901.045 3.158 2.35 3.397 4.537.021.193.074.412.01.58-3.232 8.322 2.495 8.993 8.222 9.572 5.001.506 10.011.919 15.021 1.328 3.266.266 5.227-.919 5.145-4.571-.03-1.325.385-2.67.663-3.99 1.665-7.916 5.473-10.626 13.213-8.132 5.468 1.762 7.319-.784 9.074-4.989 3.289-7.882 3.243-16.714 7.223-24.408 2.39-4.622 12.648-9.374 17.337-7.444 4.543 1.87 3.657 6.562 4.3 10.111 1.137 6.277-2.136 11.166-7.375 12.239-2.8-2.337.2-6.502-3.076-9.334-5.513 12.282-6.868 24.556-4.688 37.504 1.364-.216 1.971-.153 2.076-.353 1.75-3.341 3.923-7.395 8.097-5.315 3.57 1.778 1.724 6.178 1.116 9.474-2.17 11.767-13.183 16.295-26.379 17.588-4.921.482-9.633-.855-14.42-1.459-3.799-.48-5.427-3.362-6.113-6.869-.98-5.013-3.963-7.092-9.114-6.895-4.623.178-9.297.378-13.885-.962-1.615-.472-3.495-.3-5.216-.1-4.368.508-5.596 4.053-6.024 7.493-.409 3.287 2.693 3.005 4.898 3.367.972.16 1.889.486 2.327 2.322-13.17 1.924-24.743 10.2-38.764 8.947-5.154-.46-9.793-.833-12.223-6.69-2.56-6.168-8.988-5.786-14.113-6.018-24.764-1.12-49.546-1.96-74.323-2.773-43.309-1.421-86.6-.344-129.893-.88-5.392-.066-8.825-4.018-9.103-10.872-.173-4.267-.056-8.55.036-12.822.084-3.883-1.549-5.577-5.588-5.553-6.765.04-13.56.62-20.273-1.107-5.503-1.416-8.831-4.3-10.927-9.933-5.255-14.124-4.85-28.403-2.873-42.892.027-.193-.029-.438.07-.573 6.878-9.376 6.13-20.723 8.434-31.34 3.275-15.083 13.136-25.888 25.2-35.052 11.908-9.046 25.404-15.565 37.484-24.36 6.858-4.994 13.26-10.43 17.836-17.33 10.856-16.373 25.172-29.828 37.038-45.325 4.802-6.27 12.535-7.637 19.5-9.406 21.38-5.43 43.105-8.64 65.211-9.883 15.913-.895 31.715-1.975 47.41 1.345 10.484 2.218 20.356 6.344 29.337 12.135 19.838 12.793 38.818 26.843 58.175 40.34 17.484 12.194 33.174 25.95 44.842 43.938 1.945 2.999 4.087 5.985 4.158 10.46-5.636-2.659-8.563-7.456-12.103-11.3-13.938-15.133-29.532-28.325-45.525-41.182-13.906-11.18-28.314-21.64-43.833-30.309-19.202-10.725-40.102-15.906-62.216-16.27-21.371-.351-42.62.827-63.591 4.913-8.624 1.68-17.077 4.498-24.85 9.299 31.256-4.91 62.49-7.961 94.005-4.097-.215 7.268-11.795 1.585-10.106 10.026-3.472 2.094-8.68-.92-10.786 3.819-.032 2.477 3.187 1.835 3.158 4.73-12.21 7.4-27.372 9.01-40.81 17.364 7.067 3.16 13.897 5.776 15.474 14.437-4.926.46-10.018 1.406-15.094 1.33-32.074-.477-63.338 4.21-93.259 15.76-12.196 4.707-23.528 11.612-32.76 22.288 3.232 1.637 5.966.98 8.428.598 18.323-2.85 36.587-6.085 54.924-8.834 25.566-3.833 51.365-4.955 77.11-3.55 24.06 1.314 48.08 4.037 71.583 9.752 3.476.845 5.374-1.79 8.177-1.74 5.045.091 10.086.313 15.902.608 1.191.341 1.61.553 2.028.765M273.55 346.763c-16.58-1.966-33.258-.57-49.91-1.523-22.643-1.295-45.42-.282-68.138-.258-.777 0-1.567-.075-2.327.041-.741.114-1.933-.421-2.073 2.099h35.67c1.14 3.172-1.966 3.504-1.656 5.826 2.61.155 5.279.477 7.944.449 51.803-.544 103.623 1.249 155.418-1.083 3.995-.18 5.982-1.59 7.102-5.267 3.415-11.218 5.477-22.856 11.126-34.226-13.34-.841-25.934-2.52-38.656-1.498-2.446.197-4.498 1.758-4.85 4.361-.424 3.147-2.382 3.42-4.926 3.594-6.109.42-12.201 1.078-17.551 1.571 1.761 10.96-9.228 7.513-12.368 12.226 10.847.78 21.066 5.15 32.144 5.9-.61 3.599-3.586 5.12-2.9 8.058-14.651 0-28.815 0-44.05-.27M119.34 328.606c5.377.52 10.822 1.179 16.143 1.273 24.427.43 48.866.195 73.3.179 1.532-.001 3.606.305 4.24-1.248 2.118-5.195 5.244-10.057 6.42-15.55-2.938-1.447-5.302-.946-7.588-.998-23.622-.536-47.1 3.307-70.741 2.333a119 119 0 0 0-10.47.026c-6.44.303-12.156 6.822-11.304 13.984m151.894-92.44c-19.313-1.2-38.651-2.155-57.875.782-8.155 1.246-16.236 2.89-25.898 2.956 4.612 5.641.494 11.215.49 17.082 2.85-1.058 3.897-2.519 4.3-4.238 1.186-5.055 4.706-6.007 9.355-6.82 15.186-2.658 30.451-2.052 45.715-2.094 1.123-.004 2.373-.158 3.23 1.353.895 3.354-3.174 5.906-2.044 11.098 7.13-8.292 16.4-12.398 22.727-20.12m111.049 136.697c.533-6.095-.877-6.99-7.086-4.499 1.393 5.647 2.964 6.854 7.086 4.499m-14.51-123.6c2.76-1.83 2.203-3.172-.806-2.954-2.44.177-4.833-.142-8.223-.483 3.035 2.43 5.758 2.754 9.03 3.436M59.754 408.249c1.184-2.204 2.2-4.033 3.735-6.8-4.31 1.805-6.31 4.65-8.475 7.232-6.793 8.1-21.259 9.773-28.553-2.301-7.364-12.19-5.877-26.177 3.762-36.916 4.79-5.337 9.367-10.874 13.888-16.443 2.646-3.258.002-11.498-3.921-12.77-2.113-.684-3.275.933-4.47 2.065-8.722 8.262-17.368 16.602-26.048 24.906-1.863 1.783-3.496 4.816-6.632 2.102-3.358-2.906-4.174-8.537-1.23-10.813 4.953-3.826 8.736-9 13.74-12.5 6.15-4.3 10.126-10.527 15.643-15.361 4.62-4.05-.288-8.081-2.542-11.597-2.28-3.556-4.387-6.748.564-9.735 2.585-1.56 4.426-1.452 6.103 1.593 4.199 7.627 9.089 14.89 12.997 22.654 2.4 4.767 5.783 8.683 8.772 12.944 2.068 2.95 2.217 5.598-.197 8.416-6.676 7.79-13.344 15.59-19.894 23.487-3.41 4.111-5.659 8.737-5.527 14.32.112 4.72 2.034 8.4 6.283 10.283 4.705 2.087 8.305-.626 11.196-3.959 7.972-9.19 15.772-18.528 23.578-27.734 4.71 4.47 9.594 8.459 13.64 13.168 2.78 3.235 6.57 5.387 8.789 9.187 4.792 8.206 6.164 16.487 1.701 25.297-2.074 4.095-5.076 6.79-9.693 7.469-1.77.26-3.788.424-3.937 2.667-.701 10.5-7.138 19.159-9 29.316-6.243-3.202-7.927-7.194-6.268-13.094 1.472-5.23 4.37-9.919 5.362-15.347.374-2.047.514-3.75-.492-5.545-1.313-2.342-2.165-5.474-5.303-5.631-2.77-.139-3.306 2.873-4.514 4.775-1.872 2.949-3.583 6.01-5.616 8.842-1.348 1.877-1.802 6.21-5.61 3.534-3.194-2.243-6.17-5.303-3.388-9.776 3.684-5.923 7.581-11.714 11.556-17.935m29.656-4.656q-6.247-10.187-13.075-.798c-.798 1.099-1.484 2.278-2.276 3.382-1.216 1.695-.923 3.057.421 4.656 2.576 3.067 5.33 6.356 9.652 4.787 4.959-1.8 7.06-5.827 5.278-12.026ZM460.237 401.629c3.447-3.165 6.5-6.148 9.69-8.976 1.858-1.646 3.556-4.782 6.503-1.095 2.38 2.977 4.315 5.94.303 8.874-3.956 2.893-7.263 6.375-10.384 10.086-1.813 2.157.18 10.11 3.38 12.52 3.522 2.653 4.579-1.233 6.399-2.79 1.913-1.636 3.558-3.581 5.434-5.264 1.751-1.57 3.563-4.77 6.148-2.004 2.225 2.38 4.678 5.56.964 9.015-3.102 2.885-6.055 5.932-9.184 8.786-2.378 2.17-2.672 4.045-.846 7.01 6.49 10.54 6.329 10.6 15.317 2.323 2.53-2.33 4.933-4.911 8.418-6.012 2.569 1.627 3.065 4.417 6.266 8.688-7.289 6.39-14.632 12.72-21.843 19.195-3.659 3.285-5.57.778-7.288-2.003-4.07-6.587-7.984-13.27-11.979-19.902-3.28-5.45-6.587-10.883-9.743-16.094-18.284-.901-27.39 22.83-18.05 35.367 1.935 2.598 2.915 5.849 5.054 8.451 5.511 6.705 13.505 7.13 19.502.778 2.64-2.796 5.157-5.71 7.695-8.532 7.216 4.127 7.894 7.523 2.391 12.997-3.555 3.537-7.154 7.263-11.762 9.35-12 5.439-20.283 1.997-27.376-7.94-9.108-12.762-10.927-27.482-5.306-42.559 2.622-7.03 8.006-12.087 14.187-15.556 4.34-2.436 7.998-4.748 10.46-9.168 1.17-2.1 3.506-3.553 5.65-5.546ZM417.498 97.153c.538 4.491 1.075 8.473 1.683 12.984 8.013-11.855 12.912-24.762 19.688-36.653 1.043-1.83 1.6-4.726 4.12-4.134 3.1.727 6.504 1.439 8.872 3.924.845.887.324 2.147-.254 3.244-9.81 18.615-19.626 37.225-29.333 55.893-1.138 2.19-2.505 3.871-4.816 2.501-3.317-1.967-8.47-1.288-9.06-7.356-1.589-16.336-4.773-32.49-5.889-48.893-.047-.691-.61-1.348-1.544-3.3l-22.344 42.668c-.875.05-1.493.256-1.983.089-10.142-3.462-10.357-4.11-5.341-13.597a12166 12166 0 0 0 24.898-47.35c1.39-2.658 2.696-5.8 6.369-4.203 3.528 1.534 8.508.818 9.241 7.058 1.443 12.259 3.745 24.416 5.693 37.125ZM44.506 87.96c-1.868-8.163-.67-11.481 4.992-14.846 4.851-2.883 11.057-2.282 15.152 1.346 2.01 1.78 3.444 3.805 2.957 6.563-.853 4.827 1.75 7.348 5.473 9.755 19.17 12.396 38.222 24.975 57.301 37.51.767.504 1.395 1.218 2.072 1.82-5.702 7.405-9.719 8.14-16.87 3.286-13.495-9.163-13.425-9.047-27.98-.225-3.8 2.303-4.95 4.712-3.308 8.854 1.35 3.402 2.23 6.997 3.228 10.532 1.474 5.217-.37 8.098-6.416 9.828-4.956 1.418-4.812-3.106-5.609-5.57a3364 3364 0 0 1-18.71-59.694c-.876-2.893-1.875-4.174-4.99-4.268-3-.09-5.484-1.75-7.292-4.89m31.636 19.046-3.991-1.823 6.346 20.444c5.527-1.618 9.193-4.521 13.427-8.15-5.336-3.584-10.217-6.862-15.782-10.471M56.872 85.06c2.354-1.596 2.36-3.315.127-4.965-1.526-1.128-3.155-.706-3.851.874-1.204 2.732.723 3.7 3.723 4.09M516.586 133.016c-2.622 18.072-27.664 36.818-49.94 29.817-11.87-3.73-21.804-10.649-31.475-18.107-2.27-1.75-1.766-3.426-.048-5.355 8.457-9.492 16.821-19.067 25.245-28.588 5.362-6.06 10.881-11.986 16.103-18.164 2.109-2.495 4.106-3.127 7.045-1.72 11.804 5.65 22.548 12.614 30.2 23.577 3.88 5.557 2.684 11.89 2.87 18.54m-62.88 11.195c5.308 5.233 11.722 7.948 19.114 8.636 12.67 1.178 20.615-6.416 27.687-15.167 5.464-6.76 4.951-16.784-1.168-22.873a73.7 73.7 0 0 0-9.715-8.15c-4.253-2.974-6.937-1.942-9.813 1.647-2.412 3.01-5.206 5.71-7.737 8.628-6.32 7.288-12.581 14.629-18.881 21.935-1.39 1.613-2.424 3.177.514 5.344M363.016 84.863c-4.921 25.766-31.007 27.156-46.466 18.61-8.633-4.773-12.035-13.868-10.455-23.586 2.232-13.725 5.698-27.245 8.195-40.933 1.31-7.177 5.902-4.262 9.656-3.753 4.598.624 3.793 3.946 3.172 7.146-2.613 13.463-6.818 26.658-7.51 40.443-.418 8.356 3.125 12.746 10.872 14.937 5.672 1.605 12.71-1.623 16.49-7.255 2.578-3.84 3.346-8.23 4.355-12.544 2.466-10.537 4.8-21.105 7.163-31.666 1.632-7.302 6.7-2.906 10.311-2.899 3.954.008 3.294 2.928 2.698 5.484a6580 6580 0 0 1-8.48 36.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M421.324 488.2a24792 24792 0 0 0-13.56-35.435l-.797.196c0 19.788-.05 39.577.048 59.365.017 3.437-.552 6.102-4.248 7.27-2.83.893-4.373.906-6.362-2.37-9.528-15.698-19.656-31.03-29.557-46.502-.916-1.43-1.73-2.927-2.573-4.362 9.122-6.106 9.456-6.124 14.847 2.593 5.987 9.68 11.33 19.76 18.611 29.852.075-9.44.677-17.963-.388-26.613-.802-6.508-.33-13.173-.396-19.769-.005-.566.022-1.426.365-1.657 4.874-3.278 9.709-6.635 14.78-9.584 1.527-.888 2.57.673 3.211 2.373 6.69 17.76 13.574 35.45 20.19 53.237 2.235 6.008-3.994 5.127-6.343 8.308-3.485-5.811-5.918-10.98-7.828-16.902ZM175.24 66c-1.614-7.624-4.562-14.414-5.517-22.302 7.913-2.689 16.425-3.062 24.555-5.091 2.808-.701 5.633-1.338 8.442-2.035 9.68-2.403 10.088-2.106 11.17 8.814-5.553 1.088-11.175 2.198-16.803 3.285-.566.109-1.187-.023-1.737.127-3.483.945-8.106 1.33-9.24 4.844-1.36 4.22 1.545 8.471 3.167 12.516.664 1.656 2.453 1.372 4.1 1.028 5.1-1.066 10.235-1.974 15.36-2.929 8.642-1.61 9.024-1.298 9.954 8.263-5.915 2.252-12.21 3.072-18.432 4.2-7.743 1.405-8.304 2.248-6.757 9.848.231 1.134.333 2.299.63 3.414 2.177 8.211 2.148 8.033 10.189 6.208 6.578-1.493 13.253-2.576 19.91-3.69 2.87-.482 4.38.944 4.359 3.93-.018 2.602 2.162 6.073-2.447 6.895-12.357 2.203-24.755 4.18-37.094 6.471-3.576.665-3.858-1.65-4.39-3.878A8270 8270 0 0 1 175.238 66ZM251.567 68.288c-6.8-3.317-12.612-6.609-13.406-15.032-1.31-13.888 8.21-19.671 18.783-21.4 6.071-.991 12.373-.743 18.468.995 3.246.925 5.225 2.44 4.084 6.21-.996 3.285-2.17 5.797-6.492 4.074-4.015-1.601-8.347-1.657-12.626-1.388-4.717.296-8.413 2.532-9.388 7.222-1.016 4.883 2.69 7.412 6.485 9.19 5.757 2.698 11.775 4.846 17.48 7.641 7.755 3.8 10.633 10.439 9.518 18.786-1 7.478-6.233 12.284-12.398 15.017-10.135 4.494-20.818 3.25-31.314.318-4.757-1.329-3.027-4.535-2.331-7.415.8-3.307 2.61-4.284 6.021-2.949 7 2.74 14.148 3.994 21.49.932 6.691-2.79 7.88-9.161 2.797-14.373-4.652-4.768-11.334-4.77-17.17-7.828ZM515.268 407.088c-5.82-13.962-11.027-27.716-17.312-40.96-2.171-4.576-1.169-7.071 1.607-10.074 1.042-1.128 2.076-2.264 3.126-3.41 8.949 2.914 15.906 9.044 24.071 12.973 7.629 3.67 14.769 8.365 22.081 12.68 2.096 1.237 4.852 2.224 2.592 5.687-1.952 2.993-3.047 7.283-8.033 4.838-2.766-1.356-5.429-3.02-7.891-4.872-2.417-1.819-4.149-1.803-5.595.968-.09.172-.158.373-.293.5-7.158 6.698-8.91 13.906-2.823 22.44 4.216 5.911 1.385 10.673-3.974 15.253-3.545-4.864-5.045-10.454-7.556-16.023m4.08-32.603c-2.283-1.654-4.588-3.256-7.988-3.559 1.213 5.341 2.725 9.948 6.228 14.565 1.217-3.874 8.392-5.45 1.76-11.006M123.562 438.094c1.564-1.48 2.849-2.661 4.096-3.88 6.754-6.603 7.925-6.438 13.29 2.059-7.542 9.006-16.59 16.617-24.682 25.157-4.796 5.063-9.72 10.008-14.7 14.891-1.428 1.401-3.147 3.703-5.4 1.745-2.312-2.012-6.531-3.025-5.714-7.239 4.17-21.52 7.775-43.162 13.436-64.37 6.44 1.44 8.53 4.598 7.297 10.415a2698 2698 0 0 0-7.093 34.568c-.318 1.6-.044 3.32-.044 6.26 7.027-7.067 13.122-13.196 19.514-19.606M119.298 62.494c8.35 17.24 16.436 34.113 24.55 51.047 7.965-.955 14.385-5.315 21.568-7.503 8.9-2.711 9.301-2.765 11.478 7.272-10.5 3.948-21.047 8.09-31.72 11.874-8.575 3.04-8.824 2.938-12.682-4.963-8.236-16.865-16.281-33.823-24.349-50.77-.65-1.366-.871-2.938-1.4-4.79 4.264-.778 7.309-5.71 12.555-2.167M548.017 372.151c-1.163-2.38-.914-4.005 1.077-5.368 4.158-2.845 6.188-7.243 8.5-11.526 2.22-4.117 1.48-7.212-1.67-10.382-3.342-3.366-6.346-1.665-9.386.202-1.31.805-2.453 1.897-3.617 2.92-5.162 4.532-10.814 7.147-17.435 3.382-6.134-3.487-9.48-12.426-8.167-19.742 1.315-7.327 4.976-13.288 9.744-18.806 1.841-2.131 3.643-3.45 5.508-.692 1.602 2.367 5.836 4.875 1.725 8.196-3.278 2.648-5.752 5.452-7.121 9.541-1.278 3.817-.982 6.867 2.247 9.298 3.39 2.553 6.215.898 8.748-1.577 3.543-3.462 7.366-6.17 12.615-6.379 7.894-.312 13.755 3.204 15.297 11.118 2.429 12.465.209 26.7-14.239 35.022-2.453-.66-2.674-3.042-3.826-5.207M367.107 224.217c-.813-.167-1.231-.379-1.85-.696-4.916-2.227-9.938-2.15-14.949-2.143-1.843.002-3.73-.375-4.295-2.252-.66-2.192 1.926-1.846 2.98-2.634-.702-1.364-2.584-.315-2.862-1.928 5.714-5.732 19.422-4.855 23 2.221-5.376.605-10.345-2.838-16.42-.401 4.977.691 9.052 1.04 13.028 1.87 4.135.862 4.593 2.774 1.368 5.963"
  }));
}
var ForwardRef$5o = /*#__PURE__*/forwardRef(AlesundTurvognIcon);

function AtBIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "#fff",
    viewBox: "0 0 40 40",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__AtBIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 2.419A2.42 2.42 0 0 0 37.581 0l-26.75.012C4.848.012 0 4.86 0 10.842l.011 26.74A2.42 2.42 0 0 0 2.43 40h35.151A2.42 2.42 0 0 0 40 37.582zm-7.287 4.43c2.61-1.23 4.435-2.786 5.227-5.03l-27.109.005a9.013 9.013 0 0 0-9.013 9.012l.002 4.265q.871-.69 1.747-1.247l.085-.056a14.8 14.8 0 0 1 2.817-1.492c3.1-1.253 6.678-1.634 10.464-2.037h.012a226 226 0 0 0 2.39-.264c3.607-.42 8.82-1.293 13.18-3.054zm-15.358 7.085q1.17-.123 2.407-.265c3.83-.448 9.392-1.383 14.132-3.298 1.601-.647 2.83-1.34 4.288-2.399V37.58c0 .331-.269.602-.6.602H2.43c-.332 0-.6-.27-.6-.602l-.008-17.5c.91-.94 2.23-2.167 3.73-3.12l.137-.09.023-.015c.643-.439 1.341-.808 2.135-1.129 2.623-1.06 5.952-1.414 9.476-1.789zm13.122 17.322q-.418.45-.96.45H28.43V28.07h1.087q.542 0 .96.46.418.459.418 1.336 0 .94-.418 1.39m-.188-6.268q-.313.45-.919.45h-.94v-3.051h.94q.605 0 .92.46.313.459.313 1.086 0 .606-.314 1.055m-20.265 3.98 1.065-6.33h.042l1.066 6.33zm8.931 5.16c.258.196.738.378 1.638.378l3.877-.001h5.945q1.211 0 2.068-.324.856-.324 1.39-.909.532-.584.783-1.4.25-.815.25-1.776 0-.585-.156-1.16a3.4 3.4 0 0 0-.49-1.055 2.9 2.9 0 0 0-.857-.804q-.524-.324-1.254-.386v-.042q.627-.126 1.066-.439.438-.314.72-.762.282-.45.418-1.003.136-.555.136-1.139 0-1.692-.992-2.705-.993-1.014-3.082-1.014H24.56l.005 12.41h-1.692q-.46 0-.68-.198-.219-.198-.219-.679v-5.39h1.484v-2.528h-1.483V19.88h-3.761v3.322H14.44l-.885-3.615h-4.89L5.094 34.505h4.074l.397-2.612h3.092l.397 2.612h4.137l-2.143-8.775h3.167v6.017q0 .94.177 1.514.178.576.564.868",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5n = /*#__PURE__*/forwardRef(AtBIcon);

function BaneNORIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 77 13",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__BaneNORIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M70.718 2.166h1.401a.9.9 0 0 1 .894.905.9.9 0 0 1-.894.906h-1.401zm5.205 7.13L73.72 5.37c1.077-.474 1.368-1.368 1.368-2.456 0-1.172-.676-2.424-2.773-2.424H68.6V9.3h2.117V5.654h1.166l1.74 3.643zm-23.907.005-4.901-5.594v5.594h-2.118V.488h1.708l4.355 4.973V.488h2.117v8.813m-26.812 0-4.901-5.594v5.594h-2.117V.488h1.707l4.355 4.973V.488h2.118v8.813M4.563 6.657a.996.996 0 0 1-.99 1.002H2.317V5.654h1.256c.546 0 .99.449.99 1.001zM2.317 2.13h.912c.512 0 .928.421.928.94s-.416.94-.928.94h-.912zm4.422 4.72c0-1.787-1.324-2.267-1.324-2.267s.775-.459.775-1.618C6.19 1.646 5.468.49 3.37.49H.2v8.813h4.015c1.335 0 2.524-.95 2.524-2.451M31.48 9.3V.488h5.227v1.74H33.6v1.65h2.53v1.74h-2.53v1.944h3.209v1.74M60.883 7.514c-1.444 0-2.615-1.184-2.615-2.646 0-1.46 1.17-2.645 2.614-2.645s2.615 1.184 2.615 2.645-1.17 2.646-2.614 2.646m0-7.315c-2.548 0-4.614 2.09-4.614 4.67 0 2.578 2.066 4.668 4.614 4.668s4.613-2.09 4.613-4.67C65.496 2.29 63.43.2 60.882.2M10.915 5.63V3.885c0-.982.786-1.778 1.756-1.778h.002c.97 0 1.756.796 1.756 1.777V5.63zM10.197 7.133l-4.034 5.668h2.621l3.074-5.668M15.148 7.133h-1.66l3.072 5.668h2.621",
    clipRule: "evenodd"
  }));
}
var ForwardRef$5m = /*#__PURE__*/forwardRef(BaneNORIcon);

function BrakarIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 49.8 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__BrakarIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 8c.8-.2 1.2-.9 1.2-1.7 0-1.2-.9-2.1-2.3-2.1h-3.1v8.3h2.9c1.8 0 2.7-1 2.7-2.4.1-1-.4-1.8-1.4-2.1m-3-2.8h1.7c.9 0 1.3.5 1.3 1.3 0 .7-.4 1.2-1.3 1.2h-1.8zm1.7 6.2h-1.6V8.6h1.8c1 0 1.5.6 1.5 1.4s-.6 1.4-1.7 1.4M27.1 7.7V6.5H26v5.9h1.1V9.3c0-1.1.5-1.8 1.2-1.8q.6 0 .9.3v-1c-.2-.2-.5-.3-.8-.3-.6-.1-1.1.4-1.3 1.2M31.9 6.3c-.8 0-1.5.3-2 .7v1.1c.5-.5 1.1-.8 1.8-.8 1 0 1.6.6 1.6 1.6v.5c-.3-.4-.8-.7-1.6-.7-1.3 0-2.1.8-2.1 1.9s.9 1.9 2.1 1.9c.8 0 1.4-.4 1.7-1v.8h1.1V8.8c-.1-1.5-1-2.5-2.6-2.5m.1 5.4c-.8 0-1.3-.4-1.3-1.1s.5-1.1 1.3-1.1 1.3.4 1.3 1.1c.1.6-.4 1.1-1.3 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4 6.5 38.9 6.5 36.6 9 36.6 4.1 35.5 4.1 35.5 12.4 36.6 12.4 36.6 9.5 39.1 12.4 40.6 12.4 37.6 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9 6.3c-.8 0-1.5.3-2 .7v1.1c.5-.5 1.1-.8 1.8-.8 1 0 1.6.6 1.6 1.6v.5c-.3-.4-.8-.7-1.6-.7-1.3 0-2.1.8-2.1 1.9s.9 1.9 2.1 1.9c.8 0 1.4-.4 1.7-1v.8h1.1V8.8c-.1-1.5-1.1-2.5-2.6-2.5m.1 5.4c-.8 0-1.3-.4-1.3-1.1s.5-1.1 1.3-1.1 1.3.4 1.3 1.1c0 .6-.5 1.1-1.3 1.1M49 6.4c-.6 0-1.1.4-1.4 1.3V6.5h-1.1v5.9h1.1V9.3c0-1.1.5-1.8 1.2-1.8q.6 0 .9.3v-1c-.2-.3-.4-.4-.7-.4"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.2 6.4C.1 6.9 0 7.5 0 8.1c1.1-.3 2.1-.5 3.2-.6-.9-.6-2-.9-3-1.1M.2 9.9c.6 2.4 2.2 4.4 4.5 5.4-.3-2.6-2.1-4.7-4.5-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C4.9 0 2.2 1.8.9 4.4c2.2-.4 4.5-.5 6.8-.2.2-.3.6-.4 1-.4.5 0 1 .3 1.2.9.7.2 1.4.3 2 .6l-.7.7c-.7-.3-1.4-.5-2.2-.7 0-.1.1-.2.1-.2 0-.2-.2-.4-.4-.4s-.4.2-.4.4v.1C5.6 4.7 3 4.8.4 5.4v.1c1.6.3 3.1 1 4.3 1.9 2.4 0 4.7.4 6.9 1.4l1-1c-.7-.4-1.5-.7-2.3-.9l.7-.7c1.1.4 2.1.9 3.1 1.4-.4.4-1.9 1.8-2.3 2.2-1.9-.8-3.9-1.4-6-1.5C7.9 10.3 9 13 9 15.9c3.9-.5 7-3.9 7-7.9 0-4.4-3.6-8-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4 8.3C3 8.4 1.6 8.6.2 9c1.5.4 2.8 1.2 3.8 2.4s1.5 2.7 1.6 4.2c.8.3 1.7.4 2.5.4 0-3-1.3-5.8-3.7-7.7"
  })));
}
var ForwardRef$5l = /*#__PURE__*/forwardRef(BrakarIcon);

function BrakarNoTextIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__BrakarNoTextIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.2 6.4C.1 6.9 0 7.4 0 8v.1c1.1-.3 2.1-.5 3.2-.6-.9-.6-2-.9-3-1.1M.2 9.9c.6 2.4 2.2 4.4 4.5 5.4-.3-2.6-2.1-4.7-4.5-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 0C4.9 0 2.2 1.8.9 4.4c1.3-.3 2.6-.4 4-.4.9 0 1.9.1 2.8.2.2-.3.6-.4 1-.4.5 0 1 .3 1.2.9.6.1 1.2.3 1.8.5 0 0 .1 0 .2.1l-.7.7c-.5-.2-1-.3-1.5-.4-.1 0-.2-.1-.4-.1 0-.1-.2-.1-.3-.2 0-.1.1-.2.1-.2 0-.2-.1-.4-.3-.4h-.2c-.2 0-.4.2-.4.4v.1c-.1 0-.3 0-.4-.1-.1 0-.3 0-.4-.1-.8 0-1.7-.1-2.5-.1-1.5 0-3 .2-4.4.5v.1c1.6.3 3.1 1 4.3 1.9h.1c2.3 0 4.6.5 6.8 1.4l1-1c-.7-.4-1.4-.6-2.2-.9h-.1l.6-.7c.9.3 1.7.7 2.5 1.1l.5.3-.6.6-1.7 1.7-.3-.1c-1.7-.9-3.6-1.4-5.6-1.5l.1.1c2 2 3.1 4.7 3.1 7.5 3.9-.5 7-3.9 7-7.9 0-4.4-3.6-8-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.1 16c0-3-1.4-5.8-3.7-7.7-1.4 0-2.8.3-4.2.7 1.5.4 2.8 1.3 3.8 2.5s1.5 2.7 1.6 4.2q1.2.3 2.4.3z"
  }));
}
var ForwardRef$5k = /*#__PURE__*/forwardRef(BrakarNoTextIcon);

function FarteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 90 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__FarteIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M55.202 3.039 53.413 4.23 53.413 6.766 52.179 6.766 52.179 8.37 53.413 8.37 53.413 15.753 55.202 15.753 55.202 8.37 56.868 8.37 56.868 6.766 55.202 6.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84.855 6.56c-2.57 0-4.69 2.119-4.69 4.69 0 2.57 2.12 4.709 4.69 4.709s4.668-2.139 4.668-4.71c0-2.57-2.097-4.689-4.668-4.689m0 7.754c-1.707 0-2.838-1.358-2.838-3.065 0-1.665 1.13-3.043 2.838-3.043 1.727 0 2.817 1.378 2.817 3.043 0 1.707-1.09 3.065-2.817 3.065M34.937 0c-1.707 0-2.509 1.09-2.509 3.208v3.558h-1.234V8.37h1.234v7.383h1.81V8.37h1.666V6.766h-1.666V3.044c0-.885.37-1.399 1.05-1.399.184 0 .39.02.595.082l.206.056V.155A4.6 4.6 0 0 0 34.937 0M75.47 6.56c-1.254 0-1.908.519-2.693 1.255l-.165.154V6.766h-1.81v8.987h1.81v-4.915c0-1.666 1.028-2.632 2.427-2.632 1.336 0 1.85.822 1.85 2.241v5.306h1.81v-5.717c0-1.954-.74-3.476-3.228-3.476M68.188 13.45c-.72 0-1.275.555-1.275 1.275 0 .74.596 1.275 1.275 1.275.72 0 1.275-.576 1.275-1.296 0-.678-.555-1.254-1.275-1.254M65.974 11.25c0-2.51-1.44-4.69-4.195-4.69-2.571 0-4.278 2.119-4.278 4.69 0 2.632 1.583 4.709 4.771 4.709 1.049 0 2.128-.302 2.653-.679l.165-.118v-1.834c-.878.712-2.038.986-2.818.986-1.645 0-2.694-.803-2.838-2.098l-.016-.185h6.556zm-6.649-.659c0-.08 0-.155.006-.205.165-1.214 1.09-2.201 2.448-2.201 1.48 0 2.213.967 2.365 2.2l.025.206zM40.403 6.56c-.898 0-1.9.26-2.518.66v1.684l.214-.164c.309-.246 1.05-.658 2.14-.658 1.48 0 2.138.638 2.138 1.79v.727a3 3 0 0 0-.165-.131c-.37-.288-1.192-.72-2.344-.72-1.85 0-3.455 1.131-3.455 3.126 0 2.057 1.666 3.085 3.455 3.085.967 0 1.83-.411 2.406-1.131l.165-.218v1.143h1.707V9.851c0-1.543-.576-3.29-3.743-3.29m-.185 7.918c-1.275 0-2.036-.679-2.036-1.666 0-.966.822-1.624 2.036-1.624 1.13 0 2.088.717 2.088 1.601 0 .864-.916 1.69-2.088 1.69m2.45-3.63-.001-.002q.017.002.002.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.618 6.765 18.629 15.754 15.009 15.754 23.999 6.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.382 6.765 11.393 15.754 7.774 15.754 16.762 6.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.145 6.765 4.157 15.754.537 15.754 9.526 6.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M51.267 6.764h-.346c-1.13 0-2.294.518-2.897 1.473V6.766h-1.81v8.987h1.81V11.99c0-2.299 1.158-3.62 2.912-3.62h.33z"
  }));
}
var ForwardRef$5j = /*#__PURE__*/forwardRef(FarteIcon);

function FlybussenIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Layer 1",
    viewBox: "0 0 306.29 51.7",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__FlybussenIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0,
    d: "M193.1 2v47.7H2V2zm2-2H0v51.7h195.1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8 16.1c-1.6.5-3.7 1.3-6.3 2.3-.1 0-.2.1-.4 0-2.9-.5-9.2-2.1-9.3-2.1 0 0-.8-.3-1.5 0l-2 .7s-.1 0-.1.1v.1l5.1 4.3s.1.1 0 .1c-1.5.6-2.8 1.1-3.8 1.6-1 .4-1.8.7-2 .8h-.1l-4.3-1.8s-.6-.2-1.2 0l-1.2.5s-.1 0-.1.1v.1c.2.2 3.9 4.5 4.5 5 .3.3 1.9.2 10.8-2.6 2.5-.8 4.9-1.6 7-2.3 2.5-.9 4.7-1.8 6.8-2.9 2.9-1.4 4.1-2.5 3.8-3.3-.3-1-4.4-1.2-5.7-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9 35.1 17.7 35.1 18.2 33.1 48.3 33.1 47.9 35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.4 20.6-.8 3.5H64l-.5 2.4h5.6l-.7 3.5h-5.6l-1.1 5.1h-3.9l3.1-14.5zM69.9 35.1 73 20.6h3.9l-2.3 11H81l-.7 3.5zM95 20.6l-7.2 9.3-1.1 5.2h-3.9l1.1-5.2-3.2-9.3h4l1.7 5.6 4.1-5.6zM93.5 35.1l3.1-14.5h6.3c2.8 0 4.4 1.8 4.4 3.5 0 2.7-2.6 3.5-2.6 3.5s2 .9 2 2.9c0 2.4-2.2 4.5-5.8 4.5zm7.4-3.1c1.1 0 1.8-.7 1.8-1.7 0-.7-.6-1.2-1.4-1.2h-2.6l-.6 2.9zm-1-8.3-.5 2.5h2.3c.9 0 1.6-.6 1.6-1.4 0-.6-.5-1.1-1.2-1.1zM118.4 29.1l1.8-8.5h3.9l-1.8 8.5c-.8 3.6-3.5 6.4-7.4 6.4s-6.7-2.8-5.9-6.4l1.8-8.5h3.9l-1.8 8.5c-.4 1.7.8 2.9 2.2 2.9 1.6 0 2.9-1.2 3.3-2.9M131 30.8c0-1.6-5.6-1.8-5.6-5.6 0-2.6 2.2-5 6.1-5 3.5 0 5.1 2.1 5.1 2.1l-2.7 2.3s-1-1-2.4-1c-1 0-1.7.5-1.7 1.2 0 1.6 5.6 1.7 5.6 5.5 0 3-2.2 5.3-6.3 5.3-3.8 0-5.9-2.5-5.9-2.5l2.7-2.3s1.3 1.5 3.2 1.5c.9-.1 1.9-.4 1.9-1.5M144 30.8c0-1.6-5.6-1.8-5.6-5.6 0-2.6 2.2-5 6.1-5 3.5 0 5.1 2.1 5.1 2.1l-2.7 2.3s-1-1-2.4-1c-1 0-1.7.5-1.7 1.2 0 1.6 5.6 1.7 5.6 5.5 0 3-2.2 5.3-6.3 5.3-3.8 0-5.9-2.5-5.9-2.5l2.7-2.3s1.3 1.5 3.2 1.5c.9-.1 1.9-.4 1.9-1.5M160 31.8l-.7 3.3h-9.6l3.1-14.5h9.6l-.7 3.3h-5.6l-.5 2.3h5.6l-.7 3.1h-5.6l-.5 2.5zM178.6 20.6l-3.1 14.5h-3.3l-4.6-8.1-1.7 8.1H162l3.1-14.5h3.4l4.6 8.1 1.7-8.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0,
    d: "M304.29 2v47.7H195.1V2zm2-2H193.1v51.7h113.19z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.67 18.73c-.72.25-1.4.6-2.01 1.05-.61.44-1.14.97-1.58 1.58-.41.56-.72 1.19-.91 1.86-1.1 0-2.19.2-3.22.56-1.09.38-2.11.91-3.04 1.59-.92.67-1.72 1.47-2.4 2.38-.63.85-1.1 1.8-1.39 2.81h8.02l2.03-7.35h5.3l1.33-4.86c-.73 0-1.45.13-2.13.37ZM224.11 25.85c0-2.88 1.97-4.87 4.79-4.87 2.41 0 4.12 1.25 4.44 3.26l-2.3.45c-.17-.99-.95-1.67-2.06-1.67-1.46 0-2.41 1.1-2.41 2.83s.95 2.83 2.41 2.83c1.1 0 1.83-.6 2.06-1.61l2.3.47c-.36 1.98-2.06 3.18-4.44 3.18-2.83 0-4.79-1.98-4.79-4.87M234.37 25.85c0-2.81 2.06-4.87 4.92-4.87s4.92 2.06 4.92 4.87-2.06 4.87-4.92 4.87-4.92-2.06-4.92-4.87m7.47 0c0-1.68-1.03-2.83-2.55-2.83s-2.55 1.14-2.55 2.83 1.01 2.83 2.55 2.83 2.55-1.14 2.55-2.83M245.46 21.13h2.36v1.42c.6-.92 1.67-1.57 3-1.57 2.06 0 3.44 1.35 3.44 3.41v6.18h-2.36v-5.62c0-1.1-.69-1.87-1.8-1.87-1.44 0-2.28 1.24-2.28 3.35v4.14h-2.36zM255.87 21.13h2.36v1.42c.6-.92 1.67-1.57 3-1.57 2.06 0 3.44 1.35 3.44 3.41v6.18h-2.36v-5.62c0-1.1-.69-1.87-1.8-1.87-1.44 0-2.28 1.24-2.28 3.35v4.14h-2.36zM275.28 26.47h-7c.21 1.42 1.12 2.27 2.47 2.27 1.1 0 1.89-.52 2.13-1.44l2.21.6c-.52 1.78-2.17 2.83-4.38 2.83-3.13 0-4.79-2.41-4.79-4.87s1.53-4.87 4.66-4.87 4.74 2.36 4.74 4.55c0 .34-.02.75-.04.94Zm-2.49-1.72c-.11-1.12-.84-1.97-2.21-1.97-1.16 0-1.98.69-2.25 1.97zM276.35 25.85c0-2.88 1.97-4.87 4.79-4.87 2.41 0 4.12 1.25 4.44 3.26l-2.3.45c-.17-.99-.95-1.67-2.06-1.67-1.46 0-2.41 1.1-2.41 2.83s.95 2.83 2.41 2.83c1.1 0 1.83-.6 2.06-1.61l2.3.47c-.36 1.98-2.06 3.18-4.44 3.18-2.83 0-4.79-1.98-4.79-4.87M291.18 30.72c-1.91 0-3.33-1.03-3.33-3.24v-4.36h-1.59v-1.98h1.59v-2.77h2.36v2.77h2.32v1.98h-2.32v4.14c0 .9.49 1.39 1.22 1.39.36 0 .77-.06 1.1-.22v2.12c-.48.14-.8.19-1.35.19Z"
  })));
}
var ForwardRef$5i = /*#__PURE__*/forwardRef(FlybussenIcon);

function FramIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 48 13",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__FramIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.076 10.976h.372l.45 1.291.512-1.29h.358v1.536h-.293v-.771l.008-.315-.418 1.086H.716l-.368-1.102.02.33v.773H.075zM2.024 12.474l.139-.15a.7.7 0 0 1-.105-.393c0-.4.235-.633.582-.633q.238 0 .373.11l.129-.136.092.093-.127.14a.75.75 0 0 1 .103.414c0 .409-.248.617-.587.617a.58.58 0 0 1-.368-.115l-.135.146zm.805-.872a.26.26 0 0 0-.195-.074c-.227 0-.29.19-.29.394 0 .065.007.13.029.182zm.092.317a.6.6 0 0 0-.028-.191l-.458.502a.28.28 0 0 0 .203.074c.227 0 .283-.17.283-.384zM3.474 11.326h.285v.159c.056-.08.17-.183.315-.183a.5.5 0 0 1 .152.02l-.04.239a.6.6 0 0 0-.15-.013.37.37 0 0 0-.277.135v.83h-.285zM4.276 11.94c0-.485.242-.642.572-.642.338 0 .475.226.475.598V12h-.762c0 .26.16.305.368.305.082 0 .22-.029.317-.048l.045.224a1.5 1.5 0 0 1-.413.059c-.369-.001-.602-.135-.602-.6m.754-.133c.002-.179-.069-.302-.21-.302-.142 0-.24.106-.253.302zM6.013 11.93c0-.4.236-.634.583-.634.39 0 .57.232.57.624 0 .408-.249.619-.587.619-.362 0-.566-.23-.566-.608m.864-.01c0-.202-.056-.394-.287-.394-.228 0-.29.192-.29.396 0 .22.071.385.294.385.227 0 .283-.172.283-.387M7.445 12.939l.047-.235c.107.024.265.048.355.048.18 0 .303-.026.303-.235v-.063a.36.36 0 0 1-.221.079c-.268 0-.57-.07-.57-.607 0-.415.279-.63.615-.63.165 0 .293.022.458.054v1.198c0 .326-.278.452-.542.452q-.226-.004-.445-.061m.702-.685v-.696a.7.7 0 0 0-.175-.024c-.234 0-.328.163-.328.393 0 .283.114.379.302.379a.45.45 0 0 0 .201-.052M10.059 12.228l-.212-.282a1 1 0 0 1-.105.006h-.148v.561H9.3v-1.537h.553c.322 0 .549.153.549.483 0 .174-.082.33-.26.417l.188.235c.09.11.19.165.323.2l-.064.228c-.218-.01-.382-.124-.53-.31m-.304-.493c.222 0 .344-.085.344-.265 0-.187-.085-.259-.293-.259h-.212v.524zM10.773 11.93c0-.4.235-.634.582-.634.39 0 .57.232.57.624 0 .408-.248.619-.587.619-.362 0-.565-.23-.565-.608m.863-.01c0-.202-.056-.394-.287-.394-.227 0-.29.192-.29.396 0 .22.071.385.294.385.227 0 .284-.172.284-.387zM12.189 11.326h.285v.129a.64.64 0 0 1 .379-.159c.174 0 .279.072.326.179.09-.081.244-.179.409-.179.366 0 .37.263.37.465v.752h-.284v-.72c0-.16-.035-.245-.185-.245a.56.56 0 0 0-.28.098 1 1 0 0 1 .006.113v.754h-.283v-.72c0-.171-.032-.243-.18-.243a.6.6 0 0 0-.278.095v.867h-.285zM14.21 12.489l.034-.224c.123.02.242.04.333.04.182 0 .235-.057.235-.122 0-.183-.589-.111-.589-.53 0-.24.214-.357.458-.357q.181 0 .352.06l-.047.216c-.092-.022-.18-.043-.304-.043-.13 0-.174.058-.174.108 0 .19.585.137.585.53 0 .298-.293.372-.488.372a1.4 1.4 0 0 1-.395-.05M15.275 11.909c0-.409.27-.613.604-.613a1 1 0 0 1 .184.02v-.442h.284v1.64h-.285v-.097a.4.4 0 0 1-.278.116c-.225 0-.51-.105-.51-.624m.788.306v-.664a.7.7 0 0 0-.18-.024c-.231 0-.323.167-.323.389 0 .282.121.376.274.376a.54.54 0 0 0 .229-.077M16.601 12.183c0-.298.265-.359.482-.361l.231-.002v-.105c0-.136-.078-.17-.246-.17-.111 0-.24.031-.326.053l-.058-.215q.212-.082.435-.084c.324 0 .474.098.474.352v.578c0 .057.047.07.107.074l-.013.222h-.062c-.125 0-.26-.03-.285-.135a.6.6 0 0 1-.364.143c-.238 0-.375-.122-.375-.35m.713.047v-.235l-.216.009c-.135.002-.22.059-.22.156 0 .105.072.144.162.144.099 0 .214-.054.274-.074M17.979 10.874h.285v1.64h-.285zM19.127 11.535h-.172v-.209h.172v-.082c0-.337.201-.424.433-.424a.6.6 0 0 1 .2.028l-.048.23a1 1 0 0 0-.139-.01c-.111 0-.159.065-.159.191v.067h.251v.209h-.25v1.41h-.288zM20.25 12.513h-.11l-.391-1.187h.306l.223.759.054.2.062-.198.255-.76h.29l-.573 1.665h-.275zM21.13 10.874h.286v1.64h-.285zM21.75 10.874h.285v.97l.406-.516h.312l-.452.548.192.235a.56.56 0 0 0 .294.206l-.039.22a.52.52 0 0 1-.441-.229l-.272-.359v.563h-.285zM22.92 11.94c0-.485.242-.642.572-.642.338 0 .476.226.476.598V12h-.763c0 .26.16.305.369.305.081 0 .22-.029.316-.048l.046.224a1.5 1.5 0 0 1-.414.059c-.368-.001-.602-.135-.602-.6m.754-.133c.002-.179-.069-.302-.21-.302s-.24.106-.253.302zM24.148 12.489l.034-.224c.122.02.242.04.332.04.182 0 .236-.057.236-.122 0-.183-.59-.111-.59-.53 0-.24.215-.357.46-.357q.18 0 .35.06l-.046.216c-.093-.022-.18-.043-.305-.043-.13 0-.173.058-.173.108 0 .19.585.137.585.53 0 .298-.294.372-.489.372a1.4 1.4 0 0 1-.394-.05M25.284 10.874h.285v.97l.404-.516h.313l-.452.548.192.235a.56.56 0 0 0 .294.206l-.038.22a.52.52 0 0 1-.442-.229l-.272-.359v.563h-.285zM26.453 11.93c0-.4.236-.634.583-.634.39 0 .57.232.57.624 0 .408-.248.619-.587.619-.361 0-.566-.23-.566-.608m.864-.01c0-.202-.056-.394-.287-.394-.227 0-.29.192-.29.396 0 .22.071.385.294.385.227 0 .283-.172.283-.387M27.87 11.326h.285v.129a.64.64 0 0 1 .38-.159c.173 0 .278.072.325.179.09-.081.244-.179.41-.179.366 0 .37.263.37.465v.752h-.285v-.72c0-.16-.034-.245-.184-.245a.56.56 0 0 0-.28.098 1 1 0 0 1 .006.113v.754h-.283v-.72c0-.171-.032-.243-.18-.243a.6.6 0 0 0-.279.095v.867h-.285zM29.968 11.326h.285v.129a.64.64 0 0 1 .379-.159c.173 0 .278.072.326.179.09-.081.244-.179.409-.179.366 0 .37.263.37.465v.752h-.284v-.72c0-.16-.035-.245-.185-.245a.56.56 0 0 0-.28.098 1 1 0 0 1 .006.113v.754h-.283v-.72c0-.171-.032-.243-.18-.243a.6.6 0 0 0-.278.095v.867h-.285zM32.061 12.072v-.746h.285v.713c0 .171.028.245.182.245a.7.7 0 0 0 .305-.093v-.865h.285v1.187h-.285v-.128c-.077.057-.228.154-.395.154-.351 0-.377-.224-.377-.467M33.45 11.326h.285v.127c.086-.063.23-.156.392-.156.358 0 .381.219.381.465v.752h-.283v-.72c0-.18-.034-.246-.19-.246a.65.65 0 0 0-.3.094v.871h-.285zM34.766 11.94c0-.485.242-.642.572-.642.338 0 .475.226.475.598V12h-.763c0 .26.16.305.368.305.082 0 .22-.029.317-.048l.046.224a1.5 1.5 0 0 1-.414.059c-.368-.001-.601-.135-.601-.6m.754-.133c.002-.179-.069-.302-.21-.302-.144 0-.24.106-.253.302zM18.531 0h2.919l3.665 9.56H22.81l-2.772-7.843-2.333 7.843h-1.899l-.073-1.23zM2.348 5.828V9.56H.083V0h7.51l-.556 1.799H2.348v2.794m0 0h3.285v1.663H2.348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.017 7.505 10.95 6.247c-.16.014-.333.014-.506.014H9.75V9.56h-2.28V0h3.666c2.118 0 3.638.987 3.638 3.124 0 1.068-.506 2.001-1.52 2.582l.96 1.055c.52.568 1.065.896 2.407.99l-.73 1.809c-1.931 0-2.89-.892-3.875-2.055m-1.493-2.853c1.346 0 1.918-.568 1.918-1.474 0-.96-.386-1.365-1.599-1.365H9.751v2.84zM24.786 0h2.759l2.626 7.505L33.184 0h2.626v9.56h-2.266V6.004l.066-2.244-2.239 5.8H28.84l-1.933-5.963.147 2.407V9.56h-2.267z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M43.164 12.539c5.084-3.903 4.914-7.887 4.798-12.536h-9.595c-.116 4.65-.286 8.633 4.797 12.536m.144-6.661V3.984h1.244v-.317h-1.244v-.902h-.312v.902h-1.243v.317h1.243v1.894c0 .467-.15.921-.427 1.294a2.1 2.1 0 0 1-1.11.772c.007.451.188.882.504 1.2a1.68 1.68 0 0 0 1.189.494 1.68 1.68 0 0 0 1.189-.495 1.73 1.73 0 0 0 .503-1.199l.001-.001a2.1 2.1 0 0 1-1.11-.771 2.17 2.17 0 0 1-.427-1.294M41.037 3.82V1.925h1.244V1.61h-1.244V.707h-.312v.902h-1.244v.316h1.244V3.82c0 .467-.15.92-.427 1.293a2.1 2.1 0 0 1-1.11.771v.001a1.74 1.74 0 0 0 .484 1.236 1.7 1.7 0 0 0 1.209.514 1.67 1.67 0 0 0 1.208-.514 1.72 1.72 0 0 0 .484-1.236 2.1 2.1 0 0 1-1.109-.772 2.17 2.17 0 0 1-.427-1.293m4.231 0V1.925h-1.243V1.61h1.243V.707h.31v.902h1.245v.316H45.58V3.82c0 .467.15.921.428 1.294.278.372.667.643 1.11.77v.001A1.74 1.74 0 0 1 46.62 7.1a1.7 1.7 0 0 1-1.197.503 1.67 1.67 0 0 1-1.197-.503 1.72 1.72 0 0 1-.496-1.215 2.1 2.1 0 0 0 1.11-.771c.278-.373.428-.827.428-1.294",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H48V13H0z"
  }))));
}
var ForwardRef$5h = /*#__PURE__*/forwardRef(FramIcon);

function GOAIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 56.732 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__GOAIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34.447 15.1h.011l.58-3.288h.566l-.72 4.084h-.713l-1.496-3.358h-.014l-.593 3.358h-.56l.721-4.084h.722zM38.027 16a2.3 2.3 0 0 1-.776-.125 1.7 1.7 0 0 1-.597-.354 1.6 1.6 0 0 1-.384-.556 1.9 1.9 0 0 1-.136-.73c-.002-.337.06-.67.182-.984.116-.297.286-.57.502-.803.213-.228.469-.412.753-.542a2.36 2.36 0 0 1 1.702-.074 1.602 1.602 0 0 1 .978.908c.093.23.14.478.136.727.002.337-.058.672-.177.987-.11.297-.278.57-.492.805a2.4 2.4 0 0 1-.75.542 2.2 2.2 0 0 1-.94.199m1.771-2.483a1.5 1.5 0 0 0-.086-.516 1.174 1.174 0 0 0-.667-.705 1.4 1.4 0 0 0-.563-.104c-.251-.004-.5.055-.723.17-.215.11-.404.264-.558.45a2.22 2.22 0 0 0-.473 1.367q0 .264.088.513.083.237.25.423c.114.124.254.222.41.285.181.073.374.108.568.104.254.004.504-.054.73-.167.213-.109.402-.26.554-.446.153-.19.27-.406.348-.637a2.2 2.2 0 0 0 .122-.737M41.48 15.896h-.56l.721-4.084h1.162q.278-.003.548.066.231.058.425.196a.89.89 0 0 1 .366.753 1.2 1.2 0 0 1-.087.464 1.07 1.07 0 0 1-.59.588q-.22.096-.457.132l.872 1.882h-.635l-.813-1.823h-.63zm.398-2.29h.629q.207.001.412-.035a1 1 0 0 0 .334-.116.6.6 0 0 0 .31-.562.5.5 0 0 0-.233-.464 1.2 1.2 0 0 0-.62-.139h-.6zM45.304 11.812h1.322q.35 0 .686.094c.221.06.43.163.612.3.185.142.335.324.438.531.118.244.175.512.167.782.005.335-.059.666-.187.976-.12.283-.297.539-.522.749a2.3 2.3 0 0 1-.791.482 2.8 2.8 0 0 1-.992.17h-1.454zM45.23 15.4h.837c.279.007.556-.046.813-.153.22-.095.417-.233.58-.406.158-.168.279-.365.356-.581.078-.215.117-.442.116-.671.002-.17-.027-.34-.086-.5a1.1 1.1 0 0 0-.262-.41 1.3 1.3 0 0 0-.45-.28 1.8 1.8 0 0 0-.65-.103h-.71zM49.628 15.896h-.565l.72-4.084h.566zM54.31 15.25a1.92 1.92 0 0 1-1.093.692q-.263.06-.533.058a2.1 2.1 0 0 1-.748-.127 1.7 1.7 0 0 1-.58-.358 1.6 1.6 0 0 1-.373-.554 1.9 1.9 0 0 1-.132-.715 2.6 2.6 0 0 1 .187-.992 2.473 2.473 0 0 1 1.287-1.348 2.3 2.3 0 0 1 1.384-.152q.203.043.39.13.173.08.323.198.14.109.233.26l-.465.34a.8.8 0 0 0-.127-.172 1.045 1.045 0 0 0-.468-.275 1.2 1.2 0 0 0-.334-.045 1.6 1.6 0 0 0-.733.171c-.22.11-.418.261-.58.446-.164.186-.291.401-.376.634-.088.234-.133.481-.133.73a1.6 1.6 0 0 0 .083.52c.054.156.138.3.249.423.113.124.252.221.406.285.176.072.365.107.554.104.466.005.908-.206 1.195-.572zM4.515 6.605H6.36l-.193 1.136c-.2.1-.415.17-.635.207a5 5 0 0 1-.743.074 3 3 0 0 1-1.07-.18 2.2 2.2 0 0 1-.789-.507 2.1 2.1 0 0 1-.48-.776 2.9 2.9 0 0 1-.16-.966 4 4 0 0 1 .248-1.394 3.8 3.8 0 0 1 .681-1.161 3.3 3.3 0 0 1 1.03-.796 2.9 2.9 0 0 1 1.29-.294c.405-.015.808.075 1.17.26.288.158.537.38.727.65L9.054 1.4A3.2 3.2 0 0 0 7.616.355 5.6 5.6 0 0 0 5.578 0a5.4 5.4 0 0 0-2.225.454c-.67.294-1.274.719-1.778 1.25A5.7 5.7 0 0 0 .398 3.557a6.2 6.2 0 0 0-.42 2.285 4.3 4.3 0 0 0 .327 1.711 3.7 3.7 0 0 0 .916 1.296 4 4 0 0 0 1.423.823 5.7 5.7 0 0 0 1.852.288c.629 0 1.255-.079 1.865-.233a7.5 7.5 0 0 0 1.626-.601l.75-4.347H4.85zM16.487 4.533a2.7 2.7 0 0 0-.716-.922 3.15 3.15 0 0 0-1.082-.58 4.5 4.5 0 0 0-1.363-.201 4.1 4.1 0 0 0-1.698.334 3.9 3.9 0 0 0-1.278.896 3.9 3.9 0 0 0-.813 1.31 4.5 4.5 0 0 0-.28 1.577c-.017.825.34 1.613.969 2.146.314.262.677.46 1.068.58.435.137.888.205 1.344.202a4.3 4.3 0 0 0 1.724-.334 3.9 3.9 0 0 0 1.29-.89c.357-.376.633-.821.813-1.308.188-.51.283-1.048.28-1.591a2.8 2.8 0 0 0-.258-1.219M14.502 6.8c-.084.249-.213.48-.38.682a1.8 1.8 0 0 1-.595.465 1.8 1.8 0 0 1-.776.167q-.67 0-1.03-.395a1.42 1.42 0 0 1-.36-.995 2.5 2.5 0 0 1 .133-.813c.084-.25.212-.484.379-.689a1.8 1.8 0 0 1 .587-.465c.242-.118.507-.178.776-.174q.668 0 1.035.4c.248.275.38.635.368 1.004 0 .277-.047.552-.137.813M32.894 3.457a1.8 1.8 0 0 0-.662-.441 2.6 2.6 0 0 0-.962-.16 2.2 2.2 0 0 0-1.19.314c-.312.184-.58.432-.789.728h-.027l.65-3.676h-2.149l-1.664 9.464h2.138l.642-3.582c.06-.383.221-.744.465-1.046a1.15 1.15 0 0 1 .942-.434q.494 0 .688.26c.133.185.201.408.194.635a2.7 2.7 0 0 1-.067.561l-.628 3.61h2.139l.718-4.097q.04-.175.053-.355c.01-.116.014-.242.014-.368.002-.26-.037-.52-.116-.767a1.7 1.7 0 0 0-.39-.646M40.675 4.431a2.4 2.4 0 0 0-.602-.874 2.6 2.6 0 0 0-.929-.543 3.7 3.7 0 0 0-1.196-.187 4.1 4.1 0 0 0-1.618.315 3.8 3.8 0 0 0-1.262.862 4 4 0 0 0-.83 1.29 4.2 4.2 0 0 0-.299 1.598c-.008.441.078.879.254 1.284.16.361.398.683.697.943.304.258.656.453 1.036.573.415.133.848.2 1.283.198a4.7 4.7 0 0 0 1.698-.301 3.8 3.8 0 0 0 1.43-.983l-1.35-1.055c-.2.21-.436.382-.696.508a2.04 2.04 0 0 1-.896.187c-.183 0-.366-.026-.54-.08a1.5 1.5 0 0 1-.465-.232q-.207-.152-.335-.374a1 1 0 0 1-.127-.502q0-.059.014-.116h4.771a6 6 0 0 0 .175-1.297 3.2 3.2 0 0 0-.213-1.214m-1.684 1.057q0 .068-.014.134h-2.89q.06-.235.186-.442.142-.234.349-.414.227-.195.502-.314c.204-.087.425-.131.648-.128q.588 0 .902.295a.96.96 0 0 1 .315.736zM47.453 4.019a1.96 1.96 0 0 0-.58-.669 2.5 2.5 0 0 0-.877-.394 4.6 4.6 0 0 0-1.109-.127 4.9 4.9 0 0 0-1.544.26c-.502.164-.97.415-1.383.743l.882 1.229c.255-.19.537-.344.835-.454.293-.114.603-.173.917-.175.268-.015.534.048.767.182a.63.63 0 0 1 .274.567v.117a1 1 0 0 1-.026.187q-.83 0-1.65.106c-.507.06-1.002.19-1.471.388a2.65 2.65 0 0 0-1.045.789q-.4.506-.401 1.31c-.009.29.055.577.187.835.117.219.284.407.488.548.203.139.43.239.669.294q.352.085.714.087 1.299 0 2.032-.869h.027a4.87 4.87 0 0 0-.053.708h1.897q0-.227.034-.588.033-.36.1-.708l.455-2.594a4 4 0 0 0 .06-.413q.02-.215.02-.402a2 2 0 0 0-.22-.957M45.42 7.093a1.67 1.67 0 0 1-.521.942c-.28.256-.65.392-1.029.38a1.3 1.3 0 0 1-.609-.14q-.274-.14-.274-.54a.63.63 0 0 1 .215-.496c.159-.133.343-.233.541-.293q.363-.113.741-.14.415-.034.813-.033h.187zM54.612.222l-.622 3.663h-.026a1.92 1.92 0 0 0-.803-.749 2.7 2.7 0 0 0-1.27-.28 3.34 3.34 0 0 0-1.477.327c-.443.214-.839.517-1.161.89-.332.385-.59.83-.762 1.31a4.6 4.6 0 0 0-.274 1.603c-.005.391.058.78.187 1.15.117.334.301.641.541.901.243.26.54.463.869.596.37.147.764.22 1.161.214.454.005.903-.09 1.314-.281.377-.174.7-.447.936-.789h.04l-.16.91h1.971L56.754.221zM53.462 6.8c-.089.25-.222.48-.394.682a1.9 1.9 0 0 1-.601.465c-.234.111-.49.169-.75.167q-.68 0-1.029-.402a1.47 1.47 0 0 1-.348-1.002 2.5 2.5 0 0 1 .134-.828 2.1 2.1 0 0 1 .374-.676 1.74 1.74 0 0 1 1.363-.622c.38-.019.75.125 1.016.395.254.274.388.637.374 1.01a2.4 2.4 0 0 1-.138.811z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.805.222 18.905 4.774 21.171 4.774 22.38 2.655 22.829 5.704 19.826 7.802 23.101 7.802 23.422 9.686 25.761 9.686 23.97.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.739 6.605 15.776 9.686 18.316 9.686 19.314 8.032 20.127 6.605z"
  }));
}
var ForwardRef$5g = /*#__PURE__*/forwardRef(GOAIcon);

function HykeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Layer 2",
    viewBox: "0 0 482.13 147.98",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__HykeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.65 29.45h-68.46c-9.72 0-17.08 6.14-21.28 14.47l-21 41.18c-3.69 7.25-14.5 32.81 18.7 32.81h64c9.36-.59 13.79-4.63 17.83-11l2.93-5.74h-61c-5.69 0-9.27-2.43-6-10.11l6.1-12.73h62.48c5.92 0 11.36-3.26 14.14-8.48L478.88 59c3.82-8.89 8.7-26.96-14.23-29.55m-23.48 32a12.31 12.31 0 0 1-10.95 6.59h-28.9l1.36-2.88 7.43-14.55c.5-.98 1.22-1.83 2.1-2.49a7.34 7.34 0 0 1 4.35-1.46h32.17zM15.2 30.52c8.42 0 15.26-6.82 15.28-15.24v-.08C30.46 6.78 23.62-.02 15.2 0S-.02 6.86 0 15.28v.08c-.02 8.36 6.74 15.14 15.1 15.16zM1.77 15.28C1.69 7.87 7.62 1.8 15.03 1.72h.25c7.34-.08 13.35 5.81 13.43 13.15v.41c.08 7.41-5.85 13.48-13.26 13.56h-.25c-7.34.08-13.35-5.81-13.43-13.15z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 16.25c-.69-.55-.47-.93-.47-.93l6.35-3.84c.85-.68 1.36-1.7 1.4-2.79H11.73c-2 .12-3.91.81-5.52 2l-1.31.86h11.87c0 .32-.18.72-1.59 1.39l-4.51 2.2a.39.39 0 0 0-.11.65l6.89 5.54c1.24 1 4 1 5.14 1h1.51zM377 29.84h-29a41.24 41.24 0 0 0-24.8 8.29l-48.71 35.7L312.05.04h-27.13c-13.61 0-17.68 6.31-23.2 16.37l-6.26 12.26-45.27 88.77h42l18.42-36.13 26.52 36.13h41.41l-28.13-38.28zm-168.75 1.35c-13.6 0-17.68 6.31-23.2 16.37L163 90.83l-5.31 10.41h-18.21c-7.9 0-6.35-5.68-4.87-9l14.95-29.29c3.62-7.1 14.21-32.13-18.31-32.13h-36L110.77.04H83.23C70 .16 65.91 6.41 60.48 16.31L8.91 117.44h42l35.9-70.22h18.78c6 0 9.32 3.09 4.7 12.14L95 89.04c-5.82 11.09-5.63 28.74 15 28.82h39.2l-15.39 30.12h27.26c13.49 0 17.53-6.27 23-16.24l51.34-100.55z",
    className: "cls-1"
  })));
}
var ForwardRef$5f = /*#__PURE__*/forwardRef(HykeIcon);

function InnlandstrafikkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 77.331 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__InnlandstrafikkIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.014 0v8.111C-.014 13.463 6.351 16 6.351 16s6.364-2.54 6.364-7.889V0zM6.35 1.713 9 4.36l-.617.617L6.35 2.946 4.32 4.978l-.618-.617zM2.101 5.227.86 6.469V5.235L2.1 3.993l3.633 3.632-.617.618zm9.742 1.242L10.6 5.227l-5.13 5.13a1.255 1.255 0 1 0 1.766.006l-.27-.27.617-.617.248.249a2.125 2.125 0 1 1-2.947-.013L10.6 3.995l1.243 1.243zM16.88 3.344h.944v5.57h-.944zM20.135 6.593v2.295h-.893v-4.24h.893v.773a1.6 1.6 0 0 1 1.41-.836q.717 0 1.16.438t.443 1.267v2.598h-.893V6.561q0-1.17-.973-1.172a1.17 1.17 0 0 0-.807.307q-.34.307-.34.897M25.117 6.593v2.295h-.893v-4.24h.893v.773a1.6 1.6 0 0 1 1.41-.836q.72 0 1.16.438.442.438.442 1.267v2.598h-.892V6.561q0-1.17-.972-1.172a1.17 1.17 0 0 0-.806.307q-.342.307-.342.897M31.366 8.585q-.318.367-.893.368a1.25 1.25 0 0 1-.92-.343q-.348-.343-.347-1.012V3.317h.893v4.177q0 .637.478.637a.43.43 0 0 0 .398-.2zM35.487 8.888h-.813v-.566q-.525.63-1.411.63c-.4.014-.79-.12-1.095-.378-.29-.25-.45-.618-.435-1q0-.626.462-.936t1.252-.312h1.156V6.17q0-.844-.944-.844-.59 0-1.228.43l-.4-.557a2.74 2.74 0 0 1 1.757-.614q.748 0 1.227.378.48.377.472 1.191zm-.893-1.577v-.359h-1.003q-.965 0-.965.605a.54.54 0 0 0 .238.472c.2.119.43.176.661.164.268.005.53-.08.745-.24a.76.76 0 0 0 .324-.642M37.583 6.593v2.295h-.892v-4.24h.892v.773a1.6 1.6 0 0 1 1.411-.836q.72 0 1.16.438t.442 1.267v2.598h-.893V6.561q0-1.17-.971-1.172a1.17 1.17 0 0 0-.806.307q-.343.307-.343.897M42.183 8.347q-.598-.606-.598-1.594 0-.99.614-1.579a2.04 2.04 0 0 1 1.462-.59c.549-.01 1.064.261 1.367.718V2.975h.893v5.913h-.893v-.637q-.494.7-1.442.702a1.9 1.9 0 0 1-1.403-.606m.291-1.558c-.014.37.128.73.391.992.242.245.573.381.917.378.339.005.664-.136.892-.387.25-.269.381-.626.368-.992a1.45 1.45 0 0 0-.368-1.012 1.16 1.16 0 0 0-.9-.407 1.2 1.2 0 0 0-.916.407 1.43 1.43 0 0 0-.384 1.02M50.426 7.621c.014.375-.148.734-.439.971q-.438.363-1.123.363a3 3 0 0 1-.96-.174 2.9 2.9 0 0 1-.882-.472l.43-.693q.74.558 1.435.558c.17.011.34-.036.48-.134a.43.43 0 0 0 .175-.355q0-.318-.85-.573l-.094-.033q-1.322-.358-1.322-1.195c-.01-.37.16-.723.46-.944q.456-.354 1.19-.354c.495.002.977.152 1.385.43l-.335.66a2 2 0 0 0-1.124-.342 1 1 0 0 0-.518.116.38.38 0 0 0-.195.346.32.32 0 0 0 .207.303q.195.087.402.133.259.063.458.127c.133.043.262.094.387.144q.21.093.403.222.43.291.43.896M52.791 5.366v2.152a.7.7 0 0 0 .164.482.57.57 0 0 0 .446.18c.19 0 .378-.095.55-.284l.366.63c-.28.268-.651.42-1.038.423a1.34 1.34 0 0 1-.973-.395q-.402-.396-.402-1.064V5.366h-.535v-.718h.535V3.317h.892v1.331h1.116v.718zM57.203 5.486q-.66 0-.997.43t-.334 1.155v1.817h-.893v-4.24h.893v.85c.14-.261.341-.485.586-.653.23-.164.503-.256.785-.263l.008.9zM61.772 8.888h-.813v-.566q-.526.63-1.41.63c-.4.014-.79-.12-1.096-.378-.29-.25-.45-.618-.435-1q0-.626.462-.936t1.252-.312h1.154V6.17q0-.844-.944-.844-.59 0-1.228.43l-.398-.557a2.74 2.74 0 0 1 1.753-.614q.749 0 1.227.378.48.377.473 1.191zm-.893-1.577v-.359h-1.004q-.963 0-.964.605a.54.54 0 0 0 .238.472c.2.119.43.176.661.164.269.005.531-.08.746-.24a.77.77 0 0 0 .323-.642M64.115 4.298v.35h1.114v.718h-1.114v3.522h-.892V5.366h-.535v-.718h.535v-.327q0-.67.402-1.064c.257-.258.608-.4.972-.394.388.004.76.155 1.039.423l-.366.63q-.264-.284-.55-.284a.57.57 0 0 0-.447.18.7.7 0 0 0-.158.486M66.582 3.803a.556.556 0 1 1 .797-.776.556.556 0 0 1-.797.776m.836 5.085h-.892v-4.24h.892zM69.674 8.888h-.892V2.975h.892V6.45l1.721-1.802h1.148l-1.61 1.678 1.73 2.559H71.58L70.32 7.03l-.645.654zM74.328 8.888h-.892V2.975h.892V6.45l1.722-1.802h1.147l-1.61 1.678 1.727 2.562h-1.08l-1.26-1.857-.646.654z"
  })));
}
var ForwardRef$5e = /*#__PURE__*/forwardRef(InnlandstrafikkIcon);

function KolumbusIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 69.4 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__KolumbusIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M67 8.5c1.4.2 2.6.6 2.6 2 0 1.3-1.1 2.1-2.8 2.1-1.6 0-2.7-.7-2.9-1.9l1.5-.2c.1.7.6 1 1.4 1 .7 0 1.2-.3 1.2-.8s-.4-.7-1.5-.9c-1.5-.2-2.5-.7-2.5-2 0-1.4 1.3-2 2.7-2s2.6.7 2.7 1.8l-1.5.3c-.1-.6-.5-1-1.2-1-.6 0-1.1.3-1.1.8s.6.6 1.4.8M62.8 12.3h-1.5v-1c-.4.7-1 1.1-2 1.1-1.3 0-2.3-.7-2.3-2.2V5.9h1.6V10c0 .9.6 1.3 1.2 1.3.8 0 1.5-.7 1.5-1.9V5.9h1.6zM55.9 9.1c0 2.1-1.3 3.4-3 3.4-1.1 0-1.8-.5-2.1-1.1v1h-1.5V2.8h1.6v3.9c.4-.5 1.1-1 2.1-1 1.7 0 2.9 1.3 2.9 3.4m-5 .3c0 1.3 1 1.9 1.8 1.9 1 0 1.7-.9 1.7-2.2 0-1.2-.7-2.2-1.7-2.2-.8 0-1.8.5-1.8 1.9zM38 5.9h1.5v1c.4-.7 1-1.2 2-1.2.9 0 1.7.4 2 1.2.4-.6 1.1-1.2 2.1-1.2 1.2 0 2.2.7 2.2 2.2v4.5h-1.6V8.3c0-.9-.5-1.3-1.1-1.3-.7 0-1.4.7-1.4 1.9v3.4h-1.6v-4c0-.9-.5-1.3-1.1-1.3-.7 0-1.4.7-1.4 1.9v3.4H38zM36.3 12.3h-1.5v-1c-.4.7-1 1.1-2 1.1-1.3 0-2.3-.7-2.3-2.2V5.9h1.6V10c0 .9.6 1.3 1.2 1.3.8 0 1.5-.7 1.5-1.9V5.9h1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.4 2.8H29V12.3H27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.3 9.1c0 2-1.3 3.4-3.3 3.4s-3.3-1.4-3.3-3.4S21 5.7 23 5.7s3.3 1.4 3.3 3.4m-1.6 0c0-1.2-.5-2.2-1.7-2.2-1.1 0-1.7 1-1.7 2.2s.5 2.2 1.7 2.2c1.1 0 1.7-1 1.7-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.6 7.8 13.7 8.8 13.7 12.3 12.1 12.3 12.1 2.8 13.7 2.8 13.7 6.8 17.5 2.8 19.4 2.8 15.8 6.6 19.7 12.3 17.7 12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 10.6 0 14 7.8 9.8 7.8 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 2 0 5.3 3.8 7.4 6.9 5.7z"
  }));
}
var ForwardRef$5d = /*#__PURE__*/forwardRef(KolumbusIcon);

function BergenBysykkelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__BergenBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008A34",
    d: "M11.816 12.932a3.184 3.184 0 1 1 0-6.368 3.184 3.184 0 0 1 0 6.368m0-4.895a1.71 1.71 0 1 0 1.711 1.711c0-.944-.766-1.71-1.71-1.71m-7.632 4.895a3.184 3.184 0 1 1 3.183-3.184 3.19 3.19 0 0 1-3.183 3.184m0-4.895a1.71 1.71 0 1 0 0 3.422 1.71 1.71 0 0 0 0-3.422M6.55 5.733H3.986a.737.737 0 0 1 0-1.475h2.565a.737.737 0 0 1 0 1.475m4.485-.794a5.6 5.6 0 0 1-2.2-.446.737.737 0 1 1 .58-1.356 4.15 4.15 0 0 0 1.62.327 4.15 4.15 0 0 0 1.64-.334.74.74 0 1 1 .59 1.356 5.6 5.6 0 0 1-2.23.453"
  }));
}
var ForwardRef$5c = /*#__PURE__*/forwardRef(BergenBysykkelIcon);

function BoltIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__BoltIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#34D186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a4.86 4.86 0 0 0 0 9.718A4.86 4.86 0 0 0 8 1m0 6.433c-.87 0-1.575-.703-1.575-1.574S7.13 4.284 8 4.284c.87 0 1.575.704 1.575 1.575S8.87 7.433 8 7.433"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13.425,
    r: 1.575
  })));
}
var ForwardRef$5b = /*#__PURE__*/forwardRef(BoltIcon);

function FartebysykkelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__FartebysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD520",
    d: "M16 0H0v16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.084 9.168c1.379-.142 2.691.884 2.886 2.252.385 2.708-3.028 4.192-4.725 2.075-1.222-1.524-.439-3.762 1.414-4.26l-.41-2.35-5.28 3.557v.032c.108.183.199.386.259.59.675 2.297-1.781 4.263-3.875 3.086-1.58-.888-1.827-3.092-.475-4.308a2.683 2.683 0 0 1 3.83.258l.017.001 5.82-3.943zm-8.543.974c-1.644.122-2.148 2.326-.719 3.146 1.424.816 3.073-.693 2.385-2.157-.012-.027-.047-.117-.078-.114l-1.302.864c-.219.137-.439-.124-.275-.321l1.34-.9a1.72 1.72 0 0 0-1.35-.518m8.299.071c-1.279.382-1.626 2.053-.59 2.913.882.733 2.236.381 2.65-.68a1.693 1.693 0 0 0-1.636-2.309l.274 1.612a.212.212 0 0 1-.418.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.568 1.498 7.024 8.282a.4.4 0 0 1-.066.07c-.026.023-.256.19-.273.197-.028.01-.025-.015-.02-.035l1.966-4.58h-.878l1.211-2.436z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}
var ForwardRef$5a = /*#__PURE__*/forwardRef(FartebysykkelIcon);

function GetAroundIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 76 76",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__GetAroundIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC00CC",
    d: "M43.975 13.927c.25.348.348.495.45.633 3.344 4.02 4.158 8.598 2.722 13.53-3.03 10.392-15.163 10.23-19.761 4.995-2.24-2.554-3.26-5.535-3.412-8.873-.274-6.28 3.47-13.858 12.932-13.589 5.75.162 11.5.05 17.25.01a4.5 4.5 0 0 0 1.981-.476c3.589-1.867 5.667-4.931 6.736-8.745.049-.176.005-.382.005-.603-.196-.02-.334-.049-.47-.049-9.31 0-18.614-.191-27.919.054-8.314.216-14.745 4.02-18.75 11.442-2.584 4.789-3.202 9.96-2.427 15.314.843 5.77 3.353 10.662 7.976 14.324 4.186 3.31 9.059 4.579 14.314 4.73 1.657.05 3.353.221 4.941.653 2.942.799 5.324 2.431 6.447 5.436 1.598 4.29-.245 9.153-4.432 11.172-4.667 2.26-9.373 2.103-13.893-.53-2.2-1.288-3.617-3.22-4.24-5.71l-.21-.873c-3.712.397-7.359.794-11.08 1.192.893 6.892 4.339 11.863 10.339 15.04 5.476 2.892 11.334 3.421 17.368 2.558 3.564-.514 6.908-1.69 9.859-3.78 5.892-4.156 8.27-10.005 8.059-17.059-.128-4.21-1.431-7.937-4.608-10.834-.961-.877-2.044-1.622-3.069-2.431.054-.064.088-.133.137-.177 7.555-6.48 9.241-17.745 6.01-26.359-.27-.72-.612-1.014-1.416-.995-2.304.059-4.603.02-6.898.02-1.563-.02-3.152-.02-4.941-.02"
  }));
}
var ForwardRef$59 = /*#__PURE__*/forwardRef(GetAroundIcon);

function HafjellIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__HafjellIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4695EB",
    d: "M7.136 10.832H2.968V15h4.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3563B",
    d: "M13.032 10.826H8.266v2.942h4.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59B653",
    d: "M7.704 9.92a2.628 2.628 0 1 0 0-5.256 2.628 2.628 0 0 0 0 5.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.704 1 6.239 2.465l1.465 1.464 1.465-1.464z"
  }));
}
var ForwardRef$58 = /*#__PURE__*/forwardRef(HafjellIcon);

function HertzIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__HertzIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD100",
    d: "M10.4 15H2l.438-2.012h8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.188 1 10.05 5.988H6.2L7.25 1H4.975L2.7 11.675h2.275L5.763 8h3.85l-.788 3.675H11.1L13.375 1z"
  }));
}
var ForwardRef$57 = /*#__PURE__*/forwardRef(HertzIcon);

function KolumbusBysykkelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__KolumbusBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CB454",
    d: "M3.45 11.033 3.45 15 12.55 10.1 12.55 6.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CB454",
    d: "M3.45 1 3.45 4.85 7.883 7.3 11.5 5.317z"
  }));
}
var ForwardRef$56 = /*#__PURE__*/forwardRef(KolumbusBysykkelIcon);

function LimeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__LimeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0D0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.794c3.422 0 6.206 2.784 6.206 6.206S11.422 14.206 8 14.206 1.794 11.422 1.794 8 4.578 1.794 8 1.794M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.906
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.533 6.658 2.173-1.255a.758.758 0 0 0 .164-1.186 5.4 5.4 0 0 0-2.524-1.46.76.76 0 0 0-.95.734V6c0 .584.632.949 1.137.657M7.604 6V3.49a.76.76 0 0 0-.95-.733 5.4 5.4 0 0 0-2.524 1.46.758.758 0 0 0 .164 1.186l2.173 1.255A.76.76 0 0 0 7.604 6M9.93 8.657l2.173 1.255a.758.758 0 0 0 1.11-.45 5.4 5.4 0 0 0 0-2.923.758.758 0 0 0-1.11-.451L9.929 7.343a.76.76 0 0 0 0 1.314M6.467 9.342l-2.173 1.255a.758.758 0 0 0-.164 1.186 5.4 5.4 0 0 0 2.524 1.46.76.76 0 0 0 .95-.734V10a.76.76 0 0 0-1.137-.657M6.07 7.343 3.898 6.088a.758.758 0 0 0-1.11.45 5.4 5.4 0 0 0 0 2.923.758.758 0 0 0 1.11.451l2.174-1.255a.76.76 0 0 0 0-1.314M8.396 10v2.51c0 .496.469.856.95.733a5.4 5.4 0 0 0 2.524-1.46.758.758 0 0 0-.164-1.186L9.533 9.342A.76.76 0 0 0 8.396 10"
  })));
}
var ForwardRef$55 = /*#__PURE__*/forwardRef(LimeIcon);

function MoveAboutIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__MoveAboutIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5BD6FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.683-326.413a.29.29 0 1 0 0-.581.29.29 0 0 0 0 .581M63.828-329.177a.222.222 0 1 0 0 .444.222.222 0 0 0 0-.444",
    transform: "matrix(1.63557 0 0 1.63557 -92.815 545.086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64-332.659c-2.36 0-4.28 1.92-4.28 4.28s1.92 4.28 4.28 4.28 4.28-1.92 4.28-4.28-1.92-4.28-4.28-4.28m2.322 5.285a.262.262 0 0 0-.26.297.11.11 0 0 1-.022.095l-.385.424c-.02.022-.044.017-.053-.013l-.422-1.472a.12.12 0 0 1 .02-.097s.116-.137.115-.261a.384.384 0 1 0-.311.376c.03-.007.06.01.068.04l.365 1.403c.008.03-.01.045-.038.034l-.47-.182a.2.2 0 0 1-.08-.067s-.133-.22-.293-.22a.328.328 0 1 0 0 .656c.138 0 .269-.162.269-.162a.07.07 0 0 1 .083-.014l.384.225a.064.064 0 0 1 .025.08l-.748 1.653a4 4 0 0 1-.388.037l-.943-1.636a.3.3 0 0 1-.03-.104l-.129-2.88a.09.09 0 0 1 .05-.076l.55-.22a.09.09 0 0 1 .091.02s.23.236.433.235a.542.542 0 1 0-.538-.478.06.06 0 0 1-.044.068l-.555.134c-.03.007-.047-.011-.037-.04l.438-1.31c.01-.028.022-.051.026-.051h.005a.407.407 0 1 0-.408-.407c0 .17.21.341.21.341.023.02.033.058.02.086l-.474 1.063a.07.07 0 0 1-.077.038l-.704-.167a.2.2 0 0 1-.088-.058s-.126-.168-.264-.168a.315.315 0 1 0 0 .63c.147-.001.274-.192.274-.192a.08.08 0 0 1 .083-.028l.646.218c.029.01.054.043.055.074l.147 3.165a.4.4 0 0 0 .022.108l.598 1.611a3.842 3.842 0 1 1 1.763-.198l.24-1.405a.2.2 0 0 1 .047-.096l.548-.593a.08.08 0 0 1 .088-.015s.044.021.1.021a.261.261 0 0 0-.002-.522",
    transform: "matrix(1.63557 0 0 1.63557 -92.815 545.086)"
  })));
}
var ForwardRef$54 = /*#__PURE__*/forwardRef(MoveAboutIcon);

function OsloBysykkelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__OsloBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005FC9",
    d: "M11.816 12.932a3.184 3.184 0 1 1 0-6.368 3.184 3.184 0 0 1 0 6.368m0-4.895a1.71 1.71 0 1 0 1.711 1.711c0-.944-.766-1.71-1.71-1.71m-7.632 4.895a3.184 3.184 0 1 1 3.183-3.184 3.19 3.19 0 0 1-3.183 3.184m0-4.895a1.71 1.71 0 1 0 0 3.422 1.71 1.71 0 0 0 0-3.422M6.55 5.733H3.986a.737.737 0 0 1 0-1.475h2.565a.737.737 0 0 1 0 1.475m4.485-.794a5.6 5.6 0 0 1-2.2-.446.737.737 0 1 1 .58-1.356 4.15 4.15 0 0 0 1.62.327 4.15 4.15 0 0 0 1.64-.334.74.74 0 1 1 .59 1.356 5.6 5.6 0 0 1-2.23.453"
  }));
}
var ForwardRef$53 = /*#__PURE__*/forwardRef(OsloBysykkelIcon);

function OttoMobilityIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__OttoMobilityIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#082C2A",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.986 5.379c.328 0 .653.062.957.182s.579.297.811.519.417.486.542.776a2.3 2.3 0 0 1 0 1.833 2.4 2.4 0 0 1-.542.776 2.5 2.5 0 0 1-.81.52 2.6 2.6 0 0 1-1.915 0 2.5 2.5 0 0 1-.811-.52 2.4 2.4 0 0 1-.542-.776 2.3 2.3 0 0 1-.19-.916c0-.635.264-1.243.732-1.692a2.56 2.56 0 0 1 1.768-.702m0-2.379c-1.322 0-2.59.503-3.526 1.398A4.67 4.67 0 0 0 1 7.773c0 .627.129 1.248.38 1.827.25.579.617 1.105 1.08 1.548a5 5 0 0 0 1.618 1.035 5.18 5.18 0 0 0 3.816 0 5 5 0 0 0 1.617-1.035c.463-.443.83-.97 1.081-1.548a4.6 4.6 0 0 0 0-3.653 4.8 4.8 0 0 0-1.08-1.549 5 5 0 0 0-1.618-1.034A5.2 5.2 0 0 0 5.986 3M13.474 9.729h.055c.39 0 .764.148 1.04.412s.431.623.431.996c0 .374-.155.732-.43.996-.277.264-.651.413-1.041.413h-.055c-.39 0-.765-.149-1.04-.413a1.38 1.38 0 0 1-.431-.996c0-.373.155-.732.43-.996.277-.264.65-.412 1.04-.412"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H14V9.545H0z",
    transform: "translate(1 3)"
  }))));
}
var ForwardRef$52 = /*#__PURE__*/forwardRef(OttoMobilityIcon);

function RydeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__RydeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CC24A",
    d: "m1 14 2.33-7.006C4.543 3.326 6.873 2 10.704 2H15l-1.092 3.288h-2.86c-1.385 0-2.184.543-2.598 1.75l-2.305 6.957H1z"
  }));
}
var ForwardRef$51 = /*#__PURE__*/forwardRef(RydeIcon);

function SURFIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SURFIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40EADF",
    d: "M9.057 9.661a3.1 3.1 0 0 1-.622 1.271q-.52.636-1.195.876Q6.677 12 5.255 12H1l.313-1.427h3.86q.915 0 1.341-.21t.54-.726q.216-.983-1.244-.983H4.248q-1.473 0-2.005-.528-.655-.66-.408-1.787.165-.756.749-1.392.583-.636 1.375-.827Q4.442 4 5.636 4H15l-.313 1.427H5.721q-.815 0-1.148.072-.602.131-.75.804-.111.516.187.72t1.165.203h1.36q1.743 0 2.273.66.502.612.249 1.775"
  }));
}
var ForwardRef$50 = /*#__PURE__*/forwardRef(SURFIcon);

function TierIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__TierIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69D2AA",
    d: "M1.343 3.505h13.314a.322.322 0 0 1 .342.342v1.126a.32.32 0 0 1-.342.322H9.006v6.879a.34.34 0 0 1-.342.322H7.336a.34.34 0 0 1-.342-.322V5.295H1.343A.32.32 0 0 1 1 4.973V3.847a.322.322 0 0 1 .342-.342"
  }));
}
var ForwardRef$4$ = /*#__PURE__*/forwardRef(TierIcon);

function TrondheimBysykkelIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__TrondheimBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E02344",
    d: "M11.816 12.932a3.184 3.184 0 1 1 0-6.368 3.184 3.184 0 0 1 0 6.368m0-4.895a1.71 1.71 0 1 0 1.711 1.711c0-.944-.766-1.71-1.71-1.71m-7.632 4.895a3.184 3.184 0 1 1 3.183-3.184 3.19 3.19 0 0 1-3.183 3.184m0-4.895a1.71 1.71 0 1 0 0 3.422 1.71 1.71 0 0 0 0-3.422M6.55 5.733H3.986a.737.737 0 0 1 0-1.475h2.565a.737.737 0 0 1 0 1.475m4.485-.794a5.6 5.6 0 0 1-2.2-.446.737.737 0 1 1 .58-1.356 4.15 4.15 0 0 0 1.62.327 4.15 4.15 0 0 0 1.64-.334.74.74 0 1 1 .59 1.356 5.6 5.6 0 0 1-2.23.453"
  }));
}
var ForwardRef$4_ = /*#__PURE__*/forwardRef(TrondheimBysykkelIcon);

function VoiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VoiIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F46C63",
    d: "m11.702 3.24-3.957 9.377H4.94L.999 3.24h2.807l2.6 6.38 2.681-6.38zm1.606 9.516a1.63 1.63 0 0 1-1.202-.487 1.65 1.65 0 0 1-.489-1.22q0-.75.489-1.212a1.796 1.796 0 0 1 2.405 0q.488.464.488 1.211c.012.457-.164.898-.489 1.22a1.63 1.63 0 0 1-1.202.488"
  }));
}
var ForwardRef$4Z = /*#__PURE__*/forwardRef(VoiIcon);

function ZvippIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__ZvippIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.783 5.275 12.074 2.911 4.023 2.911 1 5.511 7.755 13.184z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD600",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.132 5.149 8.743 12.704 9.214 12.247 4.899 5.646z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.731 7.448 8.229 2.542 5.919 2.546 8.455 5.643 8.023 5.643 5.476 2.54 4.73 2.544 5.254 5.643 9.419 11.98 10.561 10.357z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#009D48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.601 5.646 4.899 5.646 5.254 5.643 7.711 5.643 5.192 2.58 3.963 2.58 1 5.511 7.972 13.42 8.961 12.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.232 7.448 8.59 7.448 10.577 10.489 15 5.511 12.014 2.58 8.26 2.58z"
  })));
}
var ForwardRef$4Y = /*#__PURE__*/forwardRef(ZvippIcon);

function NorWayBussekspressIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 906.89 155.41",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__NorWayBussekspressIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f94e4e",
    d: "M133.15 151.21H90.72L33.18 46v105.21H0v-147h45.36L100 105.85V4.2h33.18ZM143.43 77.91C143.43 32.55 175.14 0 219.87 0c45.13 0 76.86 32.55 76.86 77.91 0 45.58-31.71 77.5-76.86 77.5-44.73 0-76.44-31.92-76.44-77.5m116.13.21c0-25.2-14.7-44.73-39.69-44.73-24.57 0-39.48 19.53-39.48 44.73S195.51 122 219.87 122c24.78 0 39.69-18.69 39.69-43.89ZM342.51 89.25v62h-35.28V4.21h64.68c31.92 0 52.29 17.22 52.29 45.36 0 22.68-13.65 39.27-39.69 42.42l43.68 59.22H386Zm43.89-36.33c0-12.18-7.35-19.11-21.21-19.11h-22.68v39.27h20.16c15.75 0 23.73-7.56 23.73-20.16M430.49 79.8a25.2 25.2 0 1 1 50.4 0 25.27 25.27 0 0 1-25.2 25.2 25 25 0 0 1-25.2-24.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a347a",
    d: "m695.53 4.2-75.82 147h-40.32L576 79.38l-37.8 71.83h-38.61l-6.72-147h35.28l1.89 96.6 48.51-96.6h37l-10.33 19.53 3.15 78.12 49.57-97.65ZM687.12 121.17l-14.91 30h-37.59l75.81-147h50l13.86 147h-35.93l-2.31-30Zm42.21-85.05-29 58.38H734ZM834.75 99.54l-15.12 51.67h-35.08l15.12-52.5-29.61-94.5h35.28l17.85 59.85 42.63-59.85h39.49Z"
  }));
}
var ForwardRef$4X = /*#__PURE__*/forwardRef(NorWayBussekspressIcon);

function NordlandIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 51 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__NordlandIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.06 5.92V.505h12.318V5.92c0 5.424-6.16 9.459-6.16 9.459S.06 11.343.06 5.919m2.367-3.646 3.594.09.004-.307c-.197-.02-.273-.116-.31-.163q-.016-.023-.026-.026c-.188-.009-.25-.066-.29-.103-.019-.016-.033-.029-.051-.031h-.004c-.06-.005-.07-.005-.252.086-.23.114-.478-.044-.513-.074q-.023-.023-.04-.045c-.042-.054-.084-.107-.301-.11a.6.6 0 0 0-.19.043c-.087.029-.18.06-.263.052-.277-.03-.18-.189-.18-.189.032.078.25.024.25.024a.9.9 0 0 0 .28-.151.24.24 0 0 1 .13-.062.5.5 0 0 1 .365.09c.239.188.366.088.366.088.024-.018.186-.127.33-.123.16.006.366.111.366.111.091.03.137-.004.192-.045l.023-.016c.04-.028.089-.04.128-.046l.002-.118.104.025.042 1.093 3.936.098c.069.003.053.175-.063.175h-.181s-3.796 2.835-3.22 5.405c.121.535.713 1.218.893 1.415q.402-.01.833-.033s.445-.064.795-.423l-1.433.29c-.069.01-.102.101-.102.101s-.013.02-.018.02c-.118.01-.048-.11-.048-.11.023-.046.1-.111.1-.111l1.604-.308c.13-.167.235-.384.283-.666 0 0 .216-1.016-.047-1.753 0 0-.033-.067.15-.012 0 0 .18.079.17.168l-.002.004s-.035 1.191-.08 2.168l.118-.023c.06-.937.127-1.982.12-2l.002-.002s.008-.065.177-.103c.014-.003.099.01.039.133l-.012.029s-.045.12-.067.5l-.057 1.26v.01c-.001.06-.004.252.145.474 0 0 .126.188.103.492 0 0-.08.671-.091.702l-.002.009c-.011.045-.046.184-.248.17 0 0-.216-.032-.204-.213l.017-.264v-.005l.072-1.1-.117.024c-.028.578-.059 1.062-.089 1.148 0 0-.015.368-.488.483 0 0-6.19 0-6.397-.007 0 0-.8-.06-.81-.787 0 0-.04-.923-.076-1.904a12 12 0 0 1-.526-.534s-.084-.083.034-.092h.324s.069.009.076.067c.01.06 0 .084 0 .084s.025.032.076.033c-.03-.869-.053-1.682-.038-1.838 0 0 .045-.054.146.032l.218.158s.069.06.01.213c0 0-.168.731-.128 1.416.023.003.052 0 .083-.022 0 0-.043-.134.035-.152 0 0 .38-.013.44-.02 0 0 .093.032.003.133 0 0-.369.396-.496.516q.022.09.053.171s.281 1.206 1.179 1.317c0 0 .77.107 2.066.152-.764-.604-3.024-2.76-2.789-7H2.4c-.048-.003-.07-.175.027-.181m3.136 7.185.304.008.01-.88c-.443-.023-.792.305-.314.872m.546.012q.565.008 1.222-.005c-.169-.186-.614-.628-1.206-.83zm-.075-8.007s-.271.02-.277.23c-.004.176.167.241.27.264z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.482 12.468a50 50 0 0 1-1.01-.017v.899c.256-.004.548-.009.923-.013.11 0 .114.05.114.144v.063c0 .095-.005.145-.114.145l-.923-.014v1.284c0 .103-.028.13-.114.13h-.191c-.114 0-.143-.018-.143-.13V12.2c0-.112.05-.117.143-.117h1.316c.074 0 .114.013.114.117v.126c0 .095-.004.144-.114.144zM20.298 12.252l-.905 1.664v1.04c0 .104-.031.13-.114.13h-.191c-.119 0-.143-.018-.143-.13v-.999l-.924-1.705a.2.2 0 0 1-.027-.1c0-.049.036-.07.096-.07h.243c.1 0 .118.026.155.094l.68 1.292.705-1.292c.036-.067.055-.095.155-.095h.197c.06 0 .1.022.1.072.005.028-.004.058-.027.1M22.292 15.086h-1.275c-.114 0-.142-.018-.142-.13v-2.758c0-.112.05-.117.142-.117h.192c.1 0 .114.041.114.117v2.515l.969-.013c.11 0 .11.05.11.145v.125c0 .104-.037.117-.11.117zM24.957 15.086h-.31c-.1 0-.142-.018-.216-.1l-1.078-1.143v1.111c0 .104-.027.13-.114.13h-.192c-.114 0-.142-.017-.142-.13v-2.757c0-.113.05-.117.142-.117h.192c.1 0 .114.04.114.117v1.242l1.078-1.26c.073-.086.1-.1.193-.1h.234c.1 0 .105.068.055.126l-1.174 1.381 1.252 1.336c.087.09.06.162-.031.162zM27.134 15.086H25.73c-.114 0-.142-.018-.142-.13v-2.758c0-.112.05-.117.142-.117h1.404c.072 0 .113.014.113.117v.126c0 .095-.004.144-.113.144a61 61 0 0 1-1.098-.017v.903c.27-.008.585-.013.996-.017.11 0 .114.05.114.144v.063c0 .095-.005.145-.114.145a47 47 0 0 1-.996-.018v1.048a62 62 0 0 1 1.098-.017c.109 0 .113.05.113.144v.126c0 .104-.041.117-.113.117zM29.487 14.811c-.151.303-.557.316-.869.316-.256 0-.508-.022-.659-.035-.118-.01-.16-.018-.16-.087v-.157c0-.104.004-.15.091-.15.252 0 .192.037.796.037.325 0 .443-.032.443-.382 0-.333-.005-.405-.21-.49-.187-.08-.379-.163-.567-.249-.448-.201-.522-.274-.522-.801 0-.216 0-.45.174-.603.183-.167.448-.162.828-.162.206 0 .316.008.513.022.114.008.16.017.16.086v.157c0 .104-.005.15-.091.15-.179 0-.134-.022-.495-.022-.082 0-.242-.005-.325-.005-.325 0-.33.134-.33.423 0 .212.014.262.207.35.123.055.252.109.375.163.584.257.717.32.717.819 0 .17 0 .467-.078.62zM32.299 15.086h-.31c-.1 0-.143-.018-.216-.1l-1.079-1.143v1.111c0 .104-.027.13-.113.13h-.192c-.114 0-.142-.017-.142-.13v-2.757c0-.113.049-.117.142-.117h.192c.1 0 .113.04.113.117v1.242l1.079-1.26c.073-.086.1-.1.192-.1h.233c.1 0 .105.068.056.126l-1.175 1.381 1.253 1.336c.087.09.06.162-.032.162zM35.001 14.78c-.228.298-.526.4-.918.4-.393 0-.69-.103-.92-.4-.26-.345-.296-.769-.296-1.192s.035-.85.296-1.197c.238-.316.548-.396.92-.396.371 0 .677.08.918.396.26.346.297.774.297 1.197s-.038.845-.297 1.193m-.283-2.042c-.118-.265-.37-.35-.635-.35s-.517.085-.635.35c-.096.216-.11.612-.11.85s.014.63.11.845c.114.266.365.35.635.35s.517-.086.635-.35c.096-.216.11-.607.11-.845s-.014-.634-.11-.85M38.802 15.086h-.192c-.082 0-.11-.027-.114-.13l-.138-2.308c-.037.117-.091.328-.138.454a67 67 0 0 1-.534 1.493c-.036.1-.07.136-.174.136h-.118c-.107 0-.134-.037-.17-.136-.14-.37-.356-.957-.544-1.493-.046-.126-.095-.337-.128-.454l-.147 2.308c-.005.104-.027.13-.114.13h-.192c-.114 0-.151-.018-.142-.13l.234-2.758c.009-.112.049-.117.14-.117h.257c.1 0 .122.022.15.095.188.49.494 1.36.714 1.989.219-.631.526-1.498.709-1.989.026-.071.055-.095.155-.095h.256c.092 0 .13.005.138.117l.233 2.758c.008.112-.023.13-.141.13M42.445 15.086h-.192c-.082 0-.11-.027-.114-.13l-.138-2.308c-.035.117-.09.328-.137.454-.188.536-.393 1.124-.535 1.493-.036.1-.07.136-.174.136h-.118c-.105 0-.132-.037-.17-.136-.14-.37-.356-.957-.543-1.493-.045-.126-.096-.337-.128-.454l-.146 2.308c-.005.104-.027.13-.114.13h-.192c-.114 0-.151-.018-.142-.13l.232-2.758c.009-.112.05-.117.142-.117h.256c.1 0 .123.022.152.095.187.49.492 1.36.713 1.989.22-.631.525-1.498.708-1.989.027-.071.056-.095.156-.095h.256c.092 0 .127.005.136.117l.234 2.758c.01.112-.022.13-.142.13M45.5 14.344c-.037.238-.13.441-.257.575-.156.162-.407.234-.846.234-.44 0-.686-.072-.84-.234a1.07 1.07 0 0 1-.257-.575c-.046-.279-.055-.508-.055-1.147v-.999c0-.112.05-.117.142-.117h.192c.1 0 .114.041.114.117v1.394c0 .527.022.707.105.886.09.203.26.28.599.28s.512-.077.603-.28c.083-.18.105-.36.105-.886v-1.394c0-.112.056-.117.147-.117h.192c.1 0 .11.041.11.117v.999c0 .64-.01.868-.056 1.147zM48.443 15.086h-.151c-.078 0-.134.004-.188-.067-.37-.523-.978-1.463-1.423-2.142v2.079c0 .104-.031.13-.114.13h-.191c-.12 0-.143-.018-.143-.13v-2.758c0-.112.045-.117.143-.117h.127c.096 0 .123.005.165.063.374.536.938 1.405 1.44 2.15v-2.096c0-.112.046-.117.137-.117h.196c.1 0 .114.041.114.117v2.758c0 .104-.031.13-.114.13zM50.844 15.086h-1.403c-.114 0-.143-.018-.143-.13v-2.758c0-.112.05-.117.143-.117h1.403c.074 0 .114.014.114.117v.126c0 .095-.004.144-.114.144a61 61 0 0 1-1.098-.017v.903c.27-.008.586-.013.996-.017.11 0 .114.05.114.144v.063c0 .095-.004.145-.114.145-.41-.005-.726-.01-.996-.018v1.048a62 62 0 0 1 1.098-.017c.11 0 .114.05.114.144v.126c0 .104-.042.117-.114.117zM21.049 1.125c-.024.261-.03 1.276-.014 2.515l.003-.563c.018 1.476.068 3.27.151 4.5 0 0-2.876-3.275-4.074-5.047 0 0-.036-.503-.042-.873-.006-.373-.213-.482-.213-.482S16.258.778 16 .632c0 0-.004 4.865-.004 7.32 0 1.975 1.272 2.08 1.272 2.08l-.074-5.721c1.479 2.019 4.066 6.092 5.062 5.89 0 0 .121-5.22.172-6.85s-1.38-2.224-1.38-2.224zM42.551 6.535s-.3 1.358.204 2.438c.442-.54.532-2.079 1.296-1.925s.317 2.865 1.862 3.211c.272-3.414-.968-6.639-3.362-3.725zM27.48 8.245a6.1 6.1 0 0 0 .395 1.955c.846-.606.301-2.376.7-2.82.398-.446.804-.347.894-.296.132-.325-.084-.949-.349-1.1a.93.93 0 0 0-1.046.081c-.367.284-.725.603-.937.673 0 0 .311.424.343 1.507M36.5 1.182c.008-.24-.272-.352-.272-.352s-.4-.178-.84-.324c0 0-.023 6.026-.1 8.193-.064 1.739 1.016 1.423 1.016 1.423l.105-5.338s.077-3.227.09-3.602M31.06 10.124s.282.226.565.092c.326-.18.925-.571 1.448-1.269.227 1.16 1.023 1.124 1.023 1.124l.105-5.606s.06-1.865.065-2.242c.004-.432-.237-.546-.237-.546l-.942-.539s.012 2.095-.023 4.692c-1.116-.055-2.942.48-2.985 1.718-.057 1.595.578 2.241.98 2.577zm1.968-2.451c-.278.639-.61 1.12-1.508 1.703-.36-.366-.423-1.525-.187-1.933.235-.405 1.17-.775 1.682-.676.08.024.064.768.015.904zM48.787 10.232c.273-.237.7-.663 1.112-1.292.19 1.293 1.055 1.052 1.055 1.052l.016-6.11s.026-1.244.03-1.62c.005-.378-.237-.546-.237-.546s-.063-.08-.848-.296c0 0 .026 2.042-.001 4.438-1.055.212-3.242 1.025-3.291 2.403-.038 1.042.96 1.61 1.504 1.994.004.003.347.22.662-.02zm1.115-3.437c.054.02.03.746-.021.924-.29.729-.59 1.038-1.225 1.49-.41-.25-.98-.682-.745-1.088.234-.408 1.576-1.298 1.99-1.326M26.575 8.386c.016-.51-.1-1.103-.466-1.839-.367-.736-1.269-.87-1.269-.87 0 1.853 1.324 1.743 1.071 3.264 0 0-.228.216-.95.175-1.005-.057-.735-1.889-.536-2.52-2.238.56-1.823 4.226 1.39 3.604.523-.456.739-1.108.761-1.814zM37.09 8.953s-.134.479.1.652c.767.612 2.74.454 3.32-1.404.049 1.061.366 2.26 1.701 2.096.08-.011-.204-1.178-.518-2.305s-.472-1.58-.63-1.97c-.157-.387-.599-.371-.6-.371-2.018.24-2.9 1.823-3.374 3.3zm.666.226c.029-.778 1.291-2.251 2.598-2.409-.763.632-1.182 2.565-2.598 2.41"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H51V15H0z",
    transform: "translate(0 .448)"
  }))));
}
var ForwardRef$4W = /*#__PURE__*/forwardRef(NordlandIcon);

function OstfoldIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 74.153 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__OstfoldIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.843 13.663v.554h-1.726v-2.771h.61v2.196zM27.052 13.663v.554h-1.726v-2.771h.61v2.196zM19.502 14.155l-.03.062h-.607l-.738-1.08a3 3 0 0 1-.408.087h-.061v.988h-.61v-2.766h.61v1.264c.551-.06.969-.525.97-1.08v-.184h.62v.21c.017.486-.213.947-.611 1.226zM19.647 12.829a1.471 1.471 0 1 1 1.471 1.432 1.42 1.42 0 0 1-1.47-1.432m2.32 0a.852.852 0 1 0-1.704.053.852.852 0 0 0 1.703-.053M28.075 11.986v.623h1.094v.47h-1.094v.593h1.155v.54h-1.756v-2.766h1.756v.54zM32.274 14.155l-.03.062h-.607l-.738-1.08q-.2.058-.408.087h-.062v.988h-.61v-2.766h.61v1.264c.552-.06.97-.525.971-1.08v-.184h.62v.21c.017.486-.213.947-.611 1.226zM34.835 11.999h-.879v2.196h-.61v-2.196h-.879v-.553h2.398zM35.278 11.446h.61v2.77h-.61zM41.427 11.999h-.878v2.196h-.61v-2.196h-.88v-.553h2.399zM44.159 14.155l-.031.062h-.637l-.825-.927h-.224v.927h-.585v-2.771h1.002c.663 0 1.098.368 1.098.913a.88.88 0 0 1-.655.878zm-1.704-1.317h.351c.365 0 .575-.19.575-.44s-.21-.439-.575-.439h-.351zM46.337 13.681H45.02l-.233.536h-.62l1.274-2.771h.475l1.282 2.77h-.624zm-.215-.496-.44-1.006-.438 1.006zM48.116 11.986v.65h1.04v.478h-1.04v1.094h-.62v-2.762h1.757v.54zM49.794 11.446h.61v2.77h-.61zM53.544 14.155l-.03.062h-.606l-.738-1.08q-.2.058-.409.087H51.7v.988h-.61v-2.766h.61v1.264c.551-.06.97-.525.97-1.08v-.184h.62v.21c.017.486-.213.947-.61 1.226zM56.448 14.155l-.031.062h-.606l-.738-1.08a3 3 0 0 1-.409.087H54.6v.988h-.607v-2.766h.607v1.264h.022a1.09 1.09 0 0 0 .966-1.08v-.184h.623v.21c.018.487-.214.949-.614 1.226zM38.849 11.446v.048l-1.054 2.723h-.466l-1.045-2.723v-.048h.584l.698 2.024.708-2.024zM25.682 4.669a4.42 4.42 0 0 1-4.564 4.444 4.8 4.8 0 0 1-2.428-.64l-.8.957-.786-.65.76-.936a4.35 4.35 0 0 1-1.318-3.193 4.42 4.42 0 0 1 4.568-4.44 4.83 4.83 0 0 1 2.539.698l.75-.909.796.65-.747.878a4.36 4.36 0 0 1 1.23 3.14m-6.628 1.756 3.448-4.12a2.56 2.56 0 0 0-1.384-.394 2.635 2.635 0 0 0-2.635 2.749 2.86 2.86 0 0 0 .571 1.774zm4.7-1.756a2.86 2.86 0 0 0-.501-1.656l-3.426 4.084c.39.218.831.328 1.278.321a2.635 2.635 0 0 0 2.649-2.75M44.392 2.042v2.025h3.228v1.51h-3.228v3.387h-1.889V.378h5.486v1.669zM74.09 4.669c0 2.565-1.757 4.295-4.308 4.295h-3.62V.378h3.62c2.613 0 4.308 1.757 4.308 4.29m-1.888 0c0-1.568-.984-2.636-2.456-2.636h-1.655v5.27h1.655c1.498-.008 2.456-1.075 2.456-2.634M48.898 4.669A4.39 4.39 0 0 1 53.46.229c2.613 0 4.563 1.888 4.563 4.44a4.563 4.563 0 0 1-9.126 0m7.203 0a2.635 2.635 0 1 0-5.27 0 2.635 2.635 0 0 0 5.27 0M64.968 7.247v1.717H59.61V.378h1.888v6.869zM27.157 8.534l-.307-1.757.04-.022a6.94 6.94 0 0 0 2.99.773c1.033 0 1.73-.347 1.73-.936 0-.439-.307-.685-.794-.878l-2.205-.615a2.3 2.3 0 0 1-1.669-2.284c0-1.642 1.362-2.587 3.351-2.587a6.1 6.1 0 0 1 2.675.563v1.708a5.07 5.07 0 0 0-2.613-.69c-1.129 0-1.524.44-1.524.997 0 .282.1.686.764.905l2.134.641c1.103.317 1.757 1.09 1.757 2.196 0 1.63-1.471 2.579-3.513 2.579a8.2 8.2 0 0 1-2.816-.593M41.286 2.095H38.44v6.869h-1.893V2.095h-2.846V.378h7.585zM.063.378v6.535c0 3.074 2.451 6.887 6.36 9.087 3.904-2.196 6.35-6 6.355-9.087L12.8.378zm6.369 12.736c-1.186 0-2.148-.224-2.148-.303s.962-.307 2.148-.307 2.143.224 2.143.307c0 .084-.97.303-2.152.303zm0-1.642c-1.823 0-3.294-.33-3.294-.47s1.471-.474 3.294-.474 3.294.316 3.294.456-1.485.47-3.303.47zm0-1.91c-2.236 0-4.045-.41-4.045-.58 0-.172 1.81-.58 4.045-.58s4.04.408 4.04.58c0 .17-1.818.562-4.05.562zm4.172-2.487c-1.39.183-2.792.268-4.194.255a31.5 31.5 0 0 1-4.2-.255c-.034 0-.056 0-.047-.052a12.1 12.1 0 0 1 4.185-5.477.1.1 0 0 1 .119 0 12.1 12.1 0 0 1 4.185 5.477c.027.03 0 .048-.048.052"
  })));
}
var ForwardRef$4V = /*#__PURE__*/forwardRef(OstfoldIcon);

function ReisNordlandIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 641 329",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__ReisNordlandIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.6 162.1c-.7 3.4-2.2 6.5-3.9 9.1-5.2 8-12.9 12.5-22 14.3-15.9 3.2-31.4 1.9-46.7-4.7 1.1-6.4 2.1-12.5 3.1-18 8.4 1.8 16.6 4.1 24.9 5.2 4.3.6 9-.3 13.3-1.4 4.2-1 6.6-4.3 6.8-8.8.2-4.4-1.8-7.5-5.8-9-6.2-2.4-12.5-4.4-18.7-6.8-3.6-1.3-7.2-2.6-10.6-4.4-9.9-5.1-15.2-13.1-15.1-24.4 0-11.4 5.3-19.8 15-25.3 11.2-6.3 23.3-6.3 35.5-4.5 6.6 1 13.1 3.1 20.1 4.8-3.2 6.2-8.7 17.1-8.7 17.1-2.2-1.3-12.5-3.7-17.8-3.9-4.1 0-8.3.2-12.3 1.1s-6.7 3.7-7 8.1c-.3 4.1 1.7 7.2 5.3 8.8 4.8 2.1 10 3.6 14.9 5.6 6.1 2.5 12.4 4.7 18.2 7.9 3.8 2.1 6.7 5 8.8 8.6s2.9 7.4 3.1 11.4.2 5.1-.3 9.1ZM96.3 197.7c-11.3-.6-21.5-3.5-30.6-9.5-8-5.2-16-10.3-26.2-10v-38.1c9.4-.3 18 1.5 26.3 5.3 3 1.4 6 2.9 8.7 4.9 16.6 12.1 33.1 12.1 49.8.1 11.2-8 24.1-10.8 37.8-10.4 13.1.4 24.8 4.7 35.4 12.1 7.5 5.3 15.7 7.6 24.9 7.1 7.7-.4 14.1-3.6 20.2-7.8 10.3-7 21.5-11.2 34.1-11.4.8 0 1.6 0 2.7.1v38c-10.8-.4-18.9 5.9-27.8 10.9-22.1 12.3-44.1 11.7-66-.9-5.9-3.4-11.8-7.1-18.2-8.9-10.4-2.9-20.4-.4-29.4 5.8-10 7-20.9 11.7-33.3 12.3-2.7.1-5.3.1-8.4.2zM279.3 105.9v3.7h-241v-4.4c19.7-14.8 43.1-32 63-46.6.4-.3.9-.4 1.5-.7 19 13.7 37.9 27.5 57.1 41.4C179 85.4 198 71.7 217.3 57.7M435 140.4h-18.4c-1.8 9.4 2.6 18.8 11.4 23.6 11.2 6.1 23.2 5 35.1 2.5 3.6-.7 7-2.1 10.9-3.4 1.1 6 2.2 12 3.4 18.9-6.7 1.5-13.1 3.7-19.5 4.1-9.4.6-19.1 1-28.3-.6-23.8-4.2-38.1-21-39.1-45.5-.3-7.8.5-16.1 2.7-23.6 8.5-29.1 43.4-43.1 70.1-28.4 13.1 7.2 19.1 19.1 20.5 33.5.6 6.1 0 12.3 0 19H435m-6.9-37.2c-7 4.6-10.6 11.2-11.6 19.6H458c.8-18.1-12.6-27.1-29.9-19.6M326.9 115V84.2h19.3c1 5.3 2 10.8 3.2 17.2 10.8-18.9 26.4-23.3 46.4-16.3-4.8 6.6-9.2 12.7-13.7 18.6-.7.9-2.1 1.5-3.3 1.6-17.6 1.2-26.4 9.8-26.9 27.4-.4 15.5-.1 31-.2 46.5v4.7h-24.9V115zM523.9 122v62h-25.8v-4.8c0-16.5.1-33 0-49.4 0-3.9 1-7 3.3-10 4.6-5.9 8.8-12 13.7-18.6h-14.2c-1.2-7-2.4-13.7-3.5-20.6H524v41.5ZM104.4 230.9h1.1v35H39.2v-35.1M133.1 266.4h-6.6v-35.2h66v35.2zM213.2 253v-21.8h66.2V266h-66.2zM459.8 263.9c-9.9 6.5-21 2.6-23.7-8.4-1-4-1-8.6-.2-12.7 1.9-9.9 10.8-14.7 20.4-11.7 1.1.3 2.1.8 3.7 1.4v-16.9h8.8v50.3c-3.6 2.1-6.1-.2-8.9-2m-7.2-27c-5.3.3-7.7 3.8-8.4 8.4-.8 5-.8 10.4 4.1 13.5 2 1.3 5.7 1.4 7.9.5 1.8-.8 3.1-3.9 3.6-6.2.6-2.9 0-6 .2-9 .5-5-2-7-7.4-7.3ZM606.5 217.1c0 15.7 0 31.3-.2 47.5-.7.9-1.1 1.3-1.4 1.7-1.1 0-2.1 0-3.7-.2-.8-.5-1.1-.8-1.4-1-.9-.3-2-1.2-2.5-.9-11.9 6.8-23.5.7-24.5-13-.9-11.9 4.1-19.8 13.6-20.8 3.5-.4 7.1.7 11.2 1.2v-16.4c2.5 0 4.5 0 6.9.3 1 .7 1.5 1.1 2 1.5m-8.7 32.4v-4c.5-4.5-.6-7.9-5.8-8.5-4.7-.6-8.7 2.1-9.8 7.1-.5 2.1-.5 4.3-.4 6.4.4 6.3 3.8 10.1 8.8 10 5.1-.1 7.2-3 7.2-11M398.4 260.3c-7.2 7.5-17.9 8.9-25.5 3.6-6.8-4.9-9-15.9-4.8-24.4 3.8-7.7 13.1-11.2 22.3-8.5 9.7 2.9 14.4 14.3 10.3 25-.5 1.4-1.4 2.6-2.3 4.3m-6.8-18.1c-1.6-3.5-4.3-5.9-8.2-5-2.4.5-6 2.4-6.4 4.3-1 4.5-1 9.4-.2 13.9.6 3.5 3.9 5.1 7.7 5s6.6-2.2 7.2-5.7c.6-3.8.1-7.8-.1-12.4ZM336 243.5v22.6h-8.8V231h6.5c.5 1 1.1 2.3 1.7 3.8 1.4-.9 2.7-1.9 4.2-2.7 10.2-5.6 19.5-.2 19.5 11.3v21.5c0 .3-.1.6-.3 1.2h-8.6v-21c0-3.5-.3-6.8-4.5-7.8-3.6-.9-8.1 1.9-9.6 6.3h-.1ZM524.6 263v1.3c0 .6-.2.4-.3.6-.3.4-.6.6-.8.8s-.7.4-1 .4c-.8 0-1.7 0-2.7-.2s-.4-.1-.6-.2c-.8-.5-1.2-.8-1.6-.9-.7-.3-1.6-1-2.2-.8-3.6.9-7.2 2.6-10.8 2.7-5.5.2-9.5-3.4-10.4-8.2-1-5.5 1.5-10.5 7.1-12.2 4.1-1.3 8.5-1.5 12.9-2.1s1.3-.8 1.3-1.5c0-6.2-4.2-7.3-14.6-3.5s-1.6 0-1.9-.8-1-2-1.5-2.9-.1-1.7.6-2.1c9.2-5.4 19.1-4.5 24 2.3s1.7 3.6 1.6 5.6c-.3 6.8-.5 13.1-.5 19.3s.9 1.5 1.4 2.3m-11.8-3.5c3.2-1.8 3.5-4.3 2.8-7.4s-.8-1.3-1.6-1.2c-2 0-3.8 0-5.7.5-3.2.6-5.8 2.2-5.1 5.9.6 3.5 3.6 3.9 6.6 3.5.8-.1 1.6-.5 3-1.1ZM535 231.1c3-.3 6.2-1.3 6.3 3.6 2.8-1.3 5.3-3 8-3.8 9.1-2.7 15.7 1.9 16 11.3.3 7.3 0 14.6-.3 22.5-.6.9-.8 1.2-1.1 1.5-1.7 0-3.4.2-5.7-.1l-1.5-1c0-6.8-.2-13.6-.3-20.4 0-5.1-2.1-7.5-6-7.4-4.7.2-8.1 3.5-8.2 8 0 6.3 0 12.6-.4 19.5l-1 1.5c-1.7 0-3.4.2-5.7-.1l-1.5-1c0-10.7-.2-21.3 0-32.6.6-.8.8-1.1 1.1-1.3l.2-.2ZM486.9 249v17.2h-8.7v-50.7h8.7zM417.9 265.4c-2.8.7-5.6.9-8.6 1.2v-35.5h6.5c.4 1.6.8 3.2 1.4 5.2 4.2-5.5 9.1-7.6 16-4.9-.4 2.1-.8 4.3-1.2 6.7-2-.1-3.8-.4-5.6-.4-5 .2-8.2 3.6-8.4 9.3-.2 6 0 12-.2 18.4zM605.1 266.4c.2-.5.5-.9 1.1-1.3 0 .4-.5 1-1.1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.7 216.8c-.6-.1-1.1-.5-1.7-1.2.6.1 1.2.5 1.7 1.2M534.7 231c0 .3 0 .5-.6.9 0-.2 0-.6.6-.9M533.8 265.3c.4-.2.7 0 1.1.5-.3.1-.7 0-1.1-.5M541.3 266.1c0-.3 0-.6.5-1 0 .3 0 .7-.5 1M556.8 265.3c.3-.2.7 0 1.1.5-.3.1-.7 0-1.1-.5M564.3 266.2c0-.3 0-.6.6-1.1 0 .3 0 .7-.6 1.1M599.9 265.4c.3-.1.6 0 1 .6-.2 0-.6 0-1-.6"
  })));
}
var ForwardRef$4U = /*#__PURE__*/forwardRef(ReisNordlandIcon);

function RuterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 55.9 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__RuterIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55.5 6.6.4-1.8H53l.5-2.8h-1.9l-.5 2.7h-2.9l.5-2.7h-1.9l-.5 2.7h-2.9L43 6.6h2.9l-.5 2.7h-2.9l-.4 1.8H45l-.5 2.7h1.9l.5-2.7h2.9l-.5 2.7h1.9l.5-2.7h2.9l.4-1.8h-2.9l.5-2.7zm-5.3 2.7h-2.9l.5-2.7h2.9zM6.3 13.9 4 9.2H2.3v4.7H0V2h4.7c2.4 0 3.9 1.7 3.9 3.6 0 1.7-1 2.7-2.2 3.1L9 13.9zM4.5 4.1H2.3v3.1h2.2c1 0 1.7-.7 1.7-1.6s-.7-1.5-1.7-1.5m11.1 9.8v-.8c-.6.6-1.4.9-2.2.9-.9 0-1.6-.3-2.1-.8-.7-.7-.9-1.5-.9-2.5V5.2h2.2v5.3c0 1.2.8 1.6 1.4 1.6.7 0 1.5-.4 1.5-1.6V5.2h2.2v8.7zm7.3 0c-1.8 0-2.5-1.3-2.5-2.5V6.8h-.9V5.2h.9V2.9h2.2v2.3h1.5v1.7h-1.5v4.4c0 .5.2.8.8.8h.8v1.8zm4.8-3.7c0 1.1.7 1.9 1.9 1.9 1 0 1.4-.3 2-.8l1.3 1.3c-.9.9-1.8 1.4-3.3 1.4-2.1 0-4-.9-4-4.5 0-2.8 1.5-4.4 3.8-4.4 2.4 0 3.8 1.8 3.8 4.2v1zm3.1-2.4c-.2-.5-.7-.9-1.5-.9-.7 0-1.2.4-1.5.9-.1.3-.2.6-.2.9H31c0-.3-.1-.6-.2-.9m9.9-2.4c-.4-.2-.8-.3-1.4-.3-.9 0-1.8.4-2.2.9v-.8H35v8.7h2.2V8.7c0-1.1.7-1.5 1.4-1.6.8-.1 1.2.3 1.2.3z"
  }));
}
var ForwardRef$4T = /*#__PURE__*/forwardRef(RuterIcon);

function RuterNoTextIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Layer 1",
    viewBox: "0 0 692.83 600",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__RuterNoTextIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    d: "m674.89 230.75 17.94-92.3H547.44L574.35 0h-96.91l-26.9 138.45H305.13L332 0h-96.9l-26.91 138.45H62.79l-17.93 92.3h145.38l-26.9 138.44H17.94L0 461.55h145.39L118.47 600h96.93l26.93-138.45h145.38L360.78 600h97l26.91-138.45H630l18-92.3H502.58l27-138.5zM405.67 369.19H260.25l26.93-138.44h145.37z"
  }));
}
var ForwardRef$4S = /*#__PURE__*/forwardRef(RuterNoTextIcon);

function SJIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SJIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15.77 5.558c-.254 1.729-1.822 1.805-2.872 1.749-.074-.004-.152-.017-.214-.025-.098-.011-.106-.12-.02-.156.212-.09 1.263-.645 1.378-1.82.023-.242.022-.58.022-.645V.125H15.8v4.598c0 .536-.015.737-.03.835m-1.92 4.833c.072-1.772 1.562-2.993 3.868-2.993h6.198c.085 0 .107.053.059.141-.226.419-.952 1.624-1.852 1.624h-3.608c-1.993 0-3.328 1.06-3.71 2.148-.069.198-.265.67-.549.67-.388 0-.45-.51-.406-1.59m-3.7 0c.044 1.08-.018 1.59-.406 1.59-.284 0-.48-.472-.549-.67-.382-1.089-1.717-2.148-3.71-2.148H1.877C.978 9.163.251 7.958.025 7.54c-.048-.088-.027-.14.059-.14h6.198c2.306 0 3.797 1.22 3.868 2.992M12 14.062c1.298 0 2.6-.667 3.146-1.396.676-.903.798-2.543 3.824-2.543h2.671c.086 0 .107.054.059.142-.226.418-1.056 1.754-1.956 1.754H18.5c-.672 0-.828.448-1.15.975C16.4 14.784 14.524 16 12 16c-2.525 0-4.4-1.216-5.351-3.006-.322-.527-.48-.975-1.15-.975H4.257c-.9 0-1.731-1.336-1.957-1.754-.047-.088-.026-.142.06-.142h2.67c3.026 0 3.148 1.64 3.824 2.543.545.729 1.849 1.396 3.146 1.396M12.62.348v1.106s-.9-.424-1.579-.424-1.19.234-1.19.72c0 .605 1.154.89 1.578 1.033s1.678.682 1.678 1.776c0 1.16-.654 2.225-2.924 2.225-1.195 0-1.878-.36-1.878-.36V5.328c.395.144 1.282.361 1.74.361.777 0 1.246-.163 1.246-.653 0-.621-1.219-.95-1.69-1.139-.47-.188-1.55-.635-1.55-1.904C8.05.579 9.35 0 10.902 0c1.052 0 1.717.348 1.717.348",
    clipRule: "evenodd",
    transform: "translate(-161 -134) translate(161 134)"
  }));
}
var ForwardRef$4R = /*#__PURE__*/forwardRef(SJIcon);

function SJNordIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 72 12",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SJNordIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.546 5.946c0 1.66-1.124 1.806-2.429 1.806h-2.81V4.14h2.81c1.305 0 2.429.145 2.429 1.806m-2.437-3.078h-4.254v6.155h4.254c2.239 0 3.891-.5 3.891-3.078s-1.652-3.079-3.89-3.079zM59.222 8.831a264 264 0 0 0-2.05-1.903l.105-.019c.998-.214 1.671-.815 1.671-1.947V4.91c0-1.457-1.11-2.04-2.615-2.04h-5.389v6.154h1.45V7.003h3.102l1.78 1.65c.324.295.65.368 1.127.368h.817s.196.004.002-.188zM52.394 4.14h3.74c.794 0 1.325.08 1.325.795s-.53.795-1.326.795h-3.739zM44.372 6.314l-2.351 2.35c-.24.247-.425.443-.51.813l-.117.466-.118-.466c-.084-.37-.27-.566-.509-.812l-2.35-2.351c-.248-.24-.442-.424-.812-.508l-.465-.118.465-.118c.37-.084.564-.268.811-.507l2.98-2.98 2.976 2.977c.247.239.442.426.814.51l.465.118-.465.118c-.37.084-.565.269-.812.508zM42.116.724l-.723 1.358V0l-5.689 5.688 5.688 5.688 5.689-5.688zM30.57 2.868v4.394s-4.481-3.73-4.805-4.025c-.325-.296-.65-.37-1.128-.37h-.76v6.156h1.45V4.629s4.48 3.729 4.804 4.025c.325.295.65.369 1.128.369h.76V2.868zM18.325 0h-.275v11.375h.275zM8.216 4.626c-.133.922-.95.965-1.497.933q-.061-.004-.112-.012c-.052-.007-.055-.065-.011-.083.11-.047.658-.346.719-.972.012-.13.012-.311.012-.344V1.724h.905v2.457c-.003.288-.011.393-.016.446M7.213 7.21c.038-.948.815-1.6 2.015-1.6h3.227c.043 0 .056.03.031.074-.117.225-.496.868-.965.868H9.644c-1.038 0-1.734.567-1.932 1.148-.035.106-.137.358-.285.358-.202 0-.233-.272-.213-.85m-1.925.002c-.038-.948-.815-1.6-2.015-1.6H.043c-.043 0-.055.03-.03.074.116.225.496.868.964.868h1.879c1.037 0 1.733.567 1.931 1.148.036.106.137.358.285.358.205 0 .236-.272.215-.85m.964 1.965c-.675 0-1.354-.356-1.637-.746-.353-.483-.417-1.358-1.992-1.358H1.23c-.043 0-.055.03-.03.075.116.222.549.937 1.018.937h.648c.35 0 .432.24.6.521.494.957 1.47 1.606 2.785 1.606s2.291-.65 2.788-1.606c.168-.28.25-.52.6-.52h.648c.47 0 .902-.716 1.019-.938q.037-.074-.031-.075H9.883c-1.575 0-1.64.878-1.992 1.358-.285.388-.964.746-1.64.746m.323-7.33v.59s-.47-.226-.823-.226c-.355 0-.622.125-.622.385 0 .323.6.475.821.553.221.077.875.365.875.948 0 .621-.342 1.19-1.523 1.19-.623 0-.98-.194-.98-.194v-.586c.206.077.669.194.906.194.405 0 .65-.089.65-.35 0-.331-.635-.51-.879-.608-.246-.1-.809-.34-.809-1.018 0-.757.677-1.065 1.486-1.065.55 0 .895.186.895.186"
  })));
}
var ForwardRef$4Q = /*#__PURE__*/forwardRef(SJNordIcon);

function SkyssIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 47 12",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SkyssIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.248 5.745 3.817 3.667h-2.137L9.763 6.33h-.3v3.082H7.828V0h1.635v5.145H9.8l3.015-2.295h2.175zM4.31 5.49c1.763.293 2.505.848 2.498 1.965 0 1.373-1.275 2.033-3.533 2.033-.72 0-1.567-.053-2.535-.143L.59 9.33l.195-1.102.023-.128.127.015c.975.105 1.628.143 2.28.143.653 0 1.148-.083 1.463-.218.307-.142.427-.307.435-.54 0-.255-.173-.465-.69-.652-.203-.075-.42-.12-1.005-.225-.833-.158-1.425-.278-1.718-.39C.935 5.963.5 5.37.508 4.605c0-1.237 1.095-1.807 3.075-1.807.697 0 1.642.045 2.52.15l.135.015-.18 1.192-.128-.015a17 17 0 0 0-2.032-.127c-.653 0-1.118.052-1.388.165-.27.12-.345.232-.352.45 0 .292.232.502.757.622.165.038.615.113 1.395.24m18.495 3.69V2.85h-1.703v5.318c-.442.06-.952.105-1.305.105-1.972 0-2.182-.593-2.182-1.673V2.85h-1.702v3.765c0 2.332 1.387 2.895 3.69 2.895.442 0 1.102-.075 1.484-.172v.034c-.007.374-.015.799-.285 1.068-.255.255-.81.3-1.68.3-.787 0-1.71-.098-2.49-.217l-.202 1.215c1.05.18 1.92.262 2.775.262 2.933 0 3.6-.848 3.6-2.82m4.913-3.69c1.762.292 2.512.848 2.497 1.965 0 1.373-1.275 2.033-3.54 2.025-.727 0-1.567-.053-2.535-.143l-.15-.014.195-1.103.023-.128.127.015c.975.106 1.627.143 2.28.143s1.148-.082 1.463-.217c.307-.143.427-.308.434-.54 0-.256-.172-.458-.69-.653-.202-.075-.42-.12-1.005-.225-.832-.158-1.425-.277-1.717-.39-.758-.27-1.2-.862-1.193-1.627.008-1.23 1.096-1.808 3.076-1.808.697 0 1.65.052 2.527.157l.142.015-.18 1.193-.127-.015a17 17 0 0 0-2.032-.127c-.653 0-1.118.052-1.388.165-.27.12-.345.232-.352.45 0 .284.232.502.757.622.158.037.608.112 1.388.24m9.555 1.965c.007-1.117-.736-1.673-2.498-1.965a37 37 0 0 1-1.387-.24c-.526-.12-.758-.338-.758-.622.008-.218.082-.33.352-.45.27-.113.736-.165 1.388-.165.638 0 1.268.037 2.033.127l.127.015.18-1.193-.142-.015a23 23 0 0 0-2.528-.157c-1.98 0-3.075.578-3.075 1.808-.008.765.427 1.357 1.192 1.627.293.113.886.232 1.718.39.585.105.803.15 1.005.225.517.195.69.397.69.652-.008.233-.127.398-.435.54-.315.136-.81.218-1.462.218-.653 0-1.306-.037-2.28-.143l-.128-.014-.023.127-.195 1.102.15.016c.968.09 1.808.142 2.536.142 2.265.008 3.54-.652 3.54-2.025m9.557-4.668h.043c.066-.001.127-.002.127.13 0 1.39-.04 2.78-.38 4.13-.3 1.21-.99 2.17-1.85 2.98q-.166.152-.336.297l-.154.133c-.08.08-.16.15-.24.22-.05.05-.09.08-.17.02-.93-.77-1.78-1.61-2.3-2.77-.36-.81-.49-1.67-.58-2.55-.08-.8-.1-1.6-.1-2.4 0-.16.04-.19.18-.19h5.76m-3.58.25h-2.11l2.79 3.7h-2.48c.08.37.19.74.35 1.09s.36.67.58.97c.44.61.97 1.14 1.56 1.63q.068-.05.127-.106l.063-.054.124-.108a6 6 0 0 0 .346-.312h-.01c.35-.33.66-.69.93-1.07a.2.2 0 0 1-.09.02h-3.05l1.6-2.11q.106-.142.215-.28t.215-.28c.37-.48.77-1.013 1.17-1.545.4-.533.8-1.065 1.17-1.545h-3.5",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4P = /*#__PURE__*/forwardRef(SkyssIcon);

function SkyssNoTextIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 6.1 8",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SkyssNoTextIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.97 0H.18C.04 0 0 .03 0 .19c0 .8.02 1.6.1 2.4.09.88.22 1.74.58 2.55.52 1.16 1.37 2 2.3 2.77.08.06.12.03.17-.02.08-.07.16-.14.24-.22.16-.14.33-.28.49-.43.86-.81 1.55-1.77 1.85-2.98.34-1.35.38-2.74.38-4.13 0-.14-.07-.13-.14-.13M.25.25h5.61c-.74.96-1.6 2.13-2.34 3.09-.14.19-.29.37-.43.56l-1.6 2.11c-.22-.3-.42-.62-.58-.97S.64 4.32.56 3.95h2.48m.67 3.11c-.15.15-.31.28-.47.42-.06.05-.12.11-.19.16-.59-.49-1.12-1.02-1.56-1.63h3.05a.2.2 0 0 0 .09-.02c-.27.38-.58.74-.93 1.07z"
  }));
}
var ForwardRef$4O = /*#__PURE__*/forwardRef(SkyssNoTextIcon);

function SnelandiaIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 63 12",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SnelandiaIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.309 8.093q-.332.318-.769.464-.259.088-.534.12c-.201.023-.399.007-.598-.005a1.2 1.2 0 0 1-.24-.04c-.136-.037-.276-.07-.404-.13a2.6 2.6 0 0 1-.414-.241c-.36-.252-.604-.595-.782-.991a3.4 3.4 0 0 1-.24-.846 4.5 4.5 0 0 1-.02-1.148c.022-.229.074-.45.138-.667.123-.427.323-.818.618-1.157a2.26 2.26 0 0 1 1.34-.758c.238-.044.477-.058.716-.026.382.048.738.165 1.04.412.007.006.016.01.036.02.001-.032.006-.056.006-.08V.789c0-.085 0-.17.012-.253.023-.167.123-.247.292-.267.215-.024.428-.06.643-.088.118-.015.239-.024.359-.037.062-.008.125-.023.187-.028a.5.5 0 0 1 .143.012.17.17 0 0 1 .136.144q.013.08.012.162v7.7330000000000005q.001.068-.011.135a.26.26 0 0 1-.242.23 1 1 0 0 1-.119.008h-.911q-.037 0-.073-.003c-.18-.018-.26-.096-.279-.273l-.018-.17-.008-.013q-.008.008-.017.014zm-.11-2.449q0-.56.002-1.12c0-.057-.017-.094-.063-.128a1.7 1.7 0 0 0-.43-.226c-.206-.071-.408-.112-.63-.073a.96.96 0 0 0-.437.195 1.23 1.23 0 0 0-.389.588c-.068.205-.115.42-.117.64-.001.29-.004.58.075.863.047.17.108.334.213.479.149.207.35.344.603.38.418.056.776-.1 1.104-.342a.16.16 0 0 0 .069-.145c-.003-.37 0-.74 0-1.11M14.775 8.673h-.419c-.035 0-.07-.018-.105-.02-.114-.013-.228-.016-.34-.036-.163-.027-.323-.063-.485-.098-.172-.038-.345-.07-.514-.12a5 5 0 0 1-.455-.156c-.133-.052-.175-.126-.17-.266.002-.109.04-.209.076-.308l.269-.794a1 1 0 0 1 .033-.081c.067-.151.177-.16.308-.14.035.005.07.02.105.031.113.04.222.088.336.121.148.044.299.077.45.113.13.032.26.071.395.086.295.035.593.07.89.035.26-.03.506-.118.7-.305a.7.7 0 0 0-.047-1.055c-.143-.12-.31-.2-.476-.28-.11-.055-.227-.094-.338-.146-.187-.086-.37-.178-.557-.265q-.34-.158-.68-.313a2.64 2.64 0 0 1-.991-.75 2.2 2.2 0 0 1-.4-.81c-.066-.247-.058-.498-.055-.749 0-.169.042-.332.099-.486a2.2 2.2 0 0 1 .727-.985q.33-.255.714-.414c.243-.1.496-.168.756-.216.442-.082.883-.06 1.323-.014q.565.059 1.105.237c.172.06.34.129.51.195a.6.6 0 0 1 .105.055c.128.078.169.172.126.314-.032.104-.075.205-.114.308l-.166.414q-.054.131-.104.263c-.09.24-.234.24-.427.181-.13-.039-.254-.098-.382-.142-.154-.053-.306-.107-.463-.146-.132-.033-.27-.05-.406-.07a3 3 0 0 0-.297-.033 1.9 1.9 0 0 0-.594.07.68.68 0 0 0-.505.625c-.007.192.085.335.225.449.108.086.229.161.35.226.148.079.303.14.454.21q.262.121.524.244c.278.126.561.244.835.379q.447.217.78.587c.238.268.395.578.459.93.041.22.065.445.04.669-.02.18-.042.36-.089.533-.207.766-.694 1.3-1.412 1.635a3.2 3.2 0 0 1-.862.258c-.28.044-.56.059-.843.033zM38.056 3.278c.007-.077.009-.154.024-.23.027-.137.113-.21.24-.227.034-.005.068-.003.1-.003h.96q.06-.002.118.007c.113.023.185.09.208.201q.013.07.013.144.002 1.97 0 3.94c0 .196.075.253.25.243.195-.012.274.077.268.261-.008.213 0 .428-.002.642 0 .174-.08.263-.253.28-.063.006-.127.001-.191.001-.238-.003-.475-.003-.711-.009a1.3 1.3 0 0 1-.38-.065.8.8 0 0 1-.46-.358l-.063-.107q-.025.021-.047.04a2 2 0 0 1-.496.35c-.345.175-.71.293-1.102.303a2.7 2.7 0 0 1-.718-.08c-.671-.17-1.139-.581-1.455-1.18a2.9 2.9 0 0 1-.253-.696c-.11-.473-.13-.95-.08-1.434q.037-.365.146-.716c.192-.634.548-1.154 1.105-1.53.269-.182.567-.3.885-.358.245-.046.495-.064.742-.02.132.023.267.038.39.104.059.03.126.041.185.068.202.092.373.225.519.39q.02.029.04.059l.022-.018zm-.127 2.365V4.585c0-.053-.015-.089-.058-.12a2 2 0 0 0-.525-.277 1.06 1.06 0 0 0-.628-.04c-.38.099-.603.365-.737.71q-.099.25-.118.522c-.022.341-.023.68.063 1.015.045.172.112.335.212.484a.9.9 0 0 0 .598.382c.111.02.232.01.344-.006.31-.049.566-.201.791-.411a.17.17 0 0 0 .06-.142c-.003-.352 0-.704 0-1.058zM60.93 7.99a2 2 0 0 1-.484.366 2.9 2.9 0 0 1-.805.296 2.2 2.2 0 0 1-.624.03 2.5 2.5 0 0 1-.644-.128c-.555-.196-.96-.568-1.237-1.082q-.223-.421-.306-.887a4 4 0 0 1-.064-.598c-.009-.222-.001-.446.005-.668.003-.08.021-.16.038-.238.035-.166.06-.337.11-.499.104-.33.255-.637.464-.915a2.5 2.5 0 0 1 1.1-.848c.163-.065.333-.104.508-.131a2.08 2.08 0 0 1 1.352.216q.216.12.383.303l.089.096c.004-.055.004-.09.009-.123.01-.063.016-.128.036-.189.038-.118.131-.17.25-.172.231-.004.462-.001.694-.001l.392.001c.104.002.197.038.24.136.028.064.034.14.042.209.006.07.002.145.002.216v3.64l.001.164q.006.15.155.167c.046.005.092.002.137.003.15.005.22.068.22.216q.008.353 0 .704-.004.238-.244.26c-.075.008-.152.003-.228.003q-.33 0-.658-.006a1.4 1.4 0 0 1-.408-.068.8.8 0 0 1-.473-.382zm-.237-2.344V4.588c0-.04.003-.075-.038-.104-.177-.12-.352-.245-.565-.302a4 4 0 0 0-.216-.05.88.88 0 0 0-.52.057c-.36.148-.551.435-.653.789-.127.438-.12.882-.034 1.328q.046.248.167.471c.118.213.29.367.52.443a1 1 0 0 0 .52.029q.445-.102.768-.419a.17.17 0 0 0 .052-.128V5.646zM26.835 6.146a.9.9 0 0 0 .085.303q.252.514.79.724c.191.074.388.116.595.115q.29-.001.58-.038a4.2 4.2 0 0 0 .955-.26.5.5 0 0 1 .15-.028.18.18 0 0 1 .182.136q.044.144.082.293.067.253.13.507a.35.35 0 0 1 .006.195c-.035.104-.113.16-.206.201a5 5 0 0 1-.383.147 5 5 0 0 1-.722.167c-.333.06-.666.079-1.001.085-.19.003-.382-.018-.574-.033a2.8 2.8 0 0 1-.714-.162c-.706-.252-1.225-.71-1.547-1.387a3 3 0 0 1-.204-.613 3.8 3.8 0 0 1-.07-1.18q.01-.129.022-.258c.005-.035.02-.068.028-.103.041-.22.099-.435.195-.636.153-.327.351-.624.62-.872a2.9 2.9 0 0 1 1.439-.718c.338-.064.679-.1 1.021-.057.169.02.34.047.502.095a2.3 2.3 0 0 1 1.496 1.286c.108.231.174.476.213.731.054.342.07.684.064 1.029q0 .06-.01.116c-.017.094-.069.16-.163.188a.6.6 0 0 1-.158.028q-1.114.003-2.227.005h-1.1800000000000002zm1.984-1.132c.021-.17-.03-.323-.091-.473-.117-.288-.352-.44-.647-.509a1 1 0 0 0-.388.01c-.454.084-.793.543-.833.972zM42.714 3.304l.087-.06a3.04 3.04 0 0 1 1.256-.538c.278-.05.56-.068.843-.036.246.028.482.087.701.203.299.158.513.393.653.695q.121.262.168.55.062.395.065.793V8.11q0 .098-.015.196a.25.25 0 0 1-.218.222 1 1 0 0 1-.144.012l-1.03-.001c-.078 0-.157.004-.229-.038-.091-.054-.146-.13-.146-.239l-.002-.19V5.108c0-.166-.015-.33-.067-.491a.5.5 0 0 0-.345-.337.95.95 0 0 0-.406-.029q-.28.028-.54.138c-.17.072-.33.16-.478.273a.11.11 0 0 0-.046.1c.003.115 0 .23 0 .343V8.16a1 1 0 0 1-.01.143c-.025.14-.098.21-.24.23a1 1 0 0 1-.11.007l-1.057-.001c-.07 0-.145.006-.21-.035a.3.3 0 0 1-.157-.272q-.002-2.445-.003-4.889 0-.154.02-.305c.015-.11.085-.177.195-.2a1 1 0 0 1 .135-.017q.1-.003.201-.002h.74c.073 0 .141.012.213.035.099.032.128.098.146.193.015.082.023.165.035.262zM20.383 3.298c.035-.021.064-.036.088-.054a3.06 3.06 0 0 1 2.242-.555c.294.048.565.153.798.34q.32.261.458.65c.04.112.08.223.108.338q.076.335.076.678v3.478a1 1 0 0 1-.017.16c-.024.11-.097.171-.205.19a1 1 0 0 1-.154.013h-1.085c-.21-.014-.31-.114-.315-.32q-.003-.218-.002-.434c0-.9.005-1.8 0-2.701 0-.145-.02-.293-.053-.435a.49.49 0 0 0-.371-.374q-.023-.007-.044-.01a1.64 1.64 0 0 0-.96.157c-.133.063-.256.148-.384.222-.054.03-.067.074-.067.135q.004 1.653.001 3.307 0 .1-.012.197c-.017.149-.102.235-.251.25-.072.007-.146.004-.218.004l-.939.003c-.077 0-.157 0-.227-.045-.083-.053-.137-.125-.135-.227V3.124c.006-.21.098-.293.306-.306.094-.006.189-.003.283-.003q.352 0 .703.003.09.001.178.022c.111.027.168.106.177.222.004.074.017.147.026.236zM33.184 4.29v3.868a1 1 0 0 1-.014.162.26.26 0 0 1-.22.211 1 1 0 0 1-.127.01h-1.067c-.124 0-.234-.023-.31-.135a.24.24 0 0 1-.043-.13c-.006-.063-.004-.127-.004-.189V.777c0-.079 0-.158.012-.235.023-.166.114-.247.281-.269q.256-.032.512-.068.35-.046.699-.089c.171-.02.273.067.284.238q.002.04 0 .081v3.859zM54.121 5.664V3.188q0-.06.003-.118a.25.25 0 0 1 .207-.234.7.7 0 0 1 .154-.02q.539-.003 1.076 0c.07 0 .14.02.208.038.072.02.107.078.12.146a1 1 0 0 1 .017.179v4.98a.7.7 0 0 1-.015.152.256.256 0 0 1-.227.216 1 1 0 0 1-.146.01l-1.012-.001a.7.7 0 0 1-.205-.023c-.113-.035-.166-.125-.178-.24-.005-.04-.003-.079-.003-.118V5.661zM54.958.355c.364.01.64.12.839.393.074.103.11.22.137.346a.8.8 0 0 1-.01.371.84.84 0 0 1-.429.544 1 1 0 0 1-.709.11.95.95 0 0 1-.662-.481.77.77 0 0 1-.087-.387c0-.438.293-.763.696-.863.084-.02.172-.025.225-.033M33.493 11.613h-.315c.088-.084.06-.18.049-.272l-.058-.477a3 3 0 0 0-.023-.168c-.002-.01-.014-.018-.029-.04l-.38.968c-.057-.01-.083-.055-.105-.094a3 3 0 0 1-.122-.25c-.055-.124-.104-.251-.157-.377-.035-.084-.073-.166-.117-.266-.015.047-.03.082-.037.117q-.032.187-.053.377-.019.18-.021.36c0 .038.021.075.035.12h-.267q.01-.022.023-.043a.4.4 0 0 0 .067-.194c.023-.161.053-.321.066-.483.007-.095.033-.187.04-.282.008-.091.005-.106-.034-.182l.036-.001h.254l.366.846.018.001.329-.844h.281c-.038.086-.026.172-.013.26q.023.181.042.364l.017.104c.014.103.023.206.04.307a.22.22 0 0 0 .07.119l-.005.03zM16.356 10.426h.283l.375.865.34-.862h.284c-.057.094-.019.189-.01.284q.011.134.03.267c.022.16.043.32.074.48.009.049.041.096.065.147h-.32c.033-.047.066-.093.055-.157q-.03-.192-.056-.385c-.01-.083-.012-.168-.02-.251-.004-.053-.015-.106-.024-.168-.05.056-.062.124-.087.185-.025.065-.056.13-.083.195a5 5 0 0 0-.078.205l-.073.198-.08.198c-.095-.058-.138-.147-.176-.237l-.185-.434-.105-.254c-.01-.02-.022-.039-.042-.075-.012.077-.022.133-.032.189q-.038.249-.071.5c-.006.05-.003.1-.005.152-.001.052 0 .101.05.14h-.273q.015-.024.027-.05c.018-.043.044-.087.052-.132a30 30 0 0 0 .088-.61c.012-.087.027-.171.03-.257.002-.041-.018-.083-.03-.13zM42.828 11.603h-.289c.095-.11.105-.236.116-.36.01-.133.042-.263.055-.396.007-.089.024-.175.036-.263.008-.05.015-.102-.029-.143v-.029H43l.372.863c.077-.153.118-.3.175-.438l.167-.423h.306c-.067.057-.05.122-.044.184.012.12.021.243.038.363.01.084.032.167.046.252q.014.1.026.202a.28.28 0 0 0 .098.186h-.342v-.021c.05-.032.06-.082.053-.134-.013-.103-.033-.206-.047-.309-.006-.043 0-.09-.006-.134q-.021-.177-.047-.355c-.025-.002-.032.014-.043.04-.074.19-.154.38-.228.57q-.053.141-.104.281c-.009.026-.02.049-.035.08-.085-.051-.124-.131-.16-.21a10 10 0 0 1-.155-.35q-.07-.172-.138-.345a.2.2 0 0 0-.053-.077q-.017.13-.035.257c-.01.06-.025.117-.035.175q-.01.07-.017.14-.014.14-.021.277c-.004.043.02.074.057.095zM31.798 11.613q-.144 0-.288.002-.001-.016-.005-.034a.11.11 0 0 0 .037-.098q-.016-.105-.027-.211c-.01-.09-.014-.18-.023-.27a5 5 0 0 0-.052-.351c-.15.316-.263.646-.4.976a.32.32 0 0 1-.148-.166c-.08-.173-.146-.35-.218-.525q-.05-.124-.103-.246c-.006-.015-.017-.028-.043-.04l-.036.274c-.015.11-.035.222-.047.333a2 2 0 0 0-.014.258c0 .029.026.057.043.092H30.2c.085-.13.094-.273.108-.418.018-.192.059-.381.086-.573.016-.107.013-.107-.03-.189h.287l.375.866.338-.863h.29c-.042.06-.036.126-.027.19q.032.224.063.448c.015.116.02.236.04.35.011.056.05.106.074.16q-.002.017-.006.034zM29.47 11.64a.655.655 0 0 1-.634-.456c-.111-.406.2-.726.505-.776a.74.74 0 0 1 .441.045c.23.106.358.289.364.54.006.249-.11.439-.329.561a.65.65 0 0 1-.346.088zm.02-.143a.415.415 0 0 0 .44-.367.64.64 0 0 0-.026-.274.447.447 0 0 0-.682-.256c-.166.107-.213.271-.196.456.021.23.21.46.463.44zM40.891 10.414h.253v.03c-.057.044-.058.107-.058.172v1.042c-.03-.01-.053-.013-.073-.024a.6.6 0 0 1-.201-.18q-.273-.344-.548-.687c-.018-.022-.037-.045-.072-.063v.6739999999999999c0 .083.004.163.08.223h-.306c.096-.078.09-.178.09-.278q-.003-.356-.002-.713c0-.063-.01-.12-.058-.165v-.028h.22l.687.847q.016.014.034.027l.003-.031q0-.336.003-.673a.18.18 0 0 0-.055-.137l.003-.033zM14.93 10.427c.093 0 .178-.022.242.006.061.029.099.108.146.165l.5.62.072.081c.006-.042.013-.063.013-.085v-.57c0-.08 0-.156-.093-.22h.315c-.102.086-.08.194-.08.296v.939c-.028-.007-.048-.008-.066-.016a.5.5 0 0 1-.186-.155l-.536-.674-.092-.115c-.005.023-.011.038-.011.053v.659c0 .072.018.136.097.193h-.33c.099-.075.097-.175.096-.276a50 50 0 0 1 0-.668c0-.086-.012-.165-.084-.234zm.966.866-.009-.018-.003.021.01.012.002-.014zM60.658 10.414c.19.004.383-.006.572.015.222.024.399.134.472.356.13.4-.104.745-.5.8-.191.025-.38.012-.587.02.093-.093.088-.196.09-.297q.005-.334 0-.668c0-.07-.005-.139-.047-.198zm.236 1.036c.275.038.485-.04.581-.21a.55.55 0 0 0-.065-.565c-.096-.107-.349-.163-.516-.103zM35.81 11.293q.002-.334 0-.668c0-.072-.01-.143-.1-.196h.3c-.023.053-.051.102-.062.155-.01.052-.005.108-.005.162v.9159999999999999a.3.3 0 0 1-.172-.094c-.052-.051-.097-.107-.143-.163l-.502-.63c-.015-.02-.033-.038-.064-.073v.098q.002.303 0 .605c0 .075.008.143.075.207q-.074.002-.147.003h-.143c-.001-.01-.004-.02-.003-.021.064-.053.078-.123.076-.203-.004-.228-.001-.458-.001-.686q0-.16-.07-.28h.237l.694.868.025.021zM14.585 11.293v-.668a.24.24 0 0 0-.061-.175c-.008-.01-.008-.026-.01-.04l.019.005c.084.005.166.008.265.012-.086.08-.084.175-.084.272q0 .468-.002.935l-.047.005a.42.42 0 0 1-.196-.156l-.543-.68c-.025-.03-.05-.058-.084-.102-.003.034-.006.053-.006.072v.64c0 .064.014.12.06.165l-.004.03h-.28s-.005-.014-.003-.016c.072-.063.084-.145.082-.237q-.003-.346 0-.695c0-.086-.006-.168-.096-.234h.267l.692.864.023.02.008-.02zM42.206 10.414h.274c-.014.02-.024.031-.032.046-.015.035-.038.07-.041.108-.008.068-.006.137-.006.207v.776c0 .032-.003.065-.005.108a.45.45 0 0 1-.213-.14q-.091-.113-.18-.228-.23-.285-.46-.572l-.017-.017s-.008.01-.011.017l-.005.693c0 .073.03.132.1.188h-.32c.091-.083.09-.19.09-.296v-.667c0-.077-.013-.15-.075-.204l.006-.018q.092 0 .181-.003c.041-.003.063.015.089.047.211.27.427.538.64.807l.032.04c.005-.031.01-.05.01-.067q.004-.292.005-.587c0-.074 0-.152-.065-.208v-.03zM49.234 10.43a.26.26 0 0 0-.058.176v.55c0 .036.008.072.014.107.035.182.17.264.356.214.168-.045.22-.11.22-.278q0-.289-.004-.577c0-.07.003-.145-.073-.207h.334c-.089.101-.064.22-.066.333v.65c0 .07-.005.143.084.199h-.27l-.012-.085c-.009.002-.018 0-.024.006a.5.5 0 0 1-.393.104.4.4 0 0 1-.306-.182c-.044-.066-.047-.141-.047-.215-.003-.177 0-.355 0-.533 0-.021.003-.043 0-.064a6 6 0 0 0-.042-.217c.036-.008.086 0 .135-.002q.073 0 .146.003-.002.01.005.015zM46.73 11.594c-.08.001-.158.007-.237.003-.077-.005-.135-.05-.18-.11l-.38-.495c.028-.01.044-.018.06-.024.05-.018.104-.03.15-.056a.2.2 0 0 0 .098-.239q-.044-.143-.207-.14c-.04 0-.078.008-.124.012q-.006.045-.007.083v.777c0 .07 0 .139.085.195h-.346a.36.36 0 0 0 .067-.218q0-.375-.003-.75c0-.073.006-.15-.058-.214.19 0 .372-.025.553.012.125.026.213.098.237.23.02.115-.025.207-.114.278-.045.036-.102.06-.16.095.163.194.297.417.529.552q.014.008.033.013v-.003zM19.587 11.61h-.312c.085-.075.075-.167.075-.257v-.74c0-.068-.01-.131-.08-.187.037-.002.055-.005.075-.005.128 0 .256-.003.382.003q.091.003.175.032c.19.071.247.293.108.441-.053.058-.126.097-.196.148.155.195.303.408.522.555l-.005.004.003.006c-.07-.003-.14 0-.208-.01a.2.2 0 0 1-.12-.055 3 3 0 0 1-.42-.551c.058-.02.114-.033.164-.058.114-.054.154-.136.13-.256a.15.15 0 0 0-.087-.108.3.3 0 0 0-.244-.013v.879c0 .053.006.101.044.142q-.001.015-.004.029zM34.405 11.524a.54.54 0 0 1-.486.097c-.135-.033-.252-.16-.259-.298-.007-.152-.004-.306-.006-.46q.001-.124-.004-.244c-.003-.066-.01-.131-.072-.19h.318c-.058.07-.056.15-.056.232q.002.244 0 .489 0 .04.002.081c.01.112.047.212.16.25.121.039.241.031.342-.063a.24.24 0 0 0 .079-.176c0-.218.003-.434-.002-.65 0-.054-.024-.107-.038-.165h.306c-.085.082-.08.182-.08.28 0 .237.003.476 0 .713 0 .07.02.127.073.184-.087.017-.166.003-.252.01l-.01-.082v-.015l-.019.007zM57.938 10.992h.242v.582c-.189.04-.371.072-.56.048-.242-.031-.44-.127-.559-.352-.033-.063-.038-.128-.045-.195-.032-.302.122-.513.374-.622a.95.95 0 0 1 .551-.05c.032.006.064.006.102.01v.208a.5.5 0 0 0-.216-.094.6.6 0 0 0-.33.036.45.45 0 0 0-.274.404c-.015.226.108.368.281.483.03.02.075.021.113.032a.7.7 0 0 0 .37-.024c0-.11.003-.226-.002-.339-.001-.031-.03-.063-.045-.095l.001-.032zM17.909 11.582a.5.5 0 0 0 .137-.227c.057-.16.13-.316.194-.475q.06-.15.111-.303c.023-.068.022-.076.002-.15h.27l.078.195q.135.332.273.665c.018.044.03.09.055.131.036.064.08.124.124.19-.045.016-.102.007-.156.008-.058.002-.114 0-.184 0 .012-.02.016-.036.025-.042.03-.018.03-.044.02-.071l-.052-.132-.076-.203h-.46q-.054.159-.11.31c-.017.043-.013.076.027.102l.01.026h-.3l.013-.026zm.757-.56-.16-.413h-.02c-.05.137-.12.267-.156.414zM44.725 10.415h.258q.08.193.157.384c.088.216.175.432.27.647.024.056.071.1.114.16h-.35v-.021c.048-.025.048-.06.032-.105l-.105-.288c-.011-.03-.034-.038-.064-.038h-.4l-.098.254q-.006.016-.01.035a.15.15 0 0 0 .034.16h-.325c.079-.044.117-.118.149-.194q.163-.395.316-.791c.022-.058.066-.12.013-.183l.007-.017zm.307.603-.167-.421h-.019l-.16.421h.346M61.73 11.583c.074-.038.106-.106.135-.177q.144-.357.289-.716.027-.06.05-.122c.015-.047.049-.097-.03-.145.106-.017.191-.008.286-.01.051.134.1.267.155.4.073.178.155.353.227.533.036.092.077.18.161.242a1 1 0 0 1-.345.01c.054-.063.056-.063.027-.139l-.12-.299h-.454l-.115.33c-.019.05.016.076.044.117h-.305s-.001-.015-.003-.022zm.434-.566h.341l-.166-.433c-.079.15-.123.289-.175.433M56.241 10.414h.24q.05.114.098.226l.181.446c.046.112.087.225.139.334.03.063.077.118.121.183-.048.006-.108 0-.166.001h-.187c.08-.07.04-.139.02-.204-.023-.07-.058-.136-.082-.205q-.013-.046-.058-.044-.183 0-.365-.003c-.038 0-.058.02-.069.047q-.043.118-.079.24c-.026.09-.024.09.029.162h-.306c.041-.053.087-.099.114-.151.038-.073.063-.152.093-.229l.122-.31q.075-.181.146-.366c.01-.03.003-.065.005-.097l.004-.035zm.295.606c-.058-.146-.105-.283-.172-.422-.11.213-.155.338-.153.422zM26.847 11.358c.13.106.264.154.415.137a.4.4 0 0 0 .137-.04c.102-.058.117-.176.03-.253-.056-.048-.124-.083-.19-.12-.085-.05-.18-.087-.257-.147-.175-.138-.141-.387.061-.48a.757.757 0 0 1 .56-.014v.192l-.078-.047a.4.4 0 0 0-.298-.048c-.065.013-.12.045-.137.116-.015.07.012.125.07.163q.065.043.134.077c.066.033.133.06.196.095q.065.034.12.082c.112.097.13.225.052.349a.45.45 0 0 1-.197.166c-.18.085-.361.056-.54.01-.02-.005-.043-.036-.05-.058-.013-.052-.018-.106-.03-.18zM58.815 10.415h.648v.197a.65.65 0 0 0-.391-.053v.323h.27l.02.015v.18c-.09-.07-.188-.048-.29-.05v.422c.277.027.304.024.552-.079l-.071.228h-.766c.073-.057.081-.127.08-.2v-.792a.25.25 0 0 0-.057-.176q.007-.006.005-.015M36.155 11.612c.08-.074.079-.157.079-.242v-.75c0-.066 0-.132-.076-.196h.674v.204c-.12-.095-.253-.074-.391-.065v.328h.286v.168l-.288-.032v.423c.089.044.186.015.28.023.098.007.178-.04.268-.092l-.065.23h-.767M25.961 10.418q.287 0 .574.003c.015 0 .029 0 .056-.003l.005.19q-.02 0-.037.004c-.114-.067-.236-.064-.362-.041v.32h.292v.162l-.29-.018v.414c.187.043.37.05.553-.071a.8.8 0 0 1-.079.234h-.747c.01-.017.023-.029.027-.043.014-.037.037-.077.037-.116q.003-.423.001-.849a.24.24 0 0 0-.047-.152c-.006-.01-.003-.026-.004-.038l.02.004zM52.226 10.414h.282q-.013.035-.028.057-.17.256-.343.51a.3.3 0 0 0-.064.208c.004.054.001.108 0 .161a.4.4 0 0 0 .077.247h-.342c.077-.07.067-.157.074-.244a.68.68 0 0 0-.144-.503c-.064-.08-.108-.173-.165-.258-.035-.051-.077-.098-.117-.148q0-.015.002-.032c.266-.013.234.021.331.177.054.083.104.17.157.252l.057.083c.079-.119.158-.228.226-.343a.13.13 0 0 0-.01-.15l.006-.017zM22.715 10.426h.18c.056 0 .09.031.117.075q.113.186.228.369.017.03.044.063l.2-.296c.065-.095.065-.113.016-.213h.29c-.016.027-.025.049-.039.067q-.177.267-.359.532a.2.2 0 0 0-.043.134q.006.105 0 .207c-.004.088.008.168.096.243-.128.005-.234.005-.35.005q.017-.026.024-.047c.016-.045.037-.09.039-.136a4 4 0 0 0-.01-.325.15.15 0 0 0-.027-.074q-.142-.23-.29-.46c-.031-.049-.074-.091-.12-.146zM39.37 10.615c-.115-.09-.244-.062-.377-.06v.327h.273l.018.015v.178c-.093-.063-.19-.046-.295-.046v.4c-.002.06 0 .12.073.17h-.343c.073-.064.072-.147.072-.232q-.002-.37 0-.739c0-.07-.005-.137-.053-.195.054-.025.365-.034.65-.02v.194l-.019.01zM50.704 11.583c.049-.032.061-.08.063-.133q.004-.184.004-.368l.003-.45c0-.067-.003-.134-.047-.188v-.029h.633v.206c-.12-.093-.255-.071-.395-.064v.325h.27l.02.015v.17c-.093-.055-.188-.038-.287-.038q-.006.032-.007.062v.341c0 .057.007.115.063.151v.021h-.321v-.021zM21.996 11.58c.046-.044.054-.101.054-.159 0-.27.003-.542 0-.812 0-.06-.028-.12-.044-.186h.64v.192c-.172-.065-.274-.076-.408-.04v.315c.104.007.203 0 .303.003v.178c-.096-.053-.193-.03-.295-.036q-.005.037-.006.07v.262c0 .085.001.166.079.243h-.315l-.005-.033zM12.923 10.89v.175q-.072-.017-.145-.026c-.049-.004-.096 0-.158 0v.38c0 .066.003.128.062.18-.056.025-.106.013-.157.014-.05.003-.101 0-.165 0 .079-.098.074-.208.074-.317v-.622a.43.43 0 0 0-.065-.251h.648v.19c-.058-.018-.122-.045-.187-.054-.064-.01-.133.001-.203.004v.327h.297zM52.899 10.445c-.049.05-.049.117-.049.179 0 .258.006.516.01.775l.002.044a.66.66 0 0 0 .545-.082c.006.094-.062.157-.076.239h-.75c.082-.064.08-.14.08-.22v-.776c0-.065-.008-.125-.057-.174q.003-.01.007-.016h.288q0 .015.002.031zM24.132 11.458c.191.018.376.054.555-.085-.008.04-.009.062-.017.083-.004.017-.016.03-.022.047-.045.116-.045.115-.168.113q-.236-.001-.473.002c-.044 0-.088 0-.137-.008.068-.063.071-.142.071-.219q.005-.352.003-.704c0-.089-.003-.18-.068-.258h.318c-.062.077-.062.16-.062.245v.785zM59.746 10.414h.307c-.083.077-.074.161-.074.245v.7939999999999999c.195 0 .39.05.568-.08l-.09.228h-.754a.2.2 0 0 0 .083-.168q.003-.184.004-.37l.002-.433c0-.067-.003-.133-.047-.19v-.028zM47.01 10.983c.083-.107.159-.204.233-.302l.064-.087c.055-.08.055-.088.013-.18h.307c-.07.104-.143.187-.208.273l-.204.261.059.08.248.324c.073.097.15.187.265.243a.55.55 0 0 1-.285-.015.2.2 0 0 1-.087-.062l-.403-.532zM25.82 11.62c-.081-.008-.162-.007-.241-.023a.23.23 0 0 1-.12-.074c-.133-.165-.259-.333-.387-.5-.017-.023-.008-.041.01-.064q.124-.156.243-.316c.021-.028.033-.063.052-.093.024-.041.027-.079-.023-.12h.316c-.015.023-.024.041-.036.056q-.168.215-.338.426c-.032.038-.03.06.001.097q.123.146.233.3c.082.112.166.223.297.286l-.01.026zM55.238 10.415h.288c-.01.06-.061.092-.093.138-.03.045-.067.086-.1.128l-.107.136q-.048.063-.102.131.067.09.133.174.072.093.143.188c.079.11.162.216.302.278-.187.05-.327.003-.429-.132l-.351-.47q.03-.045.062-.087.118-.156.234-.312c.037-.05.052-.1.011-.155q.009-.007.006-.017zM48.155 10.97l.273-.35c.048-.061.08-.126.03-.206h.298c-.024.072-.08.119-.121.177q-.069.09-.14.178l-.139.174q.018.03.038.058.147.19.292.381c.061.08.13.151.224.194l.026.007-.012.017c-.084 0-.17.012-.25-.005-.062-.012-.112-.063-.154-.12l-.354-.47q-.006-.017-.01-.035M20.67 10.953l.282-.364c.041-.053.026-.106.003-.16h.31l-.415.525.041.056.26.339c.074.1.15.196.282.246-.18.054-.332.005-.429-.127q-.175-.23-.352-.46zM53.79 10.968q.135-.179.275-.356l.024-.038c.041-.07.041-.074 0-.159h.288l.006.018c-.131.17-.262.337-.397.514q.048.069.1.136l.236.308a.6.6 0 0 0 .24.197c-.18.05-.324.004-.424-.129l-.344-.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.127 10.967.275-.358c.043-.055.053-.114.02-.18h.306l-.416.529c.128.164.25.329.38.487.051.061.121.106.18.156a.355.355 0 0 1-.403-.13l-.34-.447q0-.03-.002-.057M58.652 11.601h-.355c.086-.062.084-.14.084-.217q0-.388-.003-.775c0-.067 0-.133-.076-.19h.33c-.076.099-.062.212-.062.326v.65c0 .072 0 .144.08.208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.156 10.447c-.05.044-.055.104-.057.163v.43200000000000005c0 .133-.006.265 0 .398.003.055.03.11.046.169h-.32c.089-.068.076-.153.076-.236v-.74c0-.073.005-.145-.051-.213h.304l.003.027zM46.73 11.594v.003c.054-.046.07-.106.07-.176v-.808a.26.26 0 0 0-.053-.168q0-.015.002-.031h.29v.03a.17.17 0 0 0-.044.124v.964l.066.05v.02l-.333-.008zM48.14 11.006q0 .215-.005.432c0 .06.02.11.08.159h-.341c.06-.086.062-.086.062-.207v-.812a.2.2 0 0 0-.041-.134v-.032h.272q.01.012.02.021a.18.18 0 0 0-.055.138l.003.394v.04zM25.08 11.612h-.302c.096-.1.078-.222.08-.339.003-.188 0-.379 0-.568a.46.46 0 0 0-.07-.278h.32c-.072.068-.063.147-.063.224v.767c0 .058.003.115.044.162l-.01.033zM54.648 11.583c.04-.027.056-.07.06-.115q.008-.062.008-.125.003-.355.003-.71c0-.067-.003-.133-.047-.188v-.028h.309c-.09.07-.076.152-.076.23v.75c0 .074.006.144.087.21h-.344v-.024M13.145 10.427h.315c-.066.07-.061.147-.061.224v.758c0 .07 0 .14.076.2h-.34c.084-.086.075-.195.077-.3 0-.202.003-.404 0-.605 0-.095.001-.192-.069-.277zM20.376 11.604a.27.27 0 0 0 .068-.2v-.783c0-.064-.003-.127-.058-.174l.005-.027h.306c-.07.089-.069.178-.067.269l.006.261v.057l-.006.413c0 .068.013.13.085.192l-.174.001h-.163l.004-.006-.005-.004zM39.515 10.414h.3q-.015.025-.023.046c-.012.046-.033.093-.033.138-.003.273 0 .548 0 .822 0 .065.017.124.083.183-.121.004-.225.001-.337.001a.47.47 0 0 0 .07-.291c-.004-.203 0-.404 0-.606 0-.052.003-.103-.007-.153-.007-.045-.03-.087-.051-.14zM53.762 11.006c0 .15-.002.3.005.45.001.047.028.09.047.144-.096.009-.201.004-.321 0 .077-.07.08-.148.08-.23v-.73c0-.075.005-.15-.073-.226a4 4 0 0 1 .31 0v.03c-.044.05-.051.113-.051.175l.003.331zM38.005 10.943c0 .114-.074.187-.191.187-.113 0-.216-.094-.21-.192a.21.21 0 0 1 .214-.187c.117.003.187.072.186.192zM45.17 10.21l-.474.142-.008-.012.378-.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 11.042v-.092l.026.017q0 .029.003.057l-.031.018zM20.636 11.006v-.058q.017.001.034.005l-.018.054zM53.762 11.006v-.056l.027.017.003.037h-.03zM61.73 11.583l.004.023h-.028l.024-.024zM25.08 11.612l.009-.034.025.028-.033.006zM51.459 10.414q0 .015-.002.031l-.03-.03zM21.996 11.58l.005.033q-.014-.002-.027-.006zM19.587 11.61q.001-.015.005-.028l.025.027h-.03zM56.24 10.414l-.004.034q-.014-.015-.025-.031.015 0 .03-.002zM20.39 10.42l-.004.027-.023-.027zM28.156 10.447q-.002-.014-.003-.027h.027l-.023.027zM40.942 11.257l-.003.034-.036-.03.039-.003zM48.14 11.006v-.04q.008-.002.015.004.006.018.01.036zM42.716 10.415v.029l-.018-.021.018-.006zM14.584 11.293l-.007.02-.023-.02h.030000000000000002M40.89 10.414q0 .016-.002.033l-.023-.03q.014 0 .026-.003M39.996 10.414v.028l-.018-.022.018-.008zM20.375 11.604l.005.005-.003.006h-.044l-.003-.006.004-.005h.041M59.746 10.414v.028l-.02-.022zM26.56 10.61q.018-.001.038-.004l-.01.022zM33.493 11.613l.005-.03.018.021q-.013.004-.024.01zM42.206 10.414v.03l-.021-.024q.01-.004.02-.006M31.798 11.613l.006-.033.016.027q-.01.004-.023.006M31.505 11.58q.001.016.005.033l-.025-.003.02-.031zM41.515 10.717s.008-.01.01-.016l.017.016zM53.812 10.444v-.03l.02.007-.018.023zM60.658 10.414v.028l-.019-.022zM50.729 10.414v.028q-.01-.011-.02-.022.01-.004.02-.006M14.667 11.643l.046-.004c-.01.044-.03.015-.046.004M13.892 11.612l.003-.029.018.024q-.011.001-.022.005zM48.192 10.436l-.02-.02q.015 0 .03.002l-.01.02zM54.672 10.414v.028q-.008-.011-.02-.022zM46.75 10.414l-.001.031-.018-.024zM47.9 10.414v.031l-.022-.024q.011-.002.021-.006zM57.938 10.992q0 .015-.002.032l-.02-.024zM52.899 10.445q0-.015-.002-.031l.022.007-.018.024zM47.04 10.444v-.03q.011 0 .022.003l-.02.027zM41.145 10.444v-.03l.02.007zM35.809 11.293l-.005.021q-.01-.011-.024-.021zM25.96 10.418l-.019-.004zM55.238 10.415s0 .012-.006.017l-.008-.015h.014zM14.534 10.418l-.02-.004zM44.725 10.415l-.008.017-.008-.017h.016M51.309 8.093l.016-.013.008.013zM49.234 10.43s-.006-.009-.004-.015h.013zM34.405 11.524l.018-.007v.015zM59.36 10.897l-.017-.015zM51.257 10.897l-.02-.015zM52.61 10.414l-.008.016-.007-.016zM39.282 10.897l-.018-.015zM38.724 10.422l.003-.007q.005.003.009.005l-.005.007zM54.383 10.433l-.006-.018h.013zM52.226 10.414l-.006.016-.007-.015h.013zM39.37 10.615l.017-.01v.016zM42.828 11.603v-.021l.011.013-.012.006zM43.842 11.583v.021l-.012-.007zM45.174 11.583v.021q-.006-.004-.01-.007l.011-.014zM47.062 11.603v-.021q.007.007.011.013l-.012.006zM50.704 11.583v.021l-.012-.007q.008-.008.012-.014M51.024 11.604v-.021l.012.014zM54.648 11.583v.021l-.013-.007zM41.31 10.414l-.005.018-.008-.017h.014zM58.815 10.415s0 .01-.005.015l-.009-.015zM53.52 10.42l-.004.005s-.005-.005-.008-.006l.006-.005zM15.884 11.294l.003-.02.01.017q-.008-.005-.013.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.884 11.295s.008-.005.012-.002q-.002.007-.003.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.006 0h9.851v.077l-.023.577v.001a161 161 0 0 1-.196 3.833 16 16 0 0 1-.07.82 5 5 0 0 1-.211.981q-.032.1-.06.202-.036.132-.08.26-.083.231-.176.458l-.053.133-.029.073q-.073.19-.155.375a10.3 10.3 0 0 1-1.446 2.328 7 7 0 0 1-1.55 1.402 5.2 5.2 0 0 1-.859.456q-.012.005-.022.013l-.013.01h-.036l-.01-.008a.1.1 0 0 0-.024-.015 6 6 0 0 1-.843-.456 7.4 7.4 0 0 1-1.712-1.61 10.6 10.6 0 0 1-1.36-2.306l-.04-.092a7.4 7.4 0 0 1-.349-.936C.4 6.122.27 5.664.236 5.186l-.104-1.45Q.114 3.45.101 3.163l-.011-.23-.023-.469L.02 1.5a30 30 0 0 1-.016-.492L-.002.76V.49C.001.414.006.075.006 0M5.34 1.66l-.003-.063V.512q0-.032-.003-.064l-.001-.03C5.2.398 4.546.405 4.474.426v.999q-.001.093-.01.185l-.006.08h-.764V.42C3.538.397 2.882.405 2.82.43c-.018.218-.009 2.061.013 2.13q.163.006.328.003c.137 0 .275-.002.413.007v3.12c-.177.018-.351.017-.529.016h-.25V4.85H1.93v1.232l.096.004.117.005v3.182c.112.021 5.451.017 5.526-.004V6.093l.19-.01h.023c.018-.14.012-1.175-.006-1.232-.143-.018-.78-.01-.856.014v.818c-.083.03-.695.032-.776.005v-.079l.005-3.026.002-.004.002-.003.019-.017h.715V.415h-.87v1.279h-.775zM4.907 7.14l.02.022q.016.017.027.033L5 7.27q.086.134.167.272a.15.15 0 0 1 .021.075v1.254q0 .011-.004.026l-.005.017c-.096.012-.192.007-.289.001-.085-.004-.171-.009-.259-.001L4.63 8.89l-.004-.066V7.67q-.002-.092.049-.17.06-.092.115-.186l.06-.098.034-.046.022-.03zm-.171-3.224.002.026.001-.001h.08q.072.002.14 0h.064a.3.3 0 0 0 .145-.014l-.003-.045Q5.16 3.84 5.159 3.8l.003-.166q.004-.25.005-.5c0-.04-.01-.085-.029-.121a2 2 0 0 0-.123-.21l-.043-.062-.017-.023-.01.011q-.018.017-.026.029l-.06.095q-.043.072-.09.142a.23.23 0 0 0-.037.136v.72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H63V12H0z"
  }))));
}
var ForwardRef$4N = /*#__PURE__*/forwardRef(SnelandiaIcon);

function SvipperIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 148 32",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__SvipperIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.65 7.735q.147 2.2.832 3.482c.457.856 1.442 1.225 2.477 1.225.43 0 .687-.066 1.25-.317q.846-.376 2.703-1.752 2.095-1.595 3.567-2.165c.98-.379 1.934-.568 2.803-.568 2.636 0 4.59.767 5.92 2.302s2.133 4.027 2.354 7.207h-4.964c-.158-1.712-.432-2.774-.987-3.721-.42-.718-1.395-.986-2.322-.986-.478 0-.849.13-1.535.454q-1.03.485-2.446 1.642-1.25 1.027-2.913 1.88a7.4 7.4 0 0 1-3.429.827c-2.659 0-4.645-.765-5.957-2.35q-1.966-2.373-2.316-7.16zM33.789 17.149h5.161c0 1.443 1.447 2.559 3.222 2.559 1.676 0 2.958-.853 2.958-2.33 0-.886-.492-1.706-2.498-2.362l-2.696-.82c-4.997-1.344-5.95-4.395-5.95-6.527 0-4.068 3.485-6.921 7.989-6.921s7.659 2.591 7.659 6.987h-5.162c0-1.345-.822-2.493-2.596-2.493-1.612 0-2.663 1.082-2.663 2.329 0 .46.131 1.476 2.235 2.066l2.367.754c3.221.985 6.509 2.625 6.509 6.726 0 4.854-4.208 7.02-8.35 7.02-4.833 0-8.186-2.822-8.186-6.989M62.653 8.423h5.292l-6.509 15.32h-4.24l-6.51-15.32h5.293l3.353 9.12zM68.734 3.306c0-1.607 1.381-2.821 3.025-2.821 1.642 0 2.958 1.214 2.958 2.821s-1.315 2.821-2.959 2.821c-1.643 0-3.024-1.28-3.024-2.82m.592 20.436V8.423h4.866v15.32zM94.672 16.066c0 4.954-3.616 8.07-7.462 8.07-1.578 0-3.616-.656-4.733-2.1v9.251h-4.865V8.423h4.865v1.64c1.117-1.41 3.156-2.033 4.733-2.033 3.846 0 7.462 3.116 7.462 8.036m-4.931 0c0-1.935-1.644-3.542-3.55-3.542-1.907 0-3.551 1.574-3.551 3.542s1.71 3.576 3.55 3.576c1.841 0 3.55-1.608 3.55-3.576M114.266 16.066c0 4.954-3.616 8.07-7.462 8.07-1.579 0-3.616-.656-4.734-2.1v9.251h-4.866V8.423h4.866v1.64c1.118-1.41 3.155-2.033 4.734-2.033 3.846 0 7.462 3.116 7.462 8.036m-4.932 0c0-1.935-1.644-3.542-3.55-3.542-1.907 0-3.551 1.574-3.551 3.542s1.71 3.576 3.551 3.576 3.55-1.608 3.55-3.576M132.215 17.51h-11.243c.461 1.476 1.743 2.395 3.583 2.395 1.447 0 2.926-.656 3.88-1.575l2.498 3.149c-1.512 1.64-4.142 2.657-6.706 2.657-4.865 0-8.284-3.346-8.284-8.004 0-4.986 3.846-8.102 8.251-8.102s8.088 3.084 8.088 7.742c0 .426-.033.984-.066 1.738zm-4.767-2.854c-.065-1.509-1.414-2.526-3.156-2.526-1.446 0-2.86.688-3.353 2.526zM146.417 8.489l-1.151 4.625a4.06 4.06 0 0 0-2.202-.59c-1.907 0-3.485 1.608-3.485 6.134v5.085h-4.865V8.423h4.799v3.248c.888-2.526 2.729-3.641 4.603-3.641.724 0 1.512.065 2.301.459"
  }));
}
var ForwardRef$4M = /*#__PURE__*/forwardRef(SvipperIcon);

function TromsFylkestrafikkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 39 9",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__TromsFylkestrafikkIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8.665.86 3.064 7.927H4.247c-.661 0-.876-.232-1.063-.779L.119.082H7.6c.662 0 .879.231 1.066.778m.271 6.575H7.494c-.998 0-2.12-.808-2.506-1.804l-.33-.846H3.74l-.519-1.34L5.428.835l1.493 3.84a1.37 1.37 0 0 0 1.169.846h1.054l.5 1.29zm-5.117-2.76h.921l.36.923c.37.947 1.445 1.716 2.394 1.716h1.402l.608-.535v-.001L8.129 6.76c-.98 0-2.082-.792-2.463-1.77l-.346-.885h-.925L3.9 2.83h.924l-.288-.757-1.18 1.394z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.891 1.758h-.47v-.33h1.337v.33h-.474v1.41h-.393zM14.422 2.2h.154c.196 0 .311-.099.311-.25 0-.153-.107-.234-.287-.234a.7.7 0 0 0-.178.014zm-.397-.746a3 3 0 0 1 .523-.04.87.87 0 0 1 .564.14.44.44 0 0 1 .161.365.47.47 0 0 1-.3.419.43.43 0 0 1 .234.322c.054.199.108.426.14.493h-.403a2.3 2.3 0 0 1-.12-.406c-.049-.218-.124-.274-.287-.278h-.115v.685h-.397zM16.374 2.882c.266 0 .418-.25.418-.589s-.147-.582-.418-.582-.423.264-.423.589.157.582.42.582zm-.012.313a.814.814 0 0 1-.818-.886.843.843 0 0 1 .84-.907.81.81 0 0 1 .825.88c0 .572-.344.916-.851.916zM19.001 2.501c0-.208-.016-.467-.016-.715a9 9 0 0 1-.196.673l-.213.68h-.311l-.185-.675a7 7 0 0 1-.156-.678c0 .234-.017.505-.028.72l-.033.661h-.372l.11-1.739h.526l.168.58c.059.2.11.418.147.622.047-.201.106-.43.164-.625l.185-.577h.516l.094 1.74h-.372zM19.789 2.76c.135.07.285.108.437.11.18 0 .276-.075.276-.189s-.082-.17-.29-.234c-.29-.1-.482-.261-.482-.514 0-.297.25-.53.66-.53.152-.005.304.024.444.086l-.089.316a.8.8 0 0 0-.362-.082c-.168 0-.252.08-.252.165s.096.162.323.246c.306.114.448.273.448.519 0 .292-.233.54-.7.54a1.14 1.14 0 0 1-.494-.108zM21.809 3.167V2.104h-.174v-.185h.174v-.05a.59.59 0 0 1 .144-.434.43.43 0 0 1 .304-.117q.099 0 .192.035l-.028.175a.4.4 0 0 0-.147-.028c-.19 0-.234.17-.234.363v.067h.301v.173h-.306V3.18zM22.739 1.919l.27.736c.031.084.061.183.083.257.023-.075.049-.17.082-.261l.233-.732h.234l-.318.886c-.074.291-.216.56-.416.785a.6.6 0 0 1-.278.143l-.056-.187a.63.63 0 0 0 .388-.365.1.1 0 0 0 .019-.054.14.14 0 0 0-.019-.058l-.468-1.15zM24.163 1.335h-.227v1.832h.227zM24.777 2.49c.033-.043.073-.096.11-.14l.37-.431h.27l-.483.512.549.736h-.276l-.416-.596-.117.129v.467h-.234V1.335h.234zM26.572 2.422a.323.323 0 0 0-.31-.37.37.37 0 0 0-.349.37zm-.664.161a.4.4 0 0 0 .428.432.8.8 0 0 0 .344-.065l.042.163a1 1 0 0 1-.419.08.583.583 0 0 1-.612-.631.607.607 0 0 1 .588-.673.53.53 0 0 1 .514.589.4.4 0 0 1 0 .105zM27.115 2.934a.64.64 0 0 0 .304.088c.16 0 .233-.079.233-.184s-.063-.166-.233-.234c-.234-.082-.332-.206-.332-.353a.386.386 0 0 1 .43-.367.57.57 0 0 1 .304.08l-.054.16a.5.5 0 0 0-.254-.072c-.136 0-.208.078-.208.171s.072.15.233.215c.215.08.328.187.328.374s-.173.377-.467.377a.7.7 0 0 1-.35-.09zM28.496 1.62v.3h.325v.184h-.325v.668c0 .157.045.234.17.234a.5.5 0 0 0 .134-.014v.173a.7.7 0 0 1-.201.03.33.33 0 0 1-.234-.096.5.5 0 0 1-.089-.327v-.668h-.191v-.185h.198v-.234zM29.141 2.307V1.92h.199v.234a.38.38 0 0 1 .348-.274h.06v.225h-.063a.32.32 0 0 0-.304.29.5.5 0 0 0 0 .105v.669h-.234zM30.696 2.53c-.248 0-.529.039-.529.282a.196.196 0 0 0 .211.215.31.31 0 0 0 .306-.208.3.3 0 0 0 0-.072zm.233.338q-.002.15.02.3h-.207l-.02-.16a.47.47 0 0 1-.384.187.355.355 0 0 1-.381-.357c0-.304.269-.467.75-.467v-.033a.258.258 0 0 0-.283-.29.6.6 0 0 0-.327.094l-.051-.153a.8.8 0 0 1 .414-.11c.383 0 .467.262.467.512zM31.367 3.167V2.104h-.174v-.185h.174v-.07a.503.503 0 0 1 .547-.542c.11-.001.22.027.316.082l-.063.173a.5.5 0 0 0-.264-.072c-.234 0-.311.168-.311.367v.063h.727v1.248h-.234V2.104h-.498v1.075zM32.986 2.49c.03-.043.073-.096.108-.14l.37-.431h.27l-.482.512.55.736h-.276l-.423-.596-.117.129v.467h-.233V1.335h.233zM34.305 2.49c.03-.043.072-.096.107-.14l.37-.431h.28l-.484.512.552.736h-.276l-.435-.596-.115.129v.467h-.233V1.335h.234zM12.837 5.568h.155c.195 0 .313-.098.313-.25s-.11-.234-.29-.234a.7.7 0 0 0-.178.014zm-.39-.746a3 3 0 0 1 .526-.04.87.87 0 0 1 .561.14.44.44 0 0 1 .163.363.47.47 0 0 1-.309.425.43.43 0 0 1 .234.323c.054.199.105.425.138.493h-.402a2.3 2.3 0 0 1-.12-.406c-.048-.22-.123-.276-.284-.279h-.117v.704h-.39zM14.792 6.25c.264 0 .416-.25.416-.588 0-.34-.148-.583-.417-.583-.268 0-.423.265-.423.59s.157.582.419.582zm-.022.314a.813.813 0 0 1-.817-.886.84.84 0 0 1 .845-.91.81.81 0 0 1 .826.88c0 .572-.344.916-.851.916zM17.416 5.87c0-.212-.014-.468-.014-.716-.056.222-.128.467-.194.673l-.212.68h-.314l-.187-.663a10 10 0 0 1-.157-.678c0 .234-.016.503-.028.72l-.04.66h-.364l.113-1.74h.523l.17.57c.056.201.108.418.147.622a9 9 0 0 1 .166-.624l.183-.578h.516l.1 1.749h-.38zM18.206 6.129c.135.07.284.107.435.11.183 0 .278-.076.278-.19s-.084-.17-.292-.233c-.29-.103-.467-.262-.467-.515 0-.296.248-.52.657-.52a1 1 0 0 1 .444.086l-.093.306a.8.8 0 0 0-.36-.082c-.17 0-.253.08-.253.166s.094.161.323.245c.306.115.449.274.449.52 0 .291-.234.54-.701.54a1.1 1.1 0 0 1-.491-.11zM19.717 6.129c.134.07.283.107.434.11.181 0 .276-.076.276-.19s-.082-.17-.292-.233c-.288-.103-.467-.262-.467-.515 0-.296.25-.52.66-.52.151-.006.302.024.441.086l-.086.316a.8.8 0 0 0-.363-.082c-.168 0-.252.08-.252.166s.095.161.322.245c.309.115.45.274.45.52 0 .291-.223.54-.702.54-.175 0-.347-.042-.503-.12zM22.003 5.795l-.107-.37c-.028-.103-.059-.234-.085-.334a8 8 0 0 1-.077.334l-.105.37zm-.44.294-.121.456h-.405l.53-1.74h.515l.538 1.74h-.414l-.133-.447zM23.54 6.545V5.47h-.165v-.176h.173v-.059a.6.6 0 0 1 .147-.434.43.43 0 0 1 .301-.117q.1 0 .194.035l-.028.178a.35.35 0 0 0-.147-.03c-.192 0-.234.17-.234.362v.065h.295v.176h-.3v1.075zM24.525 5.285l.27.738c.03.082.061.18.083.255.023-.076.049-.168.08-.26l.247-.734h.234l-.342.89c-.079.292-.225.56-.427.784a.7.7 0 0 1-.279.145l-.056-.19a.63.63 0 0 0 .388-.364.13.13 0 0 0 .02-.053.14.14 0 0 0-.02-.059l-.466-1.152zM25.948 4.703h-.227v1.833h.227zM26.57 5.86c.03-.045.072-.099.11-.143l.367-.432h.27l-.481.514.554.746h-.276l-.427-.6-.117.13v.467h-.234V4.703h.234zM27.837 5.86c.03-.045.072-.099.11-.143l.367-.432h.27l-.481.514.554.746h-.276l-.43-.6-.114.13v.467h-.234V4.703h.234zM29.592 5.897c-.233 0-.528.038-.528.28a.2.2 0 0 0 .127.205q.04.015.084.013a.32.32 0 0 0 .309-.208.3.3 0 0 0 0-.072zm.234.339q0 .15.019.299h-.203l-.022-.159a.47.47 0 0 1-.383.187.355.355 0 0 1-.38-.36c0-.301.268-.467.75-.467v-.025a.258.258 0 0 0-.284-.29.6.6 0 0 0-.327.093l-.051-.152a.8.8 0 0 1 .411-.11c.386 0 .467.262.467.513zM30.387 5.075a.14.14 0 0 1 0-.28.133.133 0 0 1 .14.14.136.136 0 0 1-.142.14zM29.943 6.9a.36.36 0 0 0 .248-.093c.063-.07.089-.171.089-.467V5.287h.233v1.139a.7.7 0 0 1-.15.514.58.58 0 0 1-.387.14zM31.453 6.393c.217 0 .38-.203.38-.489 0-.21-.107-.466-.376-.466s-.369.238-.369.476c0 .239.154.48.374.48zm0 .17a.594.594 0 0 1-.598-.642.61.61 0 0 1 .619-.664.59.59 0 0 1 .6.64.61.61 0 0 1-.619.667zM32.416 4.703h.233v.78a.4.4 0 0 1 .164-.161.43.43 0 0 1 .234-.066c.168 0 .436.106.436.536v.753h-.233v-.73c0-.2-.076-.369-.29-.369a.325.325 0 0 0-.304.234.3.3 0 0 0-.017.108v.757h-.233zM34.174 4.988v.297h.327v.173h-.327v.67c0 .157.044.235.17.235a.4.4 0 0 0 .134-.017v.173a.6.6 0 0 1-.201.033.33.33 0 0 1-.246-.096.5.5 0 0 1-.086-.327v-.671h-.194v-.173h.194v-.234zM35.324 6.393c.215 0 .378-.203.378-.489 0-.21-.105-.466-.374-.466-.268 0-.38.247-.38.486 0 .238.154.479.371.479zm-.012.17a.596.596 0 0 1-.598-.642.61.61 0 0 1 .619-.664.59.59 0 0 1 .6.64.614.614 0 0 1-.619.667zM36.511 4.703h-.227v1.833h.227zM37.617 5.897c-.248 0-.528.038-.528.28a.198.198 0 0 0 .21.218.31.31 0 0 0 .306-.208.2.2 0 0 0 .012-.072zm.222.34q.004.155.028.308h-.203l-.022-.159a.47.47 0 0 1-.38.187.355.355 0 0 1-.382-.36c0-.301.267-.467.75-.467v-.025a.26.26 0 0 0-.285-.29.6.6 0 0 0-.327.093l-.051-.152a.8.8 0 0 1 .413-.11c.384 0 .467.262.467.512zM38.528 4.988v.297h.327v.173h-.327v.67c0 .157.044.235.17.235a.4.4 0 0 0 .134-.017v.173a.6.6 0 0 1-.201.033.33.33 0 0 1-.245-.096.5.5 0 0 1-.09-.327v-.671h-.19v-.173h.191v-.234z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H38.856V8.868H0z"
  }))));
}
var ForwardRef$4L = /*#__PURE__*/forwardRef(TromsFylkestrafikkIcon);

function VKTIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 56 15",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VKTIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.844 6.314-1.197-3.93-.006-.023q0-.058.064-.058h.732q.064 0 .082.058l.773 2.836q.006.018.017.018t.017-.018l.762-2.836q.018-.058.081-.058h.715q.035 0 .053.023.016.023.006.058l-1.215 3.93q-.018.058-.076.058h-.732q-.058 0-.076-.058M24.855 5.064q-.006.07-.076.07h-1.796q-.035 0-.023.028.017.117.064.233.15.325.616.325a.7.7 0 0 0 .587-.302q.023-.035.052-.035.017 0 .041.023l.419.413q.029.03.029.052 0 .011-.024.047a1.3 1.3 0 0 1-.494.369q-.302.13-.662.13-.501 0-.846-.226a1.26 1.26 0 0 1-.497-.633q-.122-.291-.122-.762 0-.32.087-.564.134-.412.468-.657.335-.243.794-.244.58 0 .933.337.352.337.427.901.034.22.023.494m-1.86-.68a1.4 1.4 0 0 0-.041.186q0 .029.029.029h1.006q.034 0 .023-.03l-.03-.162a.5.5 0 0 0-.182-.27.53.53 0 0 0-.323-.096q-.366 0-.483.343M25.977 6.302a1.03 1.03 0 0 1-.45-.309.7.7 0 0 1-.16-.447v-.058q0-.03.02-.05a.07.07 0 0 1 .05-.02h.644q.03 0 .05.02t.02.05v.006q0 .128.143.218.142.09.357.09a.6.6 0 0 0 .32-.079q.122-.078.122-.194 0-.105-.105-.157a1.8 1.8 0 0 0-.343-.11 4 4 0 0 1-.43-.135 1.8 1.8 0 0 1-.593-.313q-.22-.187-.22-.535-.001-.43.334-.683.334-.253.886-.253.372 0 .651.119a1 1 0 0 1 .433.334.82.82 0 0 1 .154.488q0 .03-.02.05a.07.07 0 0 1-.05.02h-.622a.07.07 0 0 1-.05-.02.07.07 0 0 1-.02-.05q0-.127-.13-.215a.6.6 0 0 0-.346-.087.63.63 0 0 0-.314.07q-.122.07-.122.192c0 .081.04.135.12.174q.118.059.397.122l.146.038q.081.02.174.05.413.121.651.313t.239.558q0 .43-.34.672-.34.24-.916.241-.39 0-.68-.11M30.217 4.02a.07.07 0 0 1-.05.02h-.557q-.03 0-.03.03v1.232q0 .192.08.285.077.093.252.093h.192q.03 0 .05.02t.02.05v.552q0 .063-.07.075-.245.012-.349.012-.483 0-.72-.16-.24-.16-.245-.602V4.07q0-.03-.03-.03h-.33a.07.07 0 0 1-.05-.02.07.07 0 0 1-.02-.05v-.517q0-.028.02-.049a.07.07 0 0 1 .05-.02h.33q.03 0 .03-.03v-.691q0-.03.02-.05a.07.07 0 0 1 .05-.02h.65q.03 0 .05.02t.02.05v.692q0 .03.03.029h.558q.029 0 .05.02.02.02.02.05v.517q0 .03-.02.05zM32.63 3.398q.02.02.02.05V4q0 .03-.02.05a.07.07 0 0 1-.05.02h-.564q-.03 0-.029.029v2.203q0 .03-.02.05a.07.07 0 0 1-.05.02h-.68a.07.07 0 0 1-.05-.02.07.07 0 0 1-.02-.05V4.099q0-.03-.028-.03h-.343a.07.07 0 0 1-.05-.02.07.07 0 0 1-.02-.05v-.551q0-.03.02-.05a.07.07 0 0 1 .05-.02h.343q.029 0 .029-.03v-.127q0-.36.11-.56a.62.62 0 0 1 .358-.286q.246-.084.683-.072h.22q.03 0 .05.02t.02.05v.47q0 .03-.02.05a.07.07 0 0 1-.05.02h-.191q-.204.006-.282.084-.08.079-.079.288v.064q0 .03.03.029h.563q.03 0 .05.02M33.574 6.162a1.28 1.28 0 0 1-.477-.697 2 2 0 0 1-.081-.593q0-.343.081-.617.134-.43.483-.674t.837-.244c.325 0 .589.08.814.241q.336.241.476.672.093.29.093.61c0 .213-.027.405-.081.587a1.3 1.3 0 0 1-.474.712q-.345.26-.834.259-.487 0-.837-.256m1.163-.564a.65.65 0 0 0 .191-.32q.047-.186.047-.406 0-.244-.047-.413a.65.65 0 0 0-.197-.308.5.5 0 0 0-.326-.11.5.5 0 0 0-.328.11.6.6 0 0 0-.189.308 1.4 1.4 0 0 0-.046.413c0 .182.013.31.04.406a.64.64 0 0 0 .195.32.5.5 0 0 0 .334.117.47.47 0 0 0 .326-.117M36.495 6.351a.07.07 0 0 1-.02-.05V2.373q0-.03.02-.05a.07.07 0 0 1 .05-.02h.68q.029 0 .05.02.02.02.02.05v3.93q0 .028-.02.05a.07.07 0 0 1-.05.02h-.68a.07.07 0 0 1-.05-.02M39.913 2.323a.07.07 0 0 1 .05-.02h.68q.028 0 .049.02.02.02.02.05v3.929q0 .029-.02.05a.07.07 0 0 1-.05.02h-.68a.07.07 0 0 1-.05-.02.07.07 0 0 1-.02-.05V6.11q0-.018-.011-.02-.012-.003-.023.008a.8.8 0 0 1-.669.32 1.1 1.1 0 0 1-.7-.227 1.25 1.25 0 0 1-.422-.622 2.3 2.3 0 0 1-.099-.703c0-.267.035-.515.105-.72q.135-.373.422-.59.287-.219.712-.219c.283 0 .496.097.65.29q.012.018.024.012t.012-.023V2.372q0-.029.02-.05m-.026 2.554q0-.39-.128-.61a.43.43 0 0 0-.39-.227.45.45 0 0 0-.413.227q-.145.227-.145.616 0 .35.122.582.145.25.43.25.262 0 .407-.25.117-.216.116-.588M18.949 12.014V8.062q0-.058.058-.058h.296q.059 0 .058.058v2.377a.02.02 0 0 0 .01.018q.008.006.02-.006l1.232-1.29a.1.1 0 0 1 .07-.03h.348q.036 0 .047.024.012.022-.012.046l-.744.825q-.011.012-.006.03l.89 1.947.006.023q0 .047-.053.047h-.313q-.048 0-.064-.047l-.75-1.697q-.012-.024-.03-.006l-.639.674a.04.04 0 0 0-.011.03v.988q0 .057-.058.057h-.297q-.058 0-.058-.057M22.152 11.904a1.1 1.1 0 0 1-.419-.593 2.5 2.5 0 0 1-.081-.715q0-.448.081-.71.111-.371.413-.586a1.23 1.23 0 0 1 .732-.215c.287 0 .513.071.712.215q.3.215.41.581.082.25.082.715c0 .31-.027.552-.082.715q-.11.378-.41.593-.299.215-.718.215a1.2 1.2 0 0 1-.72-.215m1.197-.3a.76.76 0 0 0 .268-.415q.051-.21.052-.587c0-.252-.016-.452-.047-.588a.75.75 0 0 0-.27-.415.77.77 0 0 0-.486-.154q-.285 0-.482.154a.76.76 0 0 0-.267.415 2.8 2.8 0 0 0-.047.588q0 .383.047.587.063.261.264.415a.78.78 0 0 0 .491.154.74.74 0 0 0 .477-.153M24.919 12.014V8.062q0-.058.058-.058h.296q.058 0 .058.058v3.952q0 .059-.058.058h-.296q-.059 0-.058-.058M26.256 12.014V8.062q0-.058.058-.058h.296q.058 0 .058.058v3.952q0 .059-.058.058h-.296q-.059 0-.058-.058M29.871 10.515v.186q0 .057-.058.058h-1.877q-.024 0-.024.023.012.319.035.413a.7.7 0 0 0 .274.412q.21.152.534.152a.83.83 0 0 0 .43-.11.76.76 0 0 0 .29-.315q.036-.052.082-.023l.227.134q.047.03.023.081a1.05 1.05 0 0 1-.436.439q-.29.16-.668.16a1.23 1.23 0 0 1-.692-.198 1.06 1.06 0 0 1-.401-.535q-.105-.279-.105-.802 0-.243.01-.398.008-.153.043-.276.099-.378.398-.604.299-.227.724-.227.529 0 .814.267.285.268.354.756.023.163.023.407m-1.665-.922a.7.7 0 0 0-.247.398 2 2 0 0 0-.047.396q0 .023.024.023h1.505q.023 0 .023-.024a3 3 0 0 0-.035-.371.74.74 0 0 0-.258-.416.77.77 0 0 0-.491-.154.73.73 0 0 0-.474.148M30.69 12.014V8.062q0-.058.059-.058h.296q.058 0 .058.058v2.377a.02.02 0 0 0 .01.018q.008.006.02-.006l1.232-1.29a.1.1 0 0 1 .07-.03h.348q.035 0 .047.024.012.022-.012.046l-.744.825q-.012.012-.006.03l.89 1.947.006.023q0 .047-.053.047h-.314q-.045 0-.064-.047l-.75-1.697q-.01-.024-.029-.006l-.639.674a.04.04 0 0 0-.011.03v.988q0 .057-.059.057h-.296q-.058 0-.058-.057M34.864 9.474h-.656q-.024 0-.024.023v1.715q0 .28.125.392.125.114.393.114h.145q.057 0 .058.058v.238q0 .058-.058.058a3 3 0 0 1-.215.006q-.419 0-.634-.157-.215-.156-.215-.581V9.497q0-.023-.023-.023h-.355q-.058 0-.058-.058v-.227q0-.058.058-.058h.355q.023 0 .023-.023v-.674q0-.058.058-.058h.285q.058 0 .058.058v.674q0 .023.023.023h.657q.058 0 .058.058v.227q0 .058-.058.058M35.765 8.503a.32.32 0 0 1-.093-.232.32.32 0 0 1 .093-.236q.093-.09.233-.09t.232.09.093.236a.316.316 0 0 1-.325.325.32.32 0 0 1-.233-.093m.012 3.505V9.183q0-.058.058-.058h.297q.057 0 .058.058v2.825q0 .06-.058.059h-.297q-.058 0-.058-.059M37.881 12.026l-.953-2.83-.006-.024q0-.04.052-.04h.331q.053 0 .07.046l.727 2.278q.006.012.017.012t.018-.012l.726-2.278q.018-.047.07-.047l.331.006q.064 0 .047.064l-.953 2.825q-.018.047-.07.047h-.337q-.052 0-.07-.047M41.224 9.474h-.657q-.024 0-.024.023v1.715q0 .28.125.392.126.114.393.114h.145q.058 0 .058.058v.238q0 .058-.058.058a3 3 0 0 1-.215.006q-.419 0-.634-.157-.215-.156-.215-.581V9.497q0-.023-.023-.023h-.355q-.058 0-.058-.058v-.227q0-.058.058-.058h.355q.024 0 .023-.023v-.674q0-.058.058-.058h.285q.058 0 .058.058v.674q0 .023.023.023h.657q.058 0 .058.058v.227q0 .058-.058.058M43.595 9.178q.047.023.035.075l-.064.285q-.018.058-.076.035a.6.6 0 0 0-.226-.04l-.076.005a.7.7 0 0 0-.5.224.76.76 0 0 0-.197.538v1.714q0 .059-.058.058h-.297q-.058 0-.058-.058V9.19q0-.058.058-.058h.297q.057 0 .058.058v.355q0 .018.008.02.009.004.015-.009a.9.9 0 0 1 .311-.334.8.8 0 0 1 .439-.119q.192 0 .331.076M46.007 9.352q.285.267.285.71v1.952q0 .058-.058.058h-.296q-.059 0-.058-.058v-.238a.02.02 0 0 0-.01-.018q-.008-.005-.02.006a.9.9 0 0 1-.377.265q-.233.09-.518.09a1.12 1.12 0 0 1-.691-.21q-.28-.209-.28-.64c0-.286.106-.52.317-.688q.318-.252.881-.253h.674q.023 0 .023-.023v-.22q0-.298-.165-.469t-.515-.171a.85.85 0 0 0-.453.107.45.45 0 0 0-.215.3q-.018.058-.07.052l-.314-.04q-.064-.013-.052-.047a.75.75 0 0 1 .349-.53q.302-.203.755-.203.524 0 .808.268m-.377 2.24a.53.53 0 0 0 .25-.461v-.454q0-.023-.024-.023h-.61q-.384 0-.616.157a.5.5 0 0 0-.233.436q0 .256.178.386a.76.76 0 0 0 .462.131q.342 0 .593-.171M47.88 8.506q-.117.143-.117.486v.116q0 .023.023.023h.651q.058 0 .058.058v.262q0 .058-.058.058h-.651q-.024 0-.023.023v2.482q0 .058-.058.058h-.29q-.06 0-.059-.058V9.532q0-.023-.023-.023h-.39q-.057 0-.058-.058v-.262q0-.058.058-.058h.39q.023 0 .023-.023v-.14q0-.36.081-.566a.55.55 0 0 1 .282-.303q.201-.095.561-.095h.169q.058 0 .058.058v.244q0 .058-.058.058h-.134q-.32 0-.436.142m1.388-.003a.32.32 0 0 1-.093-.232.32.32 0 0 1 .093-.236.32.32 0 0 1 .233-.09q.14 0 .232.09.093.09.093.236a.316.316 0 0 1-.325.325.32.32 0 0 1-.233-.093m.012 3.505V9.183q0-.058.058-.058h.297q.057 0 .058.058v2.825q0 .06-.058.059h-.297q-.058 0-.058-.059M50.71 12.014V8.062q0-.058.058-.058h.296q.058 0 .058.058v2.377a.02.02 0 0 0 .01.018q.008.006.02-.006l1.232-1.29a.1.1 0 0 1 .07-.03h.348q.036 0 .047.024.012.022-.012.046l-.744.825q-.012.012-.006.03l.89 1.947.006.023q0 .047-.053.047h-.313q-.048 0-.064-.047l-.75-1.697q-.012-.024-.03-.006l-.639.674a.04.04 0 0 0-.011.03v.988q0 .057-.058.057h-.297q-.058 0-.058-.057M53.622 12.014V8.062q0-.058.058-.058h.297q.057 0 .058.058v2.377a.02.02 0 0 0 .008.018q.01.006.02-.006l1.233-1.29a.1.1 0 0 1 .07-.03h.349q.034 0 .046.024.012.022-.012.046l-.744.825q-.011.012-.005.03l.889 1.947.006.023q0 .047-.052.047h-.314q-.047 0-.064-.047l-.75-1.697q-.011-.024-.03-.006l-.639.674a.04.04 0 0 0-.011.03v.988q0 .057-.058.057h-.297q-.057 0-.058-.057M12.154 1.93A7.17 7.17 0 0 0 7.361.1h-.08A7.195 7.195 0 0 0 .084 7.295v.08q.002.8.167 1.55zM.518 9.839A7.2 7.2 0 0 0 7.28 14.57h.08a7.2 7.2 0 0 0 6.763-4.732zM11.475 5.375v.04a3.616 3.616 0 0 0 2.905 3.546q.174-.766.176-1.585v-.08a7.17 7.17 0 0 0-1.76-4.715 3.6 3.6 0 0 0-1.32 2.794"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H56V14.606H0z"
  }))));
}
var ForwardRef$4K = /*#__PURE__*/forwardRef(VKTIcon);

function VyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 31.6 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VyIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.728 10q.15 0 0 0 .15-.15 0 0c-.2-.1-.5-.1-.7-.3-.5-.3-.8-.9-1.101-1.8 0-.1-1.6-5.4-1.7-5.8-.4-1.2-1-1.7-1.6-2-.3 0-.6-.1-.9-.1h-.4c.2 0 .4.1.5.1.6.2 1.2.8 1.5 1.9.1.3 1.6 5.6 1.7 5.7.3 1 .7 1.6 1.2 1.9.3.2.6.3 1 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.127 10q0-.15 0 0c-.7-.1-1.1-1.1-1.4-1.9-.3-.9-1.2-4.1-1.8-5.9-.5-1.9-2.3-2.2-3.1-2.2.7.1 1.8.5 2.3 2.1.4 1.5 1.7 5.8 1.7 5.9.3.9.7 1.4 1.1 1.7q.45.15 1.2.3M6.927 16h-.2c-.6 0-1.4-.3-1.8-1.8l-3.8-12.8C.927.6.627.2.127.1h.6c.7 0 1.1.4 1.4 1.3 0 0 3.5 11.8 3.8 12.9.2.8.5 1.4.9 1.6zs.1 0 0 0c.1 0 0 0 0 0M5.727 1.9c-.4-1.3-1-1.8-2-1.8h-.5c.8.1 1.3.7 1.6 1.8 0 0 3.1 10.6 3.5 11.9.1-.3.2-.8.4-1.5-.3-1.2-3-10.4-3-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.227 16h.4c.5 0 .8-.1 1-.3.4-.3.6-.9.8-1.5 0-.1 3.3-11.2 3.5-11.7.4-1.5 1.3-2.1 2.2-2.4.2 0 .3-.1.5-.1h-.4c-1.2 0-2.6.5-3.1 2.5-.2.7-3.4 11.6-3.5 11.7-.2.6-.4 1.2-.8 1.5-.2.2-.4.2-.6.3M24.127 8.3l1.9-6.5c.4-1.1.9-1.7 1.7-1.8h-.5c-1 0-1.6.5-2 1.8l-1.5 5.2c0-.1.4 1.2.4 1.3M29.327.1h-.5c-.9 0-1.4.4-1.7 1.5 0 0-1.9 6.4-1.9 6.5-.1.5-.3.9-.5 1.2.2.2.3.4.5.4.3-.4.6-.9.9-1.7l1.9-6.5c.2-.8.6-1.3 1.3-1.4M25.327 10.3h-.9c-.4 1.3-.9 3-1.1 3.7-.5 1.8.3 2 .6 2h.7c-.4-.1-.9-.5-.4-2 0 0 .8-2.7 1.1-3.7M30.427.1c-.9 0-1.3.4-1.5 1.3 0 0-1.5 5-2 6.6s-.8 2-1.4 2.1h.4c1.1 0 1.5-.7 1.9-2 .3-1.1 2.2-7.5 2.2-7.5.1-.2.2-.4.4-.5M26.228 10.3l-1.2 4c-.5 1.5.3 1.7.5 1.7h.7c-.301-.1-.7-.4-.4-1.7 0 0 1-3.2 1.3-4.5-.1.2-.4.4-.9.5M27.827 16q.15 0 0 0 .15 0 0 0c-.3-.1-.6-.4-.3-1.4 0 0 3.7-12.5 3.9-13.2s-.3-1.2-.7-1.2c.1 0 .2.2.1.3l-4.2 14.1c-.3 1.2.3 1.4.6 1.4zM22.027 10q0-.15 0 0c-.2-.1-.5-.1-.7-.3-.5-.3-.9-.9-1.2-1.9 0-.1-1.6-5.4-1.7-5.6-.3-1.1-.9-1.7-1.4-1.9-.2-.2-.5-.3-.8-.3h-.4c.1 0 1.3.1 1.9 2.1s1.3 4.5 1.6 5.4c.5 1.9 1.2 2.5 2.3 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.427.8c-.4.4-.8.9-1 1.8 0 .1-3.3 11.2-3.4 11.4-.3.9-.5 1.9-1.6 2h.4c1.1 0 1.6-.5 2-2 .3-1.1 3.3-11.3 3.4-11.4.1-.4.3-.9.5-1.3 0-.2-.1-.4-.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.027.5c-.3-.1-.8-.1-1.2.3-.4.3-.8.9-1 1.7 0 .1-3.5 11.7-3.5 11.7-.2.6-.4 1.1-.8 1.5-.2.2-.5.3-.7.3h.5c.5 0 .8-.1 1-.3.4-.3.6-.9.8-1.5 0-.1 3.4-11.6 3.5-11.7.2-.8.6-1.4 1-1.8.2 0 .3-.1.4-.2M7.927 15c-.2-.2-.3-.5-.4-.8-.1-.5-3.7-12.6-3.7-12.6-.3-1-.8-1.5-1.6-1.5h-.6c.7.1 1.1.6 1.4 1.5l3.7 12.6c.2.7.5 1.1.7 1.4.2-.1.4-.3.5-.6"
  }));
}
var ForwardRef$4J = /*#__PURE__*/forwardRef(VyIcon);

function ØresundstågIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 74 11",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__ØresundstågIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.882 6.375c0-.977.786-1.761 1.756-1.761.262 0 .513.068.73.159l1.368-1.364a3.6 3.6 0 0 0-2.098-.659A3.634 3.634 0 0 0 0 6.375c0 .784.25 1.5.661 2.09L2.03 7.103a1.9 1.9 0 0 1-.148-.727m3.375-.716c.103.216.16.466.16.716A1.76 1.76 0 0 1 2.93 7.977L1.562 9.341c.593.42 1.312.659 2.087.659A3.64 3.64 0 0 0 7.3 6.364a3.64 3.64 0 0 0-.662-2.08zm36.549 4.17h2.817c1.904 0 3.523-1.284 3.523-3.397 0-2.205-1.505-3.477-3.694-3.477h-2.646zM63.336 1c-.775 0-1.391.614-1.391 1.364 0 .295.102.568.262.761L59.733 9.83h1.893l.456-1.42h2.303l.445 1.42h1.984l-2.383-6.67a1.23 1.23 0 0 0 .285-.796c0-.75-.616-1.364-1.38-1.364M34.428 9.83h1.802V5.886l2.76 3.944h1.561V2.955H38.75v3.84l-2.646-3.84h-1.665V9.83zm-26.206 0h1.836V7.489h.81l1.197 2.34h2.019l-1.517-2.647c.695-.41 1.095-1.068 1.095-1.977 0-1.387-.867-2.25-2.44-2.25h-3zm62.47-2.523H71.9v.659c-.353.25-.775.375-1.254.375-1.118 0-1.848-.796-1.848-1.943 0-1.057.639-1.932 1.848-1.932.661 0 1.106.295 1.54.727L73.37 3.99c-.673-.864-1.665-1.228-2.862-1.228-2.076 0-3.58 1.478-3.58 3.614 0 2.068 1.197 3.614 3.58 3.614.992 0 2.178-.273 3.033-.978V5.898h-2.84v1.409zM27.3 7.147c0 1.66 1.107 2.853 2.988 2.853 1.78 0 2.965-1.125 2.965-2.852V2.955h-1.847v4.022c0 .716-.285 1.296-1.118 1.296-.798 0-1.14-.523-1.14-1.296V2.955h-1.836v4.193zM14.893 9.83h5.189V8.25h-3.353V7.09h2.577V5.615H16.73V4.523h3.136V2.955h-4.972zm5.782-.853c.764.705 1.745 1.012 2.908 1.012 1.38 0 2.805-.762 2.805-2.17 0-.91-.479-1.603-1.311-1.955-.251-.103-.48-.17-1.05-.364-.433-.148-1.026-.273-1.026-.75 0-.375.388-.523.753-.523.57 0 1.072.239 1.562.603l.935-1.17c-.638-.66-1.699-.887-2.509-.887-1.436 0-2.668.75-2.668 2.25 0 1.113.97 1.659 1.745 1.92l.661.227c.445.148.867.341.867.705 0 .455-.434.568-.798.568-.719 0-1.278-.295-1.78-.784zm27.745 0c.764.705 1.745 1.012 2.908 1.012 1.38 0 2.805-.762 2.805-2.17 0-.91-.479-1.603-1.311-1.955-.251-.103-.48-.17-1.05-.364-.433-.148-1.026-.273-1.026-.75 0-.375.377-.523.753-.523.559 0 1.072.239 1.562.603l.935-1.17c-.638-.66-1.699-.887-2.508-.887-1.437 0-2.669.75-2.669 2.25 0 1.113.97 1.659 1.745 1.92l.661.227c.445.148.867.341.867.705 0 .455-.433.568-.798.568-.719 0-1.277-.295-1.78-.784zm8.062.853h1.848V4.602h2.03V2.955h-5.907v1.647h2.03zM43.63 8.216v-3.67h.753c1.106.01 1.882.67 1.882 1.84 0 1.114-.753 1.83-1.882 1.841h-.753zM10.058 6.08V4.386h.97c.547 0 .832.353.832.864 0 .466-.285.83-.81.83zm52.4.988.798-2.58.764 2.58zm.285-4.693a.583.583 0 0 1 1.163 0c0 .318-.262.58-.581.58a.59.59 0 0 1-.582-.58"
  }));
}
var ForwardRef$4I = /*#__PURE__*/forwardRef(ØresundstågIcon);

function AmericanExpressIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__AmericanExpressIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0 0 7.98 0 16 8 16 16 16 16 8 16 0 8 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006fcf",
    d: "m13.15 3.93.51-1.39H16V0H0v16h16v-2.53h-2.21l-.82-.95-.85.95H5.85V8.39H3.78l2.59-5.86h2.52l.61 1.33V2.53h3.13l.52 1.39Zm-1.77.92v-.56l.21.56 1.04 2.78h1.03l1.05-2.78.2-.55v3.33H16V3.36h-1.81l-.82 2.17-.22.59-.22-.59-.83-2.17h-1.81v4.27h1.09zM9.04 7.63h1.25L8.41 3.36H6.95L5.06 7.63H6.3l.33-.82H8.7l.33.82ZM7.46 4.81l.21-.53.21.53.44 1.08H7.01l.44-1.08ZM6.73 8.4v4.25h3.56v-.92H7.82v-.74h2.43v-.92H7.82v-.75h2.47V8.4zm7.53 4.25h1.41l-1.99-2.13 1.99-2.12h-1.39l-1.29 1.38-1.28-1.38h-1.42l1.99 2.13-1.99 2.12h1.38l1.3-1.39zm.54-2.14 1.21 1.23V9.3z"
  }));
}
var ForwardRef$4H = /*#__PURE__*/forwardRef(AmericanExpressIcon);

function ApplePayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 14 10",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__ApplePayIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.75.5H1.254L.99.502a2 2 0 0 0-.263.023.84.84 0 0 0-.7.701q-.022.131-.024.264L0 1.61v6.745q0 .06.002.12.002.133.023.264.023.131.083.25a.84.84 0 0 0 .368.368q.119.06.25.083c.087.015.176.02.263.023l.121.002h11.783l.121-.002q.133-.002.264-.023a.837.837 0 0 0 .7-.701c.016-.087.021-.176.024-.263l.001-.121V1.61l-.001-.12a2 2 0 0 0-.024-.264.9.9 0 0 0-.237-.463.84.84 0 0 0-.463-.238 2 2 0 0 0-.264-.023L12.894.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.75.799h.141q.057 0 .115.002c.067.002.146.005.219.018a.54.54 0 0 1 .46.46c.012.073.016.151.018.219a5 5 0 0 1 .002.256v6.599l-.002.115a1.5 1.5 0 0 1-.019.219.6.6 0 0 1-.154.304.54.54 0 0 1-.305.155 2 2 0 0 1-.217.018l-.117.002H1.112q-.058 0-.114-.002a2 2 0 0 1-.219-.018.536.536 0 0 1-.405-.292.6.6 0 0 1-.055-.168 1.5 1.5 0 0 1-.018-.218l-.002-.115V1.612q0-.057.002-.114a1.5 1.5 0 0 1 .018-.22.54.54 0 0 1 .46-.46C.852.807.93.804.998.802l.114-.002H12.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.823 3.515a.78.78 0 0 0 .18-.557.78.78 0 0 0-.514.266c-.111.129-.21.338-.184.536.197.017.394-.099.518-.245M4 3.798c-.286-.017-.529.162-.666.162-.136 0-.346-.153-.572-.15a.84.84 0 0 0-.717.437c-.308.53-.081 1.316.218 1.747.145.214.32.449.55.44.218-.008.304-.14.568-.14.265 0 .342.14.572.136.24-.004.39-.214.534-.427.167-.244.235-.479.24-.492-.005-.004-.462-.18-.466-.705-.004-.44.359-.649.376-.662-.205-.303-.525-.337-.637-.346M6.492 3.203c.622 0 1.055.428 1.055 1.052 0 .627-.442 1.058-1.07 1.058h-.69v1.095H5.29V3.203zm-.704 1.692h.57c.434 0 .68-.233.68-.637 0-.405-.246-.636-.677-.636h-.573zM7.677 5.744c0-.41.313-.66.869-.691l.64-.038v-.18c0-.26-.176-.415-.47-.415-.277 0-.45.133-.493.342H7.77c.027-.422.387-.733.964-.733.567 0 .929.3.929.768v1.61h-.46v-.383h-.011c-.136.26-.431.424-.738.424-.457 0-.777-.285-.777-.704m1.508-.211v-.185l-.575.036c-.287.02-.449.146-.449.346 0 .205.169.338.427.338.335 0 .597-.231.597-.535M10.097 7.267V6.88a1 1 0 0 0 .155.009c.222 0 .342-.094.416-.334 0-.004.042-.142.042-.144l-.844-2.339h.52l.59 1.901h.01l.59-1.901h.506l-.875 2.459c-.2.566-.43.748-.915.748-.04 0-.16-.004-.195-.01"
  }));
}
var ForwardRef$4G = /*#__PURE__*/forwardRef(ApplePayIcon);

function GooglePayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 14 8",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__GooglePayIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.277 0H3.723C1.676 0 0 1.733 0 3.85S1.676 7.7 3.723 7.7h6.554C12.325 7.7 14 5.968 14 3.85 14 1.733 12.325 0 10.277 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    d: "M10.277.312c.46 0 .906.094 1.327.279.408.179.773.435 1.09.76a3.596 3.596 0 0 1 1.005 2.499 3.6 3.6 0 0 1-1.006 2.499 3.4 3.4 0 0 1-1.089.76c-.42.185-.868.28-1.327.28H3.723c-.46 0-.906-.095-1.327-.28a3.5 3.5 0 0 1-1.09-.76A3.595 3.595 0 0 1 .302 3.85a3.6 3.6 0 0 1 1.006-2.499 3.4 3.4 0 0 1 1.089-.76c.42-.185.868-.28 1.327-.28zm0-.312H3.723C1.676 0 0 1.733 0 3.85S1.676 7.7 3.723 7.7h6.554C12.325 7.7 14 5.968 14 3.85 14 1.733 12.325 0 10.277 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    d: "M6.676 4.123v1.165h-.357V2.412h.947a.84.84 0 0 1 .613.248.81.81 0 0 1 .257.607.82.82 0 0 1-.257.61.84.84 0 0 1-.613.244h-.59zm0-1.357V3.77h.598a.47.47 0 0 0 .353-.148.5.5 0 0 0 .144-.352.48.48 0 0 0-.144-.349.46.46 0 0 0-.353-.152h-.598zM9.07 3.255q.397 0 .626.22.228.219.229.6v1.213h-.34v-.273h-.016q-.22.337-.59.337a.75.75 0 0 1-.527-.193.62.62 0 0 1-.212-.481q0-.306.223-.485.225-.182.596-.181.319 0 .523.121v-.085a.43.43 0 0 0-.147-.327.5.5 0 0 0-.346-.135q-.3 0-.473.262l-.315-.204q.26-.39.77-.389M8.61 4.684q0 .145.119.24a.43.43 0 0 0 .277.096q.226 0 .402-.173a.55.55 0 0 0 .177-.406q-.167-.136-.465-.137a.6.6 0 0 0-.363.108q-.149.113-.147.272M11.868 3.319l-1.191 2.833h-.369l.443-.991-.785-1.842h.389l.566 1.413h.007l.551-1.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M5.254 3.889q0-.181-.03-.347H3.726v.635h.863a.77.77 0 0 1-.32.512V5.1h.514c.3-.287.471-.711.471-1.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M4.27 4.689a.94.94 0 0 1-.543.158c-.416 0-.77-.29-.896-.68h-.53v.424a1.59 1.59 0 0 0 1.426.909c.43 0 .792-.147 1.056-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABB05",
    d: "M2.781 3.851q.001-.166.05-.316V3.11h-.53a1.689 1.689 0 0 0 0 1.481l.53-.425q-.049-.15-.05-.315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E94235",
    d: "M3.727 2.855c.235 0 .445.084.612.247l.455-.47a1.5 1.5 0 0 0-1.067-.43A1.59 1.59 0 0 0 2.3 3.11l.53.425c.127-.39.48-.68.896-.68"
  }));
}
var ForwardRef$4F = /*#__PURE__*/forwardRef(GooglePayIcon);

function MastercardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__MastercardIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M6.107 4.599H9.893V11.402000000000001H6.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M6.347 8A4.32 4.32 0 0 1 8 4.6a4.326 4.326 0 1 0 0 6.803A4.32 4.32 0 0 1 6.347 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M15 8a4.326 4.326 0 0 1-7 3.402 4.326 4.326 0 0 0 0-6.803 4.326 4.326 0 0 1 7 3.4zM14.587 10.68v-.139h.056v-.029H14.5v.03h.061v.139zm.277 0v-.168h-.043l-.05.12-.051-.12h-.038v.169h.03v-.127l.048.11h.032l.047-.11v.128z"
  }));
}
var ForwardRef$4E = /*#__PURE__*/forwardRef(MastercardIcon);

function VippsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VippsIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B24",
    d: "M2.02 3.333h11.96c.563 0 1.02.457 1.02 1.021v7.292a1.02 1.02 0 0 1-1.02 1.02H2.02A1.02 1.02 0 0 1 1 11.647V4.354c0-.564.457-1.02 1.02-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B24",
    d: "M5.813 3.917h4.375a3.938 3.938 0 0 1 0 7.875H5.812a3.937 3.937 0 1 1 0-7.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M9.127 6.91a.733.733 0 0 0 .746-.743.733.733 0 0 0-.746-.743.733.733 0 0 0-.746.743c0 .438.344.743.746.743m.975 1.2c-.497.648-1.023 1.096-1.95 1.096-.947 0-1.683-.571-2.257-1.41-.23-.343-.583-.42-.841-.238-.239.171-.296.534-.076.848.793 1.21 1.892 1.915 3.174 1.915 1.176 0 2.094-.571 2.81-1.524.268-.353.259-.715 0-.915-.238-.19-.592-.124-.86.229",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4D = /*#__PURE__*/forwardRef(VippsIcon);

function VippsLogoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 119.4 30.4",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VippsLogoIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B24",
    d: "m6 .6 5.1 14.9 5-14.9H22l-8.8 22.1H8.8L0 .6zM35.3 19.2c3.7 0 5.8-1.8 7.8-4.4 1.1-1.4 2.5-1.7 3.5-.9s1.1 2.3 0 3.7c-2.9 3.8-6.6 6.1-11.3 6.1-5.1 0-9.6-2.8-12.7-7.7-.9-1.3-.7-2.7.3-3.4s2.5-.4 3.4 1c2.2 3.3 5.2 5.6 9 5.6m6.9-12.3c0 1.8-1.4 3-3 3s-3-1.2-3-3 1.4-3 3-3 3 1.3 3 3M56.3.6v3C57.8 1.5 60.1 0 63.5 0c4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V.6zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8s-5.5 2.1-5.5 6.8M82.3.6v3C83.8 1.5 86.1 0 89.5 0c4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V.6zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8-2.9 0-5.5 2.1-5.5 6.8M110.3 0c4.5 0 7.7 2.1 9.1 7.3l-4.9.8c-.1-2.6-1.7-3.5-4.1-3.5-1.8 0-3.2.8-3.2 2.1 0 1 .7 2 2.8 2.4l3.7.7c3.6.7 5.6 3.1 5.6 6.3 0 4.8-4.3 7.2-8.4 7.2-4.3 0-9.1-2.2-9.8-7.6l4.9-.8c.3 2.8 2 3.8 4.8 3.8 2.1 0 3.5-.8 3.5-2.1 0-1.2-.7-2.1-3-2.5l-3.4-.6c-3.6-.7-5.8-3.2-5.8-6.4.1-5 4.6-7.1 8.2-7.1"
  }));
}
var ForwardRef$4C = /*#__PURE__*/forwardRef(VippsLogoIcon);

function VisaIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__VisaIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1 3.553H15V12.446000000000002H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B600",
    d: "M1.233 11.002H14.766V12.215H1.233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M1.233 3.787H14.766V5H1.233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    d: "M6.65 6.337 5.252 9.672H4.34L3.652 7.01c-.041-.163-.078-.224-.205-.293-.207-.113-.55-.218-.85-.283l.02-.097h1.468c.187 0 .355.124.398.34l.363 1.93.898-2.27zm3.574 2.246c.004-.88-1.217-.929-1.209-1.322.003-.12.117-.247.366-.28.124-.015.464-.028.85.15l.152-.708a2.3 2.3 0 0 0-.807-.147c-.853 0-1.453.453-1.458 1.102-.005.48.429.748.755.908.337.163.45.268.448.414-.002.224-.269.323-.516.327-.434.007-.686-.117-.886-.211l-.157.731c.202.093.574.173.96.177.906 0 1.499-.448 1.502-1.141m2.252 1.089h.798l-.697-3.335h-.736a.39.39 0 0 0-.368.244l-1.294 3.09h.906l.18-.497h1.107zm-.963-1.182.454-1.252.262 1.252zm-3.63-2.153L7.17 9.672h-.863l.713-3.335z"
  }));
}
var ForwardRef$4B = /*#__PURE__*/forwardRef(VisaIcon);

function BanknoteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5H1.636c-.351 0-.636.298-.636.665v9.67c0 .367.285.665.636.665h12.728c.351 0 .636-.298.636-.665v-9.67c0-.367-.285-.665-.636-.665m-.637 1.33v8.34H2.273V3.83zM8 6.4a1.61 1.61 0 1 0 1.612 1.61C9.612 7.12 8.89 6.4 8 6.4m0 .908a.702.702 0 1 1 .001 1.404A.702.702 0 0 1 8 7.308m2.893-2.805H5.107a.465.465 0 0 0-.454.475c0 .74-.574 1.338-1.281 1.338a.465.465 0 0 0-.455.475V9.21c0 .262.204.475.455.475.707 0 1.28.599 1.28 1.338 0 .262.204.475.455.475h5.786a.465.465 0 0 0 .454-.475c0-.74.574-1.338 1.281-1.338a.465.465 0 0 0 .455-.475V6.79a.465.465 0 0 0-.455-.475c-.707 0-1.28-.599-1.28-1.338a.465.465 0 0 0-.455-.475m-.408.95.025.11c.2.794.799 1.418 1.558 1.628l.105.025v1.568l-.105.025c-.76.21-1.357.834-1.558 1.628l-.025.11H5.514l-.024-.11c-.2-.794-.799-1.418-1.558-1.628l-.106-.025V7.216l.106-.025c.76-.21 1.357-.834 1.558-1.628l.024-.11z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4A = /*#__PURE__*/forwardRef(BanknoteIcon);

function BanknoteMultiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.207 2c.322 0 .588.234.63.538l.006.085-.001 1.075h.522c.32 0 .584.23.63.53l.006.093v9.056a.63.63 0 0 1-.636.623H1.636A.63.63 0 0 1 1 13.377V4.321a.63.63 0 0 1 .636-.623h.521V2.623c0-.316.24-.576.55-.617L2.793 2zm.52 2.943H2.273v7.81h11.454zm-2.834.631c.25 0 .454.2.454.445 0 .692.574 1.253 1.281 1.253.251 0 .455.2.455.445v2.264a.45.45 0 0 1-.455.445c-.707 0-1.28.56-1.28 1.253a.45.45 0 0 1-.455.445H5.107a.45.45 0 0 1-.454-.445c0-.692-.574-1.253-1.281-1.253a.45.45 0 0 1-.455-.445V7.717a.45.45 0 0 1 .455-.445c.707 0 1.28-.56 1.28-1.253a.45.45 0 0 1 .455-.445zm-.408.89H5.514l-.024.103A2.17 2.17 0 0 1 3.932 8.09l-.106.023v1.469l.106.024a2.17 2.17 0 0 1 1.558 1.524l.024.103h4.971l.025-.103a2.17 2.17 0 0 1 1.558-1.524l.105-.024V8.114l-.105-.023a2.17 2.17 0 0 1-1.558-1.524zM8 7.23a1.61 1.61 0 1 1-1.612 1.61c0-.89.722-1.61 1.612-1.61m0 .908a.702.702 0 1 0-.001 1.404A.702.702 0 0 0 8 8.138m4.57-4.893H3.43l-.001.453h9.141z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4z = /*#__PURE__*/forwardRef(BanknoteMultiIcon);

function DepositionIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.477 5.529v1.286h-1.21l1.061 1.657c.379.635.615 1.348.663 2.054l.009.265C15 13.134 13.145 15 10.817 15H5.183C2.855 15 1 13.134 1 10.79c0-.867.23-1.685.688-2.344l1.08-1.631H1.581V5.53zm-2.729 1.286H4.302L2.743 9.172a2.65 2.65 0 0 0-.438 1.189l-.021.226-.006.204c0 1.632 1.282 2.923 2.905 2.923h5.634c1.623 0 2.905-1.29 2.905-2.923 0-.546-.178-1.134-.479-1.64zM5.5 1a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 5.5 1m5 0a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 10.5 1",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4y = /*#__PURE__*/forwardRef(DepositionIcon);

function DiffIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.103 8.885 1.012 1.012-2.045 2.045 2.045 2.046L6.103 15l-2.046-2.045L2.012 15 1 13.988l2.045-2.046L1 9.897l1.012-1.012 2.045 2.044zM15 12.249v1.432H9.478v-1.432zm0-3.068v1.432H9.478V9.18zM4.774 1l-.001 2.045h2.046v1.432H4.773v2.045H3.343L3.34 4.477H1.297V3.045H3.34V1zM15 3.045v1.432H9.478V3.045z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4x = /*#__PURE__*/forwardRef(DiffIcon);

function EuroIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m0 1.273a5.727 5.727 0 1 1 0 11.454A5.727 5.727 0 0 1 8 2.273m.579 2.198c.68 0 1.373.214 1.935.579l.182.127.509.382-.764 1.018-.509-.382a2.34 2.34 0 0 0-1.353-.451c-.735 0-1.376.331-1.785.857L9 6.6v1H6.356a2.4 2.4 0 0 0-.01.736H9v1H6.747c.406.562 1.068.92 1.832.92a2.35 2.35 0 0 0 1.208-.352l.145-.099.51-.382.763 1.018-.51.382a3.6 3.6 0 0 1-2.116.706 3.5 3.5 0 0 1-3.274-2.193H4.3v-1h.765A3.7 3.7 0 0 1 5.07 7.6H4.3v-1h1.03A3.5 3.5 0 0 1 8.58 4.471",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4w = /*#__PURE__*/forwardRef(EuroIcon);

function MoneyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.972 1c1.776 0 3.292.758 3.292 1.943 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.01l-.007.127q.37-.047.76-.048c1.776 0 3.292.758 3.292 1.944 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.01 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.009 0 .387-.162.729-.442 1.013.28.285.442.625.442 1.01 0 1.185-1.516 1.943-3.292 1.943s-3.292-.758-3.292-1.943l.007-.128a6 6 0 0 1-.76.049c-1.776 0-3.292-.759-3.292-1.944 0-.384.162-.725.442-1.01-.28-.284-.442-.625-.442-1.012 0-.385.162-.725.443-1.01-.281-.284-.443-.626-.443-1.013 0-.385.162-.726.443-1.01-.28-.284-.443-.626-.443-1.013 0-.385.162-.726.443-1.01-.281-.284-.443-.626-.443-1.013C2.68 1.758 4.196 1 5.972 1m5.803 11.698-.06.02c-.5.168-1.083.26-1.698.26a5.4 5.4 0 0 1-1.758-.28c-.235.137-.344.273-.344.359 0 .304.899.753 2.102.753s2.102-.449 2.102-.753c0-.086-.109-.222-.344-.36m-7.561-2.022c-.235.136-.344.272-.344.358 0 .304.899.754 2.102.754.328 0 .643-.033.928-.093a1.33 1.33 0 0 1-.175-.661l.007-.128a6 6 0 0 1-.76.049c-.64 0-1.245-.098-1.758-.28m7.561 0-.059.02c-.5.168-1.084.259-1.699.259a5.4 5.4 0 0 1-1.757-.28c-.236.137-.345.273-.345.359 0 .112.123.245.338.367a.2.2 0 0 1 .038.018l-.038-.018q.06.034.13.067.09.02.168.07c.371.144.883.25 1.466.25.58 0 1.089-.105 1.46-.247a.6.6 0 0 1 .18-.077c.293-.138.462-.298.462-.43 0-.086-.108-.222-.344-.359m0-2.024-.059.021c-.5.168-1.084.259-1.699.259a5.4 5.4 0 0 1-1.758-.28c-.235.137-.344.273-.344.36 0 .095.09.206.25.312a.6.6 0 0 1 .237.129l.011.006q.065.017.12.051c.374.146.893.255 1.484.255 1.204 0 2.103-.45 2.103-.754 0-.086-.11-.222-.345-.359m-7.561 0c-.236.138-.344.274-.344.36 0 .128.161.284.439.42q.133.022.241.099c.367.137.861.234 1.422.234.328 0 .644-.033.929-.093a1.3 1.3 0 0 1-.175-.66l.007-.129a6 6 0 0 1-.761.05c-.64 0-1.245-.1-1.758-.28m0-2.022c-.235.136-.344.272-.344.359 0 .141.194.314.522.458l.009.003c.376.165.93.293 1.57.293.33 0 .645-.034.93-.094a1.3 1.3 0 0 1-.175-.66l.007-.128q-.369.048-.761.048a5.4 5.4 0 0 1-1.757-.279m5.803-.395c-1.203 0-2.102.45-2.102.754 0 .1.1.218.276.33q.07.02.131.061l.043.034.022.01a.6.6 0 0 1 .157.066c.372.146.886.252 1.473.252.563 0 1.059-.098 1.428-.233a.56.56 0 0 1 .232-.1c.28-.136.443-.291.443-.42 0-.305-.9-.754-2.103-.754M7.73 4.607l-.06.02c-.5.169-1.083.26-1.698.26a5.4 5.4 0 0 1-1.758-.28c-.235.136-.344.272-.344.359 0 .129.162.284.44.42a.6.6 0 0 1 .24.099c.366.137.86.234 1.422.234 1.203 0 2.102-.449 2.102-.753 0-.086-.109-.222-.344-.359M5.972 2.19c-1.203 0-2.102.449-2.102.753 0 .13.161.284.439.42a.6.6 0 0 1 .243.1c.366.137.86.234 1.42.234.586 0 1.1-.107 1.473-.251a.5.5 0 0 1 .153-.068c.3-.137.476-.3.476-.435 0-.304-.899-.753-2.102-.753",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4v = /*#__PURE__*/forwardRef(MoneyIcon);

function PriceFromIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.037 1.018 2.147.548q.106.027.193.091a.52.52 0 0 1 .2.556l-.575 2.043a.56.56 0 0 1-.68.374.526.526 0 0 1-.394-.648l.228-.81-3.602 1.98-2.038 1.112-.388.227a.58.58 0 0 1-.422.053.55.55 0 0 1-.337-.246.514.514 0 0 1 .204-.723L6.48 3.972 9.6 2.257l-.852-.218a.527.527 0 0 1-.393-.647.56.56 0 0 1 .68-.374M5.778 13.943c1.104 0 2.058-.269 2.746-.721.012.063.032.126.032.192C8.556 14.318 7.36 15 5.778 15 4.194 15 3 14.318 3 13.414c0-.066.02-.129.032-.192.688.452 1.642.72 2.746.72M3 11.299c0-.904 1.194-1.586 2.778-1.586s2.778.682 2.778 1.586-1.194 1.586-2.778 1.586S3 12.203 3 11.299m7.222-.53c1.104 0 2.059-.267 2.746-.72.013.064.032.126.032.192 0 .905-1.194 1.587-2.778 1.587a5 5 0 0 1-.62-.039c.04-.16.065-.323.065-.49 0-.198-.032-.387-.085-.568.208.02.419.039.64.039M7.445 8.127c0-.904 1.193-1.586 2.777-1.586S13 7.222 13 8.126s-1.194 1.587-2.778 1.587-2.777-.682-2.777-1.587m2.777 4.76c1.104 0 2.059-.269 2.746-.722.013.064.032.126.032.192 0 .904-1.194 1.587-2.778 1.587a5 5 0 0 1-.62-.04c.04-.16.065-.321.065-.49q-.002-.291-.083-.567c.207.02.417.039.638.039"
  }));
}
var ForwardRef$4u = /*#__PURE__*/forwardRef(PriceFromIcon);

function PricelistIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.92 12.113c-.41.046-.705.358-.705.756v1.495a.636.636 0 0 1-.636.636H1.636A.636.636 0 0 1 1 14.364v-1.736c0-.99.803-1.793 1.793-1.793l1.678-.001V1.636c0-.322.24-.588.55-.63L5.107 1h9.257c.322 0 .588.24.63.55l.006.086v11.281a2.082 2.082 0 1 1-4.165 0c0-.455-.292-.76-.705-.804l-.105-.006zm2.187.804a.81.81 0 0 0 1.614.102l.006-.102V2.273H5.744l-.001 8.561h4.282c1.149 0 2.082.863 2.082 2.083m-4.018-.81H2.793a.52.52 0 0 0-.52.521v1.1h5.669v-.859q.001-.36.115-.678zm4.018-7.636v1.273H7.364V4.47zm0 2.893v1.272H7.364V7.364z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4t = /*#__PURE__*/forwardRef(PricelistIcon);

function ReferenceIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.697 1c.169 0 .33.067.45.186l6.667 6.667a.636.636 0 0 1 0 .9l-6.061 6.06a.636.636 0 0 1-.9 0L1.186 8.148A.64.64 0 0 1 1 7.697V3.455c0-.17.067-.331.186-.45l1.819-1.819A.64.64 0 0 1 3.455 1zm-.263 1.273H3.716L2.273 3.716v3.718l6.03 6.03 5.16-5.161zM5.1 4a1.1 1.1 0 1 1 .001 2.199A1.1 1.1 0 0 1 5.1 4",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4s = /*#__PURE__*/forwardRef(ReferenceIcon);

function ShoppingCartIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.3 12a1.499 1.499 0 1 0 0 2.997A1.499 1.499 0 1 0 5.3 12m7 0a1.499 1.499 0 1 0 0 2.997 1.499 1.499 0 1 0 0-2.997M3.455 1c.285 0 .532.19.61.457l.02.091.327 2.344h9.951c.373 0 .66.317.636.677l-.013.09-1.212 5.785a.64.64 0 0 1-.524.499l-.099.007H4.667a.64.64 0 0 1-.61-.456l-.02-.092L2.9 2.272H1V1zm10.124 4.164h-8.99l.63 4.513h7.414z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4r = /*#__PURE__*/forwardRef(ShoppingCartIcon);

function StatsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.28 2.5H6.72a.61.61 0 0 0-.598.621v9.758a.61.61 0 0 0 .598.621h2.56a.61.61 0 0 0 .598-.621V3.121A.61.61 0 0 0 9.28 2.5m-.597 1.242v8.516H7.317V3.742zM4.159 8.71H1.598A.61.61 0 0 0 1 9.33v3.549a.61.61 0 0 0 .598.621h2.56a.61.61 0 0 0 .598-.621V9.331a.61.61 0 0 0-.597-.621M3.56 9.952v2.306H2.195V9.952zm10.841-4.79h-2.56a.61.61 0 0 0-.598.62v7.097a.61.61 0 0 0 .597.621h2.561a.61.61 0 0 0 .598-.621V5.782a.61.61 0 0 0-.598-.62m-.597 1.241v5.855h-1.366V6.403z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4q = /*#__PURE__*/forwardRef(StatsIcon);

function FacebookIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.418 15 6.4 8.875H4V6.25h2.4V4.5C6.4 2.138 7.738 1 9.664 1c.922 0 1.715.075 1.946.108v2.469h-1.336c-1.048 0-1.25.545-1.25 1.344V6.25H12l-.8 2.625H9.024V15z"
  }));
}
var ForwardRef$4p = /*#__PURE__*/forwardRef(FacebookIcon);

function GithubIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"
  }));
}
var ForwardRef$4o = /*#__PURE__*/forwardRef(GithubIcon);

function GoogleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4s2-4.4 4.3-4.4c1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2z"
  }));
}
var ForwardRef$4n = /*#__PURE__*/forwardRef(GoogleIcon);

function InstagramIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 2.75c-.818 0-1.75.932-1.75 1.75v7c0 .834.916 1.75 1.75 1.75h7c.818 0 1.75-.932 1.75-1.75v-7c0-.818-.932-1.75-1.75-1.75zm7 12.25h-7C2.701 15 1 13.299 1 11.5v-7C1 2.701 2.701 1 4.5 1h7C13.299 1 15 2.701 15 4.5v7c0 1.799-1.701 3.5-3.5 3.5M8 6.25c-.965 0-1.75.785-1.75 1.75S7.035 9.75 8 9.75 9.75 8.965 9.75 8 8.965 6.25 8 6.25m0 5.25c-1.93 0-3.5-1.57-3.5-3.5S6.07 4.5 8 4.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5m3.627-7.935a.84.84 0 1 1 0 1.68.84.84 0 0 1 0-1.68"
  }));
}
var ForwardRef$4m = /*#__PURE__*/forwardRef(InstagramIcon);

function LinkedinIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 12.924h-1.946v-2.81c0-.684 0-1.52-.973-1.52s-1.135.76-1.135 1.52V13H7V7.152h1.865v.76C9.108 7.455 9.757 7 10.649 7c1.946 0 2.27 1.215 2.27 2.734v3.19zM4 5c-.571 0-1-.5-1-1 0-.571.429-1 1-1s1 .429 1 1c-.071.5-.5 1-1 1m.917 8H3V7h2v6zm9.387-12H1.61A.596.596 0 0 0 1 1.613v12.862c0 .263.26.525.609.525H14.39a.596.596 0 0 0 .609-.613V1.613c-.087-.35-.348-.613-.696-.613",
    clipRule: "evenodd",
    transform: "translate(-1137 -141) translate(1136 140)"
  }));
}
var ForwardRef$4l = /*#__PURE__*/forwardRef(LinkedinIcon);

function SkypeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 12.025c-2.362 0-3.412-1.138-3.412-2.013 0-.437.35-.787.787-.787.963 0 .788 1.4 2.625 1.4.963 0 1.488-.525 1.488-1.05 0-1.05-1.225-.875-2.888-1.313S4.675 6.95 4.675 6.075c0-1.75 1.663-2.45 3.238-2.45 1.487 0 3.15.787 3.15 1.837 0 .438-.438.7-.876.7-.874 0-.7-1.225-2.45-1.225-.875 0-1.312.35-1.312.963 0 .787 1.575.962 2.8 1.225 1.663.437 2.1 1.4 2.1 2.275.088 1.575-1.05 2.625-3.325 2.625m6.475-2.888c.088-.35.525-3.325-1.837-5.862-2.188-2.363-5.6-1.925-5.95-1.838C6.161 1.175 5.55 1 4.937 1 1.874 1 1 3.887 1 4.937s.525 1.925.525 1.925c-.35 1.4.088 2.888.35 3.675.788 2.013 2.713 3.15 3.5 3.5 1.925.788 3.5.438 3.763.438.612.35 1.224.525 1.924.525 1.05 0 3.938-.875 3.938-3.938 0-1.05-.525-1.925-.525-1.925"
  }));
}
var ForwardRef$4k = /*#__PURE__*/forwardRef(SkypeIcon);

function TwitterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 4.27c-.525.253-1.05.338-1.662.422.612-.338 1.05-.846 1.225-1.523-.526.339-1.138.508-1.838.677a3.1 3.1 0 0 0-2.1-.846c-1.487 0-2.8 1.27-2.8 2.792 0 .254 0 .423.088.593C5.55 6.3 3.363 5.2 1.963 3.508c-.263.423-.35.846-.35 1.438 0 .93.525 1.777 1.312 2.285-.437 0-.875-.17-1.312-.339 0 1.354.962 2.454 2.275 2.708-.263.085-.526.085-.788.085-.175 0-.35 0-.525-.085.35 1.1 1.4 1.946 2.713 1.946-.963.762-2.188 1.185-3.588 1.185H1C2.313 13.492 3.8 14 5.375 14c5.25 0 8.137-4.23 8.137-7.87v-.338c.613-.423 1.138-.93 1.488-1.523"
  }));
}
var ForwardRef$4j = /*#__PURE__*/forwardRef(TwitterIcon);

function VimeoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.993 4.849c-.088 1.381-1.05 3.194-2.886 5.525C10.183 12.791 8.609 14 7.297 14c-.787 0-1.487-.777-2.1-2.245-.699-2.072-1.224-6.302-2.448-6.302-.087 0-.437.26-1.05.69L1 5.282c.7-.605 3.06-2.936 4.11-3.022s1.75.604 2.012 2.158c.262 1.727.7 5.266 1.574 5.266.787 0 2.186-2.935 2.274-3.453.087-.777-.263-1.64-2.012-.95C9.658 3.037 10.97 2 12.894 2q2.23.13 2.099 2.849"
  }));
}
var ForwardRef$4i = /*#__PURE__*/forwardRef(VimeoIcon);

function YoutubeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 10.5v-5L10.625 8zm8.575-5.167c-.175-1.083-.7-1.833-1.925-2C10.975 3 8 3 8 3s-2.975 0-4.9.333c-1.225.167-1.838.917-1.925 2C1 6.417 1 8 1 8s0 1.583.175 2.667.7 1.833 1.925 2C5.025 13 8 13 8 13s2.975 0 4.9-.333c1.225-.25 1.75-.917 1.925-2S15 8 15 8s0-1.583-.175-2.667"
  }));
}
var ForwardRef$4h = /*#__PURE__*/forwardRef(YoutubeIcon);

function BatteryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.05 4c.351 0 .636.278.636.62l-.001 1.07h1.679c.322 0 .588.233.63.536L15 6.31v3.38c0 .314-.24.573-.55.614l-.086.006h-1.679l.001 1.07a.625.625 0 0 1-.542.613L12.05 12H1.636A.63.63 0 0 1 1 11.38V4.62c0-.342.285-.62.636-.62zM5.292 5.24h-3.02v5.52h5.854zm6.12 0H6.717l2.834 5.52h1.863zm1.273 3.83h1.042V6.93h-1.042z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4g = /*#__PURE__*/forwardRef(BatteryIcon);

function CalculatorIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 6.5H9V8H7.5zM5 6.5h1.5V8H5zM7.5 9H9v1.5H7.5zM5 9h1.5v1.5H5zM7.5 11.5H9V13H7.5zM5 11.5h1.5V13H5zM10 6.5h1V13h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.29 1c.947 0 1.71.805 1.71 1.793v10.414c0 .988-.763 1.793-1.71 1.793H4.71C3.764 15 3 14.195 3 13.207V2.793C3 1.805 3.763 1 4.71 1zm-7.062 9.371v2.836c0 .258.173.468.396.512l.087.008h6.579c.264 0 .482-.23.482-.52l-.001-2.836V5.5H4.228v4.871m0-5.871h7.543V2.794a.51.51 0 0 0-.395-.513l-.086-.008H4.71c-.264 0-.482.23-.482.52V4.5",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4f = /*#__PURE__*/forwardRef(CalculatorIcon);

function CameraIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.421 1.5-.09.006a.64.64 0 0 0-.439.28l-.97 1.47H1.637A.64.64 0 0 0 1 3.902v9.955a.64.64 0 0 0 .636.644h12.728a.64.64 0 0 0 .636-.644V3.9l-.006-.088a.64.64 0 0 0-.63-.556H12.39l-.968-1.47a.63.63 0 0 0-.53-.287zm3.13 1.288.97 1.47.054.073c.12.135.292.214.475.214h1.677v8.666H2.273V4.545h3.991l.09-.006a.64.64 0 0 0 .44-.28l.968-1.47zM9 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 1.262a2.238 2.238 0 1 1 0 4.476 2.238 2.238 0 0 1 0-4.476M4.075 5.4a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4e = /*#__PURE__*/forwardRef(CameraIcon);

function DatabaseIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c3.312 0 6 .92 6 2.5q0 .036-.002.07l.002.053v9.056C14 14.165 11.352 15 8 15c-3.261 0-5.856-.79-5.994-2.202L2 12.68V3.623l.004-.047L2 3.5c0-1.537 2.54-2.448 5.725-2.498zM3.307 12.68c0 .425 2.063 1.075 4.693 1.075 2.545 0 4.56-.61 4.687-1.034l.006-.042v-2.477C11.602 10.722 9.916 11 8 11s-3.6-.278-4.694-.798zm9.387-7.539C11.594 5.697 9.9 6 8 6s-3.595-.303-4.694-.859v3.494C3.307 9.068 5.37 9.73 8 9.73s4.693-.663 4.693-1.096zM8 2.341c-2.594 0-4.693.719-4.693 1.159S5.407 4.659 8 4.659s4.693-.719 4.693-1.159S10.593 2.341 8 2.341",
    clipRule: "evenodd",
    transform: "translate(-1210 -463) translate(1208 462)"
  }));
}
var ForwardRef$4d = /*#__PURE__*/forwardRef(DatabaseIcon);

function DesktopIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.893 14.5v-1.235l3.47-.001v-1.706H1.636a.63.63 0 0 1-.63-.526L1 10.942V2.117c0-.341.285-.618.636-.618h12.728c.351 0 .636.277.636.618v8.823a.627.627 0 0 1-.636.618l-5.728-.001v1.706h3.471V14.5zm9.834-11.765H2.273v7.589h11.454z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4c = /*#__PURE__*/forwardRef(DesktopIcon);

function ImageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 1c.351 0 .636.285.636.636v12.728a.636.636 0 0 1-.636.636H1.636A.636.636 0 0 1 1 14.364V1.636C1 1.285 1.285 1 1.636 1zm-.637 1.273H2.273v11.454h11.454zm-4.614 4.8a.58.58 0 0 1 .942.054l2.63 4.208a.579.579 0 0 1-.49.885H3.778a.579.579 0 0 1-.48-.9l2.103-3.155a.58.58 0 0 1 .89-.088l1.12 1.12zm.393 1.36-1.593 1.992a.58.58 0 0 1-.861.048l-1.08-1.08-1.112 1.67h6.29zM6.935 3.7a1.63 1.63 0 1 1 0 3.26 1.63 1.63 0 0 1 0-3.26m0 1.157a.473.473 0 1 0 0 .946.473.473 0 0 0 0-.946",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4b = /*#__PURE__*/forwardRef(ImageIcon);

function LaptopIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.247 2c.647 0 1.178.486 1.239 1.106l.005.118v5.842l1.407 3.228c.336.77-.197 1.625-1.023 1.7l-.12.006H2.245c-.892 0-1.494-.898-1.143-1.706l1.406-3.23v-5.84c0-.636.494-1.16 1.124-1.218L3.752 2zm.187 7.82h-8.87L2.29 12.747h11.418zm-.217-6.566H3.782v5.313h8.435z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$4a = /*#__PURE__*/forwardRef(LaptopIcon);

function MobileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 11.3a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4M11.29 1c.947 0 1.71.805 1.71 1.793v10.414c0 .988-.763 1.793-1.71 1.793H4.71C3.764 15 3 14.195 3 13.207V2.793C3 1.805 3.763 1 4.71 1zm.481 9.371H4.228v2.836c0 .258.173.468.396.512l.087.008h6.578c.265 0 .483-.23.483-.52zm0-5.785H4.228v4.513h7.543zm-.482-2.313H4.711c-.265 0-.483.23-.483.52v.521h7.543v-.52a.51.51 0 0 0-.395-.513z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$49 = /*#__PURE__*/forwardRef(MobileIcon);

function PhoneIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.922 1.765a.636.636 0 0 1 .9 0l2.892 2.892a.636.636 0 0 1 0 .9L5.428 6.843l3.728 3.728 1.287-1.285a.64.64 0 0 1 .82-.068l.08.068 2.892 2.892a.636.636 0 0 1 0 .9L12.5 14.814a.64.64 0 0 1-.45.186C5.947 15 1 10.053 1 3.95c0-.168.067-.33.186-.45zm.45 1.35L2.276 4.21c.134 5.106 4.182 9.237 9.254 9.503l.26.01 1.095-1.097-1.993-1.992-1.285 1.286a.64.64 0 0 1-.821.067l-.079-.067-4.628-4.628a.636.636 0 0 1 0-.9l1.285-1.286zM9.157 1a5.843 5.843 0 0 1 5.84 5.633l.003.21h-1.273a4.57 4.57 0 0 0-4.372-4.566l-.198-.004zm0 2.314a3.53 3.53 0 0 1 3.524 3.347l.005.182h-1.273a2.257 2.257 0 0 0-2.108-2.251l-.148-.005z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$48 = /*#__PURE__*/forwardRef(PhoneIcon);

function PrinterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.471 1c.322 0 .588.24.63.55l.006.086v2.312a3.49 3.49 0 0 1 2.888 3.29L15 7.42v4.686h-2.893v2.257c0 .32-.235.584-.542.63l-.094.006H4.53a.636.636 0 0 1-.636-.636l-.001-2.257H1V7.421a3.496 3.496 0 0 1 2.892-3.473V1.636c0-.322.24-.588.55-.63L4.53 1zm-.636 8.793h-5.67v3.934h5.67zm.636-4.628H4.53c-1.218 0-2.177.91-2.252 2.106l-.004.15v3.414l1.619-.001V9.157c0-.32.236-.584.543-.63l.094-.006h6.942c.352 0 .636.285.636.636v1.677h1.62V7.422c0-1.217-.91-2.176-2.105-2.251zm-.636-2.892h-5.67v1.619h5.669zm.62 3.909a.637.637 0 1 1 0 1.273.637.637 0 0 1 0-1.273",
    clipRule: "evenodd"
  }));
}
var ForwardRef$47 = /*#__PURE__*/forwardRef(PrinterIcon);

function QRIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 10.5V12H15v3h-1.5v-1.5h-3V15H9v-1.5h1.5V12H12v-1.5zM12 9v1.5h-1.5V12H9V9zm3 0v1.5h-1.5V9zM6.41 1a.59.59 0 0 1 .59.59v4.82a.59.59 0 0 1-.59.59H1.59A.59.59 0 0 1 1 6.41V1.59A.59.59 0 0 1 1.59 1zm8 0a.59.59 0 0 1 .59.59v4.82a.59.59 0 0 1-.59.59H9.59A.59.59 0 0 1 9 6.41V1.59A.59.59 0 0 1 9.59 1zm-8 8a.59.59 0 0 1 .59.59v4.82a.59.59 0 0 1-.59.59H1.59a.59.59 0 0 1-.59-.59V9.59A.59.59 0 0 1 1.59 9zM14 2v4h-4V2zm-8 8v4H2v-4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$46 = /*#__PURE__*/forwardRef(QRIcon);

function SaveIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.471 1c.206 0 .398.1.518.266l2.892 4.05a.64.64 0 0 1 .119.37v8.678a.636.636 0 0 1-.636.636H1.636A.636.636 0 0 1 1 14.364V1.636C1 1.285 1.285 1 1.636 1zm-.327 1.273-.773-.001v3.414c0 .322-.239.588-.55.63l-.085.006H3.95a.636.636 0 0 1-.63-.55l-.006-.086V2.272H2.273v11.455h1.041V8.579c0-.323.24-.589.55-.631l.086-.006h8.1c.322 0 .588.24.63.55l.006.087-.001 5.148h1.042V5.89zm.269 6.942H4.586v4.512h6.827zm-1.677 1.62v1.272H6.264v-1.272zm-.637-8.563H4.586v2.777H9.1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$45 = /*#__PURE__*/forwardRef(SaveIcon);

function AlignCenterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.107 12.6V14H3.893v-1.4zM15 9.1v1.4H1V9.1zm-2.893-3.6v1.4H3.893V5.5zM15 2v1.4H1V2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$44 = /*#__PURE__*/forwardRef(AlignCenterIcon);

function AlignLeftIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2v1.4H1V2zM9.215 5.5v1.4H1V5.5zM15 9.1v1.307H1V9.1zm-5.785 3.5V14H1v-1.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$43 = /*#__PURE__*/forwardRef(AlignLeftIcon);

function AlignRightIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2v1.4H1V2zm0 3.5v1.4H6.785V5.5zm0 3.6v1.4H1V9.1zm0 3.5V14H6.785v-1.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$42 = /*#__PURE__*/forwardRef(AlignRightIcon);

function AttachmentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.816 1c1.78 0 3.22 1.35 3.311 3.067l.005.173v5.785c0 1.161-.943 2.082-2.132 2.082-1.14 0-2.053-.846-2.127-1.938l-.005-.144V5.107h1.303v4.918c0 .458.36.81.829.81.433 0 .773-.3.823-.706l.006-.104V4.24c0-1.095-.893-1.967-2.013-1.967-1.072 0-1.935.798-2.008 1.825l-.005.142v6.363c0 1.731 1.425 3.124 3.197 3.124 1.713 0 3.102-1.301 3.193-2.952l.004-.172V3.372H12.5v7.231C12.5 13.037 10.491 15 8 15c-2.424 0-4.391-1.858-4.496-4.2l-.004-.197V4.24C3.5 2.442 4.976 1 6.816 1",
    clipRule: "evenodd"
  }));
}
var ForwardRef$41 = /*#__PURE__*/forwardRef(AttachmentIcon);

function BoldIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.188 1c2.001 0 3.624 1.58 3.624 3.529a3.48 3.48 0 0 1-1.229 2.648C13.012 7.835 14 9.251 14 10.893c0 2.203-1.782 4.002-4.02 4.103L9.783 15H2v-1.273h1.187l.001-6.306V2.272H2V1zm.594 7.058H4.494v5.67h5.288c1.608 0 2.911-1.27 2.911-2.835 0-1.512-1.215-2.747-2.746-2.83zM4.495 6.785h4.693c1.28 0 2.317-1.01 2.317-2.256 0-1.196-.956-2.175-2.165-2.251l-.152-.005-4.693-.001z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$40 = /*#__PURE__*/forwardRef(BoldIcon);

function BulletListIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 1.58a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.69a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.68a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M15 2.671v1.4H6v-1.4zm0 4.685v1.4H6v-1.4zm0 4.685v1.4H6v-1.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3$ = /*#__PURE__*/forwardRef(BulletListIcon);

function ItalicIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1v1.325h-1.831l-3.005 11.35h1.48V15H4v-1.325h1.829l3.006-11.35H7.357V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3_ = /*#__PURE__*/forwardRef(ItalicIcon);

function LinkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.508 2.1c1.468-1.467 3.924-1.467 5.391 0 1.419 1.42 1.466 3.762.142 5.242l-.142.15-2.055 2.055-.906-.906 2.055-2.055c.967-.967.967-2.612 0-3.58-.927-.926-2.476-.965-3.455-.115l-.124.116L7.36 5.062l-.906-.906zM4.156 6.454l.906.906-2.055 2.055c-.967.967-.967 2.612 0 3.58.927.926 2.476.965 3.455.115l.124-.116 2.055-2.055.906.906L7.492 13.9c-1.468 1.468-3.924 1.468-5.391 0-1.419-1.418-1.466-3.76-.142-5.241l.142-.15zm5.313-.828.906.906-3.844 3.844-.906-.906z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3Z = /*#__PURE__*/forwardRef(LinkIcon);

function NumberListIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.361 4.617V4.19l.468-.038c.076-.005.087-.027.087-.108V2.155c0-.065-.016-.097-.071-.113l-.473-.098.06-.444h1.305v2.544c0 .086.005.103.087.108l.445.038v.427zm-.282 4.85v-.503l.729-.71c.548-.53.782-.746.782-1.055 0-.2-.098-.346-.386-.346-.3 0-.424.097-.424.482l-.74-.065c.006-.86.664-1.002 1.234-1.002.843 0 1.142.357 1.142.866s-.353.844-.75 1.223l-.614.585h.799c.054 0 .076-.01.087-.065l.076-.427h.576v1.017zm1.834 3.15c.463.07.717.346.717.833 0 .715-.537 1.05-1.314 1.05-.55 0-1.038-.195-1.316-.498l.435-.476c.207.2.434.357.815.357.305 0 .565-.108.565-.487 0-.33-.206-.465-.543-.465-.136 0-.239.01-.403.037v-.54l.267-.033c.391-.049.603-.238.603-.584 0-.206-.092-.374-.396-.374-.294 0-.435.098-.435.482l-.744-.066c0-.854.646-1 1.217-1 .836 0 1.158.319 1.158.898a.85.85 0 0 1-.626.844zM15 2.367v1.4H5v-1.4zm0 4.81v1.4H5v-1.4zm0 4.808v1.4H5v-1.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3Y = /*#__PURE__*/forwardRef(NumberListIcon);

function SourceCodeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.182 4.5.9.9-2.547 2.545 2.547 2.546-.9.9-2.996-2.996a.64.64 0 0 1-.067-.82l.067-.08zm7.636 0 2.996 2.995a.64.64 0 0 1 .067.822l-.067.078-2.996 2.996-.9-.9 2.547-2.546L10.918 5.4zM8.81 2l1.234.316L7.19 14l-1.234-.316z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3X = /*#__PURE__*/forwardRef(SourceCodeIcon);

function TextColorIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 11.413c.351 0 .636.285.636.637v2.314a.636.636 0 0 1-.636.636H1.636A.636.636 0 0 1 1 14.364V12.05c0-.352.285-.637.636-.637zm-.637 1.272H2.273v1.042h11.454zM8.58 1c.239 0 .455.134.563.341l.036.081L11.919 9.1h1.345v1.273H9.678V9.099h.889L9.782 6.9H6.217l-.785 2.199h.89v1.273H2.736V9.099H4.08l1.084-3.033.005-.015 1.653-4.629a.64.64 0 0 1 .511-.416L7.421 1zM8.13 2.273h-.26L6.67 5.628h2.657z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3W = /*#__PURE__*/forwardRef(TextColorIcon);

function UnderlineIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.727V15H1v-1.273zM5.744 1v1.273l-1.158-.001V8a3.413 3.413 0 0 0 6.822.181L11.413 8V2.272h-1.157V1h3.587v1.273l-1.158-.001L12.686 8a4.686 4.686 0 0 1-9.368.198L3.314 8V2.272H2.157V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3V = /*#__PURE__*/forwardRef(UnderlineIcon);

function UnlinkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.49 2.317c1.413-1.413 3.779-1.413 5.193 0 1.366 1.367 1.412 3.623.136 5.05l-.136.144-1.98 1.979-.873-.873 1.98-1.98c.931-.93.931-2.515 0-3.447-.893-.893-2.385-.93-3.328-.111l-.12.111-1.98 1.98-.872-.873zM4.296 6.51l.873.873-1.98 1.98c-.931.93-.931 2.515 0 3.447.893.893 2.385.93 3.328.111l.12-.111 1.98-1.98.872.873-1.98 1.98c-1.413 1.413-3.779 1.413-5.193 0-1.366-1.367-1.412-3.623-.136-5.05l.136-.144zm5.118-.798.873.873-3.703 3.703-.873-.873zm2.695 5.65.552-1.104L15 11.428l-.552 1.103zm-1.852 1.3 1.104-.552 1.17 2.338-1.105.552zm-6.79-11.11L4.574 1l1.17 2.338-1.105.552zM1.553 3.469 3.89 4.638l-.552 1.104L1 4.572z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3U = /*#__PURE__*/forwardRef(UnlinkIcon);

function AppleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__AppleIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.168 2.235C8.682 1.644 9.029.82 8.934 0c-.741.028-1.639.47-2.17 1.06-.478.525-.895 1.363-.783 2.166.828.061 1.672-.399 2.187-.991m1.855 5.203c.02 2.118 1.956 2.823 1.977 2.832-.016.05-.31 1.005-1.02 1.992-.614.852-1.251 1.701-2.256 1.72-.986.017-1.304-.556-2.432-.556s-1.48.537-2.414.573c-.97.034-1.708-.922-2.327-1.772C.285 10.489-.683 7.315.617 5.173a3.64 3.64 0 0 1 3.05-1.754c.951-.018 1.85.608 2.431.608.582 0 1.674-.752 2.822-.642.48.02 1.83.184 2.695 1.389-.07.041-1.61.893-1.592 2.664",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3T = /*#__PURE__*/forwardRef(AppleIcon);

function FigmaIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 24 25",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__FigmaIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24CB71",
    d: "M6 18.914a3 3 0 0 1 3-3h3v3a3 3 0 0 1-6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7237",
    d: "M12 3.914v6h3a3 3 0 0 0 0-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B6FF",
    d: "M15 15.914a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3737",
    d: "M6 6.914a3 3 0 0 0 3 3h3v-6H9a3 3 0 0 0-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#874FFF",
    d: "M6 12.914a3 3 0 0 0 3 3h3v-6H9a3 3 0 0 0-3 3"
  }));
}
var ForwardRef$3S = /*#__PURE__*/forwardRef(FigmaIcon);

function GooglePlayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 12.5 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__GooglePlayIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.26 6.495 9.73 5.024 7.65 7.05 9.55 8.902l2.71-1.575a.48.48 0 0 0 .239-.416.48.48 0 0 0-.24-.416M9.303 4.77 6.517 3.153.414 0l6.891 6.716zM.517 14l6.01-3.338 2.595-1.509-1.815-1.77zM.007.273 0 13.833 6.964 7.05z"
  }));
}
var ForwardRef$3R = /*#__PURE__*/forwardRef(GooglePlayIcon);

function MuralIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 24 25",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__MuralIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m19.692 9.406 3.14.181v11.942h-3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843F",
    d: "M16.027 9.587c0-1.01.813-1.823 1.822-1.823.208-1.117.242-2.174 0-3.139-2.721 0-4.939 2.218-4.939 4.962v8.825l3.14.23V9.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC83FF",
    d: "M19.693 9.587h3.139c-.023-2.744-2.239-4.962-4.962-4.962v3.14c1.01 0 1.822.812 1.822 1.822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0",
    d: "M16.027 21.522v-3.14h-5.132l.193 3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5887FF",
    d: "M7.97 21.522h3.118V9.579L7.97 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m1.188 9.58 3.139-.182v12.124h-3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B4B",
    d: "M6.15 7.764c1.009 0 1.821.813 1.821 1.823h3.14c-.023-2.744-2.239-4.962-4.962-4.962a4.97 4.97 0 0 0-4.961 4.96h3.139c0-1.01.813-1.822 1.822-1.822z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z",
    transform: "translate(0 .914)"
  }))));
}
var ForwardRef$3Q = /*#__PURE__*/forwardRef(MuralIcon);

function BicycleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__bicycle ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#0d827e',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.2 2.008a.6.6 0 0 1 .479.429l.888 3.138.164.577-.008.002.31 1.116q.06-.005.121-.006a2.85 2.85 0 1 1-1.283.306l-.232-.834L8.365 9.68a.6.6 0 0 1-1-.08L6.14 7.368l-.39.667c.58.522.948 1.276.948 2.118a2.85 2.85 0 1 1-1.986-2.716l.756-1.295-.621-1.135h-.645a.6.6 0 1 1 0-1.2h2.25l.121.012a.6.6 0 0 1 0 1.176l-.12.012h-.238l.284.518 3.634-.608-.486-1.717H8V2h2.102zM3.85 8.502a1.65 1.65 0 1 0 1.276.604L4.43 10.3a.6.6 0 1 1-1.035-.606L4.08 8.52a2 2 0 0 0-.23-.018m8.867 1.232.02.12a.6.6 0 0 1-1.133.314l-.043-.113-.359-1.29a1.65 1.65 0 1 0 1.165-.288zM7.109 6.64l.867 1.58 1.53-1.982z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3P = /*#__PURE__*/forwardRef(BicycleIcon);

function BusIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__bus ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#c5044e',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C5044E",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.8a1 1 0 1 1 1.998.003A1 1 0 0 1 10.5 11.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.996 9.595-.7-4.296A.35.35 0 0 0 13.95 5H1.7c-.35 0-.7.358-.7.717v4.925c0 .178.128.358.3.358h1.547c.236-.719.906-1.2 1.703-1.2s1.468.481 1.703 1.2h3.544c.236-.719.906-1.2 1.703-1.2s1.467.481 1.703 1.2h1.447c.193 0 .35-.161.35-.358v-.988q0-.03-.004-.06m-2.84-2.805c0-.198.158-.358.35-.358h1.087a.35.35 0 0 1 .347.311l.185 1.432a.36.36 0 0 1-.085.282.34.34 0 0 1-.262.122h-1.272a.354.354 0 0 1-.35-.358zm-4.2 0c0-.198.157-.358.35-.358h2.8c.193 0 .35.16.35.358V8.22a.354.354 0 0 1-.35.358h-2.8a.354.354 0 0 1-.35-.358zm-4.2 0c0-.198.157-.358.35-.358h2.8c.194 0 .351.16.351.358V8.22a.355.355 0 0 1-.35.358h-2.8a.354.354 0 0 1-.35-.358zm-2.1 0c0-.198.158-.358.35-.358h.701c.193 0 .349.16.349.358V8.22a.353.353 0 0 1-.349.358h-.7a.354.354 0 0 1-.35-.358z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55 11.8c0-.551.449-1 1-1s1 .449 1 1a1 1 0 0 1-2 0"
  })));
}
var ForwardRef$3O = /*#__PURE__*/forwardRef(BusIcon);

function CablewayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__cableway ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#78469a',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "m13.295 1.803-3.917.984a1.23 1.23 0 0 0-.188-.806L13.094 1zm-5.127.121a.74.74 0 1 1 0 1.482.74.74 0 0 1 0-1.482m5.011 6.011a.43.43 0 0 0-.42-.336h-9.18a.43.43 0 0 0-.422.336l-1.146 5.068a.56.56 0 0 0 .09.433l1.003 1.385a.43.43 0 0 0 .35.179h9.429a.43.43 0 0 0 .35-.179l1.002-1.385a.56.56 0 0 0 .09-.433zM5.49 11.502c0 .24-.193.433-.432.433H3.763a.432.432 0 0 1-.422-.526l.382-1.727a.43.43 0 0 1 .42-.34h.915c.239 0 .432.194.432.433zm4.494 0a.43.43 0 0 1-.432.433H6.961a.43.43 0 0 1-.432-.432V9.775c0-.238.193-.432.432-.432h2.591c.238 0 .432.194.432.432zm2.927.272a.43.43 0 0 1-.337.162h-1.295a.43.43 0 0 1-.433-.433V9.775c0-.238.194-.432.432-.432h.914a.43.43 0 0 1 .422.34l.381 1.727a.43.43 0 0 1-.084.364M6.959 2.54l-3.918.984.202.803 3.904-.98a1.23 1.23 0 0 1-.188-.807m1.623 1.273v1.724h1.43v.828H6.324v-.828h1.43V3.814c.13.047.268.084.414.084.147 0 .284-.037.414-.084",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3N = /*#__PURE__*/forwardRef(CablewayIcon);

function CarIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__car ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.002 7.2H14l-1.092-3.337C12.74 3.35 12.223 3 11.636 3H4.368c-.587 0-1.104.35-1.272.862L2 7.2h-.002A1 1 0 0 0 1 8.198v3.503c0 .276.223.499.499.499H2v.667a1.1 1.1 0 0 0 2.2 0V12.2h7.6v.667a1.1 1.1 0 0 0 2.2 0V12.2h.501a.5.5 0 0 0 .499-.499V8.198a1 1 0 0 0-.998-.998M3.27 7.133l.84-2.739a.51.51 0 0 1 .495-.344h6.79c.23 0 .431.14.494.344l.84 2.74c.01.033-.016.066-.054.066h-9.35c-.038 0-.065-.033-.055-.067M2.8 8.2c.44.002.799.36.8.804a.8.8 0 1 1-.8-.804m10.4 1.6a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3M = /*#__PURE__*/forwardRef(CarIcon);

function CarSharingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__carsharing ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388F76",
    d: "M11.094 11.516a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M12.893 6.256a2.575 2.575 0 0 0-3.641 0l-.602-.601a3.425 3.425 0 0 1 4.844 0zM10.312 7.866c.42-.42 1.1-.42 1.52 0l.601-.601a1.925 1.925 0 0 0-2.722 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388F76",
    fillRule: "evenodd",
    d: "M8.625 1.997c-.787 0-1.425.638-1.425 1.425V4.5h-.372a2.5 2.5 0 0 0-1.767.732L3.753 6.54l-1.547.31A1.5 1.5 0 0 0 1 8.319V10a.5.5 0 0 0 .5.5h.75a2 2 0 1 1 4 0h.95v2.074c0 .787.638 1.425 1.425 1.425h4.953c.787 0 1.425-.638 1.425-1.425V3.422c0-.787-.638-1.425-1.425-1.425zM8.05 3.422c0-.318.257-.575.575-.575h4.953c.318 0 .575.257.575.575v9.152a.575.575 0 0 1-.575.575H8.625a.575.575 0 0 1-.575-.575z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388F76",
    d: "M5.516 10.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
  }));
}
var ForwardRef$3L = /*#__PURE__*/forwardRef(CarSharingIcon);

function CarferryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__carferry ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#0c6693',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C6693",
    fillRule: "evenodd",
    d: "m11.858 5.7-.703-2.145c-.108-.33-.44-.555-.818-.555H5.665c-.377 0-.71.225-.817.554L4.143 5.7h-.001a.64.64 0 0 0-.642.642v2.252c0 .177.144.32.32.32h.323v.429a.707.707 0 0 0 1.414 0v-.429h4.886v.429a.707.707 0 0 0 1.414 0v-.429h.322a.32.32 0 0 0 .321-.32V6.342a.64.64 0 0 0-.642-.642M4.96 5.657l.54-1.76c.041-.132.17-.222.319-.222h4.364c.148 0 .278.09.318.221l.54 1.761c.007.022-.01.043-.035.043h-6.01c-.025 0-.042-.021-.036-.043m-.302.686a.515.515 0 1 1 0 1.028.515.515 0 0 1 0-1.028m6.686 1.028a.515.515 0 1 1 0-1.028.515.515 0 0 1 0 1.028",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C6693",
    d: "M2 12.289q.162-.023.373-.023c.576 0 .837.136 1.167.31.101.053.122.067.238.12.023.01.196.097.438.172q.158.048.348.08c.037.006.307.052.608.052.824 0 1.254-.226 1.633-.425.33-.173.591-.31 1.167-.31s.837.137 1.167.31c.38.2.81.425 1.633.425s1.253-.226 1.633-.425c.33-.173.59-.31 1.168-.31.145 0 .29.017.427.045v-1.013a3 3 0 0 0-.427-.031c-.823 0-1.253.225-1.633.424-.33.173-.59.31-1.168.31s-.838-.137-1.168-.31c-.379-.199-.809-.424-1.632-.424s-1.253.225-1.632.424c-.33.173-.59.31-1.168.31-.179 0-.326-.012-.454-.04-.094-.022-.192-.04-.322-.09a3 3 0 0 1-.392-.18c-.378-.199-.808-.424-1.631-.424a4 4 0 0 0-.373.017z"
  }));
}
var ForwardRef$3K = /*#__PURE__*/forwardRef(CarferryIcon);

function CityBikeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__citybike ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#0d827e',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 4.45h-3v1.1h2.62l1.375 3.606a2.7 2.7 0 0 0-.893.65c-.454.487-.79 1.127-1.082 1.744q-.137.29-.264.57c-.2.438-.391.857-.613 1.254q-.22.396-.461.702a1.5 1.5 0 0 0-1.959-.36L7.89 8.05h.61a.55.55 0 1 0 0-1.1h-3a.55.55 0 0 0 0 1.1h1.16l.725 1.45-1.105 2.21a4 4 0 1 0 2.682 4.34h1.467a1.5 1.5 0 0 0 2.527-.687c.486-.397.85-.92 1.147-1.452.245-.438.467-.923.674-1.378q.122-.267.237-.512c.289-.611.565-1.113.892-1.463a1.7 1.7 0 0 1 .481-.371l.688 1.806a4 4 0 1 0 1.028-.392L16.75 8.05H18a.55.55 0 0 0 .51-.346l1-2.5-1.02-.408-.862 2.154H16.33l-.817-2.146A.55.55 0 0 0 15 4.45m-7 6.28 2.018 4.036q-.014.09-.017.184H8.963a4 4 0 0 0-1.7-2.748zm9.472 2.305 1.014 2.66a.55.55 0 1 0 1.028-.39L18.5 12.642a2.9 2.9 0 1 1-1.028.392M4.45 15.5H2.1a2.9 2.9 0 0 0 5.748.55H5a.55.55 0 0 1-.55-.55m3.398-.55H5.89l.875-1.751a2.9 2.9 0 0 1 1.083 1.751m3.652.55a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3J = /*#__PURE__*/forwardRef(CityBikeIcon);

function FerryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__ferry ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#0c6693',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C6693",
    d: "M8.737 13c-.824 0-1.253-.226-1.632-.425-.33-.173-.591-.31-1.168-.31s-.838.137-1.168.31c-.38.2-.81.425-1.633.425-1.052 0-1.969-.588-2.007-.613L1 12.316l.447-.894.196.108c.037.023.743.47 1.493.47.577 0 .838-.137 1.168-.31.38-.199.81-.424 1.633-.424s1.254.225 1.633.424c.33.173.59.31 1.167.31s.837-.137 1.167-.31c.379-.199.81-.424 1.632-.424.643 0 1.046.137 1.372.292l-.479.88c-.23-.103-.48-.172-.893-.172-.577 0-.837.136-1.168.31-.378.198-.808.424-1.631.424M14.75 7.456h-1.432a.05.05 0 0 1-.05-.036l-.907-2.746a.35.35 0 0 0-.33-.242h-.554a.05.05 0 0 1-.047-.034l-.34-.825c-.073-.186-.214-.298-.417-.198l-1.213.706a.45.45 0 0 0-.244.402v.463c0 .04-.026.054-.047.054H5.78a.35.35 0 0 0-.318.198L4.362 7.422a.05.05 0 0 1-.047.034h-.667a.35.35 0 0 0-.314.195l-1.496 3.047c.313.16.658.302 1.275.302 1.4 0 1.4-.733 2.8-.733s1.4.733 2.8.733 1.4-.733 2.8-.733c.9 0 1.45.306 1.845.521l1.611-2.963a.25.25 0 0 0-.22-.37m-7.353-.2a.2.2 0 0 1-.2.2H5.272c-.125 0-.236-.098-.133-.279l.381-.78a.25.25 0 0 1 .228-.141h1.45c.11 0 .2.09.2.2zm2.204-.004a.204.204 0 0 1-.204.204H8.005a.204.204 0 0 1-.204-.204V6.46c0-.113.091-.204.204-.204h1.392c.113 0 .204.091.204.204zm2.535.204-1.933.001A.2.2 0 0 1 10 7.256v-.799c0-.11.09-.201.202-.201h1.653c.116 0 .217.079.245.191l.193.78c.053.165-.049.229-.158.229"
  }));
}
var ForwardRef$3I = /*#__PURE__*/forwardRef(FerryIcon);

function FunicularIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__funicular ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#78469a',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78469A",
    d: "m15 9.125-14 4.01v.99l14-4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78469A",
    fillRule: "evenodd",
    d: "m2.38 11.52 11.253-3.1A.5.5 0 0 0 14 7.938V3.825a1.5 1.5 0 0 0-1.885-1.45L3.487 4.668A2 2 0 0 0 2 6.6v4.631a.3.3 0 0 0 .38.29m8.917-6.08c0 .111.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V4.026a.8.8 0 0 0-.983-.779l-.863.202a.2.2 0 0 0-.154.195zm-.7.75a.2.2 0 0 1-.2.2h-2.1a.2.2 0 0 1-.2-.2V4.508a.2.2 0 0 1 .148-.194l2.1-.552a.2.2 0 0 1 .251.194zM4.194 7.598a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.06a1 1 0 0 1 .75-.968l.5-.13a.2.2 0 0 1 .25.194zm3-.472a.2.2 0 0 0 .2-.2V4.808a.2.2 0 0 0-.246-.194l-2.1.505a.2.2 0 0 0-.153.195v1.61c0 .111.09.2.2.2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3H = /*#__PURE__*/forwardRef(FunicularIcon);

function HelicopterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__helicopter ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#800664',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M15 4.671V4H4v.671h5.17v1.127h-.52a.65.65 0 0 0-.65.65v.554H2.558l-.315-.863a.21.21 0 0 0-.2-.139h-.832A.21.21 0 0 0 1 6.211l.009 1.907a.21.21 0 0 0 .176.206L8 9.475v.875c0 .359.291.65.65.65h4.7a.65.65 0 0 0 .65-.65V9.198c0-1.875-1.526-3.4-3.4-3.4h-.76V4.67zm-4.638 2.242v-.097a.23.23 0 0 1 .221-.19h.526c.891 0 1.631.66 1.76 1.516.014.083.01.128-.012.17-.03.051-.084.085-.21.085-.195 0-.888-.002-2.064 0a.22.22 0 0 1-.221-.22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M9 11.999H13V12.999H9z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3G = /*#__PURE__*/forwardRef(HelicopterIcon);

function MetroIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__metro ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#bf5826',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF5826",
    fillRule: "evenodd",
    d: "M5.004 5 5.004 6.166 7.416 6.166 7.416 12 8.584 12 8.584 6.166 10.999 6.166 10.999 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF5826",
    d: "M8 2c3.308 0 6 2.692 6 6s-2.692 6-6 6c-3.309 0-6-2.692-6-6s2.691-6 6-6m0-1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7"
  }));
}
var ForwardRef$3F = /*#__PURE__*/forwardRef(MetroIcon);

function MobilityIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__mobility ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#0d827e',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 11c-.019 0-.036.005-.055.005l-2.224-7.68A.45.45 0 0 0 9.79 3H7.5v.8h1.95a.1.1 0 0 1 .097.072l1.53 5.281a.1.1 0 0 1-.02.093l-2.398 2.819a.1.1 0 0 1-.076.035H4.94A1.496 1.496 0 0 0 2 12.5a1.496 1.496 0 0 0 2.94.4H8.79a.45.45 0 0 0 .343-.159l2.224-2.615.324 1.12c-.41.267-.682.728-.682 1.254a1.5 1.5 0 1 0 1.5-1.5m-9 2.2a.7.7 0 1 1 .002-1.402A.7.7 0 0 1 3.5 13.2m9 0a.7.7 0 1 1 .002-1.402.7.7 0 0 1-.002 1.402",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3E = /*#__PURE__*/forwardRef(MobilityIcon);

function PlaneIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__plane ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#800664',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800664",
    d: "M12.58 3.16c.329-.11.642.203.532.532A5.9 5.9 0 0 1 11.687 6L10.254 7.43l1.374 5.697-1 1-2.454-4.616-1.889 1.889.11 1.065-.858.858-.865-1.724-1.723-.864.858-.858 1.063.11 1.89-1.89-4.617-2.455 1-1L8.84 6.017l1.433-1.433a5.9 5.9 0 0 1 2.306-1.425"
  }));
}
var ForwardRef$3D = /*#__PURE__*/forwardRef(PlaneIcon);

function RunningIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__running ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.132 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M13.533 6.586l-1.734.117a.15.15 0 0 1-.12-.048L10.316 5.18a1.2 1.2 0 0 0-.347-.263l-1.6-.82a1 1 0 0 0-.828-.015l-2.213.95a.6.6 0 0 0-.237.183l-1.59 2.048a.428.428 0 0 0 .591.618L5.67 6.137a.25.25 0 0 1 .098-.066l1.408-.525-1.01 2.412a1.4 1.4 0 0 0-.062 1.049l.038.11a1.4 1.4 0 0 0 .648.777l2.667 1.478.08.082 1.69 3.205a.6.6 0 1 0 1.083-.518l-1.423-3.428a1 1 0 0 0-.327-.42L8.5 8.764l1.142-2.44 1.518 1.354a.5.5 0 0 0 .42.119l2.03-.36a.428.428 0 0 0-.078-.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.708 9.6a1.3 1.3 0 0 1-.075-.282l-.975 1.75-2.886 1.134a.6.6 0 1 0 .394 1.134l3.371-.959 1.133-1.851-.33-.183c-.353-.228-.513-.456-.632-.743"
  })));
}
var ForwardRef$3C = /*#__PURE__*/forwardRef(RunningIcon);

function SnowCoachIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__snowcoach ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3E40",
    d: "M1.924 10.478c.207.207.49.324.783.324h2.297l1 1.198H2.707a2.3 2.3 0 0 1-1.63-.675zM10.5 4C12.433 4 14 5.566 14 7.497v.643c0 .197-.16.357-.357.357H6.567a1.5 1.5 0 0 0-1.5 1.499H2.961c-.534 0-1.05-.193-1.453-.543A1.48 1.48 0 0 1 1 8.34v-.797c0-.33.2-.626.507-.748L3.5 5.999A5 5 0 0 1 7.5 4zM6.198 5.017c-.459.153-.96.55-1.194.89l-.14.21c-.039.085.01.131.054.131H6.15a.1.1 0 0 0 .1-.1V5.054a.04.04 0 0 0-.052-.036m1.252-.018a.2.2 0 0 0-.2.2v.85c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2v-.85a.2.2 0 0 0-.2-.2zm2.5 0a.2.2 0 0 0-.2.2v.85c0 .11.09.2.2.2h2.318a.2.2 0 0 0 .14-.342l-.54-.79a.4.4 0 0 0-.284-.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3E40",
    d: "M13.625 9.246a1.375 1.375 0 1 1 0 2.748H7.99c-.622 0-1.206-.3-1.567-.806l-.353-.494a.915.915 0 0 1 .745-1.448zm-6 .75a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25m2 0a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25m2 0a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25m2 0a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25"
  }));
}
var ForwardRef$3B = /*#__PURE__*/forwardRef(SnowCoachIcon);

function StandingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__standing ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5a1.25 1.25 0 1 1-.001-2.499A1.25 1.25 0 0 1 8 3.5M10.99 8.786l-.825-3.989A1 1 0 0 0 9.185 4h-2.37a1 1 0 0 0-.98.797l-.825 3.99a.428.428 0 0 0 .836.184l.587-2.197h.047L6.5 10v4.4a.6.6 0 1 0 1.2 0l.101-4.338c.004-.033.026-.062.056-.062h.29c.032 0 .055.03.057.064L8.3 14.4a.6.6 0 1 0 1.2 0V10l.02-3.226h.047l.587 2.197a.428.428 0 0 0 .836-.185"
  })));
}
var ForwardRef$3A = /*#__PURE__*/forwardRef(StandingIcon);

function StrollingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__strolling ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'undefined',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.917 8.51-1.361-1.68a.2.2 0 0 1-.029-.048l-.932-2.176A1 1 0 0 0 8.675 4H7.107a1 1 0 0 0-.837.453L5.143 6.177a1 1 0 0 0-.15.392c-.088.575-.323 2.136-.323 2.136a.428.428 0 0 0 .825.225l.554-2.132.518-.74.01 1.926c.002.303.091.6.257.853l1.708 2.621a.2.2 0 0 1 .025.057l.824 3.02a.6.6 0 1 0 1.17-.27l-.53-3.019a1 1 0 0 0-.055-.192l-.978-2.498a.2.2 0 0 1-.014-.078l.062-2.193.507.894a1 1 0 0 0 .134.185l1.54 1.652a.428.428 0 0 0 .69-.506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.507 9.362-.073 1.815a.2.2 0 0 1-.012.06l-1.059 2.946a.6.6 0 1 0 1.113.45l1.298-2.776a1 1 0 0 0 .066-.188l.072-.252zM8.003 3.5a1.25 1.25 0 1 1-.001-2.499 1.25 1.25 0 0 1 0 2.499"
  })));
}
var ForwardRef$3z = /*#__PURE__*/forwardRef(StrollingIcon);

function TaxiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__taxi ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#3d3e40',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.998 7.233h-.002l-1.092-3.337c-.168-.512-.685-.863-1.272-.863H9.5v-.502a.5.5 0 0 0-.498-.498H6.997a.5.5 0 0 0-.497.498v.502H4.364c-.587 0-1.104.35-1.272.862L1.996 7.233h-.002a1 1 0 0 0-.998.999v3.503c0 .275.223.498.499.498h.501v.667a1.1 1.1 0 0 0 2.2 0v-.667h7.6v.667a1.1 1.1 0 0 0 2.2 0v-.667h.501a.5.5 0 0 0 .5-.498V8.232a1 1 0 0 0-1-.999M3.266 7.167l.84-2.74a.51.51 0 0 1 .495-.344h6.79c.23 0 .431.141.494.345l.84 2.739c.011.033-.016.066-.054.066H3.32c-.037 0-.065-.033-.055-.066m-.47 1.066c.44.002.8.36.8.804a.8.8 0 1 1-.8-.804m10.4 1.6a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3y = /*#__PURE__*/forwardRef(TaxiIcon);

function TrainIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__train ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#00367f',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00367F",
    fillRule: "evenodd",
    d: "M1 12H14V13H1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00367F",
    d: "M14.75 8.1a.6.6 0 0 0-.091-.11l-.035-.036-.093-.095c-.315-.314-2.34-1.805-3.436-2.528-.358-.236-.76-.331-.999-.331h-3.54l1.295-.89c.1-.076.149-.134.149-.256a.33.33 0 0 0-.142-.276L6.364 2.399H5.4l1.702 1.434-1.7 1.166h.001H1v6h12.612c.196 0 .38-.098.488-.263.49-.755.9-1.41.9-1.902 0-.277-.095-.529-.25-.735m-2.537-.508c-.046.136-.173.172-.317.172h-.666c-.071 0-.185.01-.284-.063l-.95-.671a.332.332 0 0 1 .2-.599h.666c.072 0 .142.024.2.068l1.034.778c.115.086.162.18.117.315"
  }));
}
var ForwardRef$3x = /*#__PURE__*/forwardRef(TrainIcon);

function TramIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__tram ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#78469a',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "M14.062 5.272a.35.35 0 0 0-.341-.273H8.566l1.289-.89c.1-.075.149-.133.149-.255a.33.33 0 0 0-.142-.276L8.368 2.399h-.964l1.701 1.434-1.7 1.166H2.28a.35.35 0 0 0-.341.273L1.009 9.38a.45.45 0 0 0 .074.35l.812 1.124a.35.35 0 0 0 .283.145h11.643a.35.35 0 0 0 .284-.145l.812-1.123a.45.45 0 0 0 .074-.351zM3.75 8.182a.35.35 0 0 1-.35.35H2.35a.35.35 0 0 1-.342-.426l.31-1.4a.35.35 0 0 1 .34-.275H3.4a.35.35 0 0 1 .35.35zm3.5 0a.35.35 0 0 1-.35.35H4.799a.35.35 0 0 1-.35-.35V6.78a.35.35 0 0 1 .35-.35h2.1a.35.35 0 0 1 .35.35zm3.51 0a.35.35 0 0 1-.35.35h-2.1a.35.35 0 0 1-.35-.35V6.78a.35.35 0 0 1 .35-.35h2.1a.35.35 0 0 1 .35.35zm3.073.219a.35.35 0 0 1-.272.131H11.81a.35.35 0 0 1-.35-.35V6.781a.35.35 0 0 1 .35-.35h1.441a.35.35 0 0 1 .342.275l.309 1.4a.35.35 0 0 1-.07.295",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "M2 11.999H14V12.999H2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3w = /*#__PURE__*/forwardRef(TramIcon);

function WalkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__walk ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || '#8d8e9c',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.663 3.5a1.25 1.25 0 1 1 0-2.499 1.25 1.25 0 0 1 0 2.499M5.92 11.39l-.048.102-1.744 2.55a.6.6 0 1 0 .963.716l1.905-2.297q.088-.155.175-.31l.519-1.485-1.205-1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.791 7.79-2.026-1.244a.2.2 0 0 1-.064-.063l-.98-1.702a1 1 0 0 0-.644-.438l-1.44-.29a1 1 0 0 0-.797.18L5.04 5.582a1 1 0 0 0-.288.34L3.671 8.017a.428.428 0 0 0 .724.456l1.293-1.996a.2.2 0 0 1 .063-.061l1.088-.666-.309 1.533a2.3 2.3 0 0 0 .596 2.043l2.276 2.288.045.07 1.115 2.912a.6.6 0 1 0 1.137-.384l-.805-2.874-.155-.32-1.854-2.545a.35.35 0 0 1-.06-.272l.374-1.857.687.871a1 1 0 0 0 .348.28l2.12 1.03a.428.428 0 0 0 .437-.735"
  })));
}
var ForwardRef$3v = /*#__PURE__*/forwardRef(WalkIcon);

function AdditionalZonesTicketIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 0 1-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 0 1-.636.632H1.636A.634.634 0 0 1 1 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.63.63 0 0 1 1 6.327V3.132c0-.35.285-.632.636-.632zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 0 1 1.608 2.053l.005.156a2.29 2.29 0 0 1-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 0 1-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034zM8.5 5.67V7.5h1.83v.998H8.5v1.83h-.998V8.5H5.67v-.998H7.5V5.67z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3u = /*#__PURE__*/forwardRef(AdditionalZonesTicketIcon);

function AirportIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.632 7.507h2.519c.232 0 .42.26.42.493 0 .234-.19.494-.42.494H9.632l-2.239 3.662h-.98l1.12-3.662h-1.75l-.628.774h-.84L4.735 8l-.42-1.267h.84l.629.774h1.749l-1.12-3.662h.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14.001 7 7 0 0 1 0-14m0 1.2a5.801 5.801 0 0 0 0 11.6A5.8 5.8 0 0 0 8 2.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3t = /*#__PURE__*/forwardRef(AirportIcon);

function CityIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.624 14.872A.624.624 0 0 1 1 14.248V1.764c0-.345.28-.624.624-.624H9.57c.344 0 .624.28.624.624l-.001 6.733 4.184.02c.316 0 .577.235.618.54L15 9.14v5.107a.624.624 0 0 1-.54.619l-.084.005zm8.568-5.126v3.878h3.56v-3.86zM8.944 2.388H2.248v11.236h2.724v-1.135h1.249l-.001 1.135h2.724zM5.086 10.22v1.249H3.27v-1.249zm2.837 0v1.249H6.107v-1.249zM5.086 7.95v1.249H3.27V7.949zm2.837 0v1.249H6.107V7.949zM5.086 5.68v1.25H3.27v-1.25zm2.837 0v1.25H6.107v-1.25zM5.086 3.41v1.25H3.27v-1.25zm2.837 0v1.25H6.107v-1.25z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3s = /*#__PURE__*/forwardRef(CityIcon);

function CompassNeedleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (props.color ? 'eds-icon ' : '') + 'eds-icon__CompassNeedleIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color,
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF9E",
    d: "m11 8-3 7-3-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5959",
    d: "M11 8 8 1 5 8z"
  }));
}
var ForwardRef$3r = /*#__PURE__*/forwardRef(CompassNeedleIcon);

function ConductorIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.827 1.37q.173-.03.346 0l2.6.433c.506.085.877.523.877 1.036V4.1c0 .37-.19.694-.479.881.211.45.329.953.329 1.484 0 1.178-.582 2.22-1.474 2.854 2.458.798 4.28 3.009 4.474 5.681H13c-.228-2.392-1.931-4.31-4.263-4.648l-.097.251a.6.6 0 0 1-.306.323.4.4 0 0 1 .054.126l.576 2.304a.4.4 0 0 1-.03.276l-.576 1.152a.4.4 0 0 1-.716 0l-.576-1.152a.4.4 0 0 1-.03-.276l.576-2.304a.4.4 0 0 1 .054-.126.6.6 0 0 1-.306-.323l-.097-.25C4.932 10.688 3.228 12.607 3 15H1.5c.203-2.664 2.023-4.879 4.476-5.68a3.496 3.496 0 0 1-1.22-4.17H3.5v-1.3h.85V2.839c0-.513.371-.951.877-1.036zm.933 3.78h1.004a2.2 2.2 0 1 1-3.529 0H7.24a.998.998 0 0 0 1.52 0m0-1.3a.998.998 0 0 0-1.52 0H5.65v-.8L8 2.66l2.35.392v.799z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3q = /*#__PURE__*/forwardRef(ConductorIcon);

function CorrespondenceIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.943 2.5 5 3.443l4.291 4.29L5 12.023l.943.944 4.762-4.762a.67.67 0 0 0 .07-.86l-.07-.083z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.043 2.5-.943.943 4.291 4.29-4.291 4.29.943.944 4.762-4.762a.67.67 0 0 0 .07-.86l-.07-.083zM1.943 2.5 1 3.443l4.291 4.29L1 12.023l.943.944 4.762-4.762a.67.67 0 0 0 .07-.86l-.07-.083z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3p = /*#__PURE__*/forwardRef(CorrespondenceIcon);

function DestinationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.243 0c.496 0 .807.516.606.946l-.047.084L9.71 4.244l2.092 3.216a.667.667 0 0 1-.463 1.023l-.096.007h-9.81V14H.1V.667C.1.329.35.05.676.007L.766 0zm-1.23 1.333h-8.58v5.823h8.581L8.356 4.61a.67.67 0 0 1-.047-.642l.047-.086z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3o = /*#__PURE__*/forwardRef(DestinationIcon);

function DirectionIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.001 2a.6.6 0 0 1 .556.374l4.401 10.802a.6.6 0 0 1-.82.765L8.001 11.91l-4.137 2.03a.6.6 0 0 1-.82-.764L7.446 2.374A.6.6 0 0 1 8 2m-3.25 10.169 2.986-1.466a.6.6 0 0 1 .529 0l2.986 1.466-3.25-7.979z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3n = /*#__PURE__*/forwardRef(DirectionIcon);

function DirectionFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.473 2.288C8.403 2.116 8.213 2 8 2s-.403.116-.472.288l-4.5 11.143c-.069.17-.007.357.154.47.16.115.387.131.568.042L8 11.838l4.25 2.105c.18.089.407.073.568-.041s.223-.302.155-.47z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3m = /*#__PURE__*/forwardRef(DirectionFilledIcon);

function EnvironmentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.249 1.009a.645.645 0 0 1 .745.722l-.021.148-.11.648a30 30 0 0 1-.195.982 27 27 0 0 1-1.134 3.894c-.697 1.834-1.55 3.33-2.593 4.372q-.674.674-1.425 1.11c-1.751 1.02-3.609 1.043-5.332.474a7 7 0 0 1-.463-.17L1.912 15 1 14.088l1.804-1.804a7 7 0 0 1-.174-.456c-.622-1.805-.566-3.761.635-5.597a7.4 7.4 0 0 1 .96-1.172c1.01-1.01 2.57-1.86 4.54-2.585a32 32 0 0 1 3.766-1.11q.336-.078.647-.145l.592-.122zm-.685 1.446-.74.165a31 31 0 0 0-3.613 1.065C7.4 4.35 5.987 5.12 5.137 5.97a6 6 0 0 0-.792.966c-.955 1.458-.999 3.01-.495 4.471l-.043-.128 4.287-4.286.912.912-4.273 4.274c1.36.415 2.793.372 4.133-.41a5.7 5.7 0 0 0 1.163-.907c.892-.892 1.661-2.24 2.3-3.918a26 26 0 0 0 1.078-3.709q.072-.332.131-.64z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3l = /*#__PURE__*/forwardRef(EnvironmentIcon);

function GoalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.818 2.312 14 6.25l-8.182 3.937v3.938c0 .525-.363.875-.909.875S4 14.65 4 14.125V1.875C4 1.35 4.364 1 4.91 1s.908.35.908.875z"
  }));
}
var ForwardRef$3k = /*#__PURE__*/forwardRef(GoalIcon);

function GymIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4a1 1 0 0 0-2 0v2a1 1 0 0 0-2 0v4a1 1 0 1 0 2 0v2a1 1 0 1 0 2 0V8.7h6V12a1 1 0 1 0 2 0v-2a1 1 0 1 0 2 0V6a1 1 0 1 0-2 0V4a1 1 0 1 0-2 0v3.3H5z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3j = /*#__PURE__*/forwardRef(GymIcon);

function HomeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.557 1.166a.657.657 0 0 1 .873 0l5.437 4.833c.14.124.22.303.22.49v7.854a.657.657 0 0 1-.656.657H9.806a.657.657 0 0 1-.657-.657v-3.572H6.84v3.572a.66.66 0 0 1-.568.651L6.18 15H2.558a.657.657 0 0 1-.657-.657V6.49c0-.188.08-.367.22-.491zm.437 1.369-4.78 4.249v6.902h2.31v-3.572c0-.332.248-.607.568-.65l.09-.007h3.624c.363 0 .657.295.657.657v3.572h2.31V6.785z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3i = /*#__PURE__*/forwardRef(HomeIcon);

function InternationalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M6.798 2.4l-.082.017q-.692.16-1.312.476.28.323.522.73c.62 1.04.91 2.195.263 3.03-.248.322-.563.544-1.076.811L4.5 7.77l-.207.109q-.134.074-.214.132l-.055.043.013.028c.039.074.12.189.26.363l.525.621q.134.163.235.313c.674.995.582 2.055.02 2.997a2.4 2.4 0 0 1-.277.372A5.727 5.727 0 0 0 12.8 4.876c-1.077.443-2.493.828-3.02.866-.58.042-.967-.204-1.284-.692l-.359-.603-.091-.147a3 3 0 0 0-.23-.295l-.445-.518-.061-.076c-.29-.364-.466-.676-.513-1.011m3.235 3.75c1.444 0 2.643 1.033 2.661 2.364.03 2.15-2.66 4.817-4.356 4.125-.885-.361-1.02-.768-.949-2.015l.012-.193.018-.289c.03-.556.02-.995-.043-1.546-.157-1.355 1.16-2.445 2.657-2.445M4.33 3.603A5.72 5.72 0 0 0 2.273 8c0 1.518.59 2.898 1.554 3.923q.096-.1.156-.2c.332-.556.379-1.1.02-1.63a3 3 0 0 0-.17-.226l-.481-.565c-.471-.566-.616-.843-.616-1.302 0-.594.33-.913 1.033-1.286l.351-.177.226-.11.28-.145c.29-.158.461-.283.557-.407.198-.256.015-.988-.35-1.6a3.7 3.7 0 0 0-.503-.673m5.703 3.822c-.81 0-1.45.53-1.393 1.026.085.733.084 1.296.031 2.068-.05.723-.062.835.055.901l.026.014.067.028c.721.294 2.62-1.59 2.602-2.93-.007-.593-.605-1.107-1.388-1.107M8.239 2.53l.07.09c.065.082.137.167.248.295l.256.295c.13.153.19.232.26.335l.131.205.36.605c.072.11.07.12.102.119l.024-.002c.335-.025 1.36-.298 2.252-.627A5.7 5.7 0 0 0 8 2.273h.077q.037.086.162.258",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3h = /*#__PURE__*/forwardRef(InternationalIcon);

function InterrailIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.736 1.58a2.95 2.95 0 0 1 2.95 2.95l-.001 1.678h.522c.945 0 1.72.731 1.788 1.66L15 8v5.786c0 .322-.24.588-.55.63l-.086.006H1.636a.636.636 0 0 1-.63-.55L1 13.787V8c0-.945.731-1.72 1.66-1.788l.133-.005h.521V4.53a2.95 2.95 0 0 1 2.777-2.945l.173-.005zm3.47 5.9h-.521v5.67h1.042V8.001a.52.52 0 0 0-.436-.513zm-9.892 0h-.52a.52.52 0 0 0-.514.437l-.007.084v5.149h1.041zm6.589 2.31-.167.005-1.1-.001v1.158H7.364l-.001-1.158H6.264a2.94 2.94 0 0 1-1.678-.523v3.879h6.827V9.272c-.433.3-.95.487-1.51.518m-.167-6.937H6.264c-.926 0-1.677.75-1.677 1.677v2.314c0 .88.678 1.603 1.54 1.673l.137.005h1.099V7.365h1.273v1.157h1.1c.88 0 1.602-.678 1.672-1.54l.005-.138V4.53c0-.88-.678-1.602-1.54-1.672z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3g = /*#__PURE__*/forwardRef(InterrailIcon);

function InvalidTicketIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 0 1-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 0 1-.636.632H1.636A.634.634 0 0 1 1 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.63.63 0 0 1 1 6.327V3.132c0-.35.285-.632.636-.632zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 0 1 1.608 2.053l.005.156a2.29 2.29 0 0 1-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 0 1-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034zM9.294 6.004 10 6.71 8.706 8.004 10 9.298l-.706.706L8 8.71l-1.294 1.295L6 9.298l1.294-1.294L6 6.71l.706-.706L8 7.298z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3f = /*#__PURE__*/forwardRef(InvalidTicketIcon);

function LuggageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 1v1.333h-.546v11.455c0 .337-.25.616-.576.66l-.09.007-.546-.001V15H11.91v-.546H3.545V15H2.212v-.546h-.545v-1.333H13.12V1.667c0-.338.251-.617.576-.66l.09-.007zM8.333 1c.338 0 .617.25.66.576l.007.09-.001 1.758h2.365c.334 0 .611.247.66.568l.006.099v7.273a.667.667 0 0 1-.666.666H1.667A.667.667 0 0 1 1 11.364V4.09c0-.368.298-.667.667-.667H4.03V1.667c0-.338.251-.617.577-.66L4.697 1zm2.363 6.181H2.333v3.515h8.363zm0-2.424H2.333v1.091h8.363zm-3.03-2.424H5.364v1.091h2.303z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3e = /*#__PURE__*/forwardRef(LuggageIcon);

function MapIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.29c1.73 0 3.246 1.232 3.494 3.012l2.715-.679a.637.637 0 0 1 .785.53L15 4.24v8.678c0 .26-.157.49-.39.587l-.092.03-4.628 1.157a.6.6 0 0 1-.268.01l-.088-.023L6.24 13.58l-4.45 1.112a.637.637 0 0 1-.784-.53L1 14.075V5.397c0-.26.157-.49.39-.587l.092-.03 3.078-.77C4.924 2.388 6.366 1.29 8 1.29m5.727 3.765-2.324.582a5.7 5.7 0 0 1-.505 1.163c-.253.457-.573.934-.945 1.424a19 19 0 0 1-1.307 1.542l-.194.202a.636.636 0 0 1-.904 0l-.194-.202-.279-.304c-.35-.39-.7-.807-1.028-1.238-.372-.49-.692-.967-.945-1.424-.292-.526-.49-1.015-.579-1.469l-2.25.563v7.365l3.837-.958a.6.6 0 0 1 .268-.009l.088.022 3.295 1.099 3.966-.992zM8 2.563c-1.218 0-2.256.935-2.256 2.256 0 .335.162.806.471 1.364.221.398.508.827.845 1.27.305.402.633.793.961 1.157L8 8.585l.306-.347q.163-.19.322-.387l.312-.397c.337-.444.624-.873.845-1.271.31-.558.471-1.03.471-1.364 0-1.32-1.038-2.256-2.256-2.256m0 1.182a.991.991 0 1 1 0 1.982.991.991 0 0 1 0-1.982",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3d = /*#__PURE__*/forwardRef(MapIcon);

function MapFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 5.696c.544 0 .985-.458.985-1.023 0-.566-.441-1.024-.985-1.024s-.985.458-.985 1.024c0 .565.441 1.023.985 1.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.001c1.888 0 3.401 1.509 3.543 3.383l2.687-.799a.6.6 0 0 1 .77.576v8.702a.6.6 0 0 1-.403.567l-4.431 1.536a.6.6 0 0 1-.415-.008l-3.733-1.456-4.222 1.464a.6.6 0 0 1-.797-.567V5.696a.6.6 0 0 1 .43-.575l3.044-.904C4.69 2.42 6.168 1 8 1m0 1.2c-1.278 0-2.354 1.084-2.354 2.472 0 .303.115.746.34 1.282.22.522.524 1.08.848 1.593.324.515.66.97.937 1.289q.131.15.229.246.098-.096.23-.246c.277-.32.612-.774.936-1.289.324-.513.627-1.071.847-1.593.226-.536.341-.98.341-1.282C10.354 3.285 9.278 2.2 8 2.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3c = /*#__PURE__*/forwardRef(MapFilledIcon);

function MapPinIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.946 0 5.485 2.289 5.485 5.485 0 .906-.358 1.947-1.004 3.112a20 20 0 0 1-1.55 2.334 32 32 0 0 1-2.262 2.655l-.217.226a.636.636 0 0 1-.904 0l-.348-.364-.43-.469a32 32 0 0 1-1.701-2.048 20 20 0 0 1-1.55-2.334c-.646-1.165-1.004-2.206-1.004-3.112C2.515 3.289 5.055 1 8 1m0 1.273c-2.27 0-4.212 1.75-4.212 4.212 0 .648.293 1.502.844 2.495a18.6 18.6 0 0 0 1.45 2.181 31 31 0 0 0 1.633 1.967l.285.311.284-.311a31 31 0 0 0 1.633-1.967 18.6 18.6 0 0 0 1.45-2.181c.552-.993.845-1.847.845-2.495 0-2.462-1.942-4.212-4.212-4.212M8 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3b = /*#__PURE__*/forwardRef(MapPinIcon);

function MountainIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 1.45a.55.55 0 0 1 .508.338l1.916 4.599L9.979 5A.55.55 0 0 1 11 5l3.51 8.795a.55.55 0 0 1-.51.754H2a.55.55 0 0 1-.508-.761l5-12A.55.55 0 0 1 7 1.449m5.367 12-2.339-5.613.461-1.152 2.699 6.764zM8.81 7.774l2.364 5.674h-8.35l2.226-5.341.438 1.097a.55.55 0 0 0 1.003.041L7.15 7.93l.46.46a.55.55 0 0 0 .847-.084zm-.509-1.22L7 3.43 5.655 6.657l.4 1.002.453-.905a.55.55 0 0 1 .88-.143l.526.526z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$3a = /*#__PURE__*/forwardRef(MountainIcon);

function PlatformIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 4.365V2.96h-1.998V2h-1.393v.96H8.702V2H7.31v.96H4.403V2H3.01v.96H1.012v1.405H3.01v7.27H1v1.405h2.01V14h1.393v-.96H7.31V14h1.392v-.96h2.907V14h1.393v-.96h1.986v-1.405h-1.986v-7.27zm-10.597 7.27v-7.27H7.31v7.27zm7.206 0H8.702v-7.27h2.907z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$39 = /*#__PURE__*/forwardRef(PlatformIcon);

function PlaygroundIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.905 10.186a.757.757 0 1 0 0-1.514.757.757 0 0 0 0 1.514m0 1.1a1.857 1.857 0 1 0 0-3.714 1.857 1.857 0 0 0 0 3.714",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.151 1.507a.55.55 0 0 0-.492 0L3.707 3.983a.55.55 0 0 0 .246 1.042H5.26v4.15l-1.82 1.56H2a.55.55 0 0 0-.55.55v3.095c0 .303.246.55.55.55h1.643a.55.55 0 0 0 .358-.133l1.259-1.079v1.28h1.1v-1.925h5.09v1.925h1.1V13.39l.9.45V15h1.1v-1.5a.55.55 0 0 0-.304-.492l-1.696-.848V5.025h1.307a.55.55 0 0 0 .247-1.042zm-5.15 10.195 1.259-1.079v1.647l-1.82 1.56h-.89v-1.995h1.093a.55.55 0 0 0 .358-.133m7.45.27H6.36V6.884h5.09zm0-6.189H6.36v-.758h5.09zm0-1.896L8.904 2.614 6.36 3.887v.038h5.09z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$38 = /*#__PURE__*/forwardRef(PlaygroundIcon);

function PositionIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.6 1v1.432A5.6 5.6 0 0 1 13.568 7.4H15v1.2h-1.432A5.6 5.6 0 0 1 8.6 13.568V15H7.4v-1.432A5.6 5.6 0 0 1 2.432 8.6H1V7.4h1.432A5.6 5.6 0 0 1 7.4 2.432V1zm-5 7a4.4 4.4 0 1 1 8.8 0 4.4 4.4 0 0 1-8.8 0m3 0a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 0 0-2.8 0M8 10.6a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$37 = /*#__PURE__*/forwardRef(PositionIcon);

function PositionFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 1v1.59A5.51 5.51 0 0 1 13.41 7H15v2h-1.59A5.51 5.51 0 0 1 9 13.41V15H7v-1.59A5.51 5.51 0 0 1 2.59 9H1V7h1.59A5.51 5.51 0 0 1 7 2.59V1zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4",
    clipRule: "evenodd"
  }));
}
var ForwardRef$36 = /*#__PURE__*/forwardRef(PositionFilledIcon);

function PrioritySeatPregnantIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.363 4.079c.7-.142 1.384.299 1.529.986l.253 1.202q.128-.015.254-.02c1.385 0 2.508 1.104 2.508 2.465 0 .22-.04.44-.102.654l.5-.001c.524 0 .963.368 1.045.877l.642 3.986a.67.67 0 0 1-.565.763.677.677 0 0 1-.777-.554l-.601-3.737H7.476a1.32 1.32 0 0 1-1.308-1.082l-.791-3.954v-.001l-.018-.083a1.27 1.27 0 0 1 1.004-1.501m-2.01-.01 1.231 6.484a.99.99 0 0 0 .863.798l.119.007h3.933l.001 1.311H6.566a2.325 2.325 0 0 1-2.253-1.712l-.036-.16L3 4.068zM6.27 1a1.34 1.34 0 1 1 .001 2.68 1.34 1.34 0 0 1 0-2.68",
    clipRule: "evenodd",
    transform: "translate(-1319 -504) translate(1316 503)"
  }));
}
var ForwardRef$35 = /*#__PURE__*/forwardRef(PrioritySeatPregnantIcon);

function PrioritySeatSeniorsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.997 7.977v-.003a.964.964 0 0 0-.963-.965.965.965 0 0 0-.982.946v.429c-.003.15.119.276.273.279a.277.277 0 0 0 .284-.268v-.422c0-.227.186-.41.416-.41s.416.183.416.41l.002.009v6.738a.276.276 0 0 0 .274.278.276.276 0 0 0 .283-.27V7.978zm-8.431 3.55-.119-.005a.99.99 0 0 1-.862-.797L3.354 4.24H2l1.277 6.725.036.161a2.32 2.32 0 0 0 2.253 1.714H9.5l-.001-1.313zm4.605-2.074H7.704l1.303-4.188 4.34.878q.053.01.105.01c.24 0 .453-.163.504-.403a.506.506 0 0 0-.4-.596L7.889 4.008c-.054-.006-.207-.006-.207-.006-.544 0-1.046.336-1.212.873L5.14 9.147c-.205.66.172 1.359.844 1.561.082.024.293.06.425.06h3.509l.591 3.677a.665.665 0 0 0 .765.546.657.657 0 0 0 .555-.75l-.63-3.925a1.03 1.03 0 0 0-1.028-.863M8.68 3.68A1.34 1.34 0 1 0 8.68 1a1.34 1.34 0 0 0-.001 2.68",
    clipRule: "evenodd",
    transform: "translate(-1354 -504) translate(1352 503)"
  }));
}
var ForwardRef$34 = /*#__PURE__*/forwardRef(PrioritySeatSeniorsIcon);

function RebateTicketIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.277 7.02c.408 0 .738-.33.738-.735a.737.737 0 0 0-.738-.736.737.737 0 0 0-.739.736c0 .406.33.735.739.735M10.462 9.715c0 .406-.33.736-.739.736a.737.737 0 0 1-.738-.736c0-.406.33-.735.738-.735s.739.33.739.735M9.546 5.614 5.607 9.535l.847.85 3.939-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6 2.499a.6.6 0 0 0-.6.6V6.09a.6.6 0 0 0 .42.573 1.4 1.4 0 0 1 0 2.672.6.6 0 0 0-.42.573V12.9a.6.6 0 0 0 .6.6h12.8a.6.6 0 0 0 .6-.6V9.91a.6.6 0 0 0-.42-.573 1.4 1.4 0 0 1 0-2.672.6.6 0 0 0 .42-.573V3.1a.6.6 0 0 0-.6-.6zm.6 3.194V3.699h11.6v1.994a2.6 2.6 0 0 0 0 4.614v1.994H2.2v-1.994a2.6 2.6 0 0 0 0-4.614",
    clipRule: "evenodd"
  }));
}
var ForwardRef$33 = /*#__PURE__*/forwardRef(RebateTicketIcon);

function RebateTicketFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6 2.499a.6.6 0 0 0-.6.6V6.09a.6.6 0 0 0 .42.573 1.4 1.4 0 0 1 0 2.672.6.6 0 0 0-.42.573V12.9a.6.6 0 0 0 .6.6h12.8a.6.6 0 0 0 .6-.6V9.91a.6.6 0 0 0-.42-.573 1.4 1.4 0 0 1 0-2.672.6.6 0 0 0 .42-.573V3.1a.6.6 0 0 0-.6-.6zm5.415 3.786c0 .406-.33.735-.738.735a.737.737 0 0 1-.739-.735c0-.406.33-.736.739-.736.408 0 .738.33.738.736m3.447 3.43c0 .406-.33.736-.739.736a.737.737 0 0 1-.738-.736c0-.406.33-.735.738-.735s.739.33.739.735m-.916-4.1-3.939 3.92.847.85 3.939-3.92z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$32 = /*#__PURE__*/forwardRef(RebateTicketFilledIcon);

function SkiIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.35 1 .274.255C6.668 1.296 7.7 2.28 7.7 4.051L7.75 15H5V4.05c0-1.77 1.032-2.754 1.076-2.795zm3.408 0 .273.255c.044.041 1.077 1.025 1.077 2.796L11.158 15h-2.75V4.05c0-1.77 1.031-2.754 1.076-2.795zm.575 9.109a1.35 1.35 0 0 1-1.123.003v4.087h1.142zm-3.407 0a1.35 1.35 0 0 1-1.124.003v4.087h1.142zM2.956 2 2.95 12.45h.66v.802l-.661-.001v.81h-.802l-.001-.81H1.49v-.8l.657-.001.005-7.05c-.614-.11-1.085-.548-1.146-1.085L1 4.198l.001-.97c0-.629.564-1.147 1.288-1.218l.146-.008L2.437 2zm10.609-.032c.744.012 1.354.492 1.428 1.106l.007.124v.969c0 .55-.431 1.017-1.023 1.173l-.129.03v7.048h.66v.802h-.66v.81h-.802v-.81h-.658v-.801h.658V1.968zM6.36 7.752a.56.56 0 0 0-.559.548v.583l.007.08a.56.56 0 0 0 1.11-.09l-.001-.411-.001-.161-.006-.08a.56.56 0 0 0-.55-.469m3.408 0a.56.56 0 0 0-.56.548l.001.583.007.08a.56.56 0 0 0 1.11-.09l-.001-.19-.002-.396-.005-.067a.56.56 0 0 0-.55-.468M6.35 2.181c-.24.357-.548.988-.548 1.87v3.021a1.35 1.35 0 0 1 1.111-.003l-.015-3.018c0-.882-.308-1.513-.548-1.87m3.408 0c-.24.357-.548.988-.548 1.87v3.02a1.35 1.35 0 0 1 1.11-.002l-.014-3.018c0-.882-.309-1.513-.548-1.87m-7.604.68c-.174.063-.308.173-.342.303l-.009.066v.968c0 .135.107.256.266.335l.084.035zm11.694-.033v1.709c.201-.075.35-.213.35-.37v-.969c0-.156-.149-.294-.35-.37",
    clipRule: "evenodd",
    transform: "translate(-1425 -504) translate(1424 503)"
  }));
}
var ForwardRef$31 = /*#__PURE__*/forwardRef(SkiIcon);

function SuitcaseIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 12",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.726 14C1.325 14 1 13.697 1 13.323V5.58c0-.374.325-.678.726-.678h3.266V2.677c0-.343.274-.626.628-.67L5.719 2h4.562c.368 0 .672.255.72.585l.006.092v2.226h3.267c.368 0 .671.255.72.586L15 5.58v7.742c0 .374-.325.677-.726.677zM3.28 6.258h-.83v6.387h.83zm7.985 0H4.733v6.387h6.533zm2.282 0h-.83v6.387h.83zM9.555 3.355h-3.11l-.001 1.548h3.111z",
    clipRule: "evenodd",
    transform: "translate(-1245 -505) translate(1244 503)"
  }));
}
var ForwardRef$30 = /*#__PURE__*/forwardRef(SuitcaseIcon);

function TrackIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.492 9.467H4.538l-.445 1.493h7.844zm1.611 0 .445 1.493h.705a.747.747 0 0 1 0 1.493h-.26l.166.562c.156.373-.155.821-.544.896-.389.15-.778-.075-.933-.448l-.301-1.01H3.649l-.3 1.01c-.156.373-.545.597-1.012.523-.389-.15-.622-.523-.544-.896l.19-.637h-.236a.747.747 0 0 1 0-1.493h.68l.444-1.494h-.347a.747.747 0 0 1 0-1.493h.791L3.76 6.48h-.458a.747.747 0 0 1 0-1.493h.902l.7-2.35c.155-.448.544-.672 1.01-.598a.85.85 0 0 1 .545.97l-.588 1.978h4.288L9.57 3.01a.85.85 0 0 1 .545-.97c.389-.15.855.149.933.522l.722 2.425h.928a.747.747 0 0 1 0 1.493h-.484l.445 1.493h.817a.747.747 0 0 1 0 1.494zm-2.055-1.494-.445-1.493H5.427l-.445 1.493z"
  }));
}
var ForwardRef$2$ = /*#__PURE__*/forwardRef(TrackIcon);

function UniversityIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.695 1.542a.55.55 0 0 1 .61 0l6 4A.55.55 0 0 1 14 6.549h-.35v7.4H15v1.1H1v-1.1h1.35v-7.4H2a.55.55 0 0 1-.305-1.007zm4.655 12.407v-7.4h-1.2v7.4zm-3.7-7.4h1.2v7.4h-1.2zm-2.5 0h1.2v7.4h-1.2zm-1.3 0h-1.2v7.4h1.2zm7.333-1.1L8 2.66 3.816 5.45z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2_ = /*#__PURE__*/forwardRef(UniversityIcon);

function ValidTicketIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 0 1-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 0 1-.636.632H1.636A.634.634 0 0 1 1 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.63.63 0 0 1 1 6.327V3.132c0-.35.285-.632.636-.632zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 0 1 1.608 2.053l.005.156a2.29 2.29 0 0 1-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 0 1-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034zM10.236 6l.69.768-3.443 3.1a.52.52 0 0 1-.613.057l-.078-.058-1.722-1.55.691-.767 1.376 1.238z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2Z = /*#__PURE__*/forwardRef(ValidTicketIcon);

function ValidTicketFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6 2.499a.6.6 0 0 0-.6.6V6.09a.6.6 0 0 0 .42.573 1.4 1.4 0 0 1 0 2.672.6.6 0 0 0-.42.573V12.9a.6.6 0 0 0 .6.6h12.8a.6.6 0 0 0 .6-.6V9.91a.6.6 0 0 0-.42-.573 1.4 1.4 0 0 1 0-2.672.6.6 0 0 0 .42-.573V3.1a.6.6 0 0 0-.6-.6zM7 8.9l3.576-3.575.848.848-4 4a.6.6 0 0 1-.848 0l-2-2 .848-.848z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2Y = /*#__PURE__*/forwardRef(ValidTicketFilledIcon);

function ZoneIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.226 6.335q-.261.172-.496.361l-.024.02-.014.011-.01.008-.005.004-.01.008-.004.004-.01.008-.009.008-.004.003-.01.008-.004.004-.005.004-.005.004-.004.004-.005.004-.004.004h-.001l-.009.008-.004.004h-.001l-.004.004-.004.004h-.002q0 .003-.003.004l-.005.004-.004.004h-.001l-.004.004-.005.004-.004.003-.001.002q-.003 0-.004.003l-.004.004H2.54q0 .003-.003.003v.001l-.005.004-.001.001-.003.003h-.001l-.003.003-.001.001-.004.004-.002.001-.002.002-.002.002-.003.003-.002.001-.002.003-.002.001-.003.002-.001.002q-.003 0-.004.003l-.002.002-.002.002-.002.001-.002.003-.002.001-.003.003-.004.004-.002.001-.002.002-.003.003-.003.002-.004.004-.001.001-.004.003-.002.002-.002.002-.002.002-.006.006-.003.003h-.002q0 .002-.002.003l-.001.001-.005.004-.001.001-.003.003-.01.009-.003.003-.006.006-.003.003h-.001l-.003.003-.006.006-.003.003-.01.009-.003.003-.02.018-.002.003h-.001l-.009.01-.003.002-.01.01-.012.012a4.7 4.7 0 0 0-1.062 1.514l1.203.51c.26-.615.771-1.186 1.477-1.652zM2.293 10.352 1 10.535a4 4 0 0 0 .054.294l.006.027.003.012.004.016.002.011.003.012.003.011.001.004.003.012.003.011.003.012.001.004.003.011.006.023.001.004.002.008.002.003v.001l.006.022v.001l.001.003v.001l.002.007.001.004.004.011v.001l.003.01v.001l.001.004.003.007v.004h.001l.003.011v.001l.004.01v.005h.001l.002.008.001.003v.001l.004.01v.001l.004.01v.005h.001l.002.007.002.004.003.011v.001l.004.01v.001l.001.004.004.011.004.011v.001l.004.01v.001l.001.004.003.007v.004h.001l.004.012.004.01v.001l.001.003v.001l.003.007.001.003v.002l.004.01.002.004.002.007.002.004v.001l.002.006.002.004v.001l.004.01v.001l.004.01v.001l.002.003v.002l.003.006.001.004.004.01v.002l.002.003q0 .004.003.007l.001.004.003.007.001.004.001.001.004.01v.001l.002.003.002.007v.001l.002.003v.001l.003.007.001.003v.001l.005.01v.001l.002.003v.001l.002.006v.001l.002.003v.002l.003.005v.001l.002.003v.001l.005.011.001.003.003.007v.001l.002.003v.002l.003.005v.001l.001.003v.002l.005.009v.002l.002.002v.002l.003.005v.001l.002.003v.001l.002.006.001.001.001.003.005.01v.002l.002.003.003.007v.001l.002.003v.001l.003.006.002.004v.001l.005.01.002.004.003.006.002.005.003.006v.002l.002.002v.002l.005.01.005.01v.001l.002.003v.002l.003.005v.001l.002.003v.001l.005.01.002.004.003.006v.002l.002.003.003.006.001.001.001.003.001.002.005.009v.001l.002.003q0 .004.003.007v.001l.002.003v.001l.003.005v.002l.002.002.001.002.003.006.002.003v.002l.002.002v.001l.003.006v.001l.002.003v.001l.004.005v.002l.002.004.003.006.002.003v.002l.006.009v.001l.002.003v.001l.003.006.002.004h.001l.003.007.002.003v.002l.002.002v.001l.004.006v.001l.002.003v.001l.003.005.001.002.001.003h.001l.003.007.002.003.007.012.005.009v.001l.002.003v.002l.006.009v.001l.006.01q0 .002.002.003v.001l.004.006v.001l.002.003v.001l.006.01.006.01v.001l.002.003v.001l.004.006.002.003v.001l.006.01v.001l.006.01.002.003.001.001.003.006.003.005.003.005.001.001.001.003.002.002.001.002.004.006v.002l.003.004.003.005v.001l.002.003.001.001.004.006.002.003v.001l.006.01.002.004h.001l.003.006.001.001.002.003v.001l.006.01q.004.005.006.01h.001l.006.01.003.004.006.01v.001l.006.01h.001q0 .002.002.003v.001l.004.006.002.004h.001l.006.01v.001l.007.01.002.003.004.007.003.003v.001l.007.01.007.01.002.004.004.006.003.004.006.01.008.011.002.003.004.007.003.003v.001l.007.01.007.01.007.01.002.004.007.01.01.014.004.006.003.004.007.01.008.01.006.01.003.003v.001l.007.01.008.01.002.003.005.007.003.003.007.01.007.01.025.034.008.01.003.003.007.01.008.01.008.01.01.014.008.01q.263.338.595.64l.882-.962c-.588-.54-.946-1.16-1.036-1.796M4.675 13.035l-.559 1.18q.394.188.823.335l.048.017.029.01.004.001h.001l.004.002h.001l.029.01h.004v.001l.005.001.005.002.024.008.005.001.004.002h.002l.004.002.005.001.024.008.004.001h.002l.003.002h.002l.004.002.005.001.018.006h.002l.003.002h.002l.003.001h.002l.003.002h.002l.004.001.001.001.004.001h.002l.016.006h.002l.003.001.003.001h.002l.003.002h.002l.003.001.003.001.003.001h.002l.005.002.006.002.005.001.002.001.003.001h.002l.003.002h.003l.003.001h.002l.003.002h.002l.004.002h.001l.008.002.003.001h.002l.003.002h.003l.003.001.002.001h.003l.002.002h.004l.002.001.003.001h.002l.01.004h.002l.004.001h.002l.003.002h.002l.004.001.002.001.005.002h.004l.001.001.005.001.011.004h.002l.004.001h.001l.004.002h.002l.004.001h.001l.006.002.005.002.017.005.005.001h.001l.005.002h.001l.004.001h.001l.005.002.017.005h.001l.005.001h.001l.004.002h.002l.004.001h.001l.005.002.029.008.005.001.006.002q.71.19 1.48.268l.13-1.3a7.6 7.6 0 0 1-2.467-.665M11.346 13.023c-.73.35-1.582.583-2.463.674l.135 1.3h.004l.003-.001.011-.001h.002l.004-.001h.008l.004-.001h.006l.002-.001h.006l.005-.001.013-.002h.008l.003-.001h.006l.003-.001h.006l.003-.001h.007l.001-.001h.008l.004-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.006l.002-.001h.005l.006-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.003-.001h.006l.004-.001h.004l.002-.001h.006l.004-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.005-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.004-.001h.002l.004-.001h.002l.011-.002h.008l.004-.001h.002l.004-.001h.002l.004-.001h.006l.002-.001.011-.002h.008l.004-.001h.002l.004-.001h.002l.004-.001h.006l.001-.001h.006l.012-.003h.008l.004-.001h.001l.005-.001h.001l.01-.002h.002l.012-.002h.005l.002-.001h.006l.004-.002h.008l.005-.002h.006l.012-.002.006-.001h.001l.005-.001h.002l.004-.001h.006l.001-.001.005-.001.019-.003h.005l.001-.001h.005l.002-.001h.005l.005-.002h.001l.03-.005h.007l.004-.002h.007l.018-.004h.006l.001-.001h.005v-.001h.005l.002-.001.005-.001.018-.003.006-.001.006-.001.006-.001.005-.001h.002l.005-.001.018-.004h.006l.006-.002h.006l.006-.002.024-.004.006-.001.006-.002.03-.005.005-.001h.001l.005-.001.006-.002.036-.007a9 9 0 0 0 1.305-.36l.005-.002.005-.002.022-.008.01-.003h.001l.005-.002.005-.002h.001l.016-.007.005-.001.001-.001.004-.001h.001l.01-.004.005-.002.017-.007.004-.001.002-.001.003-.001.002-.001.003-.001h.002l.004-.002.005-.002h.001l.01-.005h.002l.004-.002h.001l.004-.002h.002l.003-.001.002-.001.003-.001.002-.001.003-.002h.002l.004-.002.006-.002h.001l.004-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.002-.002.006-.002h.002l.002-.002h.003l.002-.002h.002l.003-.002h.002l.004-.002h.001l.003-.001.002-.001.003-.002.014-.005.004-.002h.001l.004-.002.005-.002.005-.001.027-.012.005-.002q.003 0 .004-.002.211-.086.412-.182zM13.705 10.33c-.084.636-.436 1.259-1.02 1.8l.889.957a5 5 0 0 0 .439-.456v-.001l.01-.013h.001l.008-.01.008-.01.011-.012.008-.01.008-.01.008-.01.003-.003.008-.01.007-.009.001-.001.003-.003.004-.006h.001l.002-.004h.001l.005-.006.002-.003v-.001l.008-.009V12.5l.003-.003.004-.006h.001l.002-.003.002-.002.003-.004.001-.002.002-.002.001-.002.003-.003.002-.002q0-.002.002-.003v-.001l.003-.003.001-.002.003-.003.001-.002.002-.002.004-.006.002-.002.002-.002.001-.002.002-.002.002-.004.002-.002.002-.002.001-.002.003-.003.001-.002.002-.003.002-.001.002-.003q0-.002.002-.003l.002-.002.001-.002.002-.003.001-.001.006-.008.002-.002.004-.005q0-.002.002-.003l.005-.007.002-.003.001-.002.002-.002.001-.002.003-.004.001-.001.002-.003.002-.002.002-.004.002-.001q0-.002.002-.003v-.001l.003-.004.001-.001.003-.004v-.001l.003-.003.001-.002.003-.004.003-.004.001-.001.003-.004v-.002q.002 0 .003-.003l.001-.001.003-.004.003-.005h.001l.003-.005.003-.004.001-.002.003-.003v-.001l.003-.004.001-.001.002-.004.001-.001.003-.004.003-.005h.001l.003-.005.003-.005h.001l.003-.004v-.001l.003-.005.003-.004.001-.001.003-.004.003-.005.001-.001.003-.004.003-.005.003-.004v-.001l.004-.005.003-.004v-.001l.007-.01.003-.004.003-.005.001-.001.003-.004.003-.005.003-.005.007-.01.007-.01q0-.002.003-.005 0-.002.003-.005l.003-.005.007-.01.006-.01.003-.004.007-.01.006-.01c.213-.335.377-.689.483-1.058l.008-.027.003-.011.003-.011.002-.006.001-.005.002-.005q0-.006.003-.011v-.001l.003-.01v-.001l.001-.005.002-.005v-.006h.001l.001-.006.002-.005.001-.006.002-.005v-.005l.001-.001.001-.005v-.001l.002-.004v-.001l.002-.01v-.002l.002-.004.001-.005v-.002l.001-.004v-.001l.002-.005v-.005l.001-.001.001-.005.003-.01v-.002l.001-.004v-.002l.001-.003v-.002l.002-.004v-.005l.001-.002.001-.005v-.002l.001-.002v-.003l.001-.003.001-.003v-.003l.001-.002V10.8l.001-.002.001-.004v-.002l.001-.003v-.002l.002-.004v-.005l.001-.003v-.002l.002-.005v-.004l.001-.002v-.005l.001-.002.001-.003v-.005h.001l.001-.007v-.001l.001-.003v-.002l.002-.005v-.005l.002-.008v-.003l.001-.002.002-.01v-.005l.002-.007.003-.016q.016-.086.027-.173zM12.741 6.316l-.714 1.093c.71.464 1.225 1.033 1.492 1.647l1.198-.52a4.4 4.4 0 0 0-.643-1.043l-.011-.013-.007-.009-.004-.004-.007-.01-.008-.008-.004-.005-.007-.009-.004-.004-.007-.009-.008-.009-.004-.004-.007-.009-.004-.004-.008-.01-.004-.004-.004-.004-.003-.004-.004-.005-.004-.004-.003-.004-.001-.001-.007-.008-.001-.001-.003-.003v-.001l-.004-.004-.004-.004v-.001l-.004-.003v-.001l-.004-.004v-.001l-.003-.003-.002-.001q0-.003-.003-.004l-.004-.004v-.001l-.003-.003-.001-.001-.003-.004-.001-.001-.003-.003-.001-.001-.003-.003v-.001l-.004-.004h-.001l-.003-.004-.001-.001-.003-.003v-.001l-.004-.004-.001-.001-.003-.003v-.001l-.004-.004-.004-.004v-.001l-.004-.003v-.001l-.004-.004h-.001q0-.003-.003-.004l-.001-.001-.004-.004-.003-.004-.004-.004-.004-.004v-.001l-.004-.003-.001-.002-.003-.002v-.002q-.003 0-.004-.003l-.001-.001-.003-.003-.004-.005-.006-.005-.002-.003-.001-.001-.003-.003-.001-.001-.003-.004-.002-.001-.002-.003-.002-.001-.003-.003-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.003-.004-.002-.002-.003-.003-.002-.001-.002-.003-.001-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.001-.002q-.002 0-.002-.002l-.003-.003-.002-.002-.002-.002-.002-.001-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.001-.002-.003-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.001-.003-.004-.002-.001-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.001-.002-.002-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.001-.001-.005-.004v-.001l-.003-.003h-.001l-.003-.003-.005-.005-.001-.002-.003-.002-.001-.001-.004-.004-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003q-.002 0-.002-.002l-.002-.001-.002-.002-.002-.002-.005-.005-.002-.002-.002-.002-.002-.002L13.613 7l-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.001-.002-.002-.007-.007-.002-.002-.002-.002-.002-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.007-.006-.003-.002-.001-.002-.003-.002-.001-.002-.004-.003-.006-.005-.002-.003-.002-.001-.003-.003-.002-.002-.002-.002-.002-.001-.003-.003-.002-.002-.002-.002-.002-.002-.003-.002-.001-.001-.005-.005-.003-.002-.001-.002-.004-.003-.004-.004-.004-.003-.002-.002-.003-.003-.002-.001-.002-.003h-.002q0-.003-.003-.003l-.001-.001-.004-.004-.004-.004h-.001l-.004-.004-.005-.004-.004-.004-.005-.004-.004-.004h-.001l-.003-.004-.006-.004-.004-.004-.005-.004-.004-.004h-.001l-.004-.004-.009-.008-.004-.004h-.001l-.005-.004-.004-.004-.004-.004h-.001l-.004-.004h-.001l-.004-.004-.005-.004-.004-.004-.005-.004-.01-.007v-.001l-.004-.004-.005-.004-.004-.003-.01-.008-.004-.004-.01-.008-.014-.012a6 6 0 0 0-.57-.417M8 1a3.53 3.53 0 0 0-3.57 3.57c0 .573.21 1.23.642 2.008.251.452.576.943.968 1.458.315.415.67.842 1.057 1.273l.484.516c.111.113.26.175.419.175h.001c.16 0 .308-.062.42-.177l.135-.14q.159-.166.348-.376c.38-.421.736-.849 1.056-1.27.392-.516.717-1.007.968-1.459.431-.779.641-1.435.641-2.009A3.53 3.53 0 0 0 8 1m2.388 3.57c0 .355-.171.852-.493 1.435-.223.4-.517.844-.876 1.316-.304.4-.638.802-.992 1.194L8 8.545l-.026-.03c-.36-.4-.695-.801-.993-1.194-.359-.472-.653-.915-.876-1.316-.322-.582-.492-1.078-.492-1.436C5.613 3.23 6.661 2.182 8 2.182s2.388 1.048 2.388 2.387"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.579,
    r: 0.991,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2X = /*#__PURE__*/forwardRef(ZoneIcon);

function AccessibilityIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.997 15a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.934 6.293.002 2.134.857 3.52c.057.23.055.465-.173.523s-.406-.007-.463-.236l-.954-2.899q-.016-.036-.047-.037h-.485q-.029-.002-.041.036l-.907 2.9c-.086.22-.244.321-.463.236s-.215-.333-.13-.554l.827-3.452v-2.17l-2.436-.217c-.212-.018-.364-.135-.347-.348.016-.214.217-.341.429-.324H8.46l2.903-.005c.213-.008.45.114.457.329.01.212-.244.338-.456.348zM7.997 5.11a.805.805 0 1 1 0-1.61.805.805 0 0 1 0 1.61",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2W = /*#__PURE__*/forwardRef(AccessibilityIcon);

function AddCardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.734 10.3-.09-.007c-.293-.046-.518-.315-.518-.64V6.742H15V4.346c0-1.02-.776-1.846-1.734-1.846H2.734C1.776 2.5 1 3.326 1 4.346v5.307c0 1.02.776 1.847 1.734 1.847h5.245l-.001-1.2zm-.608-5.49v-.374c0-.345.272-.625.608-.625h10.532l.09.007a.62.62 0 0 1 .517.618v1.315H2.126zm10.875 5.69v-2h-1v2h-2v1h2v2h1v-2h2v-1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2V = /*#__PURE__*/forwardRef(AddCardIcon);

function AddIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.7 1-.001 6.3H15v1.4H8.699L8.7 15H7.3V8.7H1V7.3h6.3V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2U = /*#__PURE__*/forwardRef(AddIcon);

function AdditionalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.788 13.242V11.91H2.333V2.334h9.576v5.454h1.333V1.667a.67.67 0 0 0-.576-.66L12.576 1H1.666a.67.67 0 0 0-.66.576L1 1.666v10.91c0 .337.25.616.576.66l.09.006zm5.454-3.09v1.757H15v1.333h-1.758V15H11.91v-1.758h-1.757V11.91h1.757v-1.757z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2T = /*#__PURE__*/forwardRef(AdditionalIcon);

function AdjustmentsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 10.62a2 2 0 1 1-1.894 2.645H1v-1.273l2.101-.001A2 2 0 0 1 5 10.62m10 1.372v1.272H8.52v-1.272zM9.63 6a2 2 0 1 1-1.896 2.637H1V7.363l6.734-.001A2 2 0 0 1 9.63 6M15 7.364v1.272h-1.851V7.364zM5 1.38a2 2 0 1 1-1.899 2.63L1 4.007V2.736l2.106-.001A2 2 0 0 1 5 1.38m10 1.356v1.272H8.52V2.736z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2S = /*#__PURE__*/forwardRef(AdjustmentsIcon);

function AdminIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.18 11.5-.002-.109a3 3 0 0 0-.021-.225l-.004-.026.847-.695-.818-1.39-1.036.372-.029-.022a2.7 2.7 0 0 0-.572-.323l-.037-.014L12.318 8h-1.636l-.156.874a5.4 5.4 0 0 0-1.006-.562 3.6 3.6 0 0 0 1.238-2.723C10.758 3.607 9.167 2 7.205 2 5.242 2 3.65 3.607 3.65 5.59c0 1.013.416 1.928 1.085 2.58A5.47 5.47 0 0 0 1 13.357V14h1.273v-.643l.004-.196a4.18 4.18 0 0 1 4.18-3.982h.965l.197.004a4.2 4.2 0 0 1 1.016.183L8 10.445l.847.695s-.027.216-.027.36l.002.109q.005.11.021.226l.004.025-.847.696.818 1.389 1.036-.372.029.023q.264.194.572.323l.036.013.191 1.068h1.636l.19-1.068.037-.014q.309-.128.572-.322l.028-.023 1.037.372.818-1.39-.847-.696s.027-.214.027-.359M7.205 7.893c-1.26 0-2.28-1.031-2.28-2.304s1.02-2.303 2.28-2.303 2.28 1.031 2.28 2.303a2.29 2.29 0 0 1-2.28 2.304m6.995 4.8-.296.503-.631-.226a.47.47 0 0 0-.453.078q-.271.223-.614.346l-.05.021a.45.45 0 0 0-.244.324l-.117.651h-.592l-.114-.651a.45.45 0 0 0-.295-.345 2 2 0 0 1-.614-.346l-.044-.032a.47.47 0 0 0-.41-.046l-.63.226-.297-.502.518-.424a.45.45 0 0 0 .157-.422 2 2 0 0 1-.032-.348c0-.108.01-.22.032-.347l.007-.053a.45.45 0 0 0-.164-.37l-.518-.424.297-.502.631.227a.47.47 0 0 0 .453-.078 2 2 0 0 1 .614-.346l.05-.022a.45.45 0 0 0 .245-.324l.114-.651h.592l.117.651a.45.45 0 0 0 .294.345q.344.124.614.347l.044.031c.12.078.273.096.41.046l.63-.226.296.502-.517.424a.45.45 0 0 0-.157.422c.021.127.032.24.032.348s-.01.221-.032.348l-.007.053a.45.45 0 0 0 .164.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 10.25c-.689 0-1.25.561-1.25 1.25 0 .69.561 1.25 1.25 1.25s1.25-.56 1.25-1.25c0-.689-.561-1.25-1.25-1.25m0 1.975a.726.726 0 1 1 .725-.725c0 .4-.326.725-.725.725"
  }));
}
var ForwardRef$2R = /*#__PURE__*/forwardRef(AdminIcon);

function AgreesIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.953 1.854v1.249H2.249v10.052h10.053V7.832h1.25v5.949a.625.625 0 0 1-.54.618l-.085.006H1.625a.625.625 0 0 1-.62-.54L1 13.781V2.478c0-.316.235-.577.54-.619l.085-.005zm4.164-.26.883.884-6.985 6.985a.625.625 0 0 1-.806.066l-.077-.066-2.822-2.82.884-.884 2.379 2.379z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2Q = /*#__PURE__*/forwardRef(AgreesIcon);

function AlertIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.654 0 4.779 1.85 4.895 4.217l.005.204v1.895c0 2.084 2.1 2.59 2.1 3.79 0 .817-1.584 1.489-4.227 1.762C10.587 14.103 9.43 15 8 15s-2.587-.897-2.774-2.132C2.584 12.594 1 11.923 1 11.105c0-1.15 1.929-1.662 2.09-3.537l.01-.252V5.42C3.1 2.958 5.27 1 8 1m1.294 11.973q-.473.02-.969.025L8 13q-.673 0-1.294-.027c.204.412.683.694 1.294.694s1.09-.282 1.294-.694M8 2.39c-1.917 0-3.395 1.275-3.495 2.861l-.005.171v1.895c0 1.229-.433 2.102-1.262 3l-.578.59.094.04.214.077q.058.02.119.038l.19.057c1.12.312 2.769.493 4.723.493s3.603-.181 4.722-.493q.3-.085.524-.172l.093-.04-.394-.396c-.884-.905-1.377-1.756-1.438-2.936l-.007-.258V5.42C11.5 3.756 9.985 2.39 8 2.39",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2P = /*#__PURE__*/forwardRef(AlertIcon);

function AlertMobileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.002 5.43a2.557 2.557 0 0 1 2.557 2.556v.742c0 .27.05.537.152.787l.293.721a.6.6 0 0 1-.557.825h-.872a1.58 1.58 0 0 1-1.573 1.478 1.58 1.58 0 0 1-1.572-1.477h-.873A.6.6 0 0 1 5 10.236l.292-.721a2.1 2.1 0 0 0 .153-.787v-.742a2.557 2.557 0 0 1 2.557-2.555m-.362 5.632a.38.38 0 0 0 .362.277c.17 0 .315-.116.361-.277zm.362-4.432c-.749 0-1.356.608-1.356 1.356v.742a3.3 3.3 0 0 1-.202 1.133h3.117a3.3 3.3 0 0 1-.203-1.133v-.742c0-.748-.607-1.356-1.356-1.356",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.98 4.168H7.022v-1.2H8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.403 1a1.6 1.6 0 0 1 1.6 1.6V13.4a1.6 1.6 0 0 1-1.6 1.6H4.6a1.6 1.6 0 0 1-1.6-1.6V2.6A1.6 1.6 0 0 1 4.6 1zM4.6 2.2a.4.4 0 0 0-.4.4V13.4c0 .22.18.4.4.4h6.803a.4.4 0 0 0 .4-.4V2.6a.4.4 0 0 0-.4-.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2O = /*#__PURE__*/forwardRef(AlertMobileIcon);

function AlertMobileFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.403 1a1.6 1.6 0 0 1 1.6 1.6V13.4a1.6 1.6 0 0 1-1.6 1.6H4.6a1.6 1.6 0 0 1-1.6-1.6V2.6A1.6 1.6 0 0 1 4.6 1zM8.002 5.432a2.556 2.556 0 0 0-2.557 2.555v.742c0 .269-.052.537-.153.787L5 10.237a.602.602 0 0 0 .557.825h.872a1.58 1.58 0 0 0 1.573 1.477 1.58 1.58 0 0 0 1.573-1.476h.872a.6.6 0 0 0 .557-.826l-.293-.721a2.1 2.1 0 0 1-.152-.787v-.742a2.556 2.556 0 0 0-2.557-2.555m.361 5.63a.38.38 0 0 1-.361.277.38.38 0 0 1-.362-.277zM7.023 2.97v1.199H8.98v-1.2z"
  }));
}
var ForwardRef$2N = /*#__PURE__*/forwardRef(AlertMobileFilledIcon);

function ObjectAlignBottomFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 1.9a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6v-9a.6.6 0 0 0-.6-.6zM15 14.1H1v-1.2h14zM9.5 4.9a.6.6 0 0 0-.6.6v6a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6v-6a.6.6 0 0 0-.6-.6z"
  }));
}
var ForwardRef$2M = /*#__PURE__*/forwardRef(ObjectAlignBottomFilledIcon);

function ObjectAlignBottomIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.4 2.5a.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6v9a.6.6 0 0 1-.6.6H4a.6.6 0 0 1-.6-.6zm1.2.6v7.8h1.8V3.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 14.1H1v-1.2h14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 4.9a.6.6 0 0 0-.6.6v6a.6.6 0 0 0 .6.6h3a.6.6 0 0 0 .6-.6v-6a.6.6 0 0 0-.6-.6zm.6 6V6.1h1.8v4.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2L = /*#__PURE__*/forwardRef(ObjectAlignBottomIcon);

function ObjectAlignCenterFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 3.9H5a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h2.4v1.8H3.5a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h3.9V15h1.2v-2.9h3.9a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6H8.6V7.1H11a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6H8.6V1H7.4z"
  }));
}
var ForwardRef$2K = /*#__PURE__*/forwardRef(ObjectAlignCenterFilledIcon);

function ObjectAlignCenterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 3.4H8.6V1H7.4v2.4H5a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h2.4v.8H3.5a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h3.9V15h1.2v-2.4h3.9a.6.6 0 0 0 .6-.6V9a.6.6 0 0 0-.6-.6H8.6v-.8H11a.6.6 0 0 0 .6-.6V4a.6.6 0 0 0-.6-.6M5.6 4.6v1.8h4.8V4.6zm-1.5 6.8V9.6h7.8v1.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2J = /*#__PURE__*/forwardRef(ObjectAlignCenterIcon);

function ObjectAlignLeftFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.9 15V1h1.2v14zM4.5 3.9a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h6a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6zM4.5 8.9a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6z"
  }));
}
var ForwardRef$2I = /*#__PURE__*/forwardRef(ObjectAlignLeftFilledIcon);

function ObjectAlignLeftIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.9 15V1h1.2v14zm2-11a.6.6 0 0 1 .6-.6h6a.6.6 0 0 1 .6.6v3a.6.6 0 0 1-.6.6h-6a.6.6 0 0 1-.6-.6zm1.2.6v1.8h4.8V4.6zm-.6 3.8a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6V9a.6.6 0 0 0-.6-.6zm.6 3V9.6h7.8v1.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2H = /*#__PURE__*/forwardRef(ObjectAlignLeftIcon);

function ObjectAlignMiddleFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.5 2.9a.6.6 0 0 0-.6.6v3.9H7.1V5a.6.6 0 0 0-.6-.6h-2a.6.6 0 0 0-.6.6v2.4H1v1.2h2.9V11a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6V8.6h1.8v3.9a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6V8.6H15V7.4h-2.9V3.5a.6.6 0 0 0-.6-.6z"
  }));
}
var ForwardRef$2G = /*#__PURE__*/forwardRef(ObjectAlignMiddleFilledIcon);

function ObjectAlignMiddleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.4 3.5a.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6v3.9H15v1.2h-2.4v3.9a.6.6 0 0 1-.6.6H9a.6.6 0 0 1-.6-.6V8.6h-.8V11a.6.6 0 0 1-.6.6H4a.6.6 0 0 1-.6-.6V8.6H1V7.4h2.4V5a.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6v2.4h.8zm1.2.6v7.8h1.8V4.1zm-5 6.3V5.6h1.8v4.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2F = /*#__PURE__*/forwardRef(ObjectAlignMiddleIcon);

function ObjectAlignRightFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.9 15V1h1.2v14zM5.5 3.9a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h6a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6zm-3 5a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2E = /*#__PURE__*/forwardRef(ObjectAlignRightFilledIcon);

function ObjectAlignRightIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.9 15V1h1.2v14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.9 4a.6.6 0 0 1 .6-.6h6a.6.6 0 0 1 .6.6v3a.6.6 0 0 1-.6.6h-6a.6.6 0 0 1-.6-.6zm1.2.6v1.8h4.8V4.6zM2.5 8.4a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6V9a.6.6 0 0 0-.6-.6zm.6 3V9.6h7.8v1.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2D = /*#__PURE__*/forwardRef(ObjectAlignRightIcon);

function ObjectAlignTopFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 3.1H1V1.9h14zM4.5 3.9a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6v-9a.6.6 0 0 0-.6-.6zM9.5 3.9a.6.6 0 0 0-.6.6v6a.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6v-6a.6.6 0 0 0-.6-.6z"
  }));
}
var ForwardRef$2C = /*#__PURE__*/forwardRef(ObjectAlignTopFilledIcon);

function ObjectAlignTopIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 3.1H1V1.9h14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.4 4.5a.6.6 0 0 1 .6-.6h3a.6.6 0 0 1 .6.6v9a.6.6 0 0 1-.6.6H4a.6.6 0 0 1-.6-.6zm1.2.6v7.8h1.8V5.1zM9 3.9a.6.6 0 0 0-.6.6v6a.6.6 0 0 0 .6.6h3a.6.6 0 0 0 .6-.6v-6a.6.6 0 0 0-.6-.6zm.6 6V5.1h1.8v4.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2B = /*#__PURE__*/forwardRef(ObjectAlignTopIcon);

function ObjectDistributeHorizontallyFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.9 13.1h-.4a.6.6 0 0 1-.6-.6v-9a.6.6 0 0 1 .6-.6h.4V1.5h1.2v1.4h.4a.6.6 0 0 1 .6.6v9a.6.6 0 0 1-.6.6h-.4V15H4.9zM9.9 11.1h-.4a.6.6 0 0 1-.6-.6v-5a.6.6 0 0 1 .6-.6h.4V1.5h1.2v3.4h.4a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-.6.6h-.4V15H9.9z"
  }));
}
var ForwardRef$2A = /*#__PURE__*/forwardRef(ObjectDistributeHorizontallyFilledIcon);

function ObjectDistributeHorizontallyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.9 1v1.9H4a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h.9V15h1.2v-1.9H7a.6.6 0 0 0 .6-.6v-9a.6.6 0 0 0-.6-.6h-.9V1zm-.3 3.1v7.8h1.8V4.1zM9.9 4.4V1h1.2v3.4h.9a.6.6 0 0 1 .6.6v6a.6.6 0 0 1-.6.6h-.9V15H9.9v-3.4H9a.6.6 0 0 1-.6-.6V5a.6.6 0 0 1 .6-.6zm-.3 6V5.6h1.8v4.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2z = /*#__PURE__*/forwardRef(ObjectDistributeHorizontallyIcon);

function ObjectDistributeVerticallyFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 3.9a.6.6 0 0 0-.6.6v.4H1v1.2h3.9v.4a.6.6 0 0 0 .6.6h5a.6.6 0 0 0 .6-.6v-.4H15V4.9h-3.9v-.4a.6.6 0 0 0-.6-.6zM13.1 11.1v.4a.6.6 0 0 1-.6.6h-9a.6.6 0 0 1-.6-.6v-.4H1V9.9h1.9v-.4a.6.6 0 0 1 .6-.6h9a.6.6 0 0 1 .6.6v.4H15v1.2z"
  }));
}
var ForwardRef$2y = /*#__PURE__*/forwardRef(ObjectDistributeVerticallyFilledIcon);

function ObjectDistributeVerticallyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3.4a.6.6 0 0 0-.6.6v.9H1v1.2h3.4V7a.6.6 0 0 0 .6.6h6a.6.6 0 0 0 .6-.6v-.9H15V4.9h-3.4V4a.6.6 0 0 0-.6-.6zm.6 3V4.6h4.8v1.8zM3.5 8.4a.6.6 0 0 0-.6.6v.9H1v1.2h1.9v.9a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6v-.9H15V9.9h-1.9V9a.6.6 0 0 0-.6-.6zm.6 3V9.6h7.8v1.8z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2x = /*#__PURE__*/forwardRef(ObjectDistributeVerticallyIcon);

function AppLauncherIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.2 2v2.4H6.8V2zM9.2 6.85v2.4H6.8v-2.4zM9.2 11.6V14H6.8v-2.4zM14 2v2.4h-2.4V2zM14 6.85v2.4h-2.4v-2.4zM14 11.6V14h-2.4v-2.4zM4.4 2v2.4H2V2zM4.4 6.85v2.4H2v-2.4zM4.4 11.6V14H2v-2.4z"
  }));
}
var ForwardRef$2w = /*#__PURE__*/forwardRef(AppLauncherIcon);

function AssignToMeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.888 1a3.965 3.965 0 0 0-2.3 7.195A5.89 5.89 0 0 0 2 13.617V14h1.2v-.383a4.687 4.687 0 0 1 7.445-3.791l.706-.97a6 6 0 0 0-1.165-.66A3.965 3.965 0 0 0 7.887 1M5.123 4.965a2.765 2.765 0 1 1 5.53 0 2.765 2.765 0 0 1-5.53 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.576 10.154.848.848-.976.976H15v1.2h-3.552l.976.976-.848.848-2.425-2.424z"
  }));
}
var ForwardRef$2v = /*#__PURE__*/forwardRef(AssignToMeIcon);

function AssignToMeFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.888 1a3.965 3.965 0 0 0-2.3 7.195 5.9 5.9 0 0 0-3.548 4.736 5 5 0 0 0-.038.467v.6h4.236l5.22-5.13-.699-.392a6 6 0 0 0-.519-.258l-.054-.023A3.965 3.965 0 0 0 7.887 1M11.576 10.154l.848.848-.976.976H15v1.2h-3.552l.976.976-.848.848-2.425-2.424z"
  }));
}
var ForwardRef$2u = /*#__PURE__*/forwardRef(AssignToMeFilledIcon);

/** @deprecated BellIcon is deprecated; use AlertIcon instead */
function BellIcon(props, ref) {
  console.warn('Design system warning: BellIcon is deprecated; use AlertIcon instead');
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.654 0 4.779 1.85 4.895 4.217l.005.204v1.895c0 2.084 2.1 2.59 2.1 3.79 0 .817-1.584 1.489-4.227 1.762C10.587 14.103 9.43 15 8 15s-2.587-.897-2.774-2.132C2.584 12.594 1 11.923 1 11.105c0-1.15 1.929-1.662 2.09-3.537l.01-.252V5.42C3.1 2.958 5.27 1 8 1m1.294 11.973q-.473.02-.969.025L8 13q-.673 0-1.294-.027c.204.412.683.694 1.294.694s1.09-.282 1.294-.694M8 2.39c-1.917 0-3.395 1.275-3.495 2.861l-.005.171v1.895c0 1.229-.433 2.102-1.262 3l-.578.59.094.04.214.077q.058.02.119.038l.19.057c1.12.312 2.769.493 4.723.493s3.603-.181 4.722-.493q.3-.085.524-.172l.093-.04-.394-.396c-.884-.905-1.377-1.756-1.438-2.936l-.007-.258V5.42C11.5 3.756 9.985 2.39 8 2.39",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2t = /*#__PURE__*/forwardRef(BellIcon);

function BirthdateIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.503 7.122a.6.6 0 0 0-1.004 0l-.727 1.11-1.265.356a.6.6 0 0 0-.309.948l.819 1.045-.056 1.333a.6.6 0 0 0 .811.587l1.229-.464 1.228.464a.6.6 0 0 0 .811-.587l-.056-1.333.82-1.045a.6.6 0 0 0-.31-.948l-1.265-.357zm-.85 1.955L8 8.546l.348.53a.6.6 0 0 0 .339.25l.619.174-.404.515a.6.6 0 0 0-.127.395l.027.648-.59-.223a.6.6 0 0 0-.424 0l-.591.223.027-.648a.6.6 0 0 0-.127-.396L6.695 9.5l.619-.175a.6.6 0 0 0 .339-.248",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.901 1.889h-1.85V1h-1.2v.889h-3.7V1h-1.2v.889H3.1a.6.6 0 0 0-.6.6v11.91a.6.6 0 0 0 .6.6h9.801a.6.6 0 0 0 .6-.6V2.488a.6.6 0 0 0-.6-.6m-7.95 2.088V3.09H3.7v1.777h8.601V3.09h-1.25v.888h-1.2V3.09h-3.7v.888zm7.35 2.09H3.7v7.731h8.601z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2s = /*#__PURE__*/forwardRef(BirthdateIcon);

function BirthdateFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.95 1.889V1h1.2v.889h3.7V1h1.201v.889h1.85a.6.6 0 0 1 .6.6v2.377H2.5V2.49a.6.6 0 0 1 .6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 6.066v8.332a.6.6 0 0 0 .6.6h9.801a.6.6 0 0 0 .6-.6V6.066zM8 7.451l.85 1.297 1.481.417-.955 1.22.065 1.555L8 11.396l-1.44.543.065-1.554-.956-1.22 1.48-.417z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2r = /*#__PURE__*/forwardRef(BirthdateFilledIcon);

function BoardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.077 6.16h9.847v-1.2H3.077zM4.062 8.62h-.985v-1.2h.985zM9.478 8.62h3.446v-1.2H9.478zM8.493 8.62H5.047v-1.2h3.446zM3.077 11.042h.985v-1.2h-.985zM12.924 11.042H9.478v-1.2h3.446zM5.047 11.042h3.446v-1.2H5.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6 2.5a.6.6 0 0 0-.6.6v9.802a.6.6 0 0 0 .6.6h12.801a.6.6 0 0 0 .6-.6V3.1a.6.6 0 0 0-.6-.6zm.6 9.802V3.7h11.601v8.602z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2q = /*#__PURE__*/forwardRef(BoardIcon);

function BoardFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6 2.5a.6.6 0 0 0-.6.6v9.802a.6.6 0 0 0 .6.6h12.801a.6.6 0 0 0 .6-.6V3.1a.6.6 0 0 0-.6-.6zm11.324 3.66H3.077v-1.2h9.847zM4.062 8.621h-.985v-1.2h.985zm5.416 0h3.446v-1.2H9.478zm-.985 0H5.047v-1.2h3.446zm-5.416 2.42h.985v-1.2h-.985zm9.847 0H9.478v-1.2h3.446zm-7.877 0h3.446v-1.2H5.047z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2p = /*#__PURE__*/forwardRef(BoardFilledIcon);

function BookmarkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.79 15a.7.7 0 0 1-.376-.108L8 12.132l-4.414 2.76A.71.71 0 0 1 2.5 14.29V1.71A.71.71 0 0 1 3.21 1h9.58a.71.71 0 0 1 .71.71v12.58a.71.71 0 0 1-.71.71M8 10.584c.13 0 .26.036.376.108l3.704 2.317V2.42H3.92v10.588l3.704-2.317A.7.7 0 0 1 8 10.584"
  }));
}
var ForwardRef$2o = /*#__PURE__*/forwardRef(BookmarkIcon);

function BrightnessIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.851 7.364v1.272H1V7.364zm.637-4.776 1.305 1.305-.9.9-1.305-1.305zM8.636 1v1.851H7.364V1zm3.876 1.588.9.9-1.305 1.305-.9-.9zM15 7.364v1.272h-1.851V7.364zm-2.893 3.843 1.305 1.305-.9.9-1.305-1.305zm-3.47 1.942V15H7.363v-1.851zm-4.744-1.942.9.9-1.305 1.305-.9-.9zM8 3.893a4.107 4.107 0 1 0 0 8.214 4.107 4.107 0 0 0 0-8.214m0 1.272a2.834 2.834 0 1 1 0 5.67 2.834 2.834 0 0 1 0-5.67",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2n = /*#__PURE__*/forwardRef(BrightnessIcon);

function BugIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.784 1 .866.866-1.256 1.256q.218.334.34.725.316.229.595.506l1.126-1.126.866.866-1.224 1.224a6.4 6.4 0 0 1 .915 2.618h1.726v1.226h-1.68a6.5 6.5 0 0 1-.98 3.155l1.243 1.243-.866.867-1.143-1.142c-.839.849-1.919 1.385-3.107 1.44L8 14.729c-1.27 0-2.425-.548-3.312-1.445l-1.143 1.142-.866-.867 1.242-1.243a6.5 6.5 0 0 1-.98-3.155H1.262V7.936h1.729a6.5 6.5 0 0 1 .926-2.604L2.679 4.093l.866-.866 1.136 1.136q.275-.277.584-.51.122-.393.341-.731L4.35 1.866 5.216 1l1.259 1.258a2.82 2.82 0 0 1 3.05 0zm-5.07 4.07-.04.036q-.063.06-.126.123l.033.034-.419.416c-.628.842-1.004 1.954-1.004 3.147 0 1.227.397 2.343 1.037 3.178l.386.386-.027.027c.519.525 1.15.888 1.834 1.026V5.759a4.7 4.7 0 0 1-1.193-.422 6 6 0 0 1-.48-.267m4.582-.006-.027.017q-.2.123-.464.256a4.7 4.7 0 0 1-1.193.422v7.684c.685-.138 1.315-.5 1.834-1.026l-.027-.027.386-.386c.64-.835 1.037-1.95 1.037-3.178 0-1.17-.335-2.238-.915-3.056l-.508-.507.043-.043a4 4 0 0 0-.166-.156M8 3.036c-.671 0-1.264.422-1.515 1.037l-.01.024.135.076.133.069c.444.222.88.353 1.257.353s.813-.131 1.257-.353q.14-.07.255-.136l.011-.009-.008-.024A1.65 1.65 0 0 0 8.133 3.04z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2m = /*#__PURE__*/forwardRef(BugIcon);

function CalendarIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.273 1-.001 1.157h5.427L10.7 1h1.273l-.001 1.161.078-.004h2.314c.322 0 .588.24.63.55l.006.086v11.57c0 .323-.24.59-.55.631l-.086.006H1.636a.636.636 0 0 1-.63-.55L1 14.364V2.794c0-.323.24-.589.55-.631l.086-.006H3.95L4 2.16 4 1zm8.454 5.9H2.272v6.827h11.455zm-1.755-3.477v1.164H10.7l-.001-1.158H5.272v1.158H4l-.001-1.161-.049.004H2.273l-.001 2.198h11.455V3.429H12.05z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2l = /*#__PURE__*/forwardRef(CalendarIcon);

function CalendarDetailedIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.061 7.847a.6.6 0 1 0 0 1.2h.985a.6.6 0 0 0 0-1.2zM3.461 11.426a.6.6 0 0 1 .6-.6h.985a.6.6 0 0 1 0 1.2H4.06a.6.6 0 0 1-.6-.6M7.507 7.847a.6.6 0 0 0 0 1.2h.985a.6.6 0 0 0 0-1.2zM6.907 11.426a.6.6 0 0 1 .6-.6h.985a.6.6 0 0 1 0 1.2h-.985a.6.6 0 0 1-.6-.6M10.954 7.847a.6.6 0 0 0 0 1.2h.984a.6.6 0 1 0 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.153 1.89h5.693V1h1.2v.89H14.4a.6.6 0 0 1 .6.6v8.936a.6.6 0 0 1-.174.422l-2.954 2.979a.6.6 0 0 1-.426.177H1.6a.6.6 0 0 1-.6-.6V2.49a.6.6 0 0 1 .6-.6h2.353V1h1.2zm-1.2 1.2v1.137h1.2V3.089h5.693v1.138h1.2V3.089H13.8v1.78H2.2v-1.78zM2.2 6.067h11.6v4.261h-2.846a.6.6 0 0 0-.6.6v2.875H2.2zm9.354 7.376 1.899-1.915h-1.9z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2k = /*#__PURE__*/forwardRef(CalendarDetailedIcon);

function CalendarDetailedFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2h2.5a.5.5 0 0 1 .5.5v2.398H1V2.5a.5.5 0 0 1 .5-.5H4V1h1v1h6V1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 6.098h14v5.397h-.003a.6.6 0 0 1-.175.387l-2.961 2.944a.6.6 0 0 1-.512.168H1.5a.5.5 0 0 1-.5-.5zm10.5 5.397h2.008L11.5 13.492zM4 7.897a.6.6 0 0 0 0 1.2h1a.6.6 0 0 0 0-1.2zm-.6 3.598a.6.6 0 0 1 .6-.6h1a.6.6 0 1 1 0 1.2H4a.6.6 0 0 1-.6-.6m4.1-3.598a.6.6 0 0 0 0 1.2h1a.6.6 0 0 0 0-1.2zm-.6 3.598a.6.6 0 0 1 .6-.6h1a.6.6 0 1 1 0 1.2h-1a.6.6 0 0 1-.6-.6M11 7.897a.6.6 0 1 0 0 1.2h1a.6.6 0 1 0 0-1.2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2j = /*#__PURE__*/forwardRef(CalendarDetailedFilledIcon);

function CardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.27 3.004H2.737c-.957 0-1.733.798-1.733 1.784v6.428c0 .986.776 1.784 1.733 1.784H13.27c.958 0 1.734-.798 1.734-1.784V4.788c0-.986-.776-1.784-1.734-1.784m0 8.837H2.737l-.09-.007a.62.62 0 0 1-.517-.618V7.102h11.747v4.114a.616.616 0 0 1-.607.625m.607-6.798v1.059H2.13V4.788c0-.345.272-.625.607-.625H13.27l.09.007a.62.62 0 0 1 .517.618z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2i = /*#__PURE__*/forwardRef(CardIcon);

function ChannelsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.632 1A2.372 2.372 0 1 1 9.91 5.004l-4.24 2.41a2.4 2.4 0 0 1 0 1.173l4.24 2.409a2.372 2.372 0 1 1-.596 1.125l-4.28-2.43a2.372 2.372 0 1 1 0-3.381l4.28-2.43A2.372 2.372 0 0 1 11.632 1m0 10.529a1.1 1.1 0 1 0 0 2.198 1.1 1.1 0 0 0 0-2.198M3.372 6.9a1.1 1.1 0 1 0 0 2.198 1.1 1.1 0 0 0 0-2.198m8.26-4.628a1.1 1.1 0 1 0 0 2.198 1.1 1.1 0 0 0 0-2.198",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2h = /*#__PURE__*/forwardRef(ChannelsIcon);

function ChartIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.9 2.4a.6.6 0 0 0-.6.6v9.4H9.85V7.5a.6.6 0 0 0-.6-.6h-2.5a.6.6 0 0 0-.6.6v4.9H4.7V5.5a.6.6 0 0 0-.6-.6H1.6a.6.6 0 0 0-.6.6v8.1h14V3a.6.6 0 0 0-.6-.6zm1.9 10V3.6h-1.3v8.8zM8.65 8.1v4.3h-1.3V8.1zM3.5 12.4V6.1H2.2v6.3z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2g = /*#__PURE__*/forwardRef(ChartIcon);

function ChartFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.4 2.4a.6.6 0 0 0-.6.6v8.6H15V3a.6.6 0 0 0-.6-.6zM1.6 4.9a.6.6 0 0 0-.6.6v6.1h3.2V5.5a.6.6 0 0 0-.6-.6zM7 6.9a.6.6 0 0 0-.6.6v4.1h3.2V7.5a.6.6 0 0 0-.6-.6zM1 13.6h14v-1.2H1z"
  }));
}
var ForwardRef$2f = /*#__PURE__*/forwardRef(ChartFilledIcon);

function ChatIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.421 1.5c3.517 0 6.422 2.245 6.422 5.103q0 .146-.01.29C14.576 7.587 15 8.46 15 9.397c0 .889-.382 1.721-1.056 2.398l-.101.096v1.976c0 .436-.429.731-.83.603l-.085-.034-2.304-1.113-.067.01a7 7 0 0 1-.547.043l-.274.006c-1.766 0-3.385-.66-4.353-1.74l-2.311 1.117a.637.637 0 0 1-.909-.477l-.006-.091V9.52l-.144-.17c-.603-.747-.956-1.61-1.007-2.52L1 6.603C1 3.745 3.905 1.5 7.421 1.5m6.018 6.896-.039.08c-.941 1.907-3.28 3.23-5.979 3.23l.213-.004a5.4 5.4 0 0 0 2.102.416q.446 0 .892-.072a.64.64 0 0 1 .288.02l.09.036 1.564.755V11.61a.63.63 0 0 1 .163-.422l.068-.065c.603-.496.926-1.102.926-1.726 0-.345-.098-.683-.288-1M7.421 2.764c-2.873 0-5.148 1.758-5.148 3.839 0 .804.342 1.578.979 2.235a.63.63 0 0 1 .178.439v1.904l1.881-.909a.64.64 0 0 1 .35-.06l.088.017a6.7 6.7 0 0 0 1.672.212c2.652 0 4.795-1.497 5.11-3.363q-.001-.04.01-.079.03-.196.03-.396c0-2.08-2.276-3.84-5.15-3.84",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2e = /*#__PURE__*/forwardRef(ChatIcon);

function CheckIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.08 3 .92.976-8.502 8.826a.63.63 0 0 1-.84.071l-.08-.071L1 8.049l.92-.976 4.117 4.275z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2d = /*#__PURE__*/forwardRef(CheckIcon);

function CheckFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.999 3.91 7.065 11.85a1.5 1.5 0 0 1-2.134-.013L.997 7.806 2.428 6.41l3.58 3.668 7.576-7.58z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$2c = /*#__PURE__*/forwardRef(CheckFilledIcon);

function CheckSmallIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.498 5.357-6.603 6.476a.6.6 0 0 1-.84 0L2.5 8.346l.84-.857 3.135 3.075L12.657 4.5z"
  }));
}
var ForwardRef$2b = /*#__PURE__*/forwardRef(CheckSmallIcon);

function CheckSmallFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.998 5.424-6.885 6.792a1 1 0 0 1-1.404 0L2.002 8.56l1.404-1.424L6.411 10.1 12.594 4z"
  }));
}
var ForwardRef$2a = /*#__PURE__*/forwardRef(CheckSmallFilledIcon);

function ClockIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1.4a5.6 5.6 0 1 0 0 11.2A5.6 5.6 0 0 0 8 2.4M8.7 4v3.3H12v1.4H8a.7.7 0 0 1-.694-.605L7.3 8V4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$29 = /*#__PURE__*/forwardRef(ClockIcon);

function ClockFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 0 0 14.001A7 7 0 0 0 8 1m-.6 7V4.063h1.2V7.4h3.34v1.2H8a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  }));
}
var ForwardRef$28 = /*#__PURE__*/forwardRef(ClockFilledIcon);

function CloseIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.075 1 .925.925L8.924 8 15 14.075l-.925.925L8 8.924 1.925 15 1 14.075 7.075 8 1 1.925 1.925 1 8 7.075z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$27 = /*#__PURE__*/forwardRef(CloseIcon);

function CloseFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.585 7.999 2 12.583l1.414 1.415L8 9.413l4.584 4.585 1.415-1.415L9.413 8l4.585-4.585L12.583 2 8 6.585 3.414 2 2 3.414z"
  }));
}
var ForwardRef$26 = /*#__PURE__*/forwardRef(CloseFilledIcon);

function CloseSmallIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.15 8 4 11.15l.849.848 3.15-3.15 3.15 3.15.85-.848L8.847 8l3.15-3.151L11.15 4 8 7.15 4.848 4 4 4.849z"
  }));
}
var ForwardRef$25 = /*#__PURE__*/forwardRef(CloseSmallIcon);

function CloseSmallFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.587 8.001 4 10.59l1.414 1.414 2.587-2.587 2.588 2.587 1.414-1.414L9.416 8l2.587-2.587L10.589 4 8 6.587 5.414 4 4 5.414z"
  }));
}
var ForwardRef$24 = /*#__PURE__*/forwardRef(CloseSmallFilledIcon);

function ColorPickerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 8.006c0-.953.788-1.732 1.75-1.732s1.752.78 1.752 1.732-.788 1.732-1.751 1.732S9 8.958 9 8.006m-.121 4.426c-.525 0-.876-.347-.876-.866s.35-.866.876-.866c.525 0 .875.346.875.866s-.35.866-.875.866m-3.804-1.2c-.525 0-.875-.347-.875-.866s.35-.866.875-.866.876.346.876.866-.35.866-.876.866m-1.2-3C3.35 8.232 3 7.885 3 7.366s.35-.866.875-.866.876.346.876.866-.35.866-.876.866m.126-6.27A6.78 6.78 0 0 0 1 7.603C1 11.427 4.13 14.5 8.024 14.5c3.148 0 5.925-2.085 6.768-5.016.512-2.132.143-4.29-1.832-5.287-1.31-.604-2.414-.565-4.01-.107l-.79.234c-.968.279-1.187.265-1.387.03q.004.005.01-.005l.212-.7c.165-.58.165-1.04-.133-1.461l-.048-.06c-.566-.835-1.918-.782-2.813-.167m1.75.86.041.054c.042.05.05.135-.001.34l-.068.235-.02.065c-.26.816-.298 1.164.081 1.63.69.814 1.197.832 2.853.347l.42-.126c1.468-.447 2.34-.506 3.34-.045 1.27.642 1.544 2.24 1.16 3.848-.683 2.366-2.96 4.076-5.533 4.076-3.188 0-5.747-2.512-5.747-5.642 0-1.872.916-3.573 2.453-4.613.385-.265.94-.287 1.021-.168",
    clipRule: "evenodd"
  }));
}
var ForwardRef$23 = /*#__PURE__*/forwardRef(ColorPickerIcon);

function CommentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.5c3.858 0 7 2.6 7 5.914 0 1.253-.475 2.442-1.329 3.456l-.146.165.314 2.746a.64.64 0 0 1-.788.699l-.084-.028-3.214-1.324-.038.011c-.44.11-.893.168-1.402.184L8 13.328c-3.858 0-7-2.6-7-5.914S4.142 1.5 8 1.5m0 1.288c-3.205 0-5.727 2.088-5.727 4.626S4.795 12.04 8 12.04c.63 0 1.133-.062 1.61-.207a.63.63 0 0 1 .423.02l2.418.995-.224-1.964a.65.65 0 0 1 .12-.455l.063-.074c.853-.864 1.317-1.882 1.317-2.941 0-2.538-2.522-4.626-5.727-4.626m1.215 5.153v1.288H5.05V7.941zm1.735-2.342v1.288h-5.9V5.599z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$22 = /*#__PURE__*/forwardRef(CommentIcon);

function ComponentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.218 3.534a.6.6 0 0 0 0 .848l2.358 2.359a.6.6 0 0 0 .849 0l2.358-2.359a.6.6 0 0 0 0-.848L8.425 1.176a.6.6 0 0 0-.849 0zm2.783 1.934-1.51-1.51 1.51-1.51 1.51 1.51zM1.176 7.576a.6.6 0 0 0 0 .849l2.358 2.358a.6.6 0 0 0 .848 0l2.359-2.358a.6.6 0 0 0 0-.849L4.382 5.218a.6.6 0 0 0-.848 0zM3.958 9.51 2.448 8l1.51-1.509 1.51 1.51zM5.218 12.468a.6.6 0 0 1 0-.849l2.358-2.358a.6.6 0 0 1 .849 0l2.358 2.358a.6.6 0 0 1 0 .848l-2.358 2.359a.6.6 0 0 1-.849 0zm1.273-.425 1.51 1.51 1.51-1.51L8 10.533zM11.62 5.218 9.26 7.576a.6.6 0 0 0 0 .849l2.36 2.358a.6.6 0 0 0 .848 0l2.358-2.358a.6.6 0 0 0 0-.849l-2.358-2.358a.6.6 0 0 0-.849 0m.423 4.292L10.533 8l1.51-1.509 1.51 1.51z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$21 = /*#__PURE__*/forwardRef(ComponentIcon);

function ConfigurationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.786 1-.048.002c-2.033.144-3.657 1.938-3.586 3.996l.009.242q.01.12.026.236l.042.219-5.34 4.709c-1.12 1.034-1.195 2.774-.149 3.815l.131.122c1.113.975 2.787.86 3.716-.295l4.723-5.311.144.026c.403.062.831.058 1.345.007a3.97 3.97 0 0 0 3.065-2.774c.206-.75.17-1.514-.059-2.275l-.035-.094a.68.68 0 0 0-1.097-.192L12.381 4.72 11.277 3.62l1.29-1.282a.68.68 0 0 0-.295-1.137A5.3 5.3 0 0 0 10.786 1m-.26 1.402.058-.01-.75.747a.68.68 0 0 0 0 .965L11.9 6.162l.084.071a.68.68 0 0 0 .877-.071l.737-.735-.001.013q-.018.09-.042.178A2.59 2.59 0 0 1 11.6 7.424c-.532.05-.933.028-1.307-.096a.68.68 0 0 0-.723.193l-5.022 5.646c-.476.592-1.305.627-1.846.088-.487-.485-.45-1.333.1-1.841L8.46 6.426a.68.68 0 0 0 .181-.765 1.8 1.8 0 0 1-.128-.687c-.042-1.24.854-2.333 2.014-2.572",
    clipRule: "evenodd"
  }));
}
var ForwardRef$20 = /*#__PURE__*/forwardRef(ConfigurationIcon);

function ContactsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.437 1.5H1.563A.555.555 0 0 0 1 2.046v9.64l.005.074a.56.56 0 0 0 .558.472h4.223l1.781 2.072.06.06c.233.2.6.18.806-.06l1.78-2.073h4.224a.555.555 0 0 0 .563-.545v-9.64a.555.555 0 0 0-.563-.546m-.563 1.092v8.548H9.95l-.082.006a.57.57 0 0 0-.35.19L8 13.102l-1.518-1.764-.057-.058a.57.57 0 0 0-.375-.139H2.126V2.592zM8 3.64c.958 0 1.734.776 1.734 1.733v.585c0 .354-.107.684-.291.96l.767.58c.4.3.65.756.689 1.25l.005.136v1.149H5.096V8.885c0-.5.216-.973.587-1.3l.106-.086.768-.579a1.73 1.73 0 0 1-.29-.96v-.586c0-.957.775-1.733 1.733-1.733m.495 3.976a2 2 0 0 1-.356.07L8 7.693q-.26-.001-.499-.073l-1.036.78a.6.6 0 0 0-.237.404l-.005.081-.001.022h3.555v-.022a.6.6 0 0 0-.181-.433L9.534 8.4zM8 4.767a.607.607 0 0 0-.607.607v.585c0 .224.12.42.293.525q.024.007.044.022.114.06.243.061l.086-.003c.31-.03.548-.291.548-.605v-.585A.607.607 0 0 0 8 4.767",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1$ = /*#__PURE__*/forwardRef(ContactsIcon);

function CookieIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .9q.556 0 1.092.083l.066.015a.6.6 0 0 1 .397.807c-.144.35-.23.9-.057 1.393.158.448.568.959 1.643 1.219a.6.6 0 0 1 .454.662c-.063.468.084 1.171.52 1.69.403.48 1.098.856 2.278.641A.6.6 0 0 1 15.1 8 7.1 7.1 0 1 1 8 .9M2.1 8a5.9 5.9 0 0 0 11.76.667c-1.19.03-2.078-.43-2.663-1.124a3.57 3.57 0 0 1-.811-2.099c-1.109-.383-1.743-1.062-2.02-1.847a3.1 3.1 0 0 1-.126-1.493A5.9 5.9 0 0 0 2.1 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 4.75,
    r: 0.75
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}
var ForwardRef$1_ = /*#__PURE__*/forwardRef(CookieIcon);

function CookieFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1q.55 0 1.076.082l.11.03a.5.5 0 0 1 .307.545l-.031.11c-.15.365-.242.941-.058 1.464.171.485.611 1.016 1.713 1.283a.5.5 0 0 1 .382.458l-.003.094c-.066.495.087 1.226.543 1.768.428.509 1.16.894 2.371.674A.5.5 0 0 1 15 8a7 7 0 1 1-7-7m1 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m1.75-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
  }));
}
var ForwardRef$1Z = /*#__PURE__*/forwardRef(CookieFilledIcon);

function CopyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.96 3.4c.357 0 .647.3.647.671v10.257a.66.66 0 0 1-.647.672H2.647A.66.66 0 0 1 2 14.328V4.071a.66.66 0 0 1 .647-.672zm-.646 1.343h-7.02v8.913h7.02zM13.354 1c.327 0 .597.253.64.58l.006.092v11.255h-1.293l-.001-10.583H4.284V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1Y = /*#__PURE__*/forwardRef(CopyIcon);

function CustomerServiceIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.164 5.07c0-1.593 1.277-2.874 2.837-2.874s2.837 1.28 2.837 2.875-1.276 2.875-2.837 2.875c-1.56 0-2.837-1.28-2.837-2.875M8.001.997c-2.236 0-4.037 1.83-4.037 4.075 0 1.38.68 2.603 1.725 3.341A6.07 6.07 0 0 0 2 14.007V15h1.2v-.993c0-2.69 2.156-4.86 4.801-4.86s4.801 2.17 4.801 4.86V15h1.2v-.993c0-2.516-1.52-4.68-3.689-5.595a4.08 4.08 0 0 0 1.725-3.341c0-2.244-1.801-4.075-4.037-4.075m4.31 2.586h1.2V6.56h-1.2zm-9.82 2.995c0 1.145.928 2.073 2.073 2.073v-1.2a.873.873 0 0 1-.873-.873V3.582h-1.2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1X = /*#__PURE__*/forwardRef(CustomerServiceIcon);

function CustomerServiceFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.127 8.388a4 4 0 1 0-4.255 0A6 6 0 0 0 2 14v1h12v-1a6 6 0 0 0-3.873-5.612M12.4 3.5h1.2v3h-1.2zm-10 3c0 1.16.94 2.1 2.1 2.1V7.4a.9.9 0 0 1-.9-.9v-3H2.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1W = /*#__PURE__*/forwardRef(CustomerServiceFilledIcon);

function DateIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.25 13.25H2.75V7.125h10.5zm.875-10.5h-1.75v-.875c0-.525-.35-.875-.875-.875h-.875c-.525 0-.875.35-.875.875v.875h-3.5v-.875C6.25 1.35 5.9 1 5.375 1H4.5c-.525 0-.875.35-.875.875v.875h-1.75C1.35 2.75 1 3.1 1 3.625v10.5c0 .525.35.875.875.875h12.25c.525 0 .875-.35.875-.875v-10.5c0-.525-.35-.875-.875-.875"
  }));
}
var ForwardRef$1V = /*#__PURE__*/forwardRef(DateIcon);

function DeleteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.314 1c.322 0 .588.24.63.55l.006.086v1.678h3.25v1.273l-1.101-.001v9.778c0 .322-.24.588-.55.63l-.086.006H3.372a.636.636 0 0 1-.63-.55l-.006-.086-.001-9.778H1.8V3.315h3.249V1.636c0-.322.24-.588.55-.63L5.687 1zm1.512 3.586H4.008v9.141h7.818zM9.943 6.478v5.357H8.67V6.478zm-2.77 0v5.357H5.9V6.478zm2.504-4.205H6.322v1.041h3.355z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1U = /*#__PURE__*/forwardRef(DeleteIcon);

function DialogIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.984 10.09H8v-1.2h.984zM10.954 10.09H9.97v-1.2h.984zM12.923 8.89v1.2h-.985v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.4 5.945a1.6 1.6 0 0 1 1.6 1.6V14.4a.6.6 0 0 1-.974.47l-2.297-1.834H7.522a1.6 1.6 0 0 1-1.6-1.6V7.545a1.6 1.6 0 0 1 1.6-1.6zm-5.878 1.2c-.22 0-.4.18-.4.4v3.892c0 .22.18.4.4.4h4.416a.6.6 0 0 1 .29.075l.085.056 1.488 1.186v-5.61a.4.4 0 0 0-.4-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.478 2.999a1.6 1.6 0 0 1 1.6 1.6v.472h-1.2V4.6c0-.221-.18-.4-.4-.4H2.6a.4.4 0 0 0-.4.4v5.609l1.487-1.187.084-.055a.6.6 0 0 1 .29-.075h.985v1.2H4.27l-2.297 1.833A.601.601 0 0 1 1 11.455V4.6a1.6 1.6 0 0 1 1.6-1.6z"
  }));
}
var ForwardRef$1T = /*#__PURE__*/forwardRef(DialogIcon);

function DialogFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.401 5.946a1.6 1.6 0 0 1 1.6 1.6v6.856a.6.6 0 0 1-.974.47l-2.297-1.834H7.523c-.883 0-1.6-.716-1.6-1.6V7.547a1.6 1.6 0 0 1 1.6-1.6zM8 10.092h.984v-1.2H8zm1.97 0h.984v-1.2H9.97zm1.97 0h.984v-1.2h-.984z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.496 3c.874 0 1.582.708 1.582 1.582v.6H7.554a2.4 2.4 0 0 0-2.4 2.4v2.51h-.883l-2.297 1.833A.601.601 0 0 1 1 11.456V4.6A1.6 1.6 0 0 1 2.6 3z"
  }));
}
var ForwardRef$1S = /*#__PURE__*/forwardRef(DialogFilledIcon);

function DislikeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.648 14.864c1.058-.635 1.828-2.151 1.896-3.48l.005-.189-.001-1.274h2.547c1.006 0 1.835-.786 1.9-1.845L15 7.93l-.632-5.018a1.915 1.915 0 0 0-1.773-1.907L12.459 1H8.002c-.852 0-1.69.18-2.398.518l-.232.118-.553.265v-.264a.64.64 0 0 0-.542-.63L4.183 1H1.637A.637.637 0 0 0 1 1.637v7.01c0 .351.285.637.637.637h2.546c.22 0 .414-.112.528-.282l2.018 2.425v2.317c0 .975.98 1.53 1.92 1.12m-.644-1.113-.002-.007v-2.549a.64.64 0 0 0-.095-.336l-.052-.072-3.036-3.644V3.314l1.133-.544a4.25 4.25 0 0 1 1.805-.49l.245-.006h4.457c.32 0 .588.243.634.613l.007.104.632 5.018c0 .32-.242.589-.551.632l-.086.005H9.912a.64.64 0 0 0-.63.551l-.006.087v1.911c0 .95-.587 2.158-1.206 2.537-.047.02-.061.023-.066.019M3.545 8.01H2.273V2.275h1.272z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1R = /*#__PURE__*/forwardRef(DislikeIcon);

function HorizontalDotsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 6.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m5.25 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m5.25 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1Q = /*#__PURE__*/forwardRef(HorizontalDotsIcon);

function VerticalDotsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m0 5.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m0 5.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1P = /*#__PURE__*/forwardRef(VerticalDotsIcon);

function DraggableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 2.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 8,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 13.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 2.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 8,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 13.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1O = /*#__PURE__*/forwardRef(DraggableIcon);

function EditIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.37 14.558a.61.61 0 0 1-.432.18H1.875a.613.613 0 0 1-.612-.613v-3.062c0-.163.064-.319.179-.434l9.187-9.187c.24-.24.627-.24.867 0l3.062 3.062c.24.24.24.627 0 .867zm3.854-9.98-6.736 6.736v2.198h2.196l6.738-6.737zm1.838-1.838-.973.97 2.198 2.198.973-.97z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1N = /*#__PURE__*/forwardRef(EditIcon);

function EmailIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.34c0 .334-.24.61-.55.654l-.086.006H1.636a.645.645 0 0 1-.63-.571L1 13.339V2.661C1 2.296 1.285 2 1.636 2h12.728c.351 0 .636.296.636.661zm-1.273-6.562L8.305 9.851a.62.62 0 0 1-.61 0L2.272 6.778v5.9h11.455zm0-3.456H2.273v1.95l5.726 3.245 5.728-3.244z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1M = /*#__PURE__*/forwardRef(EmailIcon);

function ExtendIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M14.269 1c.37 0 .676.275.724.632l.007.1v5.372h-1.463V3.496L3.496 13.537h3.608V15H1.731a.73.73 0 0 1-.724-.632l-.007-.1V8.897h1.463l-.001 3.607L12.503 2.462H8.896V1z",
    transform: "translate(-1281 -187) translate(1280 186)"
  }));
}
var ForwardRef$1L = /*#__PURE__*/forwardRef(ExtendIcon);

function FavoriteRouteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.998 3.085A2.09 2.09 0 0 1 3.092 1a2.09 2.09 0 0 1 2.094 2.085A2.09 2.09 0 0 1 3.092 5.17 2.09 2.09 0 0 1 .998 3.085M3.092 2.2a.89.89 0 0 0-.894.885.89.89 0 0 0 .894.885.89.89 0 0 0 .894-.885.89.89 0 0 0-.894-.885M11.56 8.426a.6.6 0 0 1 .537.334l.739 1.486 1.652.24a.6.6 0 0 1 .332 1.024l-1.194 1.156.282 1.632a.6.6 0 0 1-.87.634l-1.478-.773-1.479.773a.6.6 0 0 1-.87-.634l.282-1.632L8.3 11.51a.6.6 0 0 1 .332-1.025l1.652-.239.738-1.486a.6.6 0 0 1 .538-.334m0 1.95-.341.686a.6.6 0 0 1-.452.327l-.755.11.544.526a.6.6 0 0 1 .174.533l-.13.749.682-.356a.6.6 0 0 1 .556 0l.68.356-.128-.749a.6.6 0 0 1 .173-.533l.544-.527-.755-.109a.6.6 0 0 1-.451-.327z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 3.685h3.438a1.522 1.522 0 1 1 0 3.044H5.674a3.182 3.182 0 1 0 0 6.363H8v-1.2H5.674a1.982 1.982 0 0 1 0-3.963h3.764a2.722 2.722 0 0 0 0-5.444H6z"
  }));
}
var ForwardRef$1K = /*#__PURE__*/forwardRef(FavoriteRouteIcon);

function FavoriteRouteFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 3.085A2.09 2.09 0 0 1 3.094 1 2.09 2.09 0 0 1 5.19 3.085 2.09 2.09 0 0 1 3.094 5.17 2.09 2.09 0 0 1 1 3.085m10.562 5.341a.6.6 0 0 1 .538.334l.738 1.487 1.652.238a.6.6 0 0 1 .332 1.025l-1.193 1.156.281 1.632a.6.6 0 0 1-.87.634l-1.478-.773-1.479.773a.6.6 0 0 1-.869-.634l.282-1.632-1.194-1.156a.6.6 0 0 1 .332-1.025l1.652-.239.739-1.486a.6.6 0 0 1 .537-.334m-5.56-4.741H9.44a1.522 1.522 0 0 1 0 3.044H5.676a3.182 3.182 0 1 0 0 6.363h2.326v-1.2H5.676a1.982 1.982 0 0 1 0-3.963H9.44a2.722 2.722 0 1 0 0-5.444H6.002z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1J = /*#__PURE__*/forwardRef(FavoriteRouteFilledIcon);

function FavoriteStopIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.542 3.171a.6.6 0 0 0-1.084 0L6.82 4.516l-1.42.215a.6.6 0 0 0-.336 1.015l1.04 1.053-.246 1.494a.6.6 0 0 0 .88.624L8 8.227l1.265.69a.6.6 0 0 0 .88-.624L9.897 6.8l1.04-1.053a.6.6 0 0 0-.337-1.015l-1.42-.215zM7.766 5.32 8 4.827l.234.493a.6.6 0 0 0 .453.335l.57.086-.428.433a.6.6 0 0 0-.165.52l.096.58-.472-.257a.6.6 0 0 0-.575 0l-.472.257.096-.58a.6.6 0 0 0-.165-.52l-.427-.433.57-.086a.6.6 0 0 0 .451-.335",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.57 14.818.43-.417za.6.6 0 0 0 .86 0L8 14.402l.43.418.002-.002.003-.003.011-.011.04-.042.146-.157a24.656 24.656 0 0 0 2.064-2.602C11.804 10.384 13 8.178 13 6.098 13 3.295 10.774 1 8 1 5.225 1 3 3.295 3 6.098c0 2.08 1.196 4.286 2.305 5.904a25 25 0 0 0 2.21 2.759l.04.042.01.01.003.004zM4.2 6.098C4.2 3.933 5.914 2.2 8 2.2c2.087 0 3.8 1.733 3.8 3.898 0 1.69-1.003 3.634-2.094 5.225A23 23 0 0 1 8 13.511l-.23-.267c-.403-.472-.94-1.14-1.475-1.92C5.204 9.731 4.2 7.786 4.2 6.097",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1I = /*#__PURE__*/forwardRef(FavoriteStopIcon);

function FavoriteStopFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.57 14.818.43-.417c.43.418.431.417.431.417a.6.6 0 0 1-.861 0m0 0 .43-.417.431.417.001-.001.054-.056.146-.157a24.656 24.656 0 0 0 2.064-2.602C11.804 10.384 13 8.178 13 6.098 13 3.295 10.774 1 8 1 5.225 1 3 3.295 3 6.098c0 2.08 1.196 4.286 2.305 5.904a25 25 0 0 0 2.064 2.602l.185.199.011.01.003.004zM8.653 3.171a.6.6 0 0 0-1.084 0L6.93 4.516l-1.42.215a.6.6 0 0 0-.337 1.015l1.04 1.053-.246 1.494a.6.6 0 0 0 .88.624l1.264-.69 1.264.69a.6.6 0 0 0 .88-.624L10.008 6.8l1.04-1.053a.6.6 0 0 0-.337-1.015l-1.419-.215z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1H = /*#__PURE__*/forwardRef(FavoriteStopFilledIcon);

function FeedbackIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.999 1.6a.6.6 0 0 1 .6-.6h9.835a.6.6 0 0 1 .6.6v1.314l1.792 1.794a.6.6 0 0 1 0 .848L13.034 7.35V14.4a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6zm9.835.6v.543l-1.701 1.703H4.566v1.2h4.368L7.182 7.401H4.566v1.2h2.23l-.362 1.754H4.566v1.2h1.967v-.378l3.2-.662a.6.6 0 0 0 .303-.164l1.798-1.8v5.25H3.2V2.2zm.515 1.726L8.11 8.17l-.314 1.52 1.517-.313 4.24-4.244z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1G = /*#__PURE__*/forwardRef(FeedbackIcon);

function FeedbackFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.435l1.924-1.924a.6.6 0 0 0 0-.848L13 2.738V1.5a.5.5 0 0 0-.5-.5zm8.165 2.9H4.5v1.2h4.965zm-3.5 3.5H4.5v1.2h2.168l.306-.92a.6.6 0 0 1 .145-.235zM5.5 12.1h-1v-1.2h1zm2.568-3.906 4.345-4.345 1.239 1.238-4.346 4.345-1.857.62z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1F = /*#__PURE__*/forwardRef(FeedbackFilledIcon);

function FileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.782 1a.67.67 0 0 1 .462.186l-.06-.051q.024.018.045.037l.015.014 3.565 3.471a.64.64 0 0 1 .153.236l.008.022a1 1 0 0 1 .024.106l.003.055.003.031v9.257a.645.645 0 0 1-.653.636H2.653A.645.645 0 0 1 2 14.364V1.636C2 1.285 2.293 1 2.653 1zm-.654 1.272H3.307v11.455h9.386l-.001-7.984h-2.91a.65.65 0 0 1-.647-.55l-.006-.086zm1.842 8.563v1.272H5.03v-1.272zm0-2.893v1.273H5.03V7.942zM7.406 5.05v1.272H5.03V5.05zm3.029-1.879v1.3l1.334-.001z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1E = /*#__PURE__*/forwardRef(FileIcon);

function FillIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.804 1a.804.804 0 0 0-.797.695L1 1.804v9.184h1.607l.001-7.245 10.413 10.414 1.137-1.137L3.744 2.607h7.244V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1D = /*#__PURE__*/forwardRef(FillIcon);

function FilterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.333 2c0-.368.299-.667.667-.667h12c.368 0 .667.299.667.667v2c0 .177-.07.346-.196.471L10 8.943v3.724a.67.67 0 0 1-.369.596l-2.666 1.333A.667.667 0 0 1 6 14V8.943L1.529 4.47A.67.67 0 0 1 1.333 4zm1.334.667v1.057l4.471 4.471a.67.67 0 0 1 .195.472v4.254l1.334-.666V8.667c0-.177.07-.347.195-.472l4.471-4.471V2.667z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1C = /*#__PURE__*/forwardRef(FilterIcon);

function FilterFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.9 1.001H2.1a.6.6 0 0 0-.6.6v2.392a.6.6 0 0 0 .178.427L6.07 8.752v5.647a.6.6 0 0 0 .9.52l2.658-1.536a.6.6 0 0 0 .3-.52V8.752l4.393-4.332a.6.6 0 0 0 .179-.427V1.6a.6.6 0 0 0-.6-.6M10.46 5.093H5.54v-1.2h4.918z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1B = /*#__PURE__*/forwardRef(FilterFilledIcon);

function FolderIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 3.6a1.1 1.1 0 0 1 1.1-1.1h3.93a.6.6 0 0 1 .422.172l1.302 1.283H13.9a1.1 1.1 0 0 1 1.1 1.1v7.346a1.1 1.1 0 0 1-1.1 1.1H2.099A1.1 1.1 0 0 1 1 12.4zm1.2.1v8.6h11.6V5.156H7.509a.6.6 0 0 1-.422-.173L5.784 3.7z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1A = /*#__PURE__*/forwardRef(FolderIcon);

function FolderFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.1 2.5A1.1 1.1 0 0 0 1 3.6v8.8a1.1 1.1 0 0 0 1.1 1.1h11.8a1.1 1.1 0 0 0 1.1-1.1V5.055a1.1 1.1 0 0 0-1.1-1.1H7.755L6.452 2.673A.6.6 0 0 0 6.03 2.5z"
  }));
}
var ForwardRef$1z = /*#__PURE__*/forwardRef(FolderFilledIcon);

function GridViewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.843 1H1.636A.636.636 0 0 0 1 1.636v5.207c0 .351.285.636.636.636h5.207a.636.636 0 0 0 .636-.636V1.636A.636.636 0 0 0 6.843 1m-.637 1.273v3.933H2.273V2.273zM14.364 1H9.157a.636.636 0 0 0-.636.636v5.207c0 .351.285.636.636.636h5.207A.636.636 0 0 0 15 6.843V1.636A.636.636 0 0 0 14.364 1m-.637 1.273v3.933H9.793V2.273zM6.843 8.52H1.636A.636.636 0 0 0 1 9.157v5.207c0 .351.285.636.636.636h5.207a.636.636 0 0 0 .636-.636V9.157a.636.636 0 0 0-.636-.636m-.637 1.272v3.934H2.273V9.793zm8.158-1.272H9.157a.636.636 0 0 0-.636.636v5.207c0 .351.285.636.636.636h5.207a.636.636 0 0 0 .636-.636V9.157a.636.636 0 0 0-.636-.636m-.637 1.272v3.934H9.793V9.793z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1y = /*#__PURE__*/forwardRef(GridViewIcon);

function HandToolIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 1c.672 0 1.254.377 1.537.928q.272-.098.58-.099c.673 0 1.255.378 1.538.928q.272-.096.58-.098c.902 0 1.643.68 1.714 1.546l.006.139v7.15c0 1.142-.29 2.03-.786 2.679-.32.417-.656.66-.918.773a.7.7 0 0 1-.174.048L12.03 15H4.866a.67.67 0 0 1-.449-.172l-.067-.071-1.48-1.812a3.84 3.84 0 0 1-.864-2.207L2 10.518v-2.17c0-.936.796-1.685 1.764-1.685q.229 0 .441.054v-3.16l.003-.043c0-.93.77-1.685 1.72-1.685q.308.001.582.1C6.791 1.376 7.373 1 8.045 1m0 1.295a.395.395 0 0 0-.39.32l-.007.07v3.94a.655.655 0 0 1-.662.647.66.66 0 0 1-.655-.56l-.006-.087V3.514a.393.393 0 0 0-.397-.39.395.395 0 0 0-.391.32l-.007.07-.003.041V9.07a.655.655 0 0 1-.661.648.66.66 0 0 1-.655-.56l-.006-.088v-.722c0-.209-.192-.39-.441-.39-.222 0-.398.143-.434.322l-.007.068v2.17c0 .522.161 1.031.46 1.46l.12.158 1.28 1.568h6.67l.04-.029q.083-.066.19-.19l.072-.089c.292-.382.485-.924.517-1.672l.005-.23v-7.15a.393.393 0 0 0-.397-.39.395.395 0 0 0-.391.32l-.006.07v2.28a.655.655 0 0 1-.662.648.66.66 0 0 1-.655-.56l-.006-.088v-3.11a.393.393 0 0 0-.397-.39.395.395 0 0 0-.391.32l-.007.07v3.11a.655.655 0 0 1-.661.648.66.66 0 0 1-.655-.56l-.006-.087v-3.94a.393.393 0 0 0-.398-.39",
    clipRule: "evenodd",
    transform: "translate(-1246 -463) translate(1244 462)"
  }));
}
var ForwardRef$1x = /*#__PURE__*/forwardRef(HandToolIcon);

function HeartIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.675 1.006c-1.007.056-1.935.5-2.646 1.225L8 2.26l-.029-.03C7.209 1.455 6.199 1 5.107 1 2.847 1 1 2.927 1 5.284c0 .993.386 2.09 1.088 3.288.57.975 1.34 1.997 2.261 3.045.71.808 1.47 1.585 2.229 2.305l.383.359.636.569c.234.2.572.2.806 0l.285-.25.35-.319a37 37 0 0 0 2.613-2.664c.92-1.048 1.69-2.07 2.261-3.045C14.614 7.374 15 6.277 15 5.284 15 2.927 13.153 1 10.893 1zm.218 1.322c1.557 0 2.834 1.332 2.834 2.956 0 .705-.31 1.588-.9 2.596-.523.892-1.245 1.85-2.114 2.84a34 34 0 0 1-2.147 2.22l-.37.346-.196.178-.197-.178a35 35 0 0 1-2.516-2.566c-.869-.99-1.59-1.948-2.113-2.84-.591-1.008-.901-1.89-.901-2.596 0-1.624 1.277-2.956 2.834-2.956.95 0 1.817.505 2.369 1.341a.622.622 0 0 0 1.048 0c.552-.836 1.418-1.341 2.369-1.341",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1w = /*#__PURE__*/forwardRef(HeartIcon);

function HistoryIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.692 2.092v1.344A7 7 0 1 1 1 8h1.2a5.8 5.8 0 1 0 1.216-3.554h1.63v1.2H1.492V2.092zM7.4 4.062V8a.6.6 0 0 0 .6.6h3.938V7.4H8.6V4.06z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1v = /*#__PURE__*/forwardRef(HistoryIcon);

function HistoryFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.692 3.436V2.092h-1.2v3.554h3.554v-1.2h-1.63A5.8 5.8 0 0 1 7.4 2.231V8a.6.6 0 0 0 .6.6h5.769A5.8 5.8 0 0 1 2.2 8H1a7 7 0 1 0 1.692-4.564"
  }));
}
var ForwardRef$1u = /*#__PURE__*/forwardRef(HistoryFilledIcon);

function IconIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 1.6a.6.6 0 0 1 .6-.6h4.924a.6.6 0 0 1 .6.6v4.89a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6zm1.2.6v3.69h3.724V2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.83 2.51-3.84 3.912a.6.6 0 0 1-.857 0L8.065 4.315l.856-.84 1.64 1.67 3.412-3.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.694 8.336a3.3 3.3 0 0 0-3.309 3.29c0 1.82 1.485 3.289 3.309 3.289 1.823 0 3.307-1.469 3.307-3.29s-1.484-3.29-3.307-3.29m-2.109 3.29c0-1.151.94-2.09 2.108-2.09s2.109.939 2.109 2.09-.94 2.089-2.108 2.089a2.1 2.1 0 0 1-2.109-2.09",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.314 11.156 3.508 9.36l.845-.851 2.84 2.82a.6.6 0 0 1 0 .851l-2.84 2.82-.845-.851 1.806-1.794H1.108v-1.2z"
  }));
}
var ForwardRef$1t = /*#__PURE__*/forwardRef(IconIcon);

function LanguageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.448 3.287H7.73v1.2H6.77a6.17 6.17 0 0 1-1.467 2.656q.182.114.375.211l1.842.935-.543 1.07-1.842-.934a6 6 0 0 1-.77-.464q-.365.258-.77.464l-1.843.934-.543-1.07 1.843-.935q.192-.097.374-.21A6.17 6.17 0 0 1 1.96 4.486H1v-1.2h3.384l-1.41-1.45.86-.837 1.441 1.482zm-1.238 1.2h2.31a5 5 0 0 1-1.155 1.901A5 5 0 0 1 3.21 4.487M10.133 4.768a.6.6 0 0 1 .544.349l4.326 9.38-1.09.503-1.205-2.613H7.557L6.35 15l-1.09-.502 4.327-9.381a.6.6 0 0 1 .545-.35m2.022 6.419L10.133 6.8 8.11 11.187z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1s = /*#__PURE__*/forwardRef(LanguageIcon);

function LanguageFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 1a1 1 0 0 0-1 1v1.4h3.551L3.076 1.924l.848-.848 1.5 1.5L4.6 3.4H8v1.2H6.987a6.25 6.25 0 0 1-1.538 2.786q.275.168.574.3l1.72.766-.487 1.096-1.72-.764A6.3 6.3 0 0 1 4.5 8.2a6.3 6.3 0 0 1-1.036.584l-1.72.764-.488-1.096 1.721-.765q.299-.134.574-.3A6.25 6.25 0 0 1 2.013 4.6H1V14a1 1 0 0 0 1 1h3.08l4.883-9.768a.6.6 0 0 1 1.09.033l3.873 9.114A1 1 0 0 0 15 14V2a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.886 15-1.02-2.4H7.62L6.42 15zM5.74 4.6H3.26A5.05 5.05 0 0 0 4.5 6.64 5.05 5.05 0 0 0 5.74 4.6M12.356 11.4H8.22l2.235-4.47z"
  }));
}
var ForwardRef$1r = /*#__PURE__*/forwardRef(LanguageFilledIcon);

function LikeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.648 1.136c1.058.635 1.828 2.151 1.896 3.48l.005.189-.001 1.274h2.547c1.006 0 1.835.786 1.9 1.845L15 8.07l-.632 5.018a1.915 1.915 0 0 1-1.773 1.907l-.136.005H8.002c-.852 0-1.69-.18-2.398-.518l-.232-.118-.553-.265v.264c0 .32-.235.585-.542.63L4.183 15H1.637A.637.637 0 0 1 1 14.363v-7.01c0-.351.285-.637.637-.637h2.546c.22 0 .414.112.528.282L6.73 4.573V2.256c0-.975.98-1.53 1.92-1.12M8.004 2.25l-.002.007v2.549c0 .12-.033.235-.095.336l-.052.072-3.036 3.644v3.829l1.133.544a4.25 4.25 0 0 0 1.805.49l.245.006h4.457c.32 0 .588-.243.634-.613l.007-.104.632-5.018a.64.64 0 0 0-.551-.632l-.086-.005H9.912a.64.64 0 0 1-.63-.551l-.006-.087V4.805c0-.95-.587-2.158-1.206-2.537-.047-.02-.061-.023-.066-.019M3.545 7.99H2.273v5.735h1.272z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1q = /*#__PURE__*/forwardRef(LikeIcon);

function ListViewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 11.6V13H4v-1.4zm-12.6 0V13H1v-1.4zM15 7.3v1.4H4V7.3zm-12.6 0v1.4H1V7.3zM15 3v1.4H4V3zM2.4 3v1.4H1V3z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1p = /*#__PURE__*/forwardRef(ListViewIcon);

function LoadingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M8 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5-.6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1o = /*#__PURE__*/forwardRef(LoadingIcon);

function ClosedLockIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.018 1 .18.005c1.858.103 3.28 1.63 3.28 3.524v1.099h1.067c.32 0 .584.236.63.542l.007.094v8.1a.636.636 0 0 1-.637.636h-9.09a.636.636 0 0 1-.637-.636v-8.1c0-.351.285-.636.637-.636h1.067v-1.1c0-1.902 1.433-3.424 3.285-3.523L8 1zM5.146 6.9H4.09v6.827h7.818V6.9l-1.056-.001-.012.002H5.146m2.852 1.4a1.402 1.402 0 0 1 .638 2.65v1.506H7.364v-1.504A1.402 1.402 0 0 1 7.998 8.3M8 2.273c-1.237 0-2.205.985-2.205 2.256v1.098h4.41V4.53c0-1.172-.825-2.107-1.916-2.24l-.143-.012z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1n = /*#__PURE__*/forwardRef(ClosedLockIcon);

function OpenedLockIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c1.32 0 2.524.764 3.116 1.946l.08.171.255.584-1.166.509-.255-.584A2.23 2.23 0 0 0 8 2.273c-1.187 0-2.127.908-2.2 2.105l-.005.15v1.1h6.75c.32 0 .584.236.63.542l.007.094v8.1a.636.636 0 0 1-.637.636h-9.09a.636.636 0 0 1-.637-.636v-8.1c0-.351.285-.636.637-.636h1.067v-1.1C4.523 2.56 6.056 1 8 1m3.91 5.9H4.09v6.827h7.82zM7.997 8.3a1.402 1.402 0 0 1 .638 2.65v1.506H7.364v-1.504A1.402 1.402 0 0 1 7.998 8.3",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1m = /*#__PURE__*/forwardRef(OpenedLockIcon);

function LogInIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.35 1a.6.6 0 0 1 .6.6v12.8c0 .33-.268.6-.6.6h-4.8v-1.2h4.2V2.2h-4.2V1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.574 7.576a.6.6 0 0 1 0 .848l-4 4-.848-.848L9.703 8.6H.95V7.4h8.753L6.726 4.424l.848-.848z"
  }));
}
var ForwardRef$1l = /*#__PURE__*/forwardRef(LogInIcon);

function LogOutIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 1v14h-1.394V1zM7.828 4.041l3.8 3.801c.245.245.27.627.074.9l-.074.086-3.8 3.8-.986-.985 2.61-2.612H1V7.639h8.453l-2.61-2.611z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1k = /*#__PURE__*/forwardRef(LogOutIcon);

function LostAndFoundIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.423 1c.875 0 1.585.709 1.585 1.584a.6.6 0 1 1-1.2 0 .385.385 0 1 0-.77 0v2.354H14.9a.6.6 0 0 1 .578.76l-2.463 8.863a.6.6 0 0 1-1.157 0L9.396 5.7a.6.6 0 0 1 .578-.76h1.863V2.584c0-.876.71-1.586 1.586-1.586m-.99 5.138h-1.67l1.675 6.022 1.673-6.022h-1.678M1 5.061a1.6 1.6 0 0 1 1.6-1.6h.37V2.19A.6.6 0 0 1 3.077 1h3.941a.6.6 0 0 1 .108 1.19V3.46h.37a1.6 1.6 0 0 1 1.6 1.6v7.355a1.6 1.6 0 0 1-1.478 1.595v.39a.6.6 0 1 1-1.2 0v-.385h-2.74v.385a.6.6 0 1 1-1.2 0v-.39a1.6 1.6 0 0 1-1.479-1.595zm6.496 7.755H2.6a.4.4 0 0 1-.4-.4v-4.8h5.697v4.8a.4.4 0 0 1-.4.4m.4-6.4H2.2V5.06c0-.22.18-.4.4-.4h4.896999999999999c.221 0 .4.18.4.4zM5.926 3.46V2.2H4.17v1.262z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1j = /*#__PURE__*/forwardRef(LostAndFoundIcon);

function LostAndFoundFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.423 1c.875 0 1.585.709 1.585 1.584a.6.6 0 0 1-1.2 0 .385.385 0 1 0-.77 0v2.354H14.9a.6.6 0 0 1 .578.76l-2.463 8.863a.6.6 0 0 1-1.157 0L9.396 5.7a.6.6 0 0 1 .578-.76h1.863V2.584c0-.876.71-1.586 1.586-1.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.477 14.011v.39a.6.6 0 1 0 1.2 0v-.385h2.741v.385a.6.6 0 1 0 1.2 0v-.39a1.6 1.6 0 0 0 1.478-1.595V5.061a1.6 1.6 0 0 0-1.6-1.6h-.37V2.19A.6.6 0 0 0 7.018 1h-3.94a.6.6 0 0 0-.108 1.19V3.46H2.6a1.6 1.6 0 0 0-1.6 1.6v7.355a1.6 1.6 0 0 0 1.477 1.595M4.17 3.461h1.756V2.2H4.17zM8 6.4H2v1.2h6z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1i = /*#__PURE__*/forwardRef(LostAndFoundFilledIcon);

function MeasureIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3.205c-3.19 0-5.8 2.651-5.8 5.952 0 1.184.336 2.285.915 3.21l-1.018.636A7.24 7.24 0 0 1 1 9.158C1 5.22 4.121 2.005 8 2.005s7.001 3.215 7.001 7.152a7.23 7.23 0 0 1-1.097 3.847l-1.018-.637a6.04 6.04 0 0 0 .915-3.21c0-3.3-2.61-5.952-5.8-5.952"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 5.725c-.606 0-1.173.166-1.663.456-.507.3-.93.733-1.226 1.255a3.5 3.5 0 0 0-.45 1.721h-1.2c0-.84.22-1.63.605-2.311.397-.702.97-1.29 1.66-1.698A4.45 4.45 0 0 1 8 4.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.867 8.231 2.01-2.057-.86-.838L9.06 7.34A2.04 2.04 0 0 0 8 7.045c-1.16 0-2.076.959-2.076 2.112S6.84 11.27 8 11.27c1.16 0 2.077-.959 2.077-2.112 0-.33-.076-.645-.21-.926m-2.743.926c0-.517.405-.912.877-.912.47 0 .877.395.877.912s-.406.912-.877.912c-.472 0-.877-.395-.877-.912",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1h = /*#__PURE__*/forwardRef(MeasureIcon);

function MeasureFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2a7 7 0 0 0-5.9 10.77l.148.23h11.504l.147-.23A7 7 0 0 0 8 2M5.054 7.3A3.4 3.4 0 0 1 8 5.6V4.4A4.6 4.6 0 0 0 3.4 9h1.2c0-.62.166-1.2.454-1.7m4.794.7 2.076-2.076-.848-.848-2.077 2.076a2.1 2.1 0 1 0 .849.849M7.1 9a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1g = /*#__PURE__*/forwardRef(MeasureFilledIcon);

function MenuIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7.3v1.4H1V7.3zM15 3v1.4H1V3zm0 8.6V13H1v-1.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1f = /*#__PURE__*/forwardRef(MenuIcon);

function MinimizeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.396 9c.306 0 .558.227.598.522L7 9.604V14H5.791v-2.924L1.867 15 1 14.133l3.924-3.925H2V9zM9.604 7a.605.605 0 0 1-.598-.522L9 6.396V2h1.209v2.924L14.133 1l.867.867-3.924 3.925H14V7z",
    transform: "translate(-1389 -187) translate(1388 186)"
  })));
}
var ForwardRef$1e = /*#__PURE__*/forwardRef(MinimizeIcon);

function NewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.073 10.625.071.008c.138.032.24.156.24.303 0 .869.698 1.576 1.555 1.576a.311.311 0 1 1 0 .622c-.81 0-1.477.622-1.549 1.414l-.006.141-.008.071a.31.31 0 0 1-.232.232L4.073 15a.31.31 0 0 1-.311-.311c0-.81-.63-1.477-1.433-1.549l-.143-.006-.071-.008a.311.311 0 0 1 .071-.614 1.6 1.6 0 0 0 1.57-1.435l.006-.141.008-.071a.31.31 0 0 1 .232-.232zM10.646 4.5c.343 0 .622.278.622.622 0 1.738 1.395 3.152 3.11 3.152a.622.622 0 1 1 0 1.244 3.114 3.114 0 0 0-3.105 2.934l-.005.176-.007.092a.62.62 0 0 1-.513.522l-.102.008a.62.62 0 0 1-.622-.622c0-1.656-1.318-3.014-2.973-3.105l-.179-.005-.092-.007a.622.622 0 0 1 .092-1.237c1.65 0 3.052-1.346 3.147-2.976l.005-.176.006-.092a.62.62 0 0 1 .514-.522zm-.013 3.157-.041.062a4.7 4.7 0 0 1-1.163 1.15l-.023.014.073.049c.373.259.706.572.985.928l.178.243.041-.06c.26-.37.573-.7.93-.976l.24-.175-.14-.098a4.6 4.6 0 0 1-.975-.987zM4.077 1c.24 0 .435.195.435.435 0 1.217.977 2.207 2.178 2.207a.435.435 0 1 1 0 .87 2.18 2.18 0 0 0-2.172 2.022l-.006.156-.007.078a.44.44 0 0 1-.35.35l-.078.007a.435.435 0 0 1-.435-.435c0-1.149-.906-2.092-2.05-2.172l-.157-.006-.078-.007a.436.436 0 0 1 .078-.863c1.144 0 2.118-.925 2.2-2.052l.007-.155.007-.078a.44.44 0 0 1 .35-.35z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1d = /*#__PURE__*/forwardRef(NewIcon);

function NightIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.961 1.016a6.9 6.9 0 0 0-3.42 1.9C.82 5.68.82 10.163 3.54 12.927s7.131 2.765 9.852 0q.575-.586 1.013-1.316c.288-.478-.13-1.074-.669-.953a5.64 5.64 0 0 1-5.276-1.558c-1.876-1.906-2.199-4.858-.83-7.13.287-.478-.13-1.074-.67-.953m-1.057 1.72-.055.171c-.746 2.45-.14 5.195 1.726 7.092l.185.18a6.88 6.88 0 0 0 4.507 1.885l.199.002.04-.04c-2.23 2.268-5.848 2.268-8.08 0s-2.231-5.943 0-8.21a5.7 5.7 0 0 1 1.297-.986z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1c = /*#__PURE__*/forwardRef(NightIcon);

function OrganizationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a2.546 2.546 0 0 1 .694 4.995l.006.096v2.192l2.388 1.763a.7.7 0 0 1 .162.167 2.546 2.546 0 1 1-.994.958L8 9.506l-2.256 1.665a2.546 2.546 0 1 1-.993-.959.7.7 0 0 1 .082-.099l.079-.067L7.3 8.283V6.091l.006-.096A2.547 2.547 0 0 1 8 1M3.545 11.31a1.146 1.146 0 1 0 0 2.29 1.146 1.146 0 0 0 0-2.29m8.91 0a1.146 1.146 0 1 0 0 2.29 1.146 1.146 0 0 0 0-2.29M8 2.4a1.146 1.146 0 1 0 0 2.291A1.146 1.146 0 0 0 8 2.4",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1b = /*#__PURE__*/forwardRef(OrganizationIcon);

function PackageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.137 1.067c.18-.09.39-.09.57 0l6.941 3.471a.6.6 0 0 1 .236.204l.035.056q.031.054.05.115l-.036-.09a.64.64 0 0 1 .067.284l-.007-.094.004.031.003.063v5.785c0 .224-.117.431-.31.546l-5.784 3.471a.64.64 0 0 1-.318.09h-.05l-.05-.006.09.007a.64.64 0 0 1-.284-.067l.092.037a1 1 0 0 1-.073-.028l-.02-.01-6.941-3.47a.64.64 0 0 1-.352-.57V4.53a.64.64 0 0 1 .188-.451l.076-.065a1 1 0 0 1 .084-.051l.004-.002zM2.272 5.56v4.94l5.67 2.834v-4.94zm11.455.577L9.214 8.393v4.846l4.513-2.708zM4.59 3.763l-1.53.765 5.52 2.76 1.53-.765zm2.832-1.416-1.408.704 5.52 2.76 1.407-.704z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$1a = /*#__PURE__*/forwardRef(PackageIcon);

function PlayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 1.733v12.534c0 .603.7.947 1.191.585l8.511-6.267a.723.723 0 0 0 0-1.17l-8.51-6.267C3.7.786 3 1.13 3 1.733m1.489 1.462L11.013 8 4.49 12.805z",
    clipRule: "evenodd",
    transform: "translate(-527 -325) translate(524 324)"
  }));
}
var ForwardRef$19 = /*#__PURE__*/forwardRef(PlayIcon);

function PrivacyIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.826 1.025a.6.6 0 0 1 .348 0l5.373 1.578a.635.635 0 0 1 .453.611V9.15c0 1.507-1.157 2.894-2.98 4.188-.926.657-1.902 1.2-2.756 1.603a.62.62 0 0 1-.528 0 18.5 18.5 0 0 1-2.755-1.603C3.158 12.044 2 10.658 2 9.15V3.214c0-.283.185-.533.453-.611zM8 2.298 3.253 3.692V9.15c0 .907.85 1.968 2.234 2.992l.212.153c.642.456 1.318.856 1.95 1.186l.351.177.414-.21c.508-.268 1.042-.58 1.563-.93l.324-.223c1.508-1.07 2.445-2.193 2.445-3.145V3.692zm2.25 3.495.707.707-3.707 3.707L5.043 8l.707-.707 1.5 1.5z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$18 = /*#__PURE__*/forwardRef(PrivacyIcon);

function ProfileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 0 1 4.161 12.628 6.4 6.4 0 0 1-.738.493A6.67 6.67 0 0 1 8.1 15l-.057-.002L8 15A7 7 0 0 1 8 1m.1 9.6c-1.465 0-2.736.829-3.37 2.044.157.123.372.28.643.435.62.355 1.524.707 2.67.719a5.77 5.77 0 0 0 3.26-1.031q.09-.066.165-.122A3.8 3.8 0 0 0 8.1 10.6M8 2.2A5.8 5.8 0 0 0 2.2 8a5.78 5.78 0 0 0 1.545 3.94A5 5 0 0 1 6.79 9.577 3.401 3.401 0 0 1 8 3a3.4 3.4 0 0 1 1.293 6.544 5 5 0 0 1 3.08 2.264A5.78 5.78 0 0 0 13.8 8c0-3.203-2.597-5.8-5.8-5.8m0 2A2.201 2.201 0 1 0 8.002 8.6 2.201 2.201 0 0 0 8 4.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$17 = /*#__PURE__*/forwardRef(ProfileIcon);

function ProfileFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1q.363 0 .716.036.58.061 1.128.211.12.032.237.067a7 7 0 0 1 1.056.428 7.02 7.02 0 0 1 3.173 3.224A6.94 6.94 0 0 1 15 8a7 7 0 0 1-.22 1.75 7.01 7.01 0 0 1-5.714 5.17 7.05 7.05 0 0 1-4.1-.61 7.03 7.03 0 0 1-3.32-3.373A7 7 0 0 1 8 1m0 9a4.4 4.4 0 0 0-3.874 2.316A5.78 5.78 0 0 0 8 13.8a5.78 5.78 0 0 0 3.873-1.485A4.4 4.4 0 0 0 8 10m0-6.4a2.8 2.8 0 1 0 .001 5.6A2.8 2.8 0 0 0 8 3.6",
    clipRule: "evenodd"
  }));
}
var ForwardRef$16 = /*#__PURE__*/forwardRef(ProfileFilledIcon);

function PurposeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.46 1.169a.575.575 0 0 1 .953.225l.345 1.034.62-.62a.575.575 0 0 1 .88.734l-.066.08-.621.619 1.035.346a.576.576 0 0 1 .288.88l-.063.072-1.918 1.918a.57.57 0 0 1-.588.14l-.566-.19a5.753 5.753 0 1 1-2.166-2.166l-.19-.566a.57.57 0 0 1 .14-.588zM6.754 4.836a4.41 4.41 0 1 0 3.5 1.725l-.87.869a3.197 3.197 0 1 1-.813-.813l.869-.87a4.4 4.4 0 0 0-2.686-.911m0 2.557a1.854 1.854 0 1 0 1.653 1.014L7.16 9.654a.575.575 0 0 1-.88-.734l.066-.08 1.247-1.246a1.85 1.85 0 0 0-.84-.201m5.909-3.242-.311.31-.697.698.696.233 1.01-1.009zM11.616 2.64l-1.009 1.009.233.696 1.008-1.008z",
    clipRule: "evenodd",
    transform: "translate(-1137 -463) translate(1136 462)"
  }));
}
var ForwardRef$15 = /*#__PURE__*/forwardRef(PurposeIcon);

function PuzzleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.431 3.496C5.431 2.096 6.603 1 8.001 1s2.57 1.096 2.57 2.496c0 .29-.051.566-.143.823H13.4a1.6 1.6 0 0 1 1.6 1.6V13.4a1.6 1.6 0 0 1-1.6 1.6H9.707a.6.6 0 0 1-.515-.91c.114-.188.178-.406.178-.638 0-.695-.591-1.297-1.37-1.297-.777 0-1.369.602-1.369 1.297 0 .232.064.45.178.639a.6.6 0 0 1-.514.909H2.6A1.6 1.6 0 0 1 1 13.4v-2.099a.6.6 0 0 1 .892-.524c.202.113.438.178.693.178.778 0 1.37-.601 1.37-1.296s-.592-1.297-1.37-1.297c-.255 0-.491.066-.693.178A.6.6 0 0 1 1 8.017V5.919a1.6 1.6 0 0 1 1.6-1.6h2.974a2.4 2.4 0 0 1-.143-.823M8.001 2.2c-.778 0-1.37.602-1.37 1.296 0 .38.172.724.456.966a.6.6 0 0 1-.389 1.057H2.6a.4.4 0 0 0-.4.4V7.19a3 3 0 0 1 .385-.028c1.397 0 2.57 1.097 2.57 2.497s-1.173 2.496-2.57 2.496q-.196 0-.385-.028v1.273c0 .22.18.4.4.4h2.856a2.4 2.4 0 0 1-.025-.348c0-1.4 1.172-2.497 2.57-2.497s2.57 1.097 2.57 2.497q-.001.177-.026.348h2.856a.4.4 0 0 0 .4-.4V5.919a.4.4 0 0 0-.4-.4H9.303a.6.6 0 0 1-.388-1.057c.284-.242.455-.587.455-.966C9.37 2.802 8.78 2.2 8 2.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$14 = /*#__PURE__*/forwardRef(PuzzleIcon);

function QuietIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.901 6.733c0 .1-.04.194-.11.265l-3.373 3.445V8.509H8.57a.45.45 0 0 1-.332-.16.45.45 0 0 1-.109-.28V4.748H6.705l1.27-2.663h5.926zm-8.425.407c.547 0 .993.394.993.877v5.327a.77.77 0 0 1-.219.515.6.6 0 0 1-.177.16L4.614 15l-.465-.672 1.466-.985.029-5.326c-.013-.031-.324-.034-.338.005l.001 2.251h-.003v.789h-.826v-.79c-.024-.03-.32-.032-.332.006v1.535h-.825v-.788c-.012-.03-.32-.034-.336.005l.001.748h-.004v.384h-.825l.004-.384c-.012-.03-.322-.035-.336.004v1.934H1v-1.938c0-.536.592-.957 1.17-.863.068-.483.62-.837 1.16-.752.068-.48.617-.834 1.152-.753V8.017c0-.483.446-.877.994-.877M14.069 1c.513 0 .931.412.931.918v4.815c0 .382-.148.744-.418 1.019l-3.76 3.839a.87.87 0 0 1-.643.265.9.9 0 0 1-.302-.055c-.346-.159-.542-.45-.558-.776V9.593h-.743c-.432.019-.9-.202-1.187-.557a1.5 1.5 0 0 1-.36-.958V5.832h-.592a.925.925 0 0 1-.88-1.223l1.457-3.054C7.132 1.24 7.483 1 7.87 1z",
    clipRule: "evenodd",
    transform: "translate(-1281 -233) translate(1280 232)"
  }));
}
var ForwardRef$13 = /*#__PURE__*/forwardRef(QuietIcon);

function QuitIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.69 2.697.559.318A6.4 6.4 0 0 1 14.5 8.58C14.5 12.125 11.59 15 8 15s-6.5-2.875-6.5-6.421a6.4 6.4 0 0 1 3.038-5.436l.21-.126.558-.319.646 1.102-.558.318a5.14 5.14 0 0 0-2.606 4.46c0 2.844 2.334 5.15 5.212 5.15s5.212-2.306 5.212-5.15a5.13 5.13 0 0 0-2.419-4.347l-.19-.114-.557-.318zM8.645 1v5.322H7.356V1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$12 = /*#__PURE__*/forwardRef(QuitIcon);

function RSSIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 6.895a8.106 8.106 0 0 1 8.101 7.848l.004.257H7.632c0-3.58-2.84-6.5-6.389-6.627L1 8.368zM1 1c7.624 0 13.823 6.092 13.996 13.674L15 15h-1.474c0-6.812-5.436-12.353-12.208-12.522L1 2.474zm1.474 11.053A1.474 1.474 0 1 1 2.473 15a1.474 1.474 0 0 1 0-2.948",
    clipRule: "evenodd"
  }));
}
var ForwardRef$11 = /*#__PURE__*/forwardRef(RSSIcon);

function RequiredIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.6 6.797 4.79-3.354.688.983-5.033 3.523 5.033 3.525-.687.982L8.6 9.101V15H7.4V9.1l-4.79 3.356-.688-.982 5.031-3.525-5.031-3.523.688-.983L7.4 6.797V1h1.2z"
  }));
}
var ForwardRef$10 = /*#__PURE__*/forwardRef(RequiredIcon);

function RequiredFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9 6.028 4.16-2.913 1.148 1.639-4.566 3.195 4.566 3.197-1.148 1.638L9 9.87V15H7V9.87l-4.16 2.914-1.148-1.639L6.256 7.95 1.692 4.754 2.84 3.116 7 6.028V1h2z"
  }));
}
var ForwardRef$$ = /*#__PURE__*/forwardRef(RequiredFilledIcon);

function RequiredSmallIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.6 6.812 3.152-2.207.688.982-3.395 2.376 3.395 2.378-.687.983L8.6 9.116V13H7.4V9.116l-3.152 2.208-.688-.983 3.394-2.378-3.393-2.376.687-.982L7.4 6.812V3h1.2z"
  }));
}
var ForwardRef$_ = /*#__PURE__*/forwardRef(RequiredSmallIcon);

function RequiredSmallFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9 6.042 2.522-1.765 1.147 1.638-2.926 2.048 2.926 2.05-1.147 1.638L9 9.885V13H7V9.885L4.478 11.65l-1.147-1.638 2.924-2.05-2.924-2.048 1.147-1.638L7 6.043V3h2z"
  }));
}
var ForwardRef$Z = /*#__PURE__*/forwardRef(RequiredSmallFilledIcon);

function RouteIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.9 10.8a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 1.2a.9.9 0 1 0 0 1.801.9.9 0 0 0 0-1.801M9 2.4a3.1 3.1 0 1 1 0 6.2H6a1.9 1.9 0 0 0 0 3.8h4v1.2H6a3.1 3.1 0 1 1 0-6.2h3a1.9 1.9 0 0 0 0-3.8H6V2.4zM3.1 1a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 1.2A.901.901 0 1 0 3.1 4.001.901.901 0 0 0 3.1 2.199"
  }));
}
var ForwardRef$Y = /*#__PURE__*/forwardRef(RouteIcon);

function RouteFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 11a2 2 0 1 1 0 4 2 2 0 0 1 0-4M9 2.4a3.1 3.1 0 1 1 0 6.2H6a1.9 1.9 0 0 0 0 3.8h4v1.2H6a3.1 3.1 0 1 1 0-6.2h3a1.9 1.9 0 0 0 0-3.8H6V2.4zM3 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  }));
}
var ForwardRef$X = /*#__PURE__*/forwardRef(RouteFilledIcon);

function RowHeightDefaultIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 5.4h13.999V3H1zm0 3.8h13.999V6.801H1zM1 13h13.999v-2.399H1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$W = /*#__PURE__*/forwardRef(RowHeightDefaultIcon);

function RowHeightMiddleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 10.129h13.999V8.718H1zM1 13h13.999v-1.411H1zm0-8.588h13.999V3H1zm0 2.871h13.999V5.871H1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$V = /*#__PURE__*/forwardRef(RowHeightMiddleIcon);

function RowHeightSmallIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 10.769h13.999V9.673H1zM1 13h13.999v-1.097H1zm0-6.673h13.999V5.23H1zm0 2.232h13.999V7.462H1zm0-4.462h13.999V3H1z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$U = /*#__PURE__*/forwardRef(RowHeightSmallIcon);

function RulesIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.993 5.38V6.74H1V5.38zm0-3.88v1.358H1V1.5zM5.798 9.261v1.358H1V9.261zm0 3.88V14.5H1v-1.358zm8.19-4.16L15 9.917l-4.3 4.372a.715.715 0 0 1-.932.07l-.08-.07-2.391-2.432 1.012-.938 1.885 1.917z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$T = /*#__PURE__*/forwardRef(RulesIcon);

function ScopeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.637 1.029a7 7 0 0 1 6.334 6.334v1.274a7 7 0 0 1-6.334 6.334H7.363A7 7 0 0 1 1.03 8.637V7.363A7 7 0 0 1 7.363 1.03zm0 1.279v2.279H7.363v-2.28a5.73 5.73 0 0 0-5.056 5.056h2.279v1.273h-2.28a5.73 5.73 0 0 0 5.056 5.056v-2.279h1.273v2.28a5.73 5.73 0 0 0 5.056-5.056h-2.279V7.363h2.28a5.73 5.73 0 0 0-5.056-5.056M8 6.207a1.793 1.793 0 1 1 0 3.586 1.793 1.793 0 0 1 0-3.586m0 1.272A.52.52 0 1 0 8 8.52a.52.52 0 0 0 0-1.04",
    clipRule: "evenodd"
  }));
}
var ForwardRef$S = /*#__PURE__*/forwardRef(ScopeIcon);

function SearchIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 0 1 4.548 9.388L15 14.044l-.956.956-3.656-3.657A5.795 5.795 0 1 1 6.796 1m0 1.352a4.443 4.443 0 1 0 0 8.885 4.443 4.443 0 0 0 0-8.885",
    clipRule: "evenodd"
  }));
}
var ForwardRef$R = /*#__PURE__*/forwardRef(SearchIcon);

function SearchFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.02 1a6.02 6.02 0 1 0 3.812 10.68l3.32 3.32.848-.848-3.32-3.32A6.02 6.02 0 0 0 7.02 1M7 4.6A2.4 2.4 0 0 0 4.6 7H3.4A3.6 3.6 0 0 1 7 3.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$Q = /*#__PURE__*/forwardRef(SearchFilledIcon);

function SelectIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.373 13.864.035.097c.218.487.94.504 1.163-.016l1.64-3.826 4.693 4.695a.636.636 0 0 0 .9 0l2.01-2.01.067-.079a.636.636 0 0 0-.067-.82L10.119 7.21l3.826-1.639c.552-.237.498-1.037-.08-1.198L1.806 1.023a.636.636 0 0 0-.783.784zM2.552 2.552l9.226 2.562-3.024 1.297-.083.043a.637.637 0 0 0-.116.992l4.909 4.908-1.11 1.11-4.908-4.909-.072-.062a.637.637 0 0 0-.963.261l-1.297 3.024z",
    clipRule: "evenodd",
    transform: "translate(-1173 -463) translate(1172 462)"
  }));
}
var ForwardRef$P = /*#__PURE__*/forwardRef(SelectIcon);

function SendIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.226 1.007a.67.67 0 0 1 .573.194l.011.01a.67.67 0 0 1 .183.563l-.004.022a.7.7 0 0 1-.032.121l.018-.055-.013.04-.005.015L10.3 14.555a.68.68 0 0 1-1.248.069l-2.56-5.118-5.117-2.56a.681.681 0 0 1-.03-1.202l.1-.045 12.637-4.656a1 1 0 0 1 .12-.033h.01zm-1.619 3.348L7.829 9.133l1.738 3.475zm-.961-.965L3.391 6.432 6.866 8.17z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$O = /*#__PURE__*/forwardRef(SendIcon);

function SettingsIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.636 1H6.364l-.382 2.135-.073.029q-.617.255-1.143.646l-.058.043-2.072-.742L1 5.89l1.694 1.39s-.055.431-.055.72l.005.218q.01.22.042.451l.008.051L1 10.111l1.636 2.779 2.073-.744.056.045q.527.39 1.145.646l.072.027L6.364 15h3.272l.381-2.136.073-.028a5.3 5.3 0 0 0 1.144-.645l.056-.045 2.074.744L15 10.111l-1.695-1.392s.056-.43.056-.719l-.005-.218a5 5 0 0 0-.042-.45l-.009-.052L15 5.89l-1.636-2.779-2.073.742-.056-.043a5.3 5.3 0 0 0-1.145-.646l-.074-.029zM7.407 2.22h1.184l.233 1.302c.056.317.28.58.588.69.456.164.869.397 1.229.693l.087.064a.93.93 0 0 0 .821.091l1.259-.453.591 1.004-1.033.849a.89.89 0 0 0-.315.844c.044.254.066.48.066.696s-.022.443-.066.695l-.012.106a.89.89 0 0 0 .328.739l1.032.847-.591 1.004-1.262-.452a.93.93 0 0 0-.906.157 4.1 4.1 0 0 1-1.228.692l-.099.042a.9.9 0 0 0-.489.648l-.233 1.302H7.407l-.23-1.302a.9.9 0 0 0-.589-.69 4.1 4.1 0 0 1-1.229-.693l-.087-.063a.93.93 0 0 0-.82-.092l-1.261.451-.592-1.004 1.035-.847a.89.89 0 0 0 .315-.844A4 4 0 0 1 3.883 8c0-.216.021-.442.066-.695l.012-.106a.9.9 0 0 0-.328-.739l-1.034-.849.592-1.004 1.263.454a.93.93 0 0 0 .905-.156c.36-.296.773-.529 1.229-.692l.099-.043a.9.9 0 0 0 .49-.648zM5.499 8a2.505 2.505 0 0 0 2.5 2.5c1.379 0 2.5-1.122 2.5-2.5A2.503 2.503 0 0 0 8 5.5 2.504 2.504 0 0 0 5.5 8m1.05 0c0-.799.652-1.45 1.45-1.45.8 0 1.45.651 1.45 1.45 0 .8-.65 1.45-1.45 1.45-.798 0-1.45-.65-1.45-1.45",
    clipRule: "evenodd"
  }));
}
var ForwardRef$N = /*#__PURE__*/forwardRef(SettingsIcon);

function CircleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 13.8A5.8 5.8 0 1 0 8 2.2a5.8 5.8 0 0 0 0 11.6M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14",
    clipRule: "evenodd"
  }));
}
var ForwardRef$M = /*#__PURE__*/forwardRef(CircleIcon);

function CircleFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"
  }));
}
var ForwardRef$L = /*#__PURE__*/forwardRef(CircleFilledIcon);

function StarredIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.535 5.267H1.733l-.105.007a.732.732 0 0 0-.423 1.23L4.057 9.48 2.89 14.086l-.02.104a.732.732 0 0 0 1.093.71L8 12.576l4.037 2.324.094.046a.732.732 0 0 0 .98-.86L11.941 9.48l2.853-2.975.067-.08a.732.732 0 0 0-.595-1.157h-3.803L8.662 1.421a.731.731 0 0 0-1.324 0z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$K = /*#__PURE__*/forwardRef(StarredIcon);

function UnstarredIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.535 5.267H1.733l-.105.007a.732.732 0 0 0-.423 1.23L4.057 9.48 2.89 14.086l-.02.104a.732.732 0 0 0 1.093.71L8 12.576l4.037 2.324.094.046a.732.732 0 0 0 .98-.86L11.941 9.48l2.853-2.975.067-.08a.732.732 0 0 0-.595-1.157h-3.803L8.662 1.421a.731.731 0 0 0-1.324 0zm2.464-1.814 1.34 2.856.05.091a.73.73 0 0 0 .611.33h2.551l-1.945 2.03-.068.082a.73.73 0 0 0-.113.603l.842 3.324-2.902-1.67-.1-.048a.73.73 0 0 0-.63.048l-2.903 1.67.843-3.324.019-.106a.73.73 0 0 0-.2-.58L3.448 6.73H6a.73.73 0 0 0 .662-.42z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$J = /*#__PURE__*/forwardRef(UnstarredIcon);

function ShareIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.455 3.728V5L2.273 5v8.425h10.242v-3h1.273v3.636c0 .322-.24.589-.55.63l-.086.007H1.636a.636.636 0 0 1-.63-.55L1 14.06V4.364c0-.322.24-.588.55-.63l.086-.006zm6.404-2.324.075.057 4.849 4.243c.263.23.287.623.072.884l-.072.073-4.849 4.243a.637.637 0 0 1-1.049-.385l-.006-.094V8.648l-.14.007c-1.93.094-2.886.587-3.898 1.809l-.145.18-.129.166c-.369.485-1.143.224-1.143-.385 0-4.396 1.75-6.373 5.166-6.66l.235-.017.053-.003V1.94c0-.515.571-.804.981-.536m.292 1.938v1.022a.636.636 0 0 1-.636.637c-2.69 0-4.17.888-4.646 3.346l-.042.235-.016.103.108-.087c1.001-.792 2.176-1.155 3.954-1.222l.341-.01.301-.002c.32 0 .584.236.63.543l.007.094-.001 1.02 3.246-2.84z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$I = /*#__PURE__*/forwardRef(ShareIcon);

function SilentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.9 7.316V5.42l-.005-.204a4 4 0 0 0-.17-.952l2.272-2.272-.99-.99-1.945 1.945C11.187 1.77 9.707 1 8 1 5.27 1 3.1 2.958 3.1 5.421v1.895l-.01.252C2.928 9.443 1 9.955 1 11.105c0 .496.59.936 1.637 1.268L1 14.01l.99.99 2.258-2.258q.462.073.977.127C5.413 14.103 6.571 15 8 15s2.587-.897 2.773-2.132c2.643-.273 4.227-.945 4.227-1.763 0-1.2-2.1-1.705-2.1-3.79m-9.622 3.802-.191-.057-.119-.038-.213-.077-.095-.04.578-.59c.829-.898 1.262-1.771 1.262-3V5.42l.005-.171C4.605 3.664 6.083 2.39 8 2.39c1.35 0 2.468.638 3.054 1.566L3.78 11.23c-.169-.037-.352-.07-.502-.112M8 13.667c-.61 0-1.09-.282-1.294-.694Q7.326 13 8 13l.325-.002q.496-.004.969-.025c-.204.412-.683.694-1.294.694m5.246-2.72a6 6 0 0 1-.524.17c-1.119.313-2.768.493-4.722.493-.912 0-1.748-.042-2.504-.116L11.5 5.49v1.826l.007.258c.061 1.18.554 2.031 1.438 2.936l.394.397z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$H = /*#__PURE__*/forwardRef(SilentIcon);

function SortIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.6 10.953 1.976-1.976.848.847-3 3a.6.6 0 0 1-.848 0l-3-3 .848-.847L9.4 10.953V6h1.2zM5.4 10.6H3V9.4h2.4zM7.8 7.4H3V6.2h4.8zM11 4.2H3V3h8z"
  }));
}
var ForwardRef$G = /*#__PURE__*/forwardRef(SortIcon);

function StandardIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1C4.14 1 1 4.141 1 8s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7m0 1c3.309 0 6 2.691 6 6s-2.691 6-6 6c-3.308 0-6-2.691-6-6s2.692-6 6-6m.024 1.9c-1.405 0-2.458.975-2.458 2.323 0 1.03.52 1.606 1.625 2.128l.34.152.427.182c.828.356 1.14.61 1.14 1.038 0 .524-.475.942-1.113.942-.56 0-1.142-.314-1.586-.845h-.153l-.822.966.002.132c.213.233.493.477.841.69a3.2 3.2 0 0 0 1.68.492c1.47 0 2.653-1.074 2.653-2.505 0-1.097-.587-1.688-1.83-2.242l-.602-.259c-.803-.35-1.11-.6-1.11-1.01 0-.433.352-.76.976-.76.466 0 .944.228 1.344.685l.15.001.812-.913.003-.128C9.805 4.293 8.91 3.9 8.024 3.9",
    clipRule: "evenodd",
    transform: "translate(-1317 -233) translate(1316 232)"
  }));
}
var ForwardRef$F = /*#__PURE__*/forwardRef(StandardIcon);

function StudentIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.814 1.036a.5.5 0 0 1 .372 0l5 2a.5.5 0 0 1 .314.464v3h-1V4.309l-1.346.673a3.495 3.495 0 0 1-1.125 4.37A6 6 0 0 1 14 15h-1a5 5 0 0 0-10 0H2a6 6 0 0 1 3.97-5.648 3.496 3.496 0 0 1-1.124-4.37l-2.07-1.035a.5.5 0 0 1 .038-.911zM5.74 5.429a2.5 2.5 0 1 0 4.52 0L8.224 6.447a.5.5 0 0 1-.448 0zm6.04-1.878L8 2.039 4.22 3.55 8 5.44z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$E = /*#__PURE__*/forwardRef(StudentIcon);

function StudentFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 15a6 6 0 0 1 12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.617 5.6A3.504 3.504 0 0 0 8 10a3.5 3.5 0 0 0 3.383-4.4L8.427 6.675c-.276.1-.578.1-.854 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.17 1.03a.5.5 0 0 0-.34 0l-5.5 2a.5.5 0 0 0 0 .94l5.5 2a.5.5 0 0 0 .34 0L13 4.214V7h1V3.5a.5.5 0 0 0-.33-.47z"
  }));
}
var ForwardRef$D = /*#__PURE__*/forwardRef(StudentFilledIcon);

function SubtractIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7.3 15 8.7 1 8.7 1 7.3z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$C = /*#__PURE__*/forwardRef(SubtractIcon);

function TagIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.018 9.4-3.442 3.468-.846-.852 3.443-3.468zM4.116 11.338l2.41-2.428-.846-.852-2.41 2.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.919 5.642c.305.91.097 1.956-.623 2.681l-5.872 5.915a2.58 2.58 0 0 1-3.664 0l-2.001-2.016a2.62 2.62 0 0 1 0-3.69L7.63 2.618a2.58 2.58 0 0 1 2.81-.572l.028-.03C11.544.933 13.3.573 14.361 1.644c1.062 1.07.707 2.835-.366 3.918zm-2.487-2.886 1.826 1.839c.697-.792.654-1.7.258-2.1-.396-.398-1.298-.441-2.084.261m-.685 1.013 1.704 1.716a1.41 1.41 0 0 1 0 1.987l-5.873 5.914a1.39 1.39 0 0 1-1.973 0l-2-2.015a1.41 1.41 0 0 1 0-1.987l5.872-5.915a1.39 1.39 0 0 1 1.26-.384c-.21.473-.309.981-.268 1.466a1.58 1.58 0 0 0-1.022 1.481c0 .87.7 1.581 1.574 1.581a1.583 1.583 0 0 0 .673-3.01 1.6 1.6 0 0 1 .053-.834m-.867 1.91q.097.135.22.258a.6.6 0 0 0 .29.162.376.376 0 0 1-.37.314.377.377 0 0 1-.373-.38.38.38 0 0 1 .233-.354",
    clipRule: "evenodd"
  }));
}
var ForwardRef$B = /*#__PURE__*/forwardRef(TagIcon);

function TerminalIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.512.992h5.218V2.47h.911a1.6 1.6 0 0 1 1.6 1.6v9.339a1.6 1.6 0 0 1-1.6 1.6H4.6a1.6 1.6 0 0 1-1.6-1.6V4.07a1.6 1.6 0 0 1 1.6-1.6h.912V.992m5.218 3.457V3.67h.911c.221 0 .4.18.4.4v9.339a.4.4 0 0 1-.4.4H4.6a.4.4 0 0 1-.4-.4V4.07c0-.22.18-.4.4-.4h.912v.78h-.405v1.2h6.028v-1.2zM6.712 2.192V4.4H9.53V2.192zM13.8 12.19V5.29H15v6.901zM5.61 7.871h5.023v-1.2H5.609zm0 2.444h1.004v-1.2H5.609zm1.004 1.972H5.609v-1.2h1.005zm1.005-1.972h1.004v-1.2H7.619zm1.004 1.972H7.619v-1.2h1.004zm1.005-1.972h1.004v-1.2H9.628zm1.004 1.972H9.628v-1.2h1.004z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$A = /*#__PURE__*/forwardRef(TerminalIcon);

function TerminalFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.73.75H5.512v1.477H4.6c-.884 0-1.6.716-1.6 1.598v9.327a1.6 1.6 0 0 0 1.6 1.598h7.041c.884 0 1.6-.716 1.6-1.598V3.825c0-.882-.716-1.598-1.6-1.598h-.91zM6.712 4.204V1.95H9.53v2.255zm3.92 1.569H5.61v1.22h5.023zM5.61 9.56h1.004V8.363H5.609zm3.013 0H7.619V8.363h1.004zm-1.004 2.47h1.004v-1.199H7.619zm-1.005 0H5.609v-1.199h1.005zm3.014-2.47h1.004V8.363H9.628zm1.004 2.47H9.628v-1.199h1.004z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.8 5.042v6.893H15V5.042z"
  }));
}
var ForwardRef$z = /*#__PURE__*/forwardRef(TerminalFilledIcon);

function TimeglassIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.956 5.646H6.044v-1.2h3.912zM8.426 9.547a.6.6 0 0 0-.852 0L5.13 12.008l.851.846L8 10.821l2.02 2.033.85-.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.999 1.6a.6.6 0 0 1 .6-.6H12.4a.6.6 0 0 1 .6.6v3.446a.6.6 0 0 1-.174.423L10.313 8l2.514 2.531a.6.6 0 0 1 .174.423v3.447a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6v-3.447a.6.6 0 0 1 .174-.423L5.687 8 3.173 5.469a.6.6 0 0 1-.174-.423zm1.2.6v2.598l2.76 2.78a.6.6 0 0 1 0 .845L4.199 11.2v2.6H11.8v-2.6l-2.76-2.778a.6.6 0 0 1 0-.846l2.76-2.779V2.2z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$y = /*#__PURE__*/forwardRef(TimeglassIcon);

function TimeglassFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 1a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .146.354L5.793 8l-2.647 2.646A.5.5 0 0 0 3 11v3.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.146-.354L10.207 8l2.647-2.646A.5.5 0 0 0 13 5V1.5a.5.5 0 0 0-.5-.5zM6 5.6h4V4.4H6zm1.646 4.046a.5.5 0 0 1 .708 0l2.5 2.5A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.354-.854z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$x = /*#__PURE__*/forwardRef(TimeglassFilledIcon);

function TimelineIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 4",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.727 12v1.75h-1.909V12h-1.273v1.75H8.636V12H7.364v1.75h-1.91V12H4.183v1.75h-1.91V12H1v2.45l.006.095c.042.342.309.605.63.605h12.728l.086-.006c.31-.046.55-.339.55-.694V12z",
    clipRule: "evenodd",
    transform: "translate(-633 -474) translate(632 462)"
  }));
}
var ForwardRef$w = /*#__PURE__*/forwardRef(TimelineIcon);

function TokenIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.948 3.638a.6.6 0 0 0-.849 0L3.638 6.099a.6.6 0 0 0 0 .849L6.099 9.41a.6.6 0 0 0 .849 0L9.41 6.948a.6.6 0 0 0 0-.849zM4.91 6.524 6.524 4.91l1.613 1.614-1.613 1.613z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 6.524a5.524 5.524 0 0 1 10.618-2.14 5.525 5.525 0 1 1-7.234 7.234A5.525 5.525 0 0 1 1 6.524M6.524 2.2a4.324 4.324 0 1 0 0 8.647 4.324 4.324 0 0 0 0-8.647m5.523 4.324a6 6 0 0 0-.026-.543 4.324 4.324 0 1 1-6.04 6.04 5.524 5.524 0 0 0 6.067-5.497",
    clipRule: "evenodd"
  }));
}
var ForwardRef$v = /*#__PURE__*/forwardRef(TokenIcon);

function ToneSmileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.939 5.059v1.475h1.2V5.059zM9.863 6.534V5.059h1.2v1.475zM8 8.884c-.76 0-1.479-.437-1.953-1.194l-1.016.638c.648 1.035 1.718 1.756 2.97 1.756s2.321-.72 2.97-1.756L9.954 7.69c-.474.757-1.192 1.194-1.953 1.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.6 2A1.6 1.6 0 0 0 1 3.6v7.343a1.6 1.6 0 0 0 1.6 1.6h.862v1.859a.6.6 0 0 0 .948.488l3.29-2.347h5.701a1.6 1.6 0 0 0 1.6-1.6V3.6a1.6 1.6 0 0 0-1.6-1.6zm-.4 1.6c0-.22.18-.4.4-.4h10.801a.4.4 0 0 1 .4.4v7.343a.4.4 0 0 1-.4.4H7.508a.6.6 0 0 0-.348.111l-2.498 1.783v-1.294a.6.6 0 0 0-.6-.6H2.6a.4.4 0 0 1-.4-.4z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$u = /*#__PURE__*/forwardRef(ToneSmileIcon);

function UnviewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.78.999 1.013 1.014-2.439 2.438c.584.321 1.144.72 1.68 1.185a11.7 11.7 0 0 1 1.665 1.784l.077.104.116.168a.65.65 0 0 1 0 .718q-.069.104-.193.271l-.09.117-.213.268c-.393.477-.848.953-1.362 1.399C11.538 11.762 9.849 12.55 8 12.55c-1.305 0-2.53-.393-3.664-1.08l-2.322 2.321L1 12.778l2.155-2.153-.189-.16A11.7 11.7 0 0 1 1.301 8.68l-.077-.104-.116-.167a.65.65 0 0 1 0-.718c.091-.14.258-.368.496-.657.393-.477.848-.953 1.362-1.399C4.462 4.34 6.151 3.551 8 3.551c.666 0 1.311.102 1.934.293zm-1.71 4.838.016.052q.121.422.122.883A3.215 3.215 0 0 1 8 9.993a3.2 3.2 0 0 1-1.7-.488l-.986.987c.857.47 1.756.73 2.686.73 1.468 0 2.86-.65 4.13-1.75.362-.314.693-.648.99-.985l.215-.253.147-.184-.147-.183a10.4 10.4 0 0 0-1.206-1.238 9 9 0 0 0-1.058-.792m-6.141 0q-.542.343-1.058.792a10 10 0 0 0-.99.985l-.216.253-.148.183.148.184c.348.422.752.845 1.206 1.238l.236.199 1.18-1.18a3.232 3.232 0 0 1-.358-2.654m4.793.247L7.288 8.519c.22.094.46.146.712.146 1.014 0 1.847-.842 1.847-1.893a1.9 1.9 0 0 0-.125-.688M8 4.878c-1.014 0-1.847.843-1.847 1.894 0 .254.048.496.137.717L8.74 5.037A1.8 1.8 0 0 0 8 4.878",
    clipRule: "evenodd"
  }));
}
var ForwardRef$t = /*#__PURE__*/forwardRef(UnviewIcon);

function UserIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a4.107 4.107 0 0 1 2.616 7.274 6.42 6.42 0 0 1 4.38 5.873l.004.217V15h-1.273v-.636c0-2.778-2.199-5.042-4.951-5.145l-.197-.004H7.42a5.15 5.15 0 0 0-5.145 4.951l-.003.198V15H1v-.636a6.42 6.42 0 0 1 4.384-6.092A4.107 4.107 0 0 1 8 1m0 1.273a2.834 2.834 0 1 0 0 5.669 2.834 2.834 0 0 0 0-5.67",
    clipRule: "evenodd"
  }));
}
var ForwardRef$s = /*#__PURE__*/forwardRef(UserIcon);

function UsersIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.508 6.985A3.56 3.56 0 0 1 9.52 8.37c1.912.79 3.275 2.627 3.355 4.79l.004.204v.636h-1.273v-.636c0-2.218-1.766-4.03-3.987-4.132l-.198-.005h-.964c-2.246 0-4.077 1.75-4.18 3.942l-.004.195v.636H1v-.636c0-2.393 1.566-4.42 3.736-5.135a3.553 3.553 0 0 1 4.435-5.514 2.492 2.492 0 0 1 3.669 3.364 3.82 3.82 0 0 1 2.155 3.262l.005.19v.637h-1.273V9.53c0-1.356-1.038-2.46-2.345-2.54l-.152-.005zm.409-3.812c-.342 0-.65.14-.872.366a3.53 3.53 0 0 1 .713 2.134l-.002-.071q.079.01.16.01a1.22 1.22 0 1 0 0-2.44m-3.712.22a2.28 2.28 0 1 1 0 4.56 2.28 2.28 0 0 1 0-4.56",
    clipRule: "evenodd"
  }));
}
var ForwardRef$r = /*#__PURE__*/forwardRef(UsersIcon);

function QuestionIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.737 11.234c0 .414-.333.75-.744.75a.747.747 0 0 1-.745-.75c0-.414.334-.75.745-.75.41 0 .744.336.744.75M6.56 6.573c0-.764.618-1.383 1.382-1.383h.165c.673 0 1.219.545 1.219 1.218 0 .24-.113.465-.304.61l-.946.714c-.462.35-.734.896-.734 1.475v.378h1.2v-.378c0-.203.096-.395.258-.517l.946-.715c.49-.37.78-.951.78-1.567a2.42 2.42 0 0 0-2.42-2.418h-.164A2.583 2.583 0 0 0 5.36 6.573v.514h1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-5.8a5.8 5.8 0 1 0 0 11.6A5.8 5.8 0 0 0 8 2.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$q = /*#__PURE__*/forwardRef(QuestionIcon);

function QuestionFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181c56",
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7m0 3c1.405 0 2.61 1.205 2.61 2.61 0 1.134-.786 2.138-1.829 2.482l-.082.023v.74H7.301V8.518c0-.355.262-.647.603-.694L8 7.818c.632 0 1.21-.577 1.21-1.209S8.631 5.4 8 5.4c-.39 0-.833.292-1.086.698l-.07.125-.313.625-1.252-.625.313-.627C6.049 4.682 6.999 4 8 4m.006 6.88a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75"
  }));
}
var ForwardRef$p = /*#__PURE__*/forwardRef(QuestionFilledIcon);

function ValidationErrorIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 7.151 2.076-2.075.848.848L8.85 8l2.075 2.076-.848.848L8 8.85l-2.076 2.075-.848-.848L7.15 8 5.076 5.924l.848-.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-5.8a5.8 5.8 0 1 0 0 11.6A5.8 5.8 0 0 0 8 2.2",
    clipRule: "evenodd"
  }));
}
var ForwardRef$o = /*#__PURE__*/forwardRef(ValidationErrorIcon);

function ValidationErrorFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-2.924-4.924L7.15 8 5.076 5.924l.848-.848L8 7.152l2.076-2.076.848.848L8.85 8l2.075 2.076-.848.848L8 8.85l-2.076 2.075z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$n = /*#__PURE__*/forwardRef(ValidationErrorFilledIcon);

function ValidationExclamationIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 9V5.844h1.2V9zM8 11.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.6a.6.6 0 0 1 .52.299l6.5 11.196a.6.6 0 0 1-.519.901H1.5a.6.6 0 0 1-.519-.9l6.5-11.197a.6.6 0 0 1 .52-.299m5.46 11.197L8 3.395l-5.458 9.402z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$m = /*#__PURE__*/forwardRef(ValidationExclamationIcon);

function ValidationExclamationCircleIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7m0 13c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6",
    className: "svg-validation-circle-exclamation"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 4H8.7V9.1H7.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.005,
    cy: 11.375,
    r: 0.875
  })));
}
var ForwardRef$l = /*#__PURE__*/forwardRef(ValidationExclamationCircleIcon);

function ValidationExclamationCircleFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4.4,
    fill: "transparent",
    className: "svg-validation-circlefilled-exclamation"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7m-.7 3h1.4v5.1H7.3zm.7 8.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9c0 .6-.4.9-.9.9",
    clipRule: "evenodd"
  }));
}
var ForwardRef$k = /*#__PURE__*/forwardRef(ValidationExclamationCircleFilledIcon);

function ValidationExclamationFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M8.365 4.217A.42.42 0 0 0 8 4a.42.42 0 0 0-.365.217l-4.578 8.129a.45.45 0 0 0 0 .436.42.42 0 0 0 .365.218h9.156a.42.42 0 0 0 .366-.218.45.45 0 0 0-.001-.436z",
    className: "svg-exclamation"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.6a.6.6 0 0 1 .52.299l6.5 11.196a.6.6 0 0 1-.519.901H1.5a.6.6 0 0 1-.519-.9l6.5-11.197a.6.6 0 0 1 .52-.299M7.4 9V5.844h1.2V9zm1.35 2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
    clipRule: "evenodd"
  }));
}
var ForwardRef$j = /*#__PURE__*/forwardRef(ValidationExclamationFilledIcon);

function ValidationInfoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 10.15v1.2h3.5v-1.2H8.6V7.266a.6.6 0 0 0-.595-.6l-1.75-.016-.01 1.2 1.155.01v2.29zM8 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 0 0 14.001A7 7 0 0 0 8 1M2.2 8a5.8 5.8 0 1 1 11.6 0A5.8 5.8 0 0 1 2.2 8",
    clipRule: "evenodd"
  }));
}
var ForwardRef$i = /*#__PURE__*/forwardRef(ValidationInfoIcon);

function ValidationInfoFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15.002A7 7 0 1 0 8 1a7 7 0 0 0 0 14.002m.82-10.283a.82.82 0 1 1-1.64 0 .82.82 0 0 1 1.64 0M8 6.597H6.25v1.2H7.4v2.353H6.25v1.2h3.5v-1.2H8.6V7.197a.6.6 0 0 0-.6-.6",
    clipRule: "evenodd"
  }));
}
var ForwardRef$h = /*#__PURE__*/forwardRef(ValidationInfoFilledIcon);

function ValidationSuccessIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.424 10.924 4.5-4.5-.848-.848L7 9.65 4.924 7.576l-.848.848 2.5 2.5a.6.6 0 0 0 .848 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2.2 8a5.8 5.8 0 1 1 11.6 0A5.8 5.8 0 0 1 2.2 8",
    clipRule: "evenodd"
  }));
}
var ForwardRef$g = /*#__PURE__*/forwardRef(ValidationSuccessIcon);

function ValidationSuccessFilledIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-.651-4.151 4.5-4.5L11 5.5 6.924 9.576 4.85 7.5 4 8.349l2.5 2.5a.6.6 0 0 0 .849 0",
    clipRule: "evenodd"
  }));
}
var ForwardRef$f = /*#__PURE__*/forwardRef(ValidationSuccessFilledIcon);

function ValueIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 14 13",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.278 2.187.008.007a1 1 0 0 1 .047.058l.008.011 2.557 3.732a1 1 0 0 1 .045.077l.008.018a.55.55 0 0 1 .049.233v.014l-.004.05.004-.064a.58.58 0 0 1-.126.36L8.481 14.77l-.012.015-.01.013a1 1 0 0 1-.068.064l-.011.01-.017.012-.016.011-.01.006a.6.6 0 0 1-.12.061l-.031.01-.007.003-.013.004a1 1 0 0 1-.073.015l-.012.002-.02.002L8 15h-.016l-.022-.001a1 1 0 0 1-.073-.009l-.022-.004-.033-.008-.013-.004a1 1 0 0 1-.082-.031l.082.03a1 1 0 0 1-.097-.037l-.012-.007-.023-.012-.034-.021-.014-.01-.009-.007-.022-.017a.6.6 0 0 1-.091-.093l.06.066-.045-.046v-.002l-.015-.018-6.393-8.086A.6.6 0 0 1 1 6.323v-.025l.006-.06L1 6.322a.6.6 0 0 1 .102-.328l-.042.071.026-.046.016-.025 2.557-3.732a1 1 0 0 1 .055-.069l.012-.012a.6.6 0 0 1 .152-.112.6.6 0 0 1 .286-.07l-.099.008A1 1 0 0 1 4.146 2h7.69a.6.6 0 0 1 .238.048l-.046-.018a.6.6 0 0 1 .245.15zM9.733 6.913H6.265l1.734 5.486zM6.43 11.455 4.994 6.913H2.839zm6.729-4.542h-2.154l-1.435 4.54zm.098-1.181-1.239-1.809-.619 1.809zM3.98 3.922l-1.239 1.81H4.6zm4.019-.266L6.577 5.732h2.844zm-1.134-.475H5.006l.62 1.808zm4.128 0H9.134l1.239 1.808z",
    clipRule: "evenodd",
    transform: "translate(-1101 -464) translate(1100 462)"
  }));
}
var ForwardRef$e = /*#__PURE__*/forwardRef(ValueIcon);

function ViewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.5c1.85 0 3.538.788 5.034 2.086a11.7 11.7 0 0 1 1.742 1.887l.116.168a.65.65 0 0 1 0 .718c-.061.092-.155.225-.282.388l-.214.268c-.393.477-.848.953-1.362 1.4C11.538 11.711 9.849 12.5 8 12.5s-3.538-.788-5.034-2.086a11.7 11.7 0 0 1-1.742-1.887l-.116-.168a.65.65 0 0 1 0-.718c.091-.139.258-.367.496-.656.393-.477.848-.953 1.362-1.4C4.462 4.289 6.151 3.5 8 3.5m3.07 2.286.016.053c.08.28.122.577.122.882 0 1.774-1.43 3.222-3.208 3.222S4.792 8.495 4.792 6.72q.002-.488.137-.934-.542.342-1.058.791c-.454.393-.858.816-1.206 1.238L2.517 8l.148.184c.348.422.752.845 1.206 1.238 1.268 1.1 2.66 1.75 4.129 1.75s2.86-.65 4.13-1.75c.453-.393.857-.816 1.205-1.238L13.482 8l-.147-.184a10.4 10.4 0 0 0-1.206-1.238 9 9 0 0 0-1.058-.792M8 4.828c1.014 0 1.847.842 1.847 1.893S9.014 8.615 8 8.615 6.153 7.772 6.153 6.72 6.986 4.828 8 4.828",
    clipRule: "evenodd"
  }));
}
var ForwardRef$d = /*#__PURE__*/forwardRef(ViewIcon);

function WarningIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    viewBox: "0 0 17.231 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181c56",
    d: "M8.615 1.5a.95.95 0 0 0-.842.496L1.73 13.121c-.34.624.123 1.379.843 1.379H14.66c.72 0 1.18-.755.842-1.379L9.457 1.996a.95.95 0 0 0-.842-.496zm-.699 4h1.398v4.1H7.916zm.705 5.5a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75"
  }));
}
var ForwardRef$c = /*#__PURE__*/forwardRef(WarningIcon);

function ZoomInIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 0 1 4.549 9.387L15 14.044l-.956.956-3.656-3.657A5.795 5.795 0 1 1 6.796 1m0 1.352a4.443 4.443 0 1 0 0 8.885 4.443 4.443 0 0 0 0-8.885M7.25 4.42l-.001 1.907 1.908.001v.92H7.248v1.908h-.92l-.001-1.908H4.42v-.92l1.907-.001.001-1.907z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$b = /*#__PURE__*/forwardRef(ZoomInIcon);

function ZoomOutIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 0 1 4.549 9.387L15 14.044l-.956.956-3.657-3.656A5.795 5.795 0 1 1 6.796 1m0 1.352a4.443 4.443 0 1 0 0 8.885 4.443 4.443 0 0 0 0-8.885m2.361 3.976v.92H4.42v-.92z",
    clipRule: "evenodd"
  }));
}
var ForwardRef$a = /*#__PURE__*/forwardRef(ZoomOutIcon);

function CloudIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.248 20.247c-4.25 0-7.86-3.315-8.219-7.55C.67 8.46 3.671 4.582 7.863 3.868c3.952-.674 7.84 1.66 9.161 5.382h.477c3.032 0 5.499 2.466 5.499 5.499s-2.467 5.498-5.499 5.498H9.248M9.232 5.585q-.527 0-1.061.09c-3.26.555-5.595 3.571-5.315 6.867.28 3.294 3.087 5.873 6.392 5.873h8.253a3.67 3.67 0 0 0 3.666-3.666 3.67 3.67 0 0 0-3.666-3.666h-1.154a.92.92 0 0 1-.888-.688c-.736-2.853-3.358-4.81-6.227-4.81"
  }));
}
var ForwardRef$9 = /*#__PURE__*/forwardRef(CloudIcon);

function CloudLightningIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.413 17.405a.917.917 0 0 1-.182-1.814 3.653 3.653 0 0 0 2.917-3.96 3.65 3.65 0 0 0-3.645-3.296h-1.16a.915.915 0 0 1-.887-.687 6.413 6.413 0 1 0-9.315 7.215.916.916 0 0 1-.888 1.603 8.244 8.244 0 0 1 3.994-15.46 8.24 8.24 0 0 1 7.773 5.497h.484a5.48 5.48 0 0 1 5.468 4.944 5.48 5.48 0 0 1-4.376 5.94 1 1 0 0 1-.183.018"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.083 22.994a.915.915 0 0 1-.761-1.425l2.716-4.072H9.252a.917.917 0 0 1-.763-1.425l3.666-5.496a.916.916 0 1 1 1.525 1.016l-2.716 4.072h3.785a.916.916 0 0 1 .763 1.425l-3.666 5.497a.92.92 0 0 1-.763.408"
  }));
}
var ForwardRef$8 = /*#__PURE__*/forwardRef(CloudLightningIcon);

function CloudRainIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.343 21.166a.916.916 0 0 1-.917-.917v-1.833a.916.916 0 1 1 1.833 0v1.833c0 .507-.41.917-.916.917M8.343 15.666a.916.916 0 0 1-.917-.916v-1.833a.917.917 0 0 1 1.833 0v1.833c0 .507-.41.916-.916.916M15.674 21.166a.916.916 0 0 1-.916-.917v-1.833a.916.916 0 1 1 1.833 0v1.833c0 .507-.41.917-.917.917M15.674 15.666a.916.916 0 0 1-.916-.916v-1.833a.916.916 0 1 1 1.833 0v1.833c0 .507-.41.916-.917.916M12.009 22.999a.916.916 0 0 1-.917-.917V20.25a.916.916 0 1 1 1.833 0v1.833c0 .507-.41.917-.916.917M12.009 17.5a.916.916 0 0 1-.917-.917V14.75a.916.916 0 1 1 1.833 0v1.833c0 .507-.41.917-.916.917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.342 17.115a.917.917 0 0 1-.368-1.756 3.684 3.684 0 0 0 2.117-4.108 3.68 3.68 0 0 0-3.584-2.917h-1.154a.916.916 0 0 1-.887-.687 6.395 6.395 0 0 0-5.852-4.802A6.39 6.39 0 0 0 3.261 6.96a6.39 6.39 0 0 0 1.987 7.304.916.916 0 1 1-1.144 1.432 8.22 8.22 0 0 1-2.555-9.39 8.21 8.21 0 0 1 8.168-5.29A8.22 8.22 0 0 1 17.031 6.5h.477a5.52 5.52 0 0 1 5.377 4.375 5.524 5.524 0 0 1-3.176 6.162.9.9 0 0 1-.367.077"
  }));
}
var ForwardRef$7 = /*#__PURE__*/forwardRef(CloudRainIcon);

function CloudSnowIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.342 18.031a.917.917 0 0 1-.368-1.756 3.684 3.684 0 0 0 2.117-4.108 3.68 3.68 0 0 0-3.584-2.916h-1.154a.916.916 0 0 1-.887-.688 6.395 6.395 0 0 0-5.852-4.801 6.395 6.395 0 0 0-6.353 4.114 6.39 6.39 0 0 0 1.987 7.303.916.916 0 1 1-1.144 1.433 8.22 8.22 0 0 1-2.555-9.39 8.215 8.215 0 0 1 8.168-5.29 8.22 8.22 0 0 1 7.314 5.486h.477a5.52 5.52 0 0 1 5.377 4.375 5.524 5.524 0 0 1-3.176 6.161.9.9 0 0 1-.367.077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.352 16.583a.92.92 0 0 1-.921-.917c0-.506.405-.916.912-.916h.009a.916.916 0 1 1 0 1.833M8.352 20.25c-.507 0-.921-.41-.921-.917s.405-.917.912-.917h.009a.916.916 0 1 1 0 1.833M12.018 18.416a.92.92 0 0 1-.92-.917c0-.506.405-.916.91-.916h.01a.916.916 0 1 1 0 1.833M12.018 22.082a.92.92 0 0 1-.92-.916c0-.507.405-.917.91-.917h.01a.916.916 0 1 1 0 1.833M15.684 16.583a.92.92 0 0 1-.92-.917c0-.506.405-.916.911-.916h.01a.916.916 0 1 1 0 1.833M15.684 20.25c-.506 0-.92-.41-.92-.917s.405-.917.911-.917h.01a.916.916 0 1 1 0 1.833"
  }));
}
var ForwardRef$6 = /*#__PURE__*/forwardRef(CloudSnowIcon);

function SunIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 17.5c-3.033 0-5.5-2.467-5.5-5.5S8.967 6.5 12 6.5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5m0-9.167A3.67 3.67 0 0 0 8.333 12 3.67 3.67 0 0 0 12 15.667 3.67 3.67 0 0 0 15.667 12 3.67 3.67 0 0 0 12 8.333M12 4.667a.917.917 0 0 1-.917-.917V1.917a.917.917 0 0 1 1.834 0V3.75c0 .506-.41.917-.917.917M12 23a.916.916 0 0 1-.917-.917V20.25a.916.916 0 1 1 1.834 0v1.833c0 .507-.41.917-.917.917M6.17 7.087a.91.91 0 0 1-.648-.269L4.22 5.516A.916.916 0 1 1 5.516 4.22l1.302 1.302a.916.916 0 0 1-.648 1.565M19.132 20.049a.91.91 0 0 1-.648-.269l-1.302-1.302a.916.916 0 1 1 1.296-1.296l1.302 1.302a.916.916 0 0 1-.648 1.565M3.75 12.917H1.917a.917.917 0 0 1 0-1.834H3.75a.917.917 0 0 1 0 1.834M22.083 12.917H20.25a.916.916 0 1 1 0-1.834h1.833a.916.916 0 1 1 0 1.834M4.868 20.049a.916.916 0 0 1-.648-1.565l1.302-1.302a.916.916 0 1 1 1.296 1.296L5.516 19.78a.91.91 0 0 1-.648.269M17.83 7.087a.916.916 0 0 1-.648-1.565l1.302-1.302a.916.916 0 1 1 1.296 1.296l-1.302 1.302a.91.91 0 0 1-.648.269"
  }));
}
var ForwardRef$5 = /*#__PURE__*/forwardRef(SunIcon);

function SunCloudIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.765 5.53c.357 0 .647-.29.647-.648V3.588a.647.647 0 0 0-1.294 0v1.294c0 .358.29.647.647.647M4.192 7.048a.645.645 0 0 0 .915 0 .647.647 0 0 0 0-.915l-.92-.919a.647.647 0 1 0-.914.915zM3.588 10.706a.647.647 0 0 0-.647-.647H1.647a.647.647 0 0 0 0 1.294h1.294c.358 0 .647-.29.647-.647M4.192 14.364l-.92.919a.647.647 0 1 0 .916.915l.919-.92a.647.647 0 1 0-.915-.914M12.88 7.238a.65.65 0 0 0 .458-.19l.918-.919a.647.647 0 1 0-.914-.915l-.92.92a.647.647 0 0 0 .458 1.104M19.118 13.294h-.337c-.883-2.488-3.392-4.094-6.024-3.855a4.079 4.079 0 0 0-7.586 1.425 4.11 4.11 0 0 0 2.237 4.3c.02.009.04.013.06.02q-.003.27.02.544c.253 2.99 2.802 5.33 5.802 5.33h5.827999999999999c2.14 0 3.882-1.74 3.882-3.882s-1.741-3.882-3.882-3.882M6.45 11.056a2.787 2.787 0 0 1 4.953-1.323 5.88 5.88 0 0 0-3.748 4.074 2.81 2.81 0 0 1-1.205-2.75m12.667 8.709H13.29c-2.333 0-4.316-1.82-4.513-4.147s1.45-4.456 3.753-4.848q.375-.063.749-.063c2.025 0 3.877 1.381 4.397 3.396a.646.646 0 0 0 .627.485h.815a2.59 2.59 0 0 1 2.588 2.588 2.59 2.59 0 0 1-2.588 2.589"
  })));
}
var ForwardRef$4 = /*#__PURE__*/forwardRef(SunCloudIcon);

function SunCloudRainIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.767 3.588c.357 0 .647-.29.647-.647V1.647a.647.647 0 0 0-1.294 0v1.294c0 .358.29.647.647.647M4.194 5.107a.645.645 0 0 0 .915 0 .647.647 0 0 0 0-.915l-.919-.92a.647.647 0 1 0-.915.916zM3.59 8.765a.647.647 0 0 0-.646-.647H1.649a.647.647 0 0 0 0 1.294h1.295c.357 0 .647-.29.647-.647M4.194 12.423l-.919.919a.647.647 0 1 0 .915.914l.92-.918a.647.647 0 1 0-.916-.915M12.883 5.297a.65.65 0 0 0 .457-.19l.919-.92a.647.647 0 1 0-.915-.914l-.919.919a.647.647 0 0 0 .458 1.105M22.916 14.442a3.9 3.9 0 0 0-3.796-3.09h-.336a5.8 5.8 0 0 0-6.025-3.855 4.079 4.079 0 0 0-7.586 1.426 4.11 4.11 0 0 0 2.237 4.3q.03.012.06.02a5.8 5.8 0 0 0 2.187 4.6.648.648 0 0 0 .808-1.01 4.51 4.51 0 0 1-1.403-5.157 4.5 4.5 0 0 1 4.486-2.904 4.515 4.515 0 0 1 4.13 3.39.646.646 0 0 0 .627.485h.814a2.6 2.6 0 0 1 2.531 2.06 2.6 2.6 0 0 1-1.496 2.9.647.647 0 0 0 .52 1.185 3.9 3.9 0 0 0 2.242-4.35M7.853 11.214c-.081.214-.145.43-.201.648a2.81 2.81 0 0 1-1.199-2.747A2.79 2.79 0 0 1 8.776 6.76a2.79 2.79 0 0 1 2.625 1.026 5.81 5.81 0 0 0-3.548 3.428M12.65 19.118a.647.647 0 0 0-.648.647v1.294a.647.647 0 1 0 1.294 0v-1.294a.647.647 0 0 0-.647-.647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 15.235a.647.647 0 0 0-.648.647v1.294a.647.647 0 1 0 1.294 0v-1.294a.647.647 0 0 0-.647-.647M17.826 19.118a.647.647 0 0 0-.647.647v1.294a.647.647 0 1 0 1.294 0v-1.294a.647.647 0 0 0-.647-.647M17.826 15.235a.647.647 0 0 0-.647.647v1.294a.647.647 0 1 0 1.294 0v-1.294a.647.647 0 0 0-.647-.647M15.238 20.412a.647.647 0 0 0-.647.647v1.294a.647.647 0 1 0 1.294 0v-1.294a.647.647 0 0 0-.647-.647M15.238 16.53a.647.647 0 0 0-.647.646v1.295a.647.647 0 1 0 1.294 0v-1.295a.647.647 0 0 0-.647-.647"
  })));
}
var ForwardRef$3 = /*#__PURE__*/forwardRef(SunCloudRainIcon);

function ThermometerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22.91a4.97 4.97 0 0 1-4.785-3.55 4.97 4.97 0 0 1 1.603-5.308v-9.78A3.185 3.185 0 0 1 12 1.091a3.186 3.186 0 0 1 3.182 3.181v9.78a4.97 4.97 0 0 1 1.602 5.308A4.97 4.97 0 0 1 12 22.91m0-20c-.752 0-1.363.61-1.363 1.362v10.236a.91.91 0 0 1-.405.756 3.16 3.16 0 0 0-1.276 3.569A3.16 3.16 0 0 0 12 21.091a3.16 3.16 0 0 0 3.044-2.258 3.16 3.16 0 0 0-1.276-3.57.91.91 0 0 1-.405-.755V4.272c0-.751-.611-1.363-1.363-1.363"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.953,
    cy: 17.908,
    r: 2.145,
    fill: "currentColor"
  }));
}
var ForwardRef$2 = /*#__PURE__*/forwardRef(ThermometerIcon);

function UmbrellaIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.917a11.046 11.046 0 0 0-10.996 9.996.917.917 0 0 0 .913 1.004h9.166v5.5a3.667 3.667 0 0 0 7.334 0 .917.917 0 1 0-1.834 0 1.833 1.833 0 1 1-3.666 0v-5.5h9.166a.917.917 0 0 0 .913-1.004A11.046 11.046 0 0 0 12 1.917m0 1.833a9.21 9.21 0 0 1 9.014 7.333H2.986A9.21 9.21 0 0 1 12 3.75"
  }));
}
var ForwardRef$1 = /*#__PURE__*/forwardRef(UmbrellaIcon);

function WindIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    color: props.color || 'currentColor',
    inline: undefined,
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9h9.002a3 3 0 1 0-2.12-5.117 1 1 0 0 0 1.419 1.41A1 1 0 1 1 11.006 7l-.004 1 .004-1H2a1 1 0 0 0 0 2M14.002 15H2a1 1 0 0 0 0 2h12.007000000000001a1 1 0 1 1-.705 1.706 1 1 0 0 0-1.42 1.41 3 3 0 1 0 2.12-5.115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 6.468a3.5 3.5 0 0 0-4.223.553 1 1 0 0 0 1.413 1.416A1.5 1.5 0 1 1 19.502 11H2a1 1 0 0 0 0 2h17.505l-.002-1v-.017L19.505 13a3.5 3.5 0 0 0 1.745-6.532"
  })));
}
var ForwardRef = /*#__PURE__*/forwardRef(WindIcon);

export { ForwardRef$5p as AKTIcon, ForwardRef$2W as AccessibilityIcon, ForwardRef$2V as AddCardIcon, ForwardRef$2U as AddIcon, ForwardRef$2T as AdditionalIcon, ForwardRef$3u as AdditionalZonesTicketIcon, ForwardRef$2S as AdjustmentsIcon, ForwardRef$2R as AdminIcon, ForwardRef$2Q as AgreesIcon, ForwardRef$3t as AirportIcon, ForwardRef$2P as AlertIcon, ForwardRef$2N as AlertMobileFilledIcon, ForwardRef$2O as AlertMobileIcon, ForwardRef$5o as AlesundTurvognIcon, ForwardRef$44 as AlignCenterIcon, ForwardRef$43 as AlignLeftIcon, ForwardRef$42 as AlignRightIcon, ForwardRef$4H as AmericanExpressIcon, ForwardRef$61 as AnimalFreeIcon, ForwardRef$62 as AnimalIcon, ForwardRef$2w as AppLauncherIcon, ForwardRef$3T as AppleIcon, ForwardRef$4G as ApplePayIcon, ForwardRef$2u as AssignToMeFilledIcon, ForwardRef$2v as AssignToMeIcon, ForwardRef$5n as AtBIcon, ForwardRef$41 as AttachmentIcon, ForwardRef$60 as BabyIcon, ForwardRef$6s as BackArrowIcon, ForwardRef$5m as BaneNORIcon, ForwardRef$4A as BanknoteIcon, ForwardRef$4z as BanknoteMultiIcon, ForwardRef$4g as BatteryIcon, ForwardRef$2t as BellIcon, ForwardRef$5c as BergenBysykkelIcon, ForwardRef$5$ as BicycleHotelIcon, ForwardRef$3P as BicycleIcon, ForwardRef$5_ as BicycleParkingIcon, ForwardRef$2r as BirthdateFilledIcon, ForwardRef$2s as BirthdateIcon, ForwardRef$2p as BoardFilledIcon, ForwardRef$2q as BoardIcon, ForwardRef$40 as BoldIcon, ForwardRef$5b as BoltIcon, ForwardRef$2o as BookmarkIcon, ForwardRef$5l as BrakarIcon, ForwardRef$5k as BrakarNoTextIcon, ForwardRef$2n as BrightnessIcon, ForwardRef$2m as BugIcon, ForwardRef$3$ as BulletListIcon, ForwardRef$3O as BusIcon, ForwardRef$5Z as BusShelterIcon, ForwardRef$5Y as CabinIcon, ForwardRef$3N as CablewayIcon, ForwardRef$4f as CalculatorIcon, ForwardRef$2j as CalendarDetailedFilledIcon, ForwardRef$2k as CalendarDetailedIcon, ForwardRef$2l as CalendarIcon, ForwardRef$4e as CameraIcon, ForwardRef$3M as CarIcon, ForwardRef$3L as CarSharingIcon, ForwardRef$2i as CardIcon, ForwardRef$3K as CarferryIcon, ForwardRef$2h as ChannelsIcon, ForwardRef$2f as ChartFilledIcon, ForwardRef$2g as ChartIcon, ForwardRef$2e as ChatIcon, ForwardRef$2c as CheckFilledIcon, ForwardRef$2d as CheckIcon, ForwardRef$2a as CheckSmallFilledIcon, ForwardRef$2b as CheckSmallIcon, ForwardRef$L as CircleFilledIcon, ForwardRef$M as CircleIcon, ForwardRef$3J as CityBikeIcon, ForwardRef$3s as CityIcon, ForwardRef$28 as ClockFilledIcon, ForwardRef$29 as ClockIcon, ForwardRef$26 as CloseFilledIcon, ForwardRef$27 as CloseIcon, ForwardRef$24 as CloseSmallFilledIcon, ForwardRef$25 as CloseSmallIcon, ForwardRef$1n as ClosedLockIcon, ForwardRef$6r as CloudDownloadIcon, ForwardRef$9 as CloudIcon, ForwardRef$8 as CloudLightningIcon, ForwardRef$7 as CloudRainIcon, ForwardRef$6 as CloudSnowIcon, ForwardRef$5T as CoffeeIcon, ForwardRef$6q as CollapsedIcon, ForwardRef$23 as ColorPickerIcon, ForwardRef$22 as CommentIcon, ForwardRef$3r as CompassNeedleIcon, ForwardRef$21 as ComponentIcon, ForwardRef$3q as ConductorIcon, ForwardRef$20 as ConfigurationIcon, ForwardRef$1$ as ContactsIcon, ForwardRef$1Z as CookieFilledIcon, ForwardRef$1_ as CookieIcon, ForwardRef$1Y as CopyIcon, ForwardRef$3p as CorrespondenceIcon, ForwardRef$5S as CouchetteIcon, ForwardRef$1W as CustomerServiceFilledIcon, ForwardRef$1X as CustomerServiceIcon, ForwardRef$5R as CutleryIcon, ForwardRef$4d as DatabaseIcon, ForwardRef$1V as DateIcon, ForwardRef$1U as DeleteIcon, ForwardRef$5w as DenmarkIcon, ForwardRef$4y as DepositionIcon, ForwardRef$4c as DesktopIcon, ForwardRef$3o as DestinationIcon, ForwardRef$1S as DialogFilledIcon, ForwardRef$1T as DialogIcon, ForwardRef$4x as DiffIcon, ForwardRef$3m as DirectionFilledIcon, ForwardRef$3n as DirectionIcon, ForwardRef$1R as DislikeIcon, ForwardRef$6p as DownArrowIcon, ForwardRef$6o as DownloadIcon, ForwardRef$6n as DownwardIcon, ForwardRef$1O as DraggableIcon, ForwardRef$1N as EditIcon, ForwardRef$1M as EmailIcon, ForwardRef$3l as EnvironmentIcon, ForwardRef$4w as EuroIcon, ForwardRef$6m as ExpandIcon, ForwardRef$1L as ExtendIcon, ForwardRef$6l as ExternalIcon, ForwardRef$4p as FacebookIcon, ForwardRef$5j as FarteIcon, ForwardRef$5a as FartebysykkelIcon, ForwardRef$1J as FavoriteRouteFilledIcon, ForwardRef$1K as FavoriteRouteIcon, ForwardRef$1H as FavoriteStopFilledIcon, ForwardRef$1I as FavoriteStopIcon, ForwardRef$1F as FeedbackFilledIcon, ForwardRef$1G as FeedbackIcon, ForwardRef$3I as FerryIcon, ForwardRef$3S as FigmaIcon, ForwardRef$1E as FileIcon, ForwardRef$1D as FillIcon, ForwardRef$1B as FilterFilledIcon, ForwardRef$1C as FilterIcon, ForwardRef$5i as FlybussenIcon, ForwardRef$1z as FolderFilledIcon, ForwardRef$1A as FolderIcon, ForwardRef$6k as ForwardIcon, ForwardRef$5h as FramIcon, ForwardRef$5X as FullIcon, ForwardRef$3H as FunicularIcon, ForwardRef$5g as GOAIcon, ForwardRef$59 as GetAroundIcon, ForwardRef$4o as GithubIcon, ForwardRef$3k as GoalIcon, ForwardRef$4n as GoogleIcon, ForwardRef$4F as GooglePayIcon, ForwardRef$3R as GooglePlayIcon, ForwardRef$1y as GridViewIcon, ForwardRef$3j as GymIcon, ForwardRef$58 as HafjellIcon, ForwardRef$1x as HandToolIcon, ForwardRef$1w as HeartIcon, ForwardRef$3G as HelicopterIcon, ForwardRef$57 as HertzIcon, ForwardRef$1u as HistoryFilledIcon, ForwardRef$1v as HistoryIcon, ForwardRef$3i as HomeIcon, ForwardRef$1Q as HorizontalDotsIcon, ForwardRef$5f as HykeIcon, ForwardRef$1t as IconIcon, ForwardRef$4b as ImageIcon, ForwardRef$5e as InnlandstrafikkIcon, ForwardRef$4m as InstagramIcon, ForwardRef$3h as InternationalIcon, ForwardRef$3g as InterrailIcon, ForwardRef$3f as InvalidTicketIcon, ForwardRef$3_ as ItalicIcon, ForwardRef$56 as KolumbusBysykkelIcon, ForwardRef$5d as KolumbusIcon, ForwardRef$1r as LanguageFilledIcon, ForwardRef$1s as LanguageIcon, ForwardRef$4a as LaptopIcon, ForwardRef$6j as LeftArrowIcon, ForwardRef$1q as LikeIcon, ForwardRef$55 as LimeIcon, ForwardRef$3Z as LinkIcon, ForwardRef$4l as LinkedinIcon, ForwardRef$1p as ListViewIcon, ForwardRef$1o as LoadingIcon, ForwardRef$5Q as LockerIcon, ForwardRef$1l as LogInIcon, ForwardRef$1k as LogOutIcon, ForwardRef$5r as LogoNegativeIcon, ForwardRef$5q as LogoPositiveIcon, ForwardRef$1i as LostAndFoundFilledIcon, ForwardRef$1j as LostAndFoundIcon, ForwardRef$3e as LuggageIcon, ForwardRef$5W as ManySeatsAvailableIcon, ForwardRef$3c as MapFilledIcon, ForwardRef$3d as MapIcon, ForwardRef$3b as MapPinIcon, ForwardRef$4E as MastercardIcon, ForwardRef$1g as MeasureFilledIcon, ForwardRef$1h as MeasureIcon, ForwardRef$1f as MenuIcon, ForwardRef$6i as MergeProfilesIcon, ForwardRef$3F as MetroIcon, ForwardRef$1e as MinimizeIcon, ForwardRef$49 as MobileIcon, ForwardRef$3E as MobilityIcon, ForwardRef$4v as MoneyIcon, ForwardRef$3a as MountainIcon, ForwardRef$54 as MoveAboutIcon, ForwardRef$3Q as MuralIcon, ForwardRef$1d as NewIcon, ForwardRef$1c as NightIcon, ForwardRef$4X as NorWayBussekspressIcon, ForwardRef$4W as NordlandIcon, ForwardRef$5v as NorwayIcon, ForwardRef$3Y as NumberListIcon, ForwardRef$2M as ObjectAlignBottomFilledIcon, ForwardRef$2L as ObjectAlignBottomIcon, ForwardRef$2K as ObjectAlignCenterFilledIcon, ForwardRef$2J as ObjectAlignCenterIcon, ForwardRef$2I as ObjectAlignLeftFilledIcon, ForwardRef$2H as ObjectAlignLeftIcon, ForwardRef$2G as ObjectAlignMiddleFilledIcon, ForwardRef$2F as ObjectAlignMiddleIcon, ForwardRef$2E as ObjectAlignRightFilledIcon, ForwardRef$2D as ObjectAlignRightIcon, ForwardRef$2C as ObjectAlignTopFilledIcon, ForwardRef$2B as ObjectAlignTopIcon, ForwardRef$2A as ObjectDistributeHorizontallyFilledIcon, ForwardRef$2z as ObjectDistributeHorizontallyIcon, ForwardRef$2y as ObjectDistributeVerticallyFilledIcon, ForwardRef$2x as ObjectDistributeVerticallyIcon, ForwardRef$1m as OpenedLockIcon, ForwardRef$1b as OrganizationIcon, ForwardRef$53 as OsloBysykkelIcon, ForwardRef$4V as OstfoldIcon, ForwardRef$52 as OttoMobilityIcon, ForwardRef$1a as PackageIcon, ForwardRef$6h as PageNavigationIcon, ForwardRef$5O as ParkAndRideIcon, ForwardRef$5P as ParkIcon, ForwardRef$5N as ParkingGarageIcon, ForwardRef$48 as PhoneIcon, ForwardRef$3D as PlaneIcon, ForwardRef$39 as PlatformIcon, ForwardRef$19 as PlayIcon, ForwardRef$38 as PlaygroundIcon, ForwardRef$5M as PlayroomIcon, ForwardRef$36 as PositionFilledIcon, ForwardRef$37 as PositionIcon, ForwardRef$5L as PowerIcon, ForwardRef$5K as PremiumSeatIcon, ForwardRef$4u as PriceFromIcon, ForwardRef$4t as PricelistIcon, ForwardRef$47 as PrinterIcon, ForwardRef$35 as PrioritySeatPregnantIcon, ForwardRef$34 as PrioritySeatSeniorsIcon, ForwardRef$18 as PrivacyIcon, ForwardRef$16 as ProfileFilledIcon, ForwardRef$17 as ProfileIcon, ForwardRef$15 as PurposeIcon, ForwardRef$14 as PuzzleIcon, ForwardRef$46 as QRIcon, ForwardRef$p as QuestionFilledIcon, ForwardRef$q as QuestionIcon, ForwardRef$13 as QuietIcon, ForwardRef$12 as QuitIcon, ForwardRef$11 as RSSIcon, ForwardRef$32 as RebateTicketFilledIcon, ForwardRef$33 as RebateTicketIcon, ForwardRef$6g as RedoIcon, ForwardRef$4s as ReferenceIcon, ForwardRef$6f as RefreshIcon, ForwardRef$4U as ReisNordlandIcon, ForwardRef$$ as RequiredFilledIcon, ForwardRef$10 as RequiredIcon, ForwardRef$Z as RequiredSmallFilledIcon, ForwardRef$_ as RequiredSmallIcon, ForwardRef$6e as ResetIcon, ForwardRef$6d as RightArrowIcon, ForwardRef$X as RouteFilledIcon, ForwardRef$Y as RouteIcon, ForwardRef$W as RowHeightDefaultIcon, ForwardRef$V as RowHeightMiddleIcon, ForwardRef$U as RowHeightSmallIcon, ForwardRef$T as RulesIcon, ForwardRef$3C as RunningIcon, ForwardRef$4T as RuterIcon, ForwardRef$4S as RuterNoTextIcon, ForwardRef$51 as RydeIcon, ForwardRef$4R as SJIcon, ForwardRef$4Q as SJNordIcon, ForwardRef$50 as SURFIcon, ForwardRef$5u as SamiIcon, ForwardRef$45 as SaveIcon, ForwardRef$S as ScopeIcon, ForwardRef$Q as SearchFilledIcon, ForwardRef$R as SearchIcon, ForwardRef$5H as SeatCompartmentFilledIcon, ForwardRef$5I as SeatCompartmentIcon, ForwardRef$5J as SeatIcon, ForwardRef$5V as SeatsAvailableIcon, ForwardRef$P as SelectIcon, ForwardRef$O as SendIcon, ForwardRef$N as SettingsIcon, ForwardRef$I as ShareIcon, ForwardRef$4r as ShoppingCartIcon, ForwardRef$H as SilentIcon, ForwardRef$31 as SkiIcon, ForwardRef$4k as SkypeIcon, ForwardRef$4P as SkyssIcon, ForwardRef$4O as SkyssNoTextIcon, ForwardRef$5G as SleepIcon, ForwardRef$4N as SnelandiaIcon, ForwardRef$3B as SnowCoachIcon, ForwardRef$G as SortIcon, ForwardRef$3X as SourceCodeIcon, ForwardRef$F as StandardIcon, ForwardRef$5U as StandingAvailableIcon, ForwardRef$3A as StandingIcon, ForwardRef$K as StarredIcon, ForwardRef$4q as StatsIcon, ForwardRef$5F as StrollerIcon, ForwardRef$3z as StrollingIcon, ForwardRef$D as StudentFilledIcon, ForwardRef$E as StudentIcon, ForwardRef$C as SubtractIcon, ForwardRef$30 as SuitcaseIcon, ForwardRef$4 as SunCloudIcon, ForwardRef$3 as SunCloudRainIcon, ForwardRef$5 as SunIcon, ForwardRef$4M as SvipperIcon, ForwardRef$5t as SwedenIcon, ForwardRef$6c as SwitchIcon, ForwardRef$5E as TVMIcon, ForwardRef$B as TagIcon, ForwardRef$3y as TaxiIcon, ForwardRef$z as TerminalFilledIcon, ForwardRef$A as TerminalIcon, ForwardRef$3W as TextColorIcon, ForwardRef$2 as ThermometerIcon, ForwardRef$4$ as TierIcon, ForwardRef$x as TimeglassFilledIcon, ForwardRef$y as TimeglassIcon, ForwardRef$w as TimelineIcon, ForwardRef$6b as ToFromIcon, ForwardRef$5D as ToiletIcon, ForwardRef$v as TokenIcon, ForwardRef$u as ToneSmileIcon, ForwardRef$2$ as TrackIcon, ForwardRef$5C as TrainCarIcon, ForwardRef$3x as TrainIcon, ForwardRef$3w as TramIcon, ForwardRef$6a as TransferIcon, ForwardRef$4L as TromsFylkestrafikkIcon, ForwardRef$4_ as TrondheimBysykkelIcon, ForwardRef$69 as TurnableIcon, ForwardRef$4j as TwitterIcon, ForwardRef$5s as UKIcon, ForwardRef$1 as UmbrellaIcon, ForwardRef$3V as UnderlineIcon, ForwardRef$68 as UndoIcon, ForwardRef$2_ as UniversityIcon, ForwardRef$3U as UnlinkIcon, ForwardRef$67 as UnsortedIcon, ForwardRef$J as UnstarredIcon, ForwardRef$t as UnviewIcon, ForwardRef$66 as UpArrowIcon, ForwardRef$65 as UploadIcon, ForwardRef$64 as UpwardIcon, ForwardRef$s as UserIcon, ForwardRef$r as UsersIcon, ForwardRef$4K as VKTIcon, ForwardRef$2Y as ValidTicketFilledIcon, ForwardRef$2Z as ValidTicketIcon, ForwardRef$n as ValidationErrorFilledIcon, ForwardRef$o as ValidationErrorIcon, ForwardRef$k as ValidationExclamationCircleFilledIcon, ForwardRef$l as ValidationExclamationCircleIcon, ForwardRef$j as ValidationExclamationFilledIcon, ForwardRef$m as ValidationExclamationIcon, ForwardRef$h as ValidationInfoFilledIcon, ForwardRef$i as ValidationInfoIcon, ForwardRef$f as ValidationSuccessFilledIcon, ForwardRef$g as ValidationSuccessIcon, ForwardRef$e as ValueIcon, ForwardRef$5B as VendingMachineIcon, ForwardRef$1P as VerticalDotsIcon, ForwardRef$63 as VerticalSwitchIcon, ForwardRef$d as ViewIcon, ForwardRef$4i as VimeoIcon, ForwardRef$4D as VippsIcon, ForwardRef$4C as VippsLogoIcon, ForwardRef$4B as VisaIcon, ForwardRef$4Z as VoiIcon, ForwardRef$4J as VyIcon, ForwardRef$5A as WaitingRoomIcon, ForwardRef$3v as WalkIcon, ForwardRef$c as WarningIcon, ForwardRef$5z as WaterTapIcon, ForwardRef$5y as WheelchairIcon, ForwardRef$5x as WifiIcon, ForwardRef as WindIcon, ForwardRef$4h as YoutubeIcon, ForwardRef$2X as ZoneIcon, ForwardRef$b as ZoomInIcon, ForwardRef$a as ZoomOutIcon, ForwardRef$4Y as ZvippIcon, ForwardRef$4I as ØresundstågIcon };
